import $ from 'jquery';
import _, { defaults, each, select } from 'underscore';
import Backbone from 'backbone';

var quantitiesById = {};
var variantsById = {};
var productsById = {};
var customVariants = {};
var LAST_SELECTED_VARIANT_ID = '';
var MOST_RECENT_CUSTOM_VARIANT = [];
var ASSET_URL_BASE = 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/';
var CREATED_LISTENER = false;
let CREATED_ENGRAVING_LISTENER = false;
var LAST_VARIANT_LISTENER_ID;
let IS_PET_PORTRAIT_CONFIRMING = false;
let IS_SYMBOL_INPUT_CHECKER = false;
let selectedBaseVariantId = null;
let selectedBaseVariantTitle = null;
let selectedBaseVariantImage = null;
let selectedBaseVariantCompareAtPrice = null;
let selectedBaseVariantPrice = null;
let ORIG_CUSTOM_SWATCH_CONTAINER = null;

var FONT_NAMES = ['font_dayrom.ttf', 'font_holland_land.ttf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf'];
var ORNAMENT_FONT_NAMES = ['font_dayrom.ttf', 'font_holland_land.ttf', 'font_kumbh_sans.ttf', 'font_grafolita.otf'];
var forceATC = false;
var PRICES_BY_TYPE = {};
let ENGRAVABLE_ID;
let hiddenCheck;
let lastShown;
let modalPond;
let petModal;
let _selfRef;
let IS_WATERCOLOR = false;
let ACTIVE_JERSEY_VARIANT_ID;
let $jerseyModal;

function getCircularText(canvas, text, diameter, startAngle, align, textInside, inwardFacing, fName, fSize, kerning, textColor, isBold) {
  // text:         The text to be displayed in circular fashion
  // diameter:     The diameter of the circle around which the text will
  //               be displayed (inside or outside)
  // startAngle:   In degrees, Where the text will be shown. 0 degrees
  //               if the top of the circle
  // align:        Positions text to left right or center of startAngle
  // textInside:   true to show inside the diameter. False to show outside
  // inwardFacing: true for base of text facing inward. false for outward
  // fName:        name of font family. Make sure it is loaded
  // fSize:        size of font family. Don't forget to include units
  // kearning:     0 for normal gap between letters. positive or
  //               negative number to expand/compact gap in pixels
  //------------------------------------------------------------------------

  // declare and intialize canvas, reference, and useful variables

  align = align.toLowerCase();
  var mainCanvas = canvas
  var ctxRef = mainCanvas.getContext('2d');
  ctxRef.imageSmoothingEnabled = false;
  var clockwise = align == "right" ? 1 : -1; // draw clockwise for aligned right. Else Anticlockwise
  startAngle = startAngle * (Math.PI / 180); // convert to radians

  diameter *= window.devicePixelRatio
  fSize = (parseFloat(fSize.split('px')[0]) * window.devicePixelRatio) + 'px'

  // calculate height of the font. Many ways to do this
  // you can replace with your own!
  var div = document.createElement("div");
  div.innerHTML = text;
  div.style.position = 'absolute';
  div.style.top = '-10000px';
  div.style.left = '-10000px';
  div.style.fontFamily = fName;
  div.style.fontSize = fSize;
  if (isBold) {
    div.style.fontWeight = 'bold';
  }
  document.body.appendChild(div);
  var textHeight = div.offsetHeight;
  document.body.removeChild(div);

  // in cases where we are drawing outside diameter,
  // expand diameter to handle it
  if (!textInside) diameter += textHeight * 2;
  mainCanvas.width = diameter
  mainCanvas.height = diameter
  // omit next line for transparent background
  ctxRef.fillStyle = textColor || 'black';
  ctxRef.font = fSize + ' ' + fName;

  // Reverse letters for align Left inward, align right outward 
  // and align center inward.
  if (((["left", "center"].indexOf(align) > -1) && inwardFacing) || (align == "right" && !inwardFacing)) text = text.split("").reverse().join("");

  // Setup letters and positioning
  ctxRef.translate(diameter / 2, diameter / 2); // Move to center
  startAngle += (Math.PI * !inwardFacing); // Rotate 180 if outward
  ctxRef.textBaseline = 'middle'; // Ensure we draw in exact center
  ctxRef.textAlign = 'center'; // Ensure we draw in exact center

  // rotate 50% of total angle for center alignment
  if (align == "center") {
    for (var j = 0; j < text.length; j++) {
      var charWid = ctxRef.measureText(text[j]).width;
      startAngle += ((charWid + (j == text.length - 1 ? 0 : kerning)) / (diameter / 2 - textHeight)) / 2 * -clockwise;
    }
  }

  // Phew... now rotate into final start position
  ctxRef.rotate(startAngle);

  // Now for the fun bit: draw, rotate, and repeat
  for (var j = 0; j < text.length; j++) {
    var charWid = ctxRef.measureText(text[j]).width; // half letter
    // rotate half letter
    ctxRef.rotate((charWid / 2) / (diameter / 2 - textHeight) * clockwise);
    // draw the character at "top" or "bottom" 
    // depending on inward or outward facing
    ctxRef.fillText(text[j], 0, (inwardFacing ? 1 : -1) * (0 - diameter / 2 + textHeight / 2));

    ctxRef.rotate((charWid / 2 + kerning) / (diameter / 2 - textHeight) * clockwise); // rotate half letter
  }
  // Return it
  return (mainCanvas);
}

const FILEPOND_OPTIONS = {
  allowReorder: false,
  credits: [],
  allowImageResize: true,
  imageResizeTargetWidth: 1000,
  imageResizeTargetHeight: 1000,
  imageResizeMode: 'contain',
  imageResizeUpscale: false,
  acceptedFileTypes: ["image/jpg", "image/jpeg", "image/png", "image/gif", "image/bmp", "image/heic"],
  imageTransformOutputQuality: 60,
  imageTransformOutputQualityMode: 'optional',
  imagePreviewHeight: 150,
  labelIdle: 'Upload Photo',
  allowDrop: false
}

var FONT_PROPERTIES = {
  'Nickainley Normal': 'F1',
  'Kumbh Sans': 'F2',
  'Dayrom': 'F3',
  'Holland Land': 'F4',
  'Magnum': 'F5',
  'Grafolita': 'F6',
  'Alga': 'F8'
}

const FONTS_BY_TAG = {
  'SQUARE_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'SPIN_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_PHOTO_KEYCHAIN': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'CIRCLE_QUADRANT_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'CIRCLE_PHOTO_KEYCHAIN': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'CIRCLE_CHARM': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_CHARM': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'CIRCLE_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'BAR_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_SNOWFLAKE_ORNAMENT': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_BIRTHSTONE_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'OVAL_VERTICAL_LOCKET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'OVAL_LOCKET_RING': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'OVAL_LOCKET_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_LOCKET_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_LOCKET_RING': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'HEART_LOCKET_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'FLIP_LOCKET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_ID_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_PENDANT_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'PAVE_CIRCLE_ENGRAVABLE_CHARM': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE': ['font_kumbh_sans.ttf'],
  'ENGRAVABLE_BAR_CHARM': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_BAR_TENNIS_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_BAR_PAPERCLIP_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_HEART_PHOTO_BOOKMARK': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_BAR_RING': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_HEART_LOCKET_KEYCHAIN': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'CIRCLE_PHOTO_SQUARE_KEYCHAIN': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
  'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE': ['font_alga.otf', 'font_kumbh_sans.ttf', 'font_magnum.ttf', 'font_nickainley_normal.otf', 'font_holland_land.ttf'],
}

const SWATCHES_CONFIG = {
  'Purple Gradient': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Purple_Gradient.svg',
  'Green Gradient': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Green_Gradient.svg',
  'Pink Gradient': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Pink_Gradient.svg',
  'Blue Gradient': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Blue_Gradient.svg',
  'Yellow Gradient': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Yellow_Gradient.svg',
  'Rose Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Rose_Gold.png',
  'Amethyst': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Amethyst-2.svg',
  'Quartz': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Quartz.svg',
  'Turquoise': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Turquoise.svg',
  'Hematite': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Hematite.svg',
  'Tigers Eye': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Tigers_Eye.svg',
  'Rose Quartz': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Rose_Quartz.svg',
  'Citrine': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Citrine.svg',
  'Lapis': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Lapis.svg',
  'Garnet': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Garnet.svg',
  'Peridot': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Peridot.svg',
  'Diamond': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Diamond.svg',
  'Emerald': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Emerald.svg',
  'Blue Zircon': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Blue_Zircon.svg',
  'Opal': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Opal.svg',
  'Aquamarine': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Aquamarine.svg',
  'Yellow Topaz': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Yellow_Topaz.svg',
  'Alexandrite': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Alexandrite.svg',
  'Sapphire': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Sapphire.svg',
  'Ruby': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-Ruby.svg',
  'Silver-White': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Silver-White.png',
  'White Gold-White': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-White_Gold-White.png',
  'Rose Gold-White': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Rose_Gold-White.png',
  'Gold-White': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Gold-White.png',
  'Blush-Silver': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Blush-Silver.png',
  'Lime': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Lime.png',
  'Winterfresh-Silver': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Winterfresh-Silver.png',
  'Pink': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Pink.png',
  'Deep Sea': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Deep_Sea.png',
  'White-Black': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-White-Black.png',
  'Pink Paradise': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Pink_Paradise.png',
  'Navy': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Navy.png',
  'Black-Black': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Black-Black.png',
  'Chocolate': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Chocolate.png',
  'USA': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-USA.png',
  'Steel': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Steel.png',
  'White-Rose Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-White-Rose_Gold.png',
  'Natural Nostalgia': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Natural_Nostalgia.png',
  'White-Silver': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-White-Silver.png',
  'Sunrise Sorbet': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-Sunrise_Sorbet.png',
  'White-Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Bracelet-White-Gold.png',
  'Pink-Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Stack-Pink-Gold.png',
  'Turquoise-Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Stack-Turquoise-Gold.png',
  'Black-Silver': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Stack-Black-Silver.png'
}

var SYMBOL_NAMES = {
  'Angel.svg': 'AG',
  'Basketball.svg': 'BB',
  'Butterfly.svg': 'BF',
  'Cheers.svg': 'CH',
  'Clover.svg': 'CL',
  'Cowboy-Boot.svg': 'CB',
  'Diamond.svg': 'DI',
  'Dolphin.svg': 'DL',
  'Earth.svg': 'EA',
  'Eye.svg': 'EY',
  'Football.svg': 'FB',
  'Graduation.svg': 'GR',
  'Guitar.svg': 'GU',
  'Heart.svg': 'HS',
  'Infinity.svg': 'IF',
  'Love.svg': 'HT',
  'Moon.svg': 'CM',
  'Mountains.svg': 'MO',
  'Note.svg': 'MU',
  'Palm-Tree.svg': 'PT',
  'Paw.svg': 'PW',
  'Peace.svg': 'PC',
  'Rainbow.svg': 'RA',
  'Shooting-Star.svg': 'SS',
  'Smiley.svg': 'SM',
  'Soccer.svg': 'SC',
  'Sparkle.svg': 'SP',
  'Star.svg': 'ST',
  'Sun.svg': 'SN',
  'Volleyball.svg': 'VB'
};

var ICON_NAMES = {
  'Angel.svg': `&#xe90c;`,
  'Basketball.svg': `&#xe91c;`,
  'Butterfly.svg': `&#xe920;`,
  'Cheers.svg': `&#xe923;`,
  'Clover.svg': `&#xe90f;`,
  'Cowboy-Boot.svg': `&#xe919;`,
  'Diamond.svg': `&#xe936;`,
  'Dolphin.svg': `&#xe922;`,
  'Earth.svg': `&#xe925;`,
  'Eye.svg': `&#xe906;`,
  'Football.svg': `&#xe924;`,
  'Graduation.svg': `&#xe928;`,
  'Guitar.svg': `&#xe91f;`,
  'Heart.svg': `&#xe908;`,
  'Infinity.svg': `&#xe92f;`,
  'Love.svg': `&#xe915;`,
  'Moon.svg': `&#xe904;`,
  'Mountains.svg': `&#xe917;`,
  'Note.svg': `&#xe905;`,
  'Palm-Tree.svg': `&#xe902;`,
  'Paw.svg': `&#xe903;`,
  'Peace.svg': `&#xe921;`,
  'Rainbow.svg': `&#xe927;`,
  'Shooting-Star.svg': `&#xe91b;`,
  'Smiley.svg': `&#xe909;`,
  'Soccer.svg': `&#xe901;`,
  'Sparkle.svg': `&#xe916;`,
  'Star.svg': `&#xe907;`,
  'Sun.svg': `&#xe90e;`,
  'Volleyball.svg': `&#xe918;`,
  'Aquarius.svg': `&#xe910;`,
  'Aries.svg': `&#xe929;`,
  'Cancer.svg': `&#xe91d;`,
  'Capricorn.svg': `&#xe91a;`,
  'Gemini.svg': `&#xe911;`,
  'Leo.svg': `&#xe913;`,
  'Libra.svg': `&#xe90d;`,
  'Pisces.svg': `&#xe912;`,
  'Sagittarius.svg': `&#xe914;`,
  'Scorpio.svg': `&#xe90b;`,
  'Taurus.svg': `&#xe91e;`,
  'Virgo.svg': `&#xe926;`
}

var ZODIAC_NAMES = {
  'Aquarius.svg': 'AQ',
  'Aries.svg': 'AR',
  'Cancer.svg': 'CA',
  'Capricorn.svg': 'CP',
  'Gemini.svg': 'GE',
  'Leo.svg': 'LE',
  'Libra.svg': 'LB',
  'Pisces.svg': 'PI',
  'Sagittarius.svg': 'SA',
  'Scorpio.svg': 'SO',
  'Taurus.svg': 'TA',
  'Virgo.svg': 'VI'
}

const CATEGORY_LIST = {
  "letters": ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
  "numbers": ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  "symbols": [
    { "itemType": "Angel", "itemText": `&#xe90c;` },
    { "itemType": "Basketball", "itemText": `&#xe91c;` },
    { "itemType": "Butterfly", "itemText": `&#xe920;` },
    { "itemType": "Cheers", "itemText": `&#xe923;` },
    { "itemType": "Clover", "itemText": `&#xe90f;` },
    { "itemType": "Cowboy Boot", "itemText": `&#xe919;` },
    { "itemType": "Diamond", "itemText": `&#xe936;` },
    { "itemType": "Dolphin", "itemText": `&#xe922;` },
    { "itemType": "Earth", "itemText": `&#xe925;` },
    { "itemType": "Eye", "itemText": `&#xe906;` },
    { "itemType": "Football", "itemText": `&#xe924;` },
    { "itemType": "Graduation", "itemText": `&#xe928;` },
    { "itemType": "Guitar", "itemText": `&#xe91f;` },
    { "itemType": "Heart", "itemText": `&#xe908;` },
    { "itemType": "Infinity", "itemText": `&#xe92f;` },
    { "itemType": "Love", "itemText": `&#xe915;` },
    { "itemType": "Moon", "itemText": `&#xe904;` },
    { "itemType": "Mountains", "itemText": `&#xe917;` },
    { "itemType": "Note", "itemText": `&#xe905;` },
    { "itemType": "Palm Tree", "itemText": `&#xe902;` },
    { "itemType": "Paw", "itemText": `&#xe903;` },
    { "itemType": "Peace", "itemText": `&#xe921;` },
    { "itemType": "Rainbow", "itemText": `&#xe927;` },
    { "itemType": "Shooting Star", "itemText": `&#xe91b;` },
    { "itemType": "Smiley", "itemText": `&#xe909;` },
    { "itemType": "Soccer", "itemText": `&#xe901;` },
    { "itemType": "Sparkle", "itemText": `&#xe916;` },
    { "itemType": "Star", "itemText": `&#xe907;` },
    { "itemType": "Sun", "itemText": `&#xe90e;` },
    { "itemType": "Volleyball", "itemText": `&#xe918;` },
    { "itemType": "Aquarius", "itemText": `&#xe910;` },
    { "itemType": "Aries", "itemText": `&#xe929;` },
    { "itemType": "Cancer", "itemText": `&#xe91d;` },
    { "itemType": "Capricorn", "itemText": `&#xe91a;` },
    { "itemType": "Gemini", "itemText": `&#xe911;` },
    { "itemType": "Leo", "itemText": `&#xe913;` },
    { "itemType": "Libra", "itemText": `&#xe90d;` },
    { "itemType": "Pisces", "itemText": `&#xe912;` },
    { "itemType": "Sagittarius", "itemText": `&#xe914;` },
    { "itemType": "Scorpio", "itemText": `&#xe90b;` },
    { "itemType": "Taurus", "itemText": `&#xe91e;` },
    { "itemType": "Virgo", "itemText": `&#xe926;` }
  ]
}

const containersByType = {
  "HEART_PHOTO_KEYCHAIN": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3, "canMixSymbols": true }
  ],
  "SQUARE_NECKLACE": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 },
  ],
  "SPIN_NECKLACE": [
    { "type": "RAW_TEXT", "backend": "Line 1 Front", "label": "Line 1 (Front)", "maxLength": 10 },
    { "type": "RAW_TEXT", "backend": "Line 2 Front", "label": "Line 2 (Front)", "maxLength": 10 },
    { "type": "RAW_TEXT", "backend": "Line 3 Front", "label": "Line 3 (Front)", "maxLength": 10 },
    { "type": "DROPDOWN", "ignoreSelector": true, "backend": "Line 1 Back", "label": "Line 1 (Back)", "maxLength": 1 },
  ],
  "CIRCLE_QUADRANT_NECKLACE": [
    { "type": "DROPDOWN", "backend": "Line 1 Left", "label": "Line 1 (Left)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Right", "label": "Line 2 (Right)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Bottom", "label": "Line 3 (Bottom)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Top", "label": "Line 4 (Top)", "maxLength": 1 },
  ],
  "CIRCLE_PHOTO_KEYCHAIN": [
    { "type": "DROPDOWN", "backend": "Line 1 Top", "label": "Line 1 (Left)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Right", "label": "Line 2 (Right)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Bottom", "label": "Line 3 (Bottom)", "maxLength": 1 },
    { "type": "DROPDOWN", "backend": "Line 1 Left", "label": "Line 4 (Top)", "maxLength": 1 },
  ],
  "CIRCLE_CHARM": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "HEART_CHARM": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "CIRCLE_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "BAR_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_SNOWFLAKE_ORNAMENT": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 12 }
  ],
  "HEART_BIRTHSTONE_BRACELET": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 9 }
  ],
  "OVAL_VERTICAL_LOCKET": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "OVAL_LOCKET_RING": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "OVAL_LOCKET_BRACELET": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "HEART_LOCKET_NECKLACE": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "HEART_LOCKET_RING": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "HEART_LOCKET_BRACELET": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "FLIP_LOCKET": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "ENGRAVABLE_ID_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 15, "canMixSymbols": true }
  ],
  "ENGRAVABLE_PENDANT_NECKLACE": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 15, "canMixSymbols": true }
  ],
  "PAVE_CIRCLE_ENGRAVABLE_CHARM": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_CIRCLE_PHOTO_NECKLACE": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 9 },
    { "type": "RAW_TEXT", "backend": "Line 2", "label": "Line 2", "maxLength": 9 },
    { "type": "RAW_TEXT", "backend": "Line 3", "label": "Line 3", "maxLength": 9 },
    { "type": "RAW_TEXT", "backend": "Line 4", "label": "Line 4", "maxLength": 9 },
  ],
  "ENGRAVABLE_BAR_CHARM": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_BAR_TENNIS_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_BAR_PAPERCLIP_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_BAR_PAPERCLIP_NECKLACE": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 40, "canMixSymbols": true }
  ],
  "ENGRAVABLE_HEART_PHOTO_BOOKMARK": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 40, "canMixSymbols": true }
  ],
  "ENGRAVABLE_BAR_RING": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 10, "canMixSymbols": true }
  ],
  "ENGRAVABLE_HEART_LOCKET_KEYCHAIN": [
    { "type": "RAW_TEXT", "backend": "Line 1", "label": "Line 1", "maxLength": 3 }
  ],
  "CIRCLE_PHOTO_SQUARE_KEYCHAIN": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 3, "canMixSymbols": true }
  ],
  "ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE": [
    { "type": "INPUT", "backend": "Line 1", "label": "Line 1", "maxLength": 9, "canMixSymbols": true }
  ],
}

if ($('#jersey-modal').length) {
  $jerseyModal = new theme.Modals('jersey-modal', 'jersey-modal', {
    solid: true
  });
}

const ignoreImageRenders = {
  "OVAL_VERTICAL_LOCKET": true,
  "OVAL_LOCKET_RING": true,
  "OVAL_LOCKET_BRACELET": true,
  "HEART_LOCKET_NECKLACE": true,
  "HEART_LOCKET_RING": true,
  "HEART_LOCKET_BRACELET": true,
  "FLIP_LOCKET": true,
}

const ignoreFirstImage = {
  "OVAL_VERTICAL_LOCKET": true,
  "OVAL_LOCKET_RING": true,
  "OVAL_LOCKET_BRACELET": true,
  "HEART_LOCKET_NECKLACE": true,
  "HEART_LOCKET_RING": true,
  "HEART_LOCKET_BRACELET": true,
  "FLIP_LOCKET": true
}

function containsNonLatinCodepoints(s) {
  return /[^\u0000-\u00ff]/.test(s);
}

function checkMostlyUppercase(s) {
  // check if a string is mostly uppercase
  let upper = 0;
  let lower = 0;
  for (var i = 0; i < s.length; i++) {
    if (s[i] == s[i].toUpperCase()) {
      upper++;
    } else {
      lower++;
    }
  }
  return (upper >= 1);
}

function nonLatinCodepointsInString(s) {
  if (!s || s.length == 0) return 0;
  let amount = 0;
  for (var i = 0; i < s.length; i++) {
    if (containsNonLatinCodepoints(s[i])) {
      amount++;
    }
  }
  return amount;
}

function isValidBarBraceletText(nonLatin, normalChars) {
  let limit = 10 - ((nonLatin || 0) * 2) - ((normalChars || 0));

  return limit >= 0;
}

function isNotEmptyText(textValue) {
  let text = textValue || $('#TEXT1').val();
  if (!text || text.length == 0) return false;

  return true;
}

if ($('#letter-block').length || $('#custom-strap-keychain').length || $('#monogram-heart-keychain').length || $('#required-line1').length || $('.required-line1').length) {
  $('.add-to-cart').on('click', function (e) {
    if (!isNotEmptyText()) {
      $('#invalid-text').show();
      $('.invalid-text').show();
      e.preventDefault();
      e.stopPropagation();
      return;
    } else {
      $('#invalid-text').hide();
      $('.invalid-text').hide();
      return true;
    }
  });
}

function isValidIdBraceletText(nonLatin, normalChars) {
  if (nonLatin > 0) {
    if (normalChars > 0) {
      return nonLatin <= 2 && normalChars <= 6;
    } else {
      return nonLatin <= 4;
    }
  } else {
    return normalChars <= 15;
  }
}

function isValidPendantNecklaceText(nonLatin, normalChars) {
  if (nonLatin > 0) {
    if (normalChars > 0) {
      return nonLatin <= 2 && normalChars <= 8;
    } else {
      return nonLatin <= 5;
    }
  } else {
    return normalChars <= 15;
  }
}

const handleBirthstoneStretchBracelet = () => {
  let CURR_BIRTHSTONES = 1;
  const iconPrefix = 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-';
  const iconSuffix = '.svg';
  const birthstoneValues = [
    { value: 'Garnet', month: 'January' },
    { value: 'Amethyst', month: 'February' },
    { value: 'Aquamarine', month: 'March' },
    { value: 'Diamond', month: 'April' },
    { value: 'Emerald', month: 'May' },
    { value: 'Alexandrite', month: 'June' },
    { value: 'Ruby', month: 'July' },
    { value: 'Peridot', month: 'August' },
    { value: 'Sapphire', month: 'September' },
    { value: 'Tourmaline', month: 'October' },
    { value: 'Yellow Topaz', month: 'November' },
    { value: 'Blue Zircon', month: 'December' },
  ];
  const handleBirthstoneStretchBraceletATC = () => {
    let properties = {};

    for (let i = 0; i < CURR_BIRTHSTONES; i++) {
      let birthstoneContainer = $(`.birthstone-container-${i}`);
      if (!birthstoneContainer.length) {
        continue;
      }
      properties[`Birthstone ${i + 1}`] = birthstoneContainer.data('value');
    }

    const cartAdditions = [{ quantity: 1, id: $('select[name="id"]').val(), properties: properties }];

    const data = {
      items: cartAdditions
    };
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        ShopifyAPI.getCart(function (cart) {
          $('body').trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
      }
    }
  }
  const generateBirthstoneImage = (value) => {
    return `${iconPrefix}${value.replaceAll(' ', '_')}${iconSuffix}`;
  }
  const renderBirthstoneValues = () => {
    for (let i = 0; i < CURR_BIRTHSTONES; i++) {
      let birthstoneContainer = $(`.birthstone-container-${i}`);
      if (birthstoneContainer.length) {
        continue;
      }
      let birthstoneContainerHTML = `
      <div data-value="Garnet" class="birthstone-container birthstone-container-${i}">
      <label class="birthstone-container-label">Position ${i + 1}: <b><span class="birthstone-value-name">Garnet</span></b></label>
        <div class="birthstone-container-inner">`;

      let count = 0;
      for (let birthstoneValue of birthstoneValues) {
        let activeString = '';
        if (count == 0) {
          activeString = 'active';
        }
        birthstoneContainerHTML += `
        <div class="birthstone-value ${activeString}" data-value="${birthstoneValue.value}" data-month="${birthstoneValue.month}">
        <img class="${activeString}" src="${generateBirthstoneImage(birthstoneValue.value)}" alt="${birthstoneValue.value}" />
        <span class="birthstone-value-text ${activeString}">${birthstoneValue.month}</span>
        </div>
        `
        count++;
      }

      birthstoneContainerHTML += '</div></div>';
      $('.birthstone-stretch-bracelet-container').append(birthstoneContainerHTML);
    }
  }

  $('body').on('click', '.variant-input', function () {
    if ($(this).data('index') == 'option1') {
      const value = parseInt($(this).data('value'));
      if (value !== CURR_BIRTHSTONES) {
        if (value < CURR_BIRTHSTONES) {
          for (let i = value; i < CURR_BIRTHSTONES; i++) {
            $(`.birthstone-container-${i}`).remove();
          }
        }
        CURR_BIRTHSTONES = value;
        console.log('CURR_BIRTHSTONES', CURR_BIRTHSTONES);
        renderBirthstoneValues();
      }
    }
  });

  $('body').on('click', '.add-to-cart', function (e) {
    e.preventDefault();
    e.stopPropagation();
    handleBirthstoneStretchBraceletATC();
  });

  CURR_BIRTHSTONES = $('fieldset[data-index="option1"]').find('input:checked').val();
  if (CURR_BIRTHSTONES) {
    CURR_BIRTHSTONES = parseInt(CURR_BIRTHSTONES);
  } else {
    CURR_BIRTHSTONES = 1;
  }

  $('body').on('click', '.birthstone-value', function () {
    const value = $(this).data('value');
    $('.birthstone-value').removeClass('active');
    $(this).closest('.birthstone-container').find('.birthstone-value img').removeClass('active');
    $(this).closest('.birthstone-container').find('.birthstone-value span').removeClass('active');
    $(this).addClass('active');
    $(this).find('img').addClass('active');

    $(this).closest('.birthstone-container').find('.birthstone-value-name').text(value);
    $(this).closest('.birthstone-container').data('value', value);
  });

  renderBirthstoneValues();
}

if ($('.birthstone-stretch-bracelet-container').length) {
  handleBirthstoneStretchBracelet();
}

let braceletVariants = {};
function handleActiveBraceletColor() {
  let variantSelected = $('select[name="id"]').val();
  if (!braceletVariants[variantSelected]) {
    var productHandle = window.location.href;
    if (!productHandle) return;
    productHandle = productHandle.split('/products/');

    if (productHandle && productHandle.length) {
      productHandle = productHandle[1];
      if (!productHandle) {
        return;
      }
      productHandle = productHandle.split('?')[0];
      if (!productHandle) {
        return;
      }
    }

    $.getJSON('/products/' + productHandle + '.js', function (data) {
      for (var indVariant in data.variants) {
        var eachVariant = data.variants[indVariant];
        var id = eachVariant.id;
        braceletVariants[id] = eachVariant;
      }
    });
  }
  if (!$('.jersey-charm-overlay').length) {
    if (!braceletVariants[variantSelected] || (braceletVariants[variantSelected] && !braceletVariants[variantSelected].title) || (braceletVariants[variantSelected] && braceletVariants[variantSelected].title != 'Black')) {
      $('.preview-text').css('color', 'black');
      $('.preview-text-secondary').css('color', 'black');
    } else {
      $('.preview-text').css('color', 'white');
      $('.preview-text-secondary').css('color', 'white');
    }
  }
}

const birthMonthFlowers = [
  { month: 'DEFAULT', flower: 'Select a month', color: 'DEFAULT' },
  { month: 'January', flower: 'Carnation', color: 'Pink & White' },
  { month: 'February', flower: 'Violet', color: 'Purple' },
  { month: 'March', flower: 'Daffodil', color: 'Yellow' },
  { month: 'April', flower: 'Daisy', color: 'White' },
  { month: 'May', flower: 'Lily of the Valley', color: 'White' },
  { month: 'June', flower: 'Rose', color: 'Pink & Red' },
  { month: 'July', flower: 'Larkspur', color: 'Blue & Purple' },
  { month: 'August', flower: 'Gladiolus', color: 'Multi-colored' },
  { month: 'September', flower: 'Aster', color: 'Purple & Pink' },
  { month: 'October', flower: 'Marigold', color: 'Orange & Yellow' },
  { month: 'November', flower: 'Chrysanthemum', color: 'Yellow & Orange' },
  { month: 'December', flower: 'Narcissus', color: 'White & Yellow' }
];

const handleFilagreeNecklace = () => {
  let CURR_PHOTOS = 1;
  let CURR_STORED_PHOTOS = [];
  let missingPhotoModal = new theme.Modals('missing-photo-modal', 'missing-photo-modal', {
    solid: true
  });

  let uploadStartModal = new theme.Modals('upload-filagree-modal', 'upload-filagree-modal', {
    solid: true
  });

  let PARENT_CONTAINER = null;
  let ACTIVE_PINTURA_EDITOR = null;

  const handlePinturaEditor = function (file, parentContainer) {
    uploadStartModal.open();
    $('.pintura-editor').html('');
    const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
    let pinturaData = pintura.appendDefaultEditor('#pintura-filagree-editor', {
      src: file,
      imageCropAspectRatio: 1,
      cropEnableButtonFlipHorizontal: false,
      cropEnableButtonFlipVertical: false,
      imageCropLimitToImage: true,
      willRenderCanvas: (shapes, state) => {
        const {
          utilVisibility,
          selectionRect,
          lineColor,
          backgroundColor,
        } = state;

        if (utilVisibility.crop <= 0) return shapes;

        const { x, y, width, height } = selectionRect;

        const defaultShape = {
          x: x + width * 0.5,
          y: y + height * 0.5,
          rx: width * 0.5,
          ry: height * 0.5,
          opacity: utilVisibility.crop,
          inverted: true,
          backgroundColor: [...backgroundColor, 0.5],
          strokeWidth: 1,
          strokeColor: [...lineColor],
        }

        return {
          // Copy all props from current shapes
          ...shapes,

          // Now we add an inverted ellipse shape to the interface shapes array
          interfaceShapes: [
            defaultShape,
            // Spread all existing interface shapes onto the array
            ...shapes.interfaceShapes,
          ],
        };
      },
      imageReader: createDefaultImageReader({
        preprocessImageFile: async (file, options, onprogress) => {
          return file;
        },
      }),
      imageWriter: createDefaultImageWriter({
        mimeType: 'image/jpeg',
        quality: 0.5,
        targetSize: {
          width: 1000,
          height: 1000,
          fit: 'contain',
          upscale: false,
        },
        postprocessImageData: (imageData) =>
          new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            canvas.width = imageData.width;
            canvas.height = imageData.height;
            const ctx = canvas.getContext('2d');
            ctx.putImageData(imageData, 0, 0);

            ctx.globalCompositeOperation = 'destination-in';

            ctx.fillStyle = 'black';
            ctx.beginPath();
            ctx.arc(
              imageData.width * 0.5,
              imageData.height * 0.5,
              imageData.width * 0.5,
              0,
              2 * Math.PI
            );
            ctx.fill();

            resolve(
              ctx.getImageData(0, 0, canvas.width, canvas.height)
            );
          }),
      })
    });
    $('.PinturaRoot').append('<div class="editorLoading"><div class="lds-dual-ring"></div> <span style="text-align: center;">Loading...</span></div>')

    //$('#upsell-upload-file-multi-' + productId).replaceWith($('#upsell-upload-file-multi-' + productId).val('').clone(true));

    return pinturaData;
  }

  $('#upload-filagree-confirm').on('click', function (e) {
    const self = this;
    ACTIVE_PINTURA_EDITOR.processImage().then((imageWriterResult) => {
      var formData = new FormData();
      formData.append('file', imageWriterResult.dest);
      formData.append('upload_preset', 'ml_unsigned');
      formData.append('api_key', '211575742393728');
      $('.editorLoading').css('display', 'flex');

      let originalText = '';
      if ($(PARENT_CONTAINER).find('span').length) {
        originalText = $(PARENT_CONTAINER).find('span').html();
        $(PARENT_CONTAINER).find('span').html('Uploading...');
      }
      $.ajax({
        url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
        type: 'POST',
        data: formData,
        async: true,
        success: function (data) {
          $('#upload-filagree-confirm')
            .text('Upload')
            .prop('disabled', false)
            .removeClass('btn--no-animate');
          uploadStartModal.close();
          $('.editorLoading').hide();
          if ($(PARENT_CONTAINER).find('span').length) {
            $(PARENT_CONTAINER).find('span').html(originalText);
          }
          CURR_STORED_PHOTOS[$(PARENT_CONTAINER).attr('id')] = data.url;

          renderFilagreePhotoBoxes();

          return data.url;
        },
        error: function (data, error, errorThrown) {
          $('#upload-filagree-confirm')
            .text('Upload')
            .prop('disabled', false)
            .removeClass('btn--no-animate');
          $('.editorLoading').hide();
          if ($(PARENT_CONTAINER).find('span').length) {
            $(PARENT_CONTAINER).find('span').html(originalText);
          }
        },
        cache: false,
        contentType: false,
        processData: false,
        timeout: 15000
      });
    });
  });

  let hasDecidedToSkip = false;

  const validateFilagreePhotos = () => {
    if (hasDecidedToSkip) {
      return true;
    }

    let hasMissingPhoto = false;
    $('.filagree-photo').each(function () {
      if (!$(this).data('url') || $(this).data('url') == '') {
        hasMissingPhoto = true;
        return false;
      }
    });

    return !hasMissingPhoto;
  }

  $('#missing-photo-skip').on('click', function () {
    hasDecidedToSkip = true;
    missingPhotoModal.close();
    handleFilagreeATC($('.add-to-cart'));
  });

  $('#missing-photo-close').on('click', function () {
    missingPhotoModal.close();

    // pick the first available filagree photo input
    $('.filagree-photo-upload').each(function () {
      let input = $(this);
      let closestParent = $(input).closest('.filagree-photo');
      let hasValue = ($(input).val() || ($(input).data('url') && $(input).data('url') != ''));
      let parentHasValue = ($(closestParent).data('url') && $(closestParent).data('url') != '');
      if (!hasValue && !parentHasValue) {
        $(input).click();
        return false;
      }
    });
  });

  const handleFilagreeATC = (button) => {
    const validator = validateFilagreePhotos();
    if (!validator) {
      missingPhotoModal.open();
      return false;
    }
    $(button).prop('disabled', true);
    $(button).removeClass('is-added').addClass('is-adding');
    $(button).html('Adding...');

    let properties = {
      '_filagree_charm': true
    };

    let i = 1;
    $('.filagree-photo-box-taken').each(function () {
      properties[`photo${i}`] = $(this).data('url');
      i += 1;
    });

    const cartAdditions = [{
      quantity: 1,
      id: $('select[name="id"]').val(),
      properties: properties
    }];

    const data = {
      items: cartAdditions
    };

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        $(button).prop('disabled', false);
        $(button).removeClass('is-adding').addClass('is-added');
        $(button).html('Add to Cart');
        ShopifyAPI.getCart(function (cart) {
          $('body').trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
      } else {
        if (xhr.response && xhr.status && xhr.status != 200) {
          $(button).prop('disabled', false);
          $(button).removeClass('is-adding').addClass('is-added');
          $(button).html('Add to Cart');
        }
      }
    };
  }

  const renderFilagreePhotoBoxes = () => {
    let html = '';
    for (var i = 0; i < CURR_PHOTOS; i++) {
      if (CURR_STORED_PHOTOS[`filagree-photo-box-${i}`]) {
        html += `
            <label id="filagree-photo-box-${i}" style="display: inline-block;" data-url="${CURR_STORED_PHOTOS[`filagree-photo-box-${i}`]}" class="filagree-photo-box-taken filagree-photo">
              <img src="${CURR_STORED_PHOTOS[`filagree-photo-box-${i}`]}" alt="Photo ${i + 1}" class="filagree-photo-box-taken-image" />
              <div class="filagree-image-overlay"><span>Replace Photo</span></div>
              <input type="file" style="display: none;" id="filagree-photo-upload-${i}" class="filagree-photo-upload" accept="image/*,.heic" />
            </label>
          `;
      } else {
        if ($(`#filagree-photo-box-${i}`).length) {
          html += '<label id="filagree-photo-box-' + i + '" class="filagree-photo-box filagree-photo">' + $(`#filagree-photo-box-${i}`).html() + '</label>';
        } else {
          html += `
          <label id="filagree-photo-box-${i}" class="filagree-photo-box filagree-photo">
              <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-upload w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" x2="12" y1="3" y2="15"></line></svg> Upload Photo ${i + 1}</span>
              <input type="file" style="display: none;" id="filagree-photo-upload-${i}" class="filagree-photo-upload" accept="image/*,.heic" />
          </label>
        `;
        }
      }
    }

    $('.filagree-photo-boxes').html(html);
  }

  $('body').on('click', '.add-to-cart', function (e) {
    e.preventDefault();
    e.stopPropagation();
    handleFilagreeATC($(this));
  });

  $('body').on('click', '.variant-input', function () {
    if ($(this).data('index') == 'option2') {
      const value = parseInt($(this).data('value'));
      if (value !== CURR_PHOTOS) {
        CURR_PHOTOS = value;
        renderFilagreePhotoBoxes();
      }
    }
  });

  $('body').on('change', '.filagree-photo-upload', function () {
    const file = this.files[0];

    if (!file) {
      return;
    }

    PARENT_CONTAINER = $(this).closest('.filagree-photo');
    $('#pintura-earring-editor').html('');
    ACTIVE_PINTURA_EDITOR = handlePinturaEditor($(this).prop('files')[0], PARENT_CONTAINER);
  });

  CURR_PHOTOS = $('fieldset[data-index="option2"]').find('input:checked').val();
  if (CURR_PHOTOS) {
    CURR_PHOTOS = parseInt(CURR_PHOTOS);
  } else {
    CURR_PHOTOS = 1;
  }
  renderFilagreePhotoBoxes();
}

if ($('#filagree-necklace').length) {
  handleFilagreeNecklace();
}

const handleColorSelector = () => {
  let CURSOR_LOCKED = false;
  let ACTIVE_CONTAINER;

  function getActualGradientColor(x, y, width, height) {
    // Create a canvas to render the gradient
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // Set canvas size to match element
    canvas.width = width;
    canvas.height = height;

    // Draw the first gradient (rainbow) on canvas
    const rainbowGradient = ctx.createLinearGradient(0, 0, width, 0);
    rainbowGradient.addColorStop(0, '#ff0000');
    rainbowGradient.addColorStop(0.17, '#ffff00');
    rainbowGradient.addColorStop(0.33, '#00ff00');
    rainbowGradient.addColorStop(0.5, '#00ffff');
    rainbowGradient.addColorStop(0.67, '#0000ff');
    rainbowGradient.addColorStop(0.83, '#ff00ff');
    rainbowGradient.addColorStop(1, '#ff0000');

    ctx.fillStyle = rainbowGradient;
    ctx.fillRect(0, 0, width, height);

    // Draw the second gradient (white to black overlay) on top
    const overlayGradient = ctx.createLinearGradient(0, 0, 0, height);
    overlayGradient.addColorStop(0, '#ffffff');      // White at top
    overlayGradient.addColorStop(0.5, 'rgba(255,255,255,0)'); // Transparent white at 50%
    overlayGradient.addColorStop(0.5, 'rgba(0,0,0,0)');       // Transparent black at 50%
    overlayGradient.addColorStop(1, '#000000');      // Black at bottom

    ctx.fillStyle = overlayGradient;
    ctx.fillRect(0, 0, width, height);

    // Get pixel data at coordinates
    const pixelData = ctx.getImageData(x, y, 1, 1).data;

    return {
      r: pixelData[0],
      g: pixelData[1],
      b: pixelData[2],
      a: 1
    };
  }

  const calculateJerseyTextSize = (charCount, elementWidth) => {
    if (charCount <= 7) {
      return 0.13333333333333 * elementWidth + 'px';
    } else if (charCount <= 9) {
      return 0.105 * elementWidth + 'px';
    } else if (charCount <= 11) {
      return 0.095 * elementWidth + 'px';
    } else if (charCount <= 13) {
      return 0.085 * elementWidth + 'px';
    } else {
      return 0.075 * elementWidth + 'px';
    }
  }

  const calculateJerseyResultTextSize = (charCount, elementWidth) => {
    if (charCount <= 7) {
      return 0.15 * elementWidth + 'px';
    } else if (charCount <= 9) {
      return 0.125 * elementWidth + 'px';
    } else if (charCount <= 11) {
      return 0.105 * elementWidth + 'px';
    } else if (charCount <= 13) {
      return 0.095 * elementWidth + 'px';
    } else {
      return 0.085 * elementWidth + 'px';
    }
  }

  let JERSEY_COLOR = 'rgb(0, 0, 0)';
  let ACTIVE_COLOR = 'rgb(255, 255, 255)';

  function loadCharmResultPreviews() {
    if (!$('.jersey-charm-text-overlay-render').length) return;
    $('.jersey-charm-text-overlay-render').each(function () {
      let canvas = $(this);
      let width = canvas.width();
      let height = canvas.height();
      let charmItem = $(canvas).closest('.charm-type-option');
      let spanElement = $(charmItem).find('.jersey-charm-text-overlay-render-text');
      let textColor = $(charmItem).data('jersey-number-color') || ACTIVE_COLOR;
      let text = $(charmItem).data('jersey-text') || '';
      let numberText = $(charmItem).data('jersey-number') || '';
      const PREVIEW_OPTIONS = {
        element: document.getElementById(canvas.attr('id')),
        text: text,
        width: width,
        fontSize: calculateJerseyResultTextSize(text.length, width),
        kerning: -text.length * 0.3,
        rotation: 360,
        textCentering: "center",
        font: 'Jersey M54',
        align: false,
        textInside: true,
        textColor: textColor
      }
      getCircularText(PREVIEW_OPTIONS.element, PREVIEW_OPTIONS.text, PREVIEW_OPTIONS.width, PREVIEW_OPTIONS.rotation, PREVIEW_OPTIONS.textCentering, PREVIEW_OPTIONS.align, PREVIEW_OPTIONS.textInside, PREVIEW_OPTIONS.font, PREVIEW_OPTIONS.fontSize, PREVIEW_OPTIONS.kerning, PREVIEW_OPTIONS.textColor);
      $(spanElement).find('span').text(numberText);
      $(spanElement).find('span').css('color', textColor);
      TextFill('#' + $(spanElement).attr('id'), {
        explicitWidth: $(spanElement).parent().width() * 0.8,
        explicitHeight: $(spanElement).parent().height() * 0.45,
      });

      setTimeout(function () {
        TextFill('#' + $(spanElement).attr('id'), {
          explicitWidth: $(spanElement).parent().width() * 0.8,
          explicitHeight: $(spanElement).parent().height() * 0.45,
        });
      }, 1000);
    });
  }

  window.addEventListener('loadCharmResultPreviews', function () {
    loadCharmResultPreviews();
  });

  function loadCircleTextPreview() {
    if (!$('#ornament-circle-text-overlay-preview').length) return;
    const PREVIEW_OPTIONS = {
      element: document.getElementById('ornament-circle-text-overlay-preview'),
      text: $('#JERSEY_TEXT1').val().toUpperCase(),
      width: $('#ornament-circle-text-overlay-preview').width(),
      fontSize: calculateJerseyTextSize($('#JERSEY_TEXT1').val().length, $('#ornament-circle-text-overlay-preview').width()),
      kerning: -$('#JERSEY_TEXT1').val().length * 0.5,
      rotation: 360,
      textCentering: "center",
      font: 'Jersey M54',
      align: false,
      textInside: true,
      textColor: ACTIVE_COLOR
    }
    getCircularText(PREVIEW_OPTIONS.element, PREVIEW_OPTIONS.text, PREVIEW_OPTIONS.width, PREVIEW_OPTIONS.rotation, PREVIEW_OPTIONS.textCentering, PREVIEW_OPTIONS.align, PREVIEW_OPTIONS.textInside, PREVIEW_OPTIONS.font, PREVIEW_OPTIONS.fontSize, PREVIEW_OPTIONS.kerning, PREVIEW_OPTIONS.textColor);
  }

  function loadCircleTextCharmPreview() {
    if (!$('#jersey-preview-canvas').length) return;
    const PREVIEW_OPTIONS = {
      element: document.getElementById('jersey-preview-canvas'),
      text: $('#JERSEY_TEXT1').val().toUpperCase(),
      width: $('#jersey-preview-canvas').width(),
      fontSize: calculateJerseyTextSize($('#JERSEY_TEXT1').val().length, $('#jersey-preview-canvas').width()),
      kerning: -$('#JERSEY_TEXT1').val().length * 0.5,
      rotation: 360,
      textCentering: "center",
      font: 'Jersey M54',
      align: false,
      textInside: true,
      textColor: ACTIVE_COLOR
    }
    getCircularText(PREVIEW_OPTIONS.element, PREVIEW_OPTIONS.text, PREVIEW_OPTIONS.width, PREVIEW_OPTIONS.rotation, PREVIEW_OPTIONS.textCentering, PREVIEW_OPTIONS.align, PREVIEW_OPTIONS.textInside, PREVIEW_OPTIONS.font, PREVIEW_OPTIONS.fontSize, PREVIEW_OPTIONS.kerning, PREVIEW_OPTIONS.textColor);
  }

  if ($('#jersey-preview-canvas').length) {
    setInterval(function () {
      loadCircleTextCharmPreview();
    }, 250);
  }

  function loadCircleText() {
    $('.jersey-charm-overlay').css('display', 'block');
    if (!$('#ornament-circle-text-overlay').length) return;
    const OPTIONS = {
      element: document.getElementById('ornament-circle-text-overlay'),
      text: $('#JERSEY_TEXT1').val().toUpperCase(),
      width: $('#ornament-circle-text-overlay').width(),
      fontSize: calculateJerseyTextSize($('#JERSEY_TEXT1').val().length, $('#ornament-circle-text-overlay').width()),
      kerning: -$('#JERSEY_TEXT1').val().length * 0.5,
      rotation: 360,
      textCentering: "center",
      font: 'Jersey M54',
      align: false,
      textInside: true,
      textColor: ACTIVE_COLOR
    }
    getCircularText(OPTIONS.element, OPTIONS.text, OPTIONS.width, OPTIONS.rotation, OPTIONS.textCentering, OPTIONS.align, OPTIONS.textInside, OPTIONS.font, OPTIONS.fontSize, OPTIONS.kerning, OPTIONS.textColor);
  }

  function handleColorCursorSelect(e) {
    $('.jersey-charm-overlay').css('display', 'block');
    let colorCursor = $('.color-map').find('.color-cursor');
    let x = e.offsetX;
    let y = e.offsetY;
    if (x < 0) {
      x = 0;
    }
    if (y < 0) {
      y = 0;
    }
    var mousePos = { 'x': x, 'y': y };
    $(colorCursor).css('left', mousePos.x);
    $(colorCursor).css('top', mousePos.y);

    let color = getActualGradientColor(mousePos.x, mousePos.y, $('.color-map').width(), $('.color-map').height());
    $('.current-color-bar').css('background-color', `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`);
  }

  function handleJerseyATC(button) {
    $(button).prop('disabled', true);
    $(button).removeClass('is-added').addClass('is-adding');
    $(button).html('Adding...');

    const properties = {
      'Text': $('#JERSEY_TEXT1').val(),
      'Number': $('#JERSEY_TEXT2').val(),
      '_jersey_color': JERSEY_COLOR,
      '_jersey_number_color': ACTIVE_COLOR,
      '_jerseycharm': true,
    }

    const cartAdditions = [{
      quantity: 1,
      id: $('select[name="id"]').val(),
      properties: properties
    }];

    const data = {
      items: cartAdditions
    };

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        $(button).prop('disabled', false);
        $(button).removeClass('is-adding').addClass('is-added');
        $(button).html('Add to Cart');
        ShopifyAPI.getCart(function (cart) {
          $('body').trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
      } else {
        if (xhr.response && xhr.status && xhr.status != 200) {
          $(button).prop('disabled', false);
          $(button).removeClass('is-adding').addClass('is-added');
          $(button).html('Add to Cart');
        }
      }
    };
  }

  if ($('#jersey-modal').length == 0) {
    $('.add-to-cart-btn').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      handleJerseyATC($(this));
    });
  }

  $('#jersey-modal-add-to-cart').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    handleJerseyATC($(this));
  });

  $('.color-map').on('pointermove', function (e) {
    if (CURSOR_LOCKED) return;
    handleColorCursorSelect(e);
  });

  $('.color-map').on('dragstart touchstart mousedown', function (e) {
    CURSOR_LOCKED = false;
  });

  $('.color-map').on('click', function (e) {
    CURSOR_LOCKED = true;
    handleColorCursorSelect(e);
  });

  let $colorModal = new theme.Modals('color-selector-modal', 'color-selector-modal', {
    solid: true
  });

  $('.color-modal-select-type').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    ACTIVE_CONTAINER = $(this);
    if ($('#jersey-modal').length) {
      // hide the modal, set a delay, open the new modal
      $jerseyModal.close();
      setTimeout(function () {
        $colorModal.open();
      }, 500);
      setTimeout(function () {
        loadCircleTextCharmPreview();
      }, 1000);
    } else {
      $colorModal.open();
    }
  });

  $('#ornament-circle-text-overlay').css('top', '39.5%');
  $('#ornament-circle-text-overlay').css('height', '100%');
  $('#ornament-circle-text-overlay').css('width', '100%');
  $('#ornament-circle-text-overlay').css('left', '0%');
  $('#ornament-circle-text-overlay').css('text-transform', 'uppercase');
  $('#ornament-circle-text-overlay').css('max-width', '100%');
  $('#ornament-circle-text-overlay').css('z-index', '15');

  $('#ornament-circle-text-overlay-preview').css('top', '39.5%');
  $('#ornament-circle-text-overlay-preview').css('height', '100%');
  $('#ornament-circle-text-overlay-preview').css('width', '100%');
  $('#ornament-circle-text-overlay-preview').css('left', '0%');
  $('#ornament-circle-text-overlay-preview').css('text-transform', 'uppercase');
  $('#ornament-circle-text-overlay-preview').css('max-width', '100%');
  $('#ornament-circle-text-overlay-preview').css('z-index', '15');

  if ($('#jersey-preview-canvas').length) {
    $('#jersey-preview-canvas').css('top', '39.5%');
    $('#jersey-preview-canvas').css('height', '100%');
    $('#jersey-preview-canvas').css('width', '100%');
    $('#jersey-preview-canvas').css('left', '0%');
    $('#jersey-preview-canvas').css('text-transform', 'uppercase');
    $('#jersey-preview-canvas').css('max-width', '100%');
    $('#jersey-preview-canvas').css('z-index', '15');
  }

  $('#jersey-charm-text-overlay').css('z-index', '15');
  $('#jersey-charm-text-overlay').css('width', '40%');
  $('#jersey-charm-text-overlay').css('max-width', '40%');
  $('#jersey-charm-text-overlay').css('top', '69.4%');
  $('#jersey-charm-text-overlay').css('height', '30%');
  $('#jersey-charm-text-overlay').css('font-family', 'Jersey M54');
  $('#jersey-charm-text-overlay').css('color', 'white');

  $('#jersey-charm-text-overlay-preview').css('z-index', '15');
  $('#jersey-charm-text-overlay-preview').css('width', '40%');
  $('#jersey-charm-text-overlay-preview').css('max-width', '40%');
  $('#jersey-charm-text-overlay-preview').css('top', '69.4%');
  $('#jersey-charm-text-overlay-preview').css('height', '30%');
  $('#jersey-charm-text-overlay-preview').css('font-family', 'Jersey M54');
  $('#jersey-charm-text-overlay-preview').css('color', 'white');

  $('.overlay-image').css('background-color', JERSEY_COLOR);
  $('#jersey-charm-text-overlay').css('color', ACTIVE_COLOR);
  $('#jersey-charm-text-overlay-preview').css('color', ACTIVE_COLOR);
  $('.color-modal-select-type[data-type="NUMBER_COLOR"]').html('<div class="color-preview" style="background-color: ' + ACTIVE_COLOR + '"></div><div class="color-text">Custom Color</div>');
  $('.color-modal-select-type[data-type="NUMBER_COLOR"]').data('color', ACTIVE_COLOR);
  $('.color-modal-select-type[data-type="JERSEY_COLOR"]').html('<div class="color-preview" style="background-color: ' + JERSEY_COLOR + '"></div><div class="color-text">Custom Color</div>');
  $('.color-modal-select-type[data-type="JERSEY_COLOR"]').data('color', JERSEY_COLOR);

  $('.color-modal-select').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (ACTIVE_CONTAINER) {
      $(ACTIVE_CONTAINER).data('color', $('.current-color-bar').css('background-color'));
      $(ACTIVE_CONTAINER).html('<div class="color-preview" style="background-color: ' + $(ACTIVE_CONTAINER).data('color') + '"></div><div class="color-text">Custom Color</div>');
      if ($(ACTIVE_CONTAINER).data('type') == 'JERSEY_COLOR') {
        $('.overlay-image').css('background-color', $(ACTIVE_CONTAINER).data('color'));
        JERSEY_COLOR = $(ACTIVE_CONTAINER).data('color');
      } else if ($(ACTIVE_CONTAINER).data('type') == 'NUMBER_COLOR') {
        $('#jersey-charm-text-overlay').css('color', $(ACTIVE_CONTAINER).data('color'));
        $('#jersey-charm-text-overlay-preview').css('color', $(ACTIVE_CONTAINER).data('color'));
        if ($('#jersey-preview-canvas').length) {
          $('#jersey-preview-canvas').css('color', $(ACTIVE_CONTAINER).data('color'));
        }
        ACTIVE_COLOR = $(ACTIVE_CONTAINER).data('color');
        loadCircleText();
        loadCircleTextPreview();
        loadCircleTextCharmPreview();
      }
    }
    $colorModal.close();
    if ($('#jersey-modal').length) {
      setTimeout(function () {
        $jerseyModal.open();
      }, 500);
    }
  });

  let POPULAR_COLORS = [
    '#0066cc',
    '#cc0000',
    '#009900',
    '#ffcc00',
    '#333333',
    '#ffffff',
    '#ff6600',
    '#663399'
  ]

  for (var i = 0; i < POPULAR_COLORS.length; i++) {
    let color = POPULAR_COLORS[i];
    $('.popular-colors').append('<div class="popular-color" style="background-color: ' + color + '"></div>');
  }

  $('.popular-color').click(function () {
    let color = $(this).css('background-color');
    $('.current-color-bar').css('background-color', color);
  });

  $('#JERSEY_TEXT1').on('input', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).val($(this).val().replace(/[^a-zA-Z]/g, ''));
    $(this).parent().find('.input-count').text($(this).attr('maxlength') - $(this).val().length + ' characters remaining. Only letters.');
    loadCircleText();
    loadCircleTextPreview();
    loadCircleTextCharmPreview();
  });

  $(document).on('modalOpen.preview-modal', function () {
    let previewWidth = $('#jersey-charm-text-overlay-preview').parent().width();
    let previewHeight = $('#jersey-charm-text-overlay-preview').parent().height();
    TextFill('#jersey-charm-text-overlay-preview', {
      explicitWidth: previewWidth * 0.8,
      explicitHeight: previewHeight * 0.6,
    });

    $('#ornament-circle-text-overlay-preview').attr('width', $('#ornament-circle-text-overlay-preview').width());
    $('#ornament-circle-text-overlay-preview').attr('height', $('#ornament-circle-text-overlay-preview').height());
    loadCircleTextPreview();
  });

  if ($('#jersey-preview-canvas').length) {
    $('#confirm-jersey-button').on('click', function () {
      $jerseyModal.close();

      let data = {
        'text': $('#JERSEY_TEXT1').val(),
        'number': $('#JERSEY_TEXT2').val(),
        'color': $('.color-modal-select-type[data-type="JERSEY_COLOR"]').data('color'),
        'numberColor': $('.color-modal-select-type[data-type="NUMBER_COLOR"]').data('color'),
        'variantId': ACTIVE_JERSEY_VARIANT_ID,
        '_jerseycharm': true
      }

      window.dispatchEvent(new CustomEvent('addJerseyRequest', {
        detail: data
      }));
    });
  }

  $('#JERSEY_TEXT2').on('input', function () {
    $(this).val($(this).val().replace(/[^0-9]/g, ''));
    $(this).parent().find('.input-count').text($(this).attr('maxlength') - $(this).val().length + ' characters remaining. Only numbers.');
    $('#jersey-charm-text-overlay span').text($('#JERSEY_TEXT2').val());
    $('#jersey-charm-text-overlay-preview span').text($('#JERSEY_TEXT2').val());
    $('#jersey-charm-text-overlay').css('font-family', 'Jersey M54');
    $('#jersey-charm-text-overlay-preview').css('font-family', 'Jersey M54');

    let width = $('#jersey-charm-text-overlay').parent().width();
    let height = $('#jersey-charm-text-overlay').parent().height();
    TextFill('#jersey-charm-text-overlay', {
      explicitWidth: width * 0.8,
      explicitHeight: height * 0.6,
    });

    if ($('#jersey-preview-canvas').length) {
      let previewWidth = $('#jersey-charm-text-overlay-preview').parent().width();
      let previewHeight = $('#jersey-charm-text-overlay-preview').parent().height();
      TextFill('#jersey-charm-text-overlay-preview', {
        explicitWidth: previewWidth * 0.8,
        explicitHeight: previewHeight * 0.6,
      });
    }
  });
}

if ($('.color-map').length) {
  handleColorSelector();
}

let flowerSelection = [];
let flowerText = '';
const buildPropertiesObject = () => {
  const properties = {};
  properties['Custom Text'] = flowerText;
  for (var i = 0; i < flowerSelection.length; i++) {
    properties['Flower ' + (i + 1)] = flowerSelection[i].flower;
  }

  return properties;
}

const handleFlowerBuilder = () => {
  let activeButton = null;
  let activeId = null;

  $('#flower-builder-text').on('input', function () {
    flowerText = $(this).val();
  });

  $('.add-to-cart-btn').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $addToCart = $('.add-to-cart-btn');
    const cartAdditions = [{
      quantity: 1,
      id: $('select[name="id"]').val(),
      properties: buildPropertiesObject(flowerSelection)
    }];
    const data = {
      items: cartAdditions
    };
    $addToCart.prop('disabled', true);
    $addToCart.removeClass('is-added').addClass('is-adding');

    const $body = $('body');
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function (cart) {
          $body.trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
      } else {
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').removeClass('is-added');
      }
    }
  });

  const validateColors = () => {
    for (var i = 0; i < flowerSelection.length; i++) {
      if (flowerSelection[i].color == 'DEFAULT') {
        return false;
      }
    }
    return true;
  }

  const handleValidation = () => {
    if (validateColors()) {
      $('#flower-builder-result-container').show();

      let resultNames = '';
      for (var i = 0; i < flowerSelection.length; i++) {
        resultNames += '<div class="flower-builder-flower-title flower-builder-result-row"><div>' + flowerSelection[i].month + '</div><div>' + flowerSelection[i].flower + '</div></div>';
      }
      $('.flower-builder-result-list').html(resultNames);
      $('.add-to-cart-btn').prop('disabled', false);
    } else {
      $('#flower-builder-result-container').hide();
      $('.add-to-cart-btn').prop('disabled', true);
    }
  }

  const flowerModal = new theme.Modals('flower-modal', 'flower-modal', {
    solid: true
  });

  $('body').on('click', '.variant-input', function () {
    handleValidation();
  });

  $('body').on('variantChange', function (data) {
    handleValidation();
  });

  const reloadSelections = () => {
    let html = '';
    for (var i = 0; i < flowerSelection.length; i++) {
      html += '<div class="flower-builder-birth-month-option">';
      html += '<div class="flower-builder-flower-row">'
      html += '<div class="flower-builder-row-title"><div class="flower-builder-flower-title">Flower ' + (i + 1) + ':</div>';
      html += '<div class="flower-builder-flower-month">' + (flowerSelection[i].month == 'DEFAULT' ? '' : (flowerSelection[i].flower + '<br />' + flowerSelection[i].color)) + '</div></div>';
      html += '<div class="flower-select flower-button" data-index="' + i + '" data-flower="' + flowerSelection[i].flower + '">' + (flowerSelection[i].month == 'DEFAULT' ? flowerSelection[i].flower : flowerSelection[i].month) + '</div>';
      html += '</div></div>';
    }

    $('#flower-builder-birth-month-container').html(html);

    handleValidation();
  }

  const handleSelect = (button) => {
    if (activeId != $(button).data('index')) {
      $('.flower-modal-button').removeClass('active');
    }
    activeButton = $(button);
    activeId = $(button).data('index');
    flowerModal.open();
  }

  $('body').on('click', '.flower-select', function () {
    handleSelect($(this));
  });

  $('body').on('click', '.flower-builder-birth-month-option', function () {
    const el = $(this);
    const button = el.find('.flower-select');
    handleSelect(button);
  });

  $('.flower-modal-button').click(function () {
    $('.flower-modal-button').removeClass('active');
    const el = $(this);
    el.addClass('active');
    const flowerText = $(el).find('.flower-modal-button-flower').text();
    const monthText = $(el).find('.flower-modal-button-month').text();
    activeButton.data('flower', flowerText);
    activeButton.text(monthText);
    flowerSelection[parseInt(activeButton.data('index'))].flower = flowerText;
    flowerSelection[parseInt(activeButton.data('index'))].month = $(el).find('.flower-modal-button-month').text();
    flowerSelection[parseInt(activeButton.data('index'))].color = $(el).find('.flower-modal-button-color').text();
    reloadSelections();
    flowerModal.close();
  });

  const handleFlowerSelection = () => {
    let count = $('#flower-builder-count').val();
    count = parseInt(count);

    if (isNaN(count)) {
      count = 1;
    }

    if (flowerSelection.length > count) {
      const origLength = flowerSelection.length;
      for (var i = count; i < origLength; i++) {
        flowerSelection.pop();
      }
    } else if (flowerSelection.length < count) {
      for (var i = flowerSelection.length; i < count; i++) {
        flowerSelection.push({
          month: 'DEFAULT',
          flower: 'Select a month',
          color: 'DEFAULT'
        })
      }
    }

    reloadSelections();
  }

  $('body').on('click', '#flower-builder-count-container .flower-builder-count-option', function () {
    const el = $(this);
    $('.flower-builder-count-option').removeClass('active');
    $(el).addClass('active');
    const count = $(el).text();
    $('#flower-builder-count').val(count);
    handleFlowerSelection();
  });

  $('#flower-builder-count-container .flower-builder-count-option').first().click();
}

const handleFlowerModal = () => {
  let activeButton = null;
  let activeId = null;

  const flowerModal = new theme.Modals('flower-modal', 'flower-modal', {
    solid: true
  });

  const charmBuilderFlowerModal = new theme.Modals('charm-builder-flower-modal', 'charm-builder-flower-modal', {
    solid: true
  });

  $('#flower-builder-modal-text').on('input', function () {
    flowerText = $(this).val();
  });

  const handleSelect = (button) => {
    if (activeId != $(button).data('index')) {
      $('.flower-modal-button').removeClass('active');
    }
    activeButton = $(button);
    activeId = $(button).data('index');
    charmBuilderFlowerModal.close();

    setTimeout(() => {
      flowerModal.open();
    }, 500);
  }

  const validateFlowerModalColors = () => {
    for (var i = 0; i < flowerSelection.length; i++) {
      if (flowerSelection[i].color == 'DEFAULT') {
        return false;
      }
    }
    return true;
  }

  const handleFlowerModalValidation = () => {
    if (validateFlowerModalColors()) {
      $('#flower-builder-modal-result-container').show();

      let resultNames = '';
      for (var i = 0; i < flowerSelection.length; i++) {
        resultNames += '<div class="flower-builder-flower-title flower-builder-result-row"><div>' + flowerSelection[i].month + '</div><div>' + flowerSelection[i].flower + '</div></div>';
      }
      $('.flower-builder-modal-result-list').html(resultNames);
      $('#submit-flower-modal').prop('disabled', false);
    } else {
      $('#flower-builder-modal-result-container').hide();
      $('#submit-flower-modal').prop('disabled', true);
    }
  }

  const reloadFlowerModalSelections = () => {
    let html = '';
    for (var i = 0; i < flowerSelection.length; i++) {
      let selectedMonth = flowerSelection[i].month != 'DEFAULT';
      html += '<div class="flower-builder-birth-month-option flower-modal-option ' + (selectedMonth ? 'selected-flower' : '') + '">';
      html += '<div class="flower-builder-flower-title">Flower ' + (i + 1) + ':</div>';
      html += '<div class="flower-builder-flower-month">' + (!selectedMonth ? '' : (flowerSelection[i].flower + '<br />' + flowerSelection[i].color)) + '</div>';
      html += '<div class="flower-select flower-button" data-index="' + i + '" data-flower="' + flowerSelection[i].flower + '">' + (flowerSelection[i].month == 'DEFAULT' ? flowerSelection[i].flower : flowerSelection[i].month) + '</div>';
      html += '</div>';
    }

    $('#flower-builder-modal-birth-month-container').html(html);

    $('.flower-select').off('click');
    $('.flower-select').click(function () {
      handleSelect($(this));
    });

    $('.flower-builder-birth-month-option').off('click');
    $('.flower-builder-birth-month-option').click(function () {
      const el = $(this);
      const button = el.find('.flower-select');
      handleSelect(button);
    });

    handleFlowerModalValidation();
  }

  $('.flower-modal-button').click(function () {
    $('.flower-modal-button').removeClass('active');
    const el = $(this);
    el.addClass('active');
    const flowerText = $(el).find('.flower-modal-button-flower').text();
    const monthText = $(el).find('.flower-modal-button-month').text();
    activeButton.data('flower', flowerText);
    activeButton.css('text-align', 'center');
    activeButton.text(monthText);
    flowerSelection[parseInt(activeButton.data('index'))].flower = flowerText;
    flowerSelection[parseInt(activeButton.data('index'))].month = $(el).find('.flower-modal-button-month').text();
    flowerSelection[parseInt(activeButton.data('index'))].color = $(el).find('.flower-modal-button-color').text();
    reloadFlowerModalSelections();
    flowerModal.close();

    setTimeout(() => {
      charmBuilderFlowerModal.open();
    }, 500);
  });

  const handleFlowerModalSelection = () => {
    let count = $('#flower-builder-modal-count').val();
    count = parseInt(count);

    if (isNaN(count)) {
      count = 1;
    }

    if (flowerSelection.length > count) {
      const origLength = flowerSelection.length;
      for (var i = count; i < origLength; i++) {
        flowerSelection.pop();
      }
    } else if (flowerSelection.length < count) {
      for (var i = flowerSelection.length; i < count; i++) {
        flowerSelection.push({
          month: 'DEFAULT',
          flower: 'Select month',
          color: 'DEFAULT'
        })
      }
    }

    reloadFlowerModalSelections();
  }
  $('#charm-builder-flower-modal .flower-builder-count-option').click(function () {
    const el = $(this);
    $('.flower-builder-count-option').removeClass('active');
    $(el).addClass('active');
    const count = $(el).text();
    $('#flower-builder-modal-count').val(count);
    handleFlowerModalSelection();
  });

  $('#charm-builder-flower-modal .flower-builder-count-option').first().click();
}

if ($('#flower-builder-count-container').length) {
  handleFlowerBuilder();
}

if ($('#charm-builder-flower-modal').length) {
  handleFlowerModal();
}

function createInputContainer(title, maxLength, parentContainer, backend) {
  let html = '<div class="symbol-input-container no-override" data-char-limit="' + maxLength + '" data-name="' + backend + '">';
  html += '<label class="symbol-dropdown-label">' + title + '</label>';
  html += '<div class="symbol-input-inner">';
  html += '<input type="text" class="symbol-input" value="" />';
  html += '</div></div>';
  $(parentContainer).append(html);
}

const renderContainersByType = (ornamentType, isPreview) => {
  const containers = containersByType[ornamentType];
  if (!containers) return;

  for (var i = 0; i < containers.length; i++) {
    if (containers[i]['type'] == 'INPUT') {
      let container = $('.custom-symbol-input-dropdown-container');
      if (isPreview) {
        container = $('.preview-modal-dropdown-container');
      }
      createSymbolInputContainer(containers[i]['label'] || 'Text', containers[i]['maxLength'] || 1, containers[i]['canMixSymbols'] || false, container, containers[i]['backend']);
    } else if (containers[i]['type'] == 'RAW_TEXT') {
      let container = $('.custom-symbol-input-dropdown-container');
      if (isPreview) {
        container = $('.preview-modal-dropdown-container');
      }
      createInputContainer(containers[i]['label'] || 'Text', containers[i]['maxLength'] || 1, container, containers[i]['backend']);
    } else {
      let container = $('.custom-symbol-dropdown-container');
      if (isPreview) {
        container = $('.preview-modal-dropdown-container');
      }
      createSymbolDropdownContainer(containers[i]['label'] || 'Text', container, containers[i]['backend'], containers[i]['ignoreSelector']);
    }
  }

  setupDropdownContainers();
  setupSymbolInputContainers();
}

let ACTIVE_SYMBOL_CATEGORY = "letters";

const convertTitleToSymbolName = function (title) {
  return title.replaceAll(' ', '-') + '.svg';
}

const handleDropdownVisibility = function (inner, parentContainer, caretIcon, dropdownButton) {
  let currentDisplay = ($(inner).css('display') == 'none') ? false : true;
  $(inner).css('width', $(inner).parent().width());
  $(inner).css('display', currentDisplay ? 'none' : 'flex');
  if (!currentDisplay) {
    $(parentContainer).css('border-bottom-left-radius', 0)
    if (!$(parentContainer).hasClass('symbol-input')) {
      $(parentContainer).css('border-bottom-right-radius', 0);
    }
    if (dropdownButton) {
      $(dropdownButton).css('border-bottom-right-radius', 0);
    }
  } else {
    $(parentContainer).css('border-bottom-left-radius', '5px')
    if (!$(parentContainer).hasClass('symbol-input')) {
      $(parentContainer).css('border-bottom-right-radius', '5px');
    }
    if (dropdownButton) {
      $(dropdownButton).css('border-bottom-right-radius', '5px');
    }
  }
  if ($(caretIcon).text() == "+") {
    $(caretIcon).text('-');
  } else {
    $(caretIcon).text('+');
  }
}

function isCharacterKeyPress(evt) {
  if (typeof evt.which == "undefined") {
    // This is IE, which only fires keypress events for printable keys
    return true;
  } else if (typeof evt.which == "number" && evt.which > 0) {
    // In other browsers except old versions of WebKit, evt.which is
    // only greater than zero if the keypress is a printable key.
    // We need to filter out backspace and ctrl/alt/meta key combinations
    return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which != 8 && evt.which != 37 && evt.which != 39 && evt.which != 40;
  }
  return false;
}

function setupDropdownContainers() {
  $('.symbol-dropdown-parent').each(function () {
    const symbolDropdown = $(this).find('.symbol-dropdown');
    const symbolContainer = $(this).find('.symbol-container-list');
    const parentContainer = $(this).find('.symbol-dropdown');
    const activeCharacter = $(this).find('.active-character');
    const label = $(this).parent().find('.symbol-dropdown-label');
    const inner = $(this).find('.symbol-dropdown-inner');
    const caretIcon = $(this).find('.caret-icon');

    $(symbolDropdown).on('click', function (e) {
      handleDropdownVisibility(inner, parentContainer, caretIcon);
      e.stopPropagation();
      e.preventDefault();
    });
    // handle button presses
    function handleCategoryPress(category, button) {
      $('.symbol-dropdown-button').removeClass('active');
      $(button).addClass('active');
      loadCategory(category);
    }

    function loadCategory(category) {
      ACTIVE_SYMBOL_CATEGORY = category;
      $(symbolContainer).find('.symbol-container-item-wrapper').remove();
      const categoryData = CATEGORY_LIST[category];
      if (!categoryData) return;
      let html = '';
      for (var i = 0; i < categoryData.length; i++) {
        const itemType = (categoryData[i] && categoryData[i]['itemType']) || categoryData[i];
        const itemText = (categoryData[i] && categoryData[i]['itemText']) || categoryData[i];
        const font = (ACTIVE_SYMBOL_CATEGORY == "symbols" && "Icons") || "Arial";
        html += '<li class="symbol-container-item" style="font-family: ' + font + '" data-type="' + itemType + '" data-text="' + itemText + '">' + itemText + '</li>';
      }
      $(symbolContainer).html(html);
    }

    if ($(label).data('ignore-selector') == true || $(label).data('ignore-selector') == 'true') {
      loadCategory('symbols');
    }

    $(this).on('click', '.symbol-container-item', function () {
      const font = (ACTIVE_SYMBOL_CATEGORY == "symbols" && "Icons") || "Arial";
      $('.symbol-container-item').removeClass('active');
      $(this).addClass('active');
      $(activeCharacter).css('font-family', font);
      $(activeCharacter).text($(this).data('text'));
      $(activeCharacter).data('type', $(this).data('type'));
      $(activeCharacter).data('text', $(this).data('text'));
      $(activeCharacter).data('symbol-id', (ACTIVE_SYMBOL_CATEGORY == "symbols" && convertTitleToSymbolName($(this).data('type'))) || $(this).data('type'));
      handleDropdownVisibility(inner, parentContainer, caretIcon);
      $('.font-button.active').click();
    });

    $(this).on('click', '.symbol-dropdown-button', function (e) {
      const el = $(this);
      e.preventDefault();
      e.stopPropagation();
      if ($(el).hasClass('clear-button')) {
        $(activeCharacter).text('');
        $(activeCharacter).data('type', '');
        $(activeCharacter).data('text', '');
        $(activeCharacter).data('symbol-id', '');
        $(activeCharacter).change();
        $('.symbol-container-item').removeClass('active');
        $('.font-button.active').click();
        return;
      }
      if ($(el).hasClass('symbols')) {
        handleCategoryPress('symbols', $(this));
      } else if ($(el).hasClass('letters')) {
        handleCategoryPress('letters', $(this));
      } else if ($(el).hasClass('numbers')) {
        handleCategoryPress('numbers', $(this));
      }
    });

    // render default category
    handleCategoryPress(ACTIVE_SYMBOL_CATEGORY, $(this).parent().find('.' + ACTIVE_SYMBOL_CATEGORY));
  });
}

function setupSymbolInputContainers() {
  $('.symbol-input-container').each(function () {
    const container = $(this);
    const canMix = $(this).data('can-mix-symbols');
    const dropdown = $(this).find('.symbol-input-dropdown');
    const dropdownInner = $(this).find('.symbol-input-dropdown-inner');
    const symbolInput = $(this).find('.symbol-input');
    const dropdownLabel = $(this).find('.symbol-dropdown-label');
    const dropdownButton = $(this).find('.symbol-input-button');
    const caretIcon = $(dropdownButton).find('.caret-icon');
    const characterLimit = $(container).data('char-limit');
    const origLabel = $(dropdownLabel).text();
    const errorLabel = $(this).find('.symbol-dropdown-error-label');

    let errorTimeout;

    $(container).on('click', '.clear-button', function (e) {
      $(symbolInput).val('');
      $(symbolInput).change();
      $(symbolInput).focus();
      e.stopPropagation();
      e.preventDefault();
    });

    $(symbolInput).attr('maxlength', characterLimit);
    function updateLimitText() {
      let currentLength = $(symbolInput).val().length;
      if ($('#ornament-type').val() == 'BAR_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CHARM' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_TENNIS_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_RING' || IS_SYMBOL_INPUT_CHECKER) {
        for (var i = 0; i < $(symbolInput).val().length; i++) {
          if (containsNonLatinCodepoints($(symbolInput).val()[i])) {
            currentLength++;
          }
        }
      }
      $(dropdownLabel).text(`${origLabel} (${characterLimit - currentLength} characters)`);
    }
    function preloadSymbols() {
      const categoryData = CATEGORY_LIST["symbols"];
      let html = '';
      for (var i = 0; i < categoryData.length; i++) {
        const itemType = (categoryData[i] && categoryData[i]['itemType']) || categoryData[i];
        const itemText = (categoryData[i] && categoryData[i]['itemText']) || categoryData[i];
        html += '<li class="symbol-container-item" style="font-family: Icons" data-type="' + itemType + '" data-text="' + itemText + '">' + itemText + '</li>';
      }
      $(dropdownInner).html(html);
    }
    $(symbolInput).keyup(function (e) {
      $(symbolInput).attr('data-char-' + $(symbolInput).val().length.toString(), $(symbolInput).val()[$(symbolInput).val().length - 1]);

      if (!canMix && containsNonLatinCodepoints($(symbolInput).val())) {
        $(dropdownLabel).text(`${origLabel} (0 characters)`);
        return;
      }
      updateLimitText();
      for (var i = 0; i <= parseInt($(symbolInput).attr('maxlength')); i++) {
        if ($(symbolInput).val().length < i) {
          $(symbolInput).attr('data-char-' + i, '');
        }
      }
      if (!canMix && containsNonLatinCodepoints($(symbolInput).val())) {
        $(dropdownLabel).text(`${origLabel} (0 characters)`);
        return;
      }
      $(symbolInput).change();
    });
    $(symbolInput).keydown(function (e) {
      if (isCharacterKeyPress(e) && ($('#ornament-type').val() == 'BAR_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CHARM' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_TENNIS_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_RING' || IS_SYMBOL_INPUT_CHECKER)) {
        const nonLatin = nonLatinCodepointsInString($(symbolInput).val());
        const textCharacters = $(symbolInput).val().length - nonLatinCodepointsInString($(symbolInput).val()) + 1;
        let isValid = isValidBarBraceletText(nonLatin, textCharacters);
        // check if the key press is for cutting or for backspace or delete or left or right
        if (e.which == 8 || e.which == 46 || e.which == 37 || e.which == 39) {
          return;
        }
        if (!isValid) {
          $(errorLabel).text("Max of 10 characters or 5 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      if (isCharacterKeyPress(e) && $('#ornament-type').val() == 'ENGRAVABLE_ID_BRACELET') {
        const nonLatin = nonLatinCodepointsInString($(symbolInput).val());
        const textCharacters = $(symbolInput).val().length - nonLatinCodepointsInString($(symbolInput).val()) + 1;
        let isValid = isValidIdBraceletText(nonLatin, textCharacters);
        if (!isValid) {
          $(errorLabel).text("Max of 15 characters, 2 symbols and 6 characters, or 4 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      if (isCharacterKeyPress(e) && $('#ornament-type').val() == 'ENGRAVABLE_PENDANT_NECKLACE') {
        const nonLatin = nonLatinCodepointsInString($(symbolInput).val());
        const textCharacters = $(symbolInput).val().length - nonLatinCodepointsInString($(symbolInput).val()) + 1;
        let isValid = isValidPendantNecklaceText(nonLatin, textCharacters);
        if (!isValid) {
          $(errorLabel).text("Max of 15 characters, 2 symbols and 8 characters, or 5 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }

      if (isCharacterKeyPress(e) && !canMix && containsNonLatinCodepoints($(symbolInput).val())) {
        $(errorLabel).text("Please choose text or a symbol!");
        $(errorLabel).show();
        if (errorTimeout) {
          clearTimeout(errorTimeout);
        }
        errorTimeout = setTimeout(() => {
          $(errorLabel).hide();
        }, 3000);
        e.preventDefault();
        e.stopPropagation();
        return;
      }
    });
    $(container).on('click', '.symbol-container-item', function (e) {
      const type = $(this).data('type');
      const text = $(this).data('text');

      // run a check to ensure we're not over limit
      let currentLength = $(symbolInput).val().length;

      if (currentLength >= characterLimit) {
        return;
      }
      if ($('#ornament-type').val() == 'BAR_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CHARM' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_TENNIS_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET' || $('#ornament-type').val() == 'ENGRAVABLE_BAR_RING' || IS_SYMBOL_INPUT_CHECKER) {
        let isValid = isValidBarBraceletText(nonLatinCodepointsInString($(symbolInput).val()) + 1, $(symbolInput).val().length - (nonLatinCodepointsInString($(symbolInput).val())));
        // check if the key press is for cutting or for backspace or delete or left or right
        if (e.which == 8 || e.which == 46 || e.which == 37 || e.which == 39) {
          return;
        }
        if (!isValid) {
          $(errorLabel).text("Max of 10 characters or 5 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      if ($('#ornament-type').val() == 'ENGRAVABLE_ID_BRACELET') {
        let isValid = isValidIdBraceletText(nonLatinCodepointsInString($(symbolInput).val()) + 1, $(symbolInput).val().length - (nonLatinCodepointsInString($(symbolInput).val())));
        if (!isValid) {
          $(errorLabel).text("Max of 15 characters, 2 symbols and 6 characters, or 4 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      if ($('#ornament-type').val() == 'ENGRAVABLE_PENDANT_NECKLACE') {
        let isValid = isValidPendantNecklaceText(nonLatinCodepointsInString($(symbolInput).val()) + 1, $(symbolInput).val().length - (nonLatinCodepointsInString($(symbolInput).val())));
        if (!isValid) {
          $(errorLabel).text("Max of 15 characters, 2 symbols and 8 characters, or 5 symbols!");
          $(errorLabel).show();
          if (errorTimeout) {
            clearTimeout(errorTimeout);
          }
          errorTimeout = setTimeout(() => {
            $(errorLabel).hide();
          }, 3000);
          $(dropdownLabel).text(`${origLabel} (0 characters)`);
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      }
      if (currentLength > 0 && !canMix) {
        $(errorLabel).text("Please choose text or a symbol!");
        $(errorLabel).show();
        if (errorTimeout) {
          clearTimeout(errorTimeout);
        }
        errorTimeout = setTimeout(() => {
          $(errorLabel).hide();
        }, 3000);
        //$(dropdownLabel).text(`${origLabel} (0 characters)`);
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      $(symbolInput).attr('data-char-' + $(symbolInput).val().length.toString(), type);
      $(symbolInput).val($(symbolInput).val() + text);
      updateLimitText();
      if (!canMix) {
        $(dropdownLabel).text(`${origLabel} (0 characters)`);
      }
      $(symbolInput).change();
      $(symbolInput).change();
      $(symbolInput).focus();
    });
    $(dropdownButton).click(function (e) {
      handleDropdownVisibility($(dropdown), $(symbolInput), $(caretIcon), $(dropdownButton));
      preloadSymbols();
      $(symbolInput).focus();
      e.stopPropagation();
      e.preventDefault();
    });

    updateLimitText();
  });
}

function generateTextValues(fontProperty) {
  var textValues = {};

  for (var i = 0; i < $('.active-character').length; i++) {
    var name = $($('.symbol-dropdown-parent')[i]).parent().find('.symbol-dropdown-label').text();
    var text = $($('.symbol-dropdown-parent')[i]).find('.active-character').text();
    if (!name) continue;
    textValues[name.toUpperCase()] = text;
  }

  for (var i = 0; i < $('.symbol-input-container').length; i++) {
    var name = $($('.symbol-input-container')[i]).attr('data-name');
    var text = $($('.symbol-input-container')[i]).find('.symbol-input').val();
    if (!name) continue;
    textValues[name.toUpperCase()] = text;
  }

  let resultValue = '[FONT_' + fontProperty + ']';
  for (var i = 0; i < Object.keys(textValues).length; i++) {
    resultValue += '[' + Object.keys(textValues)[i] + '_' + textValues[Object.keys(textValues)[i]] + ']';
  }

  return { '_engraving_data': resultValue, ...textValues };
}

function createSymbolDropdownContainer(title, parentContainer, backend, ignoreSelector) {
  let html = '<div><label class="symbol-dropdown-label" data-ignore-selector="' + ignoreSelector + '" data-name="' + backend + '">' + title + '</label><div class="symbol-dropdown-parent" data-uuid="123">';
  html += '<div class="symbol-dropdown"><div class="active-character"></div><span class="caret-icon">+</span>';
  html += '</div><div class="symbol-dropdown-inner">';
  html += '<div class="symbol-dropdown-button-selectors">';
  if (!ignoreSelector) {
    html += '<button class="symbol-dropdown-button symbols">SYMBOLS</button>';
    html += '<button class="symbol-dropdown-button letters">LETTERS</button>';
    html += '<button class="symbol-dropdown-button numbers">NUMBERS</button>';
  }
  html += '<button class="symbol-dropdown-button clear-button">CLEAR</button></div>';
  html += '<ul class="symbol-container-list"></ul></div></div></div>';
  $(parentContainer).append(html);
}

function createSymbolInputContainer(title, maxLength, canMixSymbols, parentContainer, backend) {
  let html = '<div class="symbol-input-container" data-can-mix-symbols="' + canMixSymbols + '" data-char-limit="' + maxLength + '" data-name="' + backend + '">';
  html += '<div><label class="symbol-dropdown-label">' + title + '</label> <span class="symbol-dropdown-error-label" style="color: red;"></span></div>';
  html += '<div class="symbol-input-inner">';
  html += '<input type="text" class="symbol-input" value="" />';
  html += '<button class="symbol-input-button">';
  html += 'ADD SYMBOL<span class="caret-icon">+</span>';
  html += '</button></div>';
  html += '<div class="symbol-input-dropdown"><div class="symbol-input-dropdown-inner">';
  html += '</div></div></div>';
  $(parentContainer).append(html);
}

var IMAGES_BY_ACTIVE_VARIANT = {};
var IMAGE_NAMES_BY_ACTIVE_VARIANT = {};
var VARIANTS_BY_SKU = {};
var VARIANTS_BY_COLOR = {};
var COLORS_BY_VARIANT = {};
var SKUS_BY_ID = {};
var IMAGES_ALL = [];
var LAST_VARIANT_SELECTED;
var PRIMARY_SLICK_CLONE;
var SECONDARY_SLICK_CLONE;
var currentFilter = '';
var previousFilter = '';
let earringImage = null;

// Handle image containers after 1s, just in case we have a loading issue-

function storeSliderClones() {
  if (!PRIMARY_SLICK_CLONE) {
    var copy = $(window.primarySlick[0].slick.$slides).clone(true, true);
    PRIMARY_SLICK_CLONE = copy;
    window.primarySlickCache = PRIMARY_SLICK_CLONE;
  }

  if (!SECONDARY_SLICK_CLONE) {
    var copy = $(window.secondarySlick[0].slick.$slides).clone(true, true);
    SECONDARY_SLICK_CLONE = copy;
    window.secondarySlickCache = SECONDARY_SLICK_CLONE;
  }
}

const handleSlickLoadEvents = function () {
  // loop through active images
  var index = 0;
  $('.secondary-slick-clone .slick-slide').each(function (el) {
    $(this).attr('data-index', index);
    $(this).attr('data-slick-index', index);
    var image = $(this).find('img')
    $(image).removeClass('animation-delay-3').addClass('animation-delay-' + ((index + 1) * 3))
    index += 1;
  });
  index = 0;
  $('.primary-slick-clone .slick-slide').each(function (el) {
    $(this).attr('data-index', index);
    $(this).attr('data-slick-index', index);
    var image = $(this).find('img')
    $(image).removeClass(function (index, className) {
      return (className.match(/(^|\s)animation-delay-\S+/g) || []).join(' ');
    }); // wildcard remove all animation delays
    $(this).removeClass('slick-current')
    $(this).removeClass('slick-active')
    if (index > 0) {
      $(image).addClass('animation-delay-' + ((index + 1) * 3))
    }
    index += 1;
  })
}

const handleSliderFilters = function (slick, slickName) {
  var query = '.item-enabled';

  var $slickCache = (slickName == "primary") ? PRIMARY_SLICK_CLONE : SECONDARY_SLICK_CLONE;

  if (slick.$slidesCache !== null) {
    slick.unload();
    slick.$slideTrack.children(slick.options.slide).remove();
    $slickCache.appendTo(slick.$slideTrack);
    slick.reinit();
    slick.goTo(0);
    slick.refresh();
  }

  hideOrShowVariantImages();
  previousFilter = currentFilter;

  slick.filterSlides(function (index, element) {
    return $(element).hasClass('item-enabled');
  });

  handleSlickLoadEvents();

  $(slick).find('.slick-list').css('max-height', '100%');
  $(slick).find('.slick-slide').height('auto');
  $(slick).find('.slick-list').height('auto');
  slick.animateHeight();
  slick.slickSetOption(null, null, true);

  slick.refresh();
  if (slickName == "primary") {
    slick.goTo(0, true);
  }

  currentFilter = query;

  var runs = 0;
  var interval = setInterval(function () {
    /*$(slick).find('.slick-list').css('max-height', '100%');
    $(slick).find('.slick-slide').height('auto');
    $(slick).find('.slick-list').height('auto');*/
    if (slickName == "primary") {
      slick.goTo(0, true);
    }
    slick.slickSetOption(null, null, true);
    runs += 1
    if (runs > 5) {
      clearInterval(interval);
    }
  }, 100);

  return currentFilter;
}

function hideOrShowVariantImages() {
  $('.product__thumb').each(function () {
    var thumb = $(this);
    var zoomURL = $(thumb).data('zoom');
    var formattedImage = zoomURL;
    var variantSelected = $('select[name="id"]').val() || LAST_VARIANT_LISTENER_ID;

    if (formattedImage.indexOf('/files/') > -1) {
      formattedImage = formattedImage.split('/files/')[1]
    }

    if (formattedImage.indexOf('/') > -1) {
      var split = formattedImage.split('/');
      formattedImage = split[split.length - 1];
    }

    if (formattedImage.indexOf('.') < 0) return
    formattedImage = formattedImage.split('.')[0];

    if (formattedImage.indexOf('_1800x1800') > -1) {
      formattedImage = formattedImage.split('_1800x1800')[0];
    }

    if (formattedImage && formattedImage.split('-') && formattedImage.split('-')[0] == '1') {
      var variantSelected = $('select[name="id"]').val();
      var variantColor = COLORS_BY_VARIANT[variantSelected];

      var matchesColor = (variantSelected && variantColor && formattedImage && formattedImage.toUpperCase().indexOf(variantColor) > -1);

      if (zoomURL.indexOf('ALL-') < 0 && !matchesColor) {
        $(thumb).closest('.product__thumb-item').removeClass('item-enabled');
      } else {
        $(thumb).closest('.product__thumb-item').addClass('item-enabled')
      }
    } else {
      const isAll = zoomURL.indexOf('ALL-') > -1;
      const isSKUMatch = zoomURL.indexOf(SKUS_BY_ID[variantSelected]) > -1;
      const arrayContainsImages = (IMAGE_NAMES_BY_ACTIVE_VARIANT[variantSelected] && IMAGE_NAMES_BY_ACTIVE_VARIANT[variantSelected].indexOf(formattedImage) > -1);

      if (isAll || isSKUMatch || arrayContainsImages) {
        $(thumb).closest('.product__thumb-item').addClass('item-enabled');
      } else {
        $(thumb).closest('.product__thumb-item').removeClass('item-enabled');
      }
    }
  });

  $('.photo-zoom-link').each(function () {
    var thumb = $(this);
    var zoomURL = $(thumb).data('zoom-size');
    var formattedImage = zoomURL;
    var variantSelected = $('select[name="id"]').val() || LAST_VARIANT_LISTENER_ID;

    if (formattedImage.indexOf('/files/') > -1) {
      formattedImage = formattedImage.split('/files/')[1]
    }

    if (formattedImage.indexOf('/') > -1) {
      var split = formattedImage.split('/');
      formattedImage = split[split.length - 1];
    }

    if (zoomURL.indexOf('.') < 0) return
    formattedImage = formattedImage.split('.')[0];

    if (formattedImage.indexOf('_1800x1800') > -1) {
      formattedImage = formattedImage.split('_1800x1800')[0];
    }

    if (formattedImage && formattedImage.split('-') && formattedImage.split('-')[0] == '1') {
      var variantSelected = $('select[name="id"]').val();
      var variantColor = COLORS_BY_VARIANT[variantSelected];

      var matchesColor = (variantSelected && variantColor && formattedImage && formattedImage.toUpperCase().indexOf(variantColor) > -1);

      if (zoomURL.indexOf('ALL-') < 0 && !matchesColor) {
        $(thumb).closest('.slide-parent').removeClass('item-enabled');
      } else {
        $(thumb).closest('.slide-parent').addClass('item-enabled')
      }
    } else {
      if (thumb && zoomURL) {
        if (zoomURL.indexOf('ALL-') < 0 && (zoomURL.indexOf(SKUS_BY_ID[variantSelected]) < 0) && !(IMAGE_NAMES_BY_ACTIVE_VARIANT[variantSelected] && IMAGE_NAMES_BY_ACTIVE_VARIANT[variantSelected].indexOf(formattedImage) > -1)) {
          $(thumb).closest('.slide-parent').removeClass('item-enabled');
        } else {
          $(thumb).closest('.slide-parent').addClass('item-enabled')
        }
      }
    }
  });
}

const handlePortraitValidation = (fieldText, validationError) => {
  if (validationError && fieldText.length < 1 && !IS_WATERCOLOR && !$('#watercolor-portrait').length) {
    lastShown = Date.now();
    $(validationError).show();
    $(validationError).text('Name is required');
    setTimeout(() => {
      if (Date.now() - lastShown >= 3000) {
        $(validationError).hide();
      }
    }, 3000);
    return false;
  } else {
    return true;
  }
}

const handleAddPetPortait = function () {
  const selectedBackgroundColor = $('#pet-portrait-modal').find('.custom-swatch-container').data('selected-swatch');
  const name = $('#pet-portrait-modal').find('#MODAL_TEXT1').val();
  const cloudinaryUrl = $('.pet-portrait-image-container').data('cloudinary-url');

  const validation = handlePortraitValidation($('#MODAL_TEXT1').val(), $('#modal-pet-portrait-name-error'));
  if (!validation) return;

  IS_PET_PORTRAIT_CONFIRMING = false;

  let properties = {
    'photo': cloudinaryUrl,
    'originalURL': cloudinaryUrl,
    'petPortraitName': name,
    'petPortraitBackground': selectedBackgroundColor,
    '_circlerender': 'IGNORE'
  }

  const selectedID = LAST_SELECTED_VARIANT_ID;
  $('#MODAL_TEXT1').val('');
  modalPond.removeFiles({ revert: true });
  $('.pet-portrait-image-container').data('cloudinary-url', '');
  petModal.close();
  _selfRef.handlePetPortraitATCConfirm(properties, selectedID, $('#add-pet-portrait'), petModal);
}

function handlePetPortraitCharm() {
  let skipPortraitUpload = false;
  let missingFileModal = new theme.Modals('missing-file-modal', 'missing-file-modal', {
    solid: true
  });

  if ($('.custom-swatch').length) {
    $('.custom-swatch').click(function () {
      const container = $(this).closest('.custom-swatch-container');
      const swatch = $(this).find('.color-swatch');
      const customValue = $(swatch).data('custom-value');
      const wrapperContainer = $(this).closest('.variant-wrapper');
      $(container).find('.color-swatch').removeClass('active');
      $(swatch).addClass('active');
      $(container).data('selected-swatch', customValue);
      $(wrapperContainer).find('.variant__label-info').text('— ' + customValue);
    });

    $('.custom-swatch:first').click();
    if ($('#pet-portrait-modal').length) {
      $('#pet-portrait-modal').find('.custom-swatch:first').click();
    }
  }

  const handleFileUpload = function (pond, $addToCart, output, secondaryFunction) {
    var formData = new FormData();
    formData.append('file', output);
    formData.append('upload_preset', 'ml_unsigned');
    formData.append('api_key', '211575742393728');
    $addToCart.prop('disabled', true);
    $addToCart.text('Uploading...');
    $.ajax({
      url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      async: true,
      success: function (data) {
        $('.pet-portrait-image-container').data('cloudinary-url', data.url);
        $addToCart.prop('disabled', false);
        $addToCart.text('Add to Cart');

        $('.add-to-cart-btn').prop('disabled', false);
        $('.add-to-cart-btn').text('Add to Cart');

        if (secondaryFunction) {
          secondaryFunction();
        }
      },
      error: function (data) {
        $addToCart.prop('disabled', false);
        $addToCart.text('Add to Cart');

        $('.add-to-cart-btn').prop('disabled', false);
        $('.add-to-cart-btn').text('Add to Cart');
      }
    });
  }

  const handlePortraitATC = function (properties, selectedID, $addToCart, modal) {
    if (modal) {
      modal.open();
    }

    if (!skipPortraitUpload && $('#missing-file-modal').length && !properties.photo) {
      missingFileModal.open();
      return;
    }

    const cartAdditions = [{
      quantity: 1,
      id: selectedID,
      properties: properties
    }];
    const data = {
      items: cartAdditions
    };
    const $body = $('body');
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        if (modal) {
          modal.close();
        }
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function (cart) {
          $body.trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
      } else {
        if (modal) {
          modal.close();
        }
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').removeClass('is-added');
        if (xhr.response && xhr.status && xhr.status != 200) {
          let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
            solid: true
          });
          let message = xhr.response && JSON.parse(xhr.response).message;
          if (message && message.indexOf("'") > -1) {
            let start = message.split("'");
            let end = ' is sold out. Please remove the item.';
            message = start[0] + "'" + start[1] + "'" + end;
          }
          $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
          $('#warning-modal-close').click(function (e) {
            warningModal.close();
          });
          warningModal.open();
        }
      }
    };
  }

  if ($('#pet-portrait-charm').length) {
    let pond = FilePond.create(
      document.querySelector('#pet-portrait-image'),
      FILEPOND_OPTIONS
    );

    $('#pet-portrait-image').on('change', function () {
      let file = $('#pet-portrait-image').prop('files')[0];
      pond.removeFiles({ revert: true });
      pond.addFile(file, { index: 0 });
    });

    pond.on('addfilestart', function (file) {
      $('.filepond--item').removeAttr('data-drag-state');
      $('.filepond--item').off();
      $('.add-to-cart-btn').prop('disabled', true);
      $('.add-to-cart-btn').text('Uploading...');
    });

    pond.on('preparefile', function (file, output) {
      handleFileUpload(pond, $('.add-to-cart-btn'), output, true);
    });

    pond.on('removefile', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
    });

    pond.on('processfileabort', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
    });

    pond.on('processfilerevert', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
    });

    document.querySelector('#upload-portrait-button').addEventListener('click', () => {
      pond.browse();
    });

    $('.add-to-cart-btn').click(function (e) {
      e.stopPropagation();
      e.preventDefault();

      const validation = handlePortraitValidation($('#TEXT1').val(), $('#pet-portrait-name-error'));
      if (!validation) return;

      const selectedBackgroundColor = $('.custom-swatch-container').data('selected-swatch');
      const name = $('#TEXT1').val();
      const cloudinaryUrl = $('#pet-portrait-image-container').data('cloudinary-url');

      const properties = {
        '_circlerender': 'IGNORE',
        'photo': cloudinaryUrl,
        'Name': name,
        'Background': selectedBackgroundColor
      }

      const selectedID = $('select[name="id"]').val();

      handlePortraitATC(properties, selectedID, $('.add-to-cart-btn'));
    });
  }

  if ($('#missing-file-modal').length) {
    $('#upload-portrait-button').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      missingFileModal.close();
      $('#pet-portrait-charm').focus();
    });

    $('#skip-portrait-upload').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      skipPortraitUpload = true;
      missingFileModal.close();
      $('.add-to-cart-btn').click();
    });
  }

  if ($('#pet-portrait-image-modal').length) {
    modalPond = FilePond.create(
      document.querySelector('#pet-portrait-image-modal'),
      FILEPOND_OPTIONS
    );

    modalPond.on('addfilestart', function (file) {
      $('.add-to-cart-btn').prop('disabled', true);
      $('.add-to-cart-btn').text('Uploading...');
      $('#add-pet-portrait').prop('disabled', true);
      $('#add-pet-portrait').text('Uploading...');
    });

    modalPond.on('preparefile', function (file, output) {
      handleFileUpload(modalPond, $('#add-pet-portrait'), output, function () {
        if (IS_PET_PORTRAIT_CONFIRMING) {
          handleAddPetPortait();
        }
      });
    });

    modalPond.on('removefile', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
      $('#add-pet-portrait').prop('disabled', false);
      $('#add-pet-portrait').text('Add to Cart');
    });

    modalPond.on('processfileabort', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
      $('#add-pet-portrait').prop('disabled', false);
      $('#add-pet-portrait').text('Add to Cart');
    });

    modalPond.on('processfilerevert', function (file) {
      $('.add-to-cart-btn').prop('disabled', false);
      $('.add-to-cart-btn').text('Add to Cart');
      $('#add-pet-portrait').prop('disabled', false);
      $('#add-pet-portrait').text('Add to Cart');
    });

    $('#close-pet-portrait').click(function (e) {
      // reset form fields
      $('#MODAL_TEXT1').val('');
      $('.pet-portrait-image-container').data('cloudinary-url', '');
      modalPond.removeFiles({ revert: true });
    });
  }
}

handlePetPortraitCharm();

function handleCirclePhotoEarring() {
  if ($('#circle-photo-earring').length) {
    let IS_UPLOADING_1 = false;
    let IS_UPLOADING_2 = false;
    let ACTIVE_PINTURA_EDITOR = null;
    let ACTIVE_UPLOAD = null;

    const missingEarringsModal = new theme.Modals('missing-earring-modal', 'missing-earring-modal', {
      solid: true
    });

    let skipEarringUpload = false;

    const uploadStartModal = new theme.Modals('upload-earring-modal', 'upload-earring-modal', {
      solid: true
    });

    const handlePinturaEditor = function (file, uploadItem) {
      const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
      let pinturaData = pintura.appendDefaultEditor('#pintura-earring-editor', {
        src: file,
        imageCropAspectRatio: 1,
        cropEnableButtonFlipHorizontal: false,
        cropEnableButtonFlipVertical: false,
        imageCropLimitToImage: true,
        willRenderCanvas: (shapes, state) => {
          const {
            utilVisibility,
            selectionRect,
            lineColor,
            backgroundColor,
          } = state;

          if (utilVisibility.crop <= 0) return shapes;

          const { x, y, width, height } = selectionRect;

          const defaultShape = {
            x: x + width * 0.5,
            y: y + height * 0.5,
            rx: width * 0.5,
            ry: height * 0.5,
            opacity: utilVisibility.crop,
            inverted: true,
            backgroundColor: [...backgroundColor, 0.5],
            strokeWidth: 1,
            strokeColor: [...lineColor],
          }

          return {
            // Copy all props from current shapes
            ...shapes,

            // Now we add an inverted ellipse shape to the interface shapes array
            interfaceShapes: [
              defaultShape,
              // Spread all existing interface shapes onto the array
              ...shapes.interfaceShapes,
            ],
          };
        },
        imageReader: createDefaultImageReader({
          preprocessImageFile: async (file, options, onprogress) => {
            return file;
          },
        }),
        imageWriter: createDefaultImageWriter({
          mimeType: 'image/jpeg',
          quality: 0.5,
          targetSize: {
            width: 1000,
            height: 1000,
            fit: 'contain',
            upscale: false,
          },
          postprocessImageData: (imageData) =>
            new Promise((resolve) => {
              const canvas = document.createElement('canvas');
              canvas.width = imageData.width;
              canvas.height = imageData.height;
              const ctx = canvas.getContext('2d');
              ctx.putImageData(imageData, 0, 0);

              ctx.globalCompositeOperation = 'destination-in';

              ctx.fillStyle = 'black';
              ctx.beginPath();
              ctx.arc(
                imageData.width * 0.5,
                imageData.height * 0.5,
                imageData.width * 0.5,
                0,
                2 * Math.PI
              );
              ctx.fill();

              resolve(
                ctx.getImageData(0, 0, canvas.width, canvas.height)
              );
            }),
        })
      });
      $('.PinturaRoot').append('<div class="editorLoading"><div class="lds-dual-ring"></div> <span style="text-align: center;">Loading...</span></div>')

      //$('#upsell-upload-file-multi-' + productId).replaceWith($('#upsell-upload-file-multi-' + productId).val('').clone(true));

      return pinturaData;
    }

    const handleATC = function ($addToCart, image1, image2, selectedID) {
      const properties = {
        'photo1': image1,
        'photo2': image2
      }

      const cartAdditions = [{
        quantity: 1,
        id: selectedID,
        properties: properties
      }];

      const data = {
        items: cartAdditions
      };
      $addToCart.removeClass('is-added').addClass('is-adding');
      $addToCart.prop('disabled', true);
      const $body = $('body');
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      xhr.send(JSON.stringify(data));
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          $addToCart.prop('disabled', false);
          $addToCart.removeClass('is-adding').addClass('is-added');
          ShopifyAPI.getCart(function (cart) {
            $body.trigger('afterAddToCart.ajaxCart', cart);
            $('.cart-link').trigger('click');
          });
        } else {
          if (xhr.response && xhr.status && xhr.status != 200) {
            let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
              solid: true
            });
            let message = xhr.response && JSON.parse(xhr.response).message;
            if (message && message.indexOf("'") > -1) {
              let start = message.split("'");
              let end = ' is sold out. Please remove the item.';
              message = start[0] + "'" + start[1] + "'" + end;
            }
            $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
            $('#warning-modal-close').click(function (e) {
              warningModal.close();
            });
            warningModal.open();
          }
        }
      };
    }

    $('.upload-multi').on('click', function () {
      const uploadItem = $(this);
      const fileInput = $('#upload-image-file-' + uploadItem.data('index'));
      ACTIVE_UPLOAD = uploadItem;
      fileInput.focus();
    });

    const handleUploadItem = function (el) {
      const file = $(el).prop('files')[0];
      const uploadItem = $(el).parent().find('.upload-multi[data-index="' + $(el).data('index') + '"]');
      ACTIVE_UPLOAD = uploadItem;
      if (file) {
        $('#pintura-earring-editor').html('');
        uploadStartModal.open();
        ACTIVE_PINTURA_EDITOR = handlePinturaEditor(file, uploadItem);
        earringImage = uploadItem.data('index');
        uploadItem.find('.camera-icon').hide();
      } else {
        uploadItem.find('.upload-image-result').hide();
        uploadItem.find('.upload-image-result').attr('src', '');
        uploadItem.find('.upload-text').text('Upload Photo ' + (uploadItem.data('index') + 1));
        uploadItem.find('.camera-icon').show();
      }
    }

    $('body').on('change', '#upload-image-file-0', function () {
      handleUploadItem(this);
    });

    $('body').on('change', '#upload-image-file-1', function () {
      handleUploadItem(this);
    });

    $('#close-earring-modal').click(function (e) {
      $('#pintura-earring-editor').html('');
      $('#upload-image-file-' + ACTIVE_UPLOAD.data('index')).removeAttr('files');
      $('#upload-image-file-' + ACTIVE_UPLOAD.data('index')).val('');
      $('#upload-image-file-' + ACTIVE_UPLOAD.data('index')).change();
    });

    $('#upload-earring-confirm').click(function (e) {
      const self = this;
      ACTIVE_PINTURA_EDITOR.processImage().then((imageWriterResult) => {
        var formData = new FormData();
        formData.append('file', imageWriterResult.dest);
        formData.append('upload_preset', 'ml_unsigned');
        formData.append('api_key', '211575742393728');
        $('.editorLoading').css('display', 'flex');
        $.ajax({
          url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
          type: 'POST',
          data: formData,
          async: true,
          success: function (data) {
            $('#upload-earring-confirm')
              .text('Upload')
              .prop('disabled', false)
              .removeClass('btn--no-animate');
            uploadStartModal.close();
            $('.editorLoading').hide();
            $(ACTIVE_UPLOAD).data('cloudinary-url', data.url);
            $(ACTIVE_UPLOAD).find('.upload-image-result').attr('src', data.url);
            $(ACTIVE_UPLOAD).find('.upload-image-result').show();
            $(ACTIVE_UPLOAD).find('.upload-text').text('Click to Replace Image');
          },
          error: function (data, error, errorThrown) {
            $('#upload-earring-confirm')
              .text('Upload')
              .prop('disabled', false)
              .removeClass('btn--no-animate');
            $('.editorLoading').hide();
          },
          cache: false,
          contentType: false,
          processData: false,
          timeout: 15000
        }).done(function (response) {
          var optionsRevised = response.url;
          if (optionsRevised.indexOf('http://res.cloudinary.com/dgwldii6i/image/upload/') > -1) {
            var splitImage = optionsRevised.split('http://res.cloudinary.com/dgwldii6i/image/upload/')[1];
            var splitName = 'l_' + splitImage.split('/')[1];
            if (splitName) {
              splitName = splitName.substr(0, splitName.lastIndexOf('.'));
            }
            optionsRevised = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
          }
        });
      });
    });

    $('#skip-earring-upload').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      skipEarringUpload = true;
      missingEarringsModal.close();
      $('.add-to-cart-btn').click();
    });

    document.querySelector('#upload-earring-button').addEventListener('click', () => {
      missingEarringsModal.close();

      const firstUpload = $('#upload-image-file-0');
      const secondUpload = $('#upload-image-file-1');

      if (firstUpload && firstUpload.parent().find('.upload-multi[data-index="0"]').find('.upload-image-result').attr('src') == '') {
        firstUpload.click();
      } else if (secondUpload && secondUpload.parent().find('.upload-multi[data-index="1"]').find('.upload-image-result').attr('src') == '') {
        secondUpload.click();
      }
    });

    $('body').on('click', '.add-to-cart-btn', function (e) {
      e.stopPropagation();
      e.preventDefault();

      const image1 = $('.upload-multi[data-index="0"]').data('cloudinary-url');
      const image2 = $('.upload-multi[data-index="1"]').data('cloudinary-url');

      if (!skipEarringUpload) {
        if (!image1 || image1 == '') {
          missingEarringsModal.open();
          return;
        } else if (!image2 || image2 == '') {
          missingEarringsModal.open();
          return;
        }
      }

      handleATC($('.add-to-cart-btn'), image1, image2, $('select[name="id"]').val());
    });
  }
}

handleCirclePhotoEarring();

function handleSliderImages() {
  var productHandle = window.location.href;
  if (!productHandle) return;
  productHandle = productHandle.split('/products/');

  if (productHandle && productHandle.length) {
    productHandle = productHandle[1];
    if (!productHandle) {
      return;
    }
    productHandle = productHandle.split('?')[0];
    if (!productHandle) {
      return;
    }
  }

  var IMAGE_NAMES_ALL = [];

  $('body').on('variantChange', function (data) {
    if (data.variant && data.variant.id) {
      LAST_VARIANT_LISTENER_ID = data.variant.id;
    }
  });

  $.getJSON('/products/' + productHandle + '.js', function (data) {
    if (!(data && data.images && data.images.length)) return

    for (var indVariant in data.variants) {
      var eachVariant = data.variants[indVariant];
      var sku = eachVariant.sku;
      if (sku && sku[sku.length - 1] == '_') {
        sku = sku.substring(0, sku.length - 1);
      }

      VARIANTS_BY_SKU[sku] = eachVariant.id;

      if (eachVariant && eachVariant.options && eachVariant.options.length > 0) {
        var firstOption = eachVariant.options[0];
        var firstOptionUpper = eachVariant.options[0].toUpperCase();
        VARIANTS_BY_COLOR[firstOptionUpper.replaceAll(' ', '_')] = eachVariant.id;
        COLORS_BY_VARIANT[eachVariant.id] = firstOptionUpper.replaceAll(' ', '_');
      }

      SKUS_BY_ID[eachVariant.id] = sku;
    }

    for (var image in data.images) {
      var eachImage = data.images[image];
      if (eachImage.indexOf('/files/') < 0) continue;

      var split = eachImage.split('/files/');
      if (!(split.length > 1)) continue

      var imageType = (split.length > 2 ? split[2] : split[1]);
      if (imageType.indexOf('/') > -1) {
        var split = imageType.split('/');
        imageType = split[split.length - 1];
      }

      // here imagetype is now set to the name
      imageType = imageType.split('.')[0];

      // let's split to get the first dash
      var firstNum = imageType.split('-')[0];
      var secondNum = imageType.split('-')[1];
      var color = imageType.split('-SKU-')[1];

      IMAGE_NAMES_ALL.push(imageType);

      var variantNumber;
      var skuNumber;

      if (imageType.indexOf('ALL-') < 0) {
        if (firstNum == "1") {
          // go with our second method of image selection, which is based off of color (or first variant type)
          variantNumber = color.toUpperCase() && VARIANTS_BY_COLOR[color.toUpperCase().replaceAll(' ', '_')];
        } else {
          // go with our original method of image selection, which is based off of SKU
          skuNumber = imageType.split('SKU-') && imageType.split('SKU-')[1];
          variantNumber = skuNumber && VARIANTS_BY_SKU[skuNumber];
        }
      }

      if (imageType) {
        if (imageType.indexOf('SKU') > -1 && variantNumber) {
          if (!(IMAGES_BY_ACTIVE_VARIANT[variantNumber])) {
            IMAGES_BY_ACTIVE_VARIANT[variantNumber] = [];
            IMAGE_NAMES_BY_ACTIVE_VARIANT[variantNumber] = [];
          }
          IMAGES_BY_ACTIVE_VARIANT[variantNumber].push(eachImage);
          IMAGE_NAMES_BY_ACTIVE_VARIANT[variantNumber].push(imageType);
        } else if (imageType.indexOf('ALL') > -1) {
          IMAGES_ALL.push(imageType);
        }
      }
    }

    var allFailed = true;
    // loop through variants and if no images, assume all images
    for (var i = 0; i < data.variants.length; i++) {
      var variant = data.variants[i].id;
      var imageList = IMAGES_BY_ACTIVE_VARIANT[variant]
      if (!imageList || imageList.length == 0) {
        IMAGES_BY_ACTIVE_VARIANT[variant] = data.images;
        IMAGE_NAMES_BY_ACTIVE_VARIANT[variant] = IMAGE_NAMES_ALL;
      } else {
        allFailed = false;
      }
    }

    if (allFailed) {
      $('.secondary-slick-clone').show();
      $('.primary-slick-clone').show();
      $('.main-image-selector').show();
      return
    }; // no custom images

    var firstRun = true;

    setInterval(function () {
      var variantSelected = $('select[name="id"]').val() || LAST_VARIANT_LISTENER_ID;

      if (!PRIMARY_SLICK_CLONE && !SECONDARY_SLICK_CLONE) {
        storeSliderClones();
      }

      if (!LAST_VARIANT_SELECTED || LAST_VARIANT_SELECTED != variantSelected) {
        LAST_VARIANT_SELECTED = variantSelected;

        handleSliderFilters(window.secondarySlick[0].slick, "secondary");
        handleSliderFilters(window.primarySlick[0].slick, "primary");

        // Create a slight delay for the first run to allow for load/filter time of images / sliders
        if (firstRun) {
          firstRun = false;
          setTimeout(function () {
            $('.secondary-slick-clone').show();
            $('.primary-slick-clone').show();
            $('.main-image-selector').show();
          }, 100);
        } else {
          $('.secondary-slick-clone').show();
          $('.primary-slick-clone').show();
          $('.main-image-selector').show();
        }
      }
    }, 100);
  });
}

handleSliderImages()

function updateLatestImage(url) {
  // check if ornament

  // sizing -> top: (x / 1500) - .20166666666666667 then subtract 20% to do half the image for top
  // right padding is (1500 - (x + 302.5)) / 1500
  if ($('#ornament-type').val() && $('.ornament-image-overlay-container').length) {
    var top = 33.93333333333333;
    var right = 0.533333333333333;
    if ($('#ornament-type').val() == 'CIRCLE_CENTER_CUTOUT') {
      top = 33.93333333333333;
      right = 0.533333333333333;
    } else if ($('#ornament-type').val() == 'CIRCLE_HEART_CUTOUT') {
      top = 35.73333333333333;
      right = 0.533333333333333;
    } else if ($('#ornament-type').val() == 'BIRD') {
      top = 37;
      right = 0.333333333333333;
    } else if ($('#ornament-type').val() == 'HEART') {
      top = 54.33333333333333;
      right = 3.733333333333334;
    } else if ($('#ornament-type').val() == 'CIRCLE_SYMBOL') {
      top = 58.33333333333333;
      right = 2.733333333333333;
    } else if ($('#ornament-type').val() == 'PAW') {
      top = 58.33333333333333;
      right = 2.533333333333333;
    } else if ($('#ornament-type').val() == 'ZODIAC') {
      top = 58.33333333333333;
      right = 2.733333333333333;
    } else if ($('#ornament-type').val() == 'CRESCENT_STAR') {
      top = 18.066666666666663;
      right = 0.466666666666667;
    } else if ($('#ornament-type').val() == 'HEART_PHOTO_KEYCHAIN') {
      top = 26.8;
      right = 0;
    } else if ($('#ornament-type').val() == 'CIRCLE_PHOTO_KEYCHAIN') {
      top = 26.7;
      right = 0.333333;
    } else if ($('#ornament-type').val() == 'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE') {
      top = 42.7;
      right = 1;
    } else if ($('#ornament-type').val() == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET') {
      top = 39.5;
      right = 1.5;
    } else if ($('#ornament-type').val() == 'CIRCLE_PHOTO_SQUARE_KEYCHAIN') {
      top = 29;
      right = 3.5;
    } else if ($('#ornament-type').val() == 'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE') {
      top = 38;
      right = 3.75;
    } else if ($('#ornament-type').val() == 'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK') {
      top = 44.5;
      right = 0.5;
    } else if ($('#ornament-type').val() == 'ENGRAVABLE_HEART_PHOTO_BOOKMARK') {
      top = 45.5;
      right = 0.5;
    }

    $('.ornament-image-overlay-container').css('top', top + '%');
    $('.ornament-image-overlay-container').css('right', right + '%');
    $('.ornament-image-overlay-container').attr('src', url);
  }
}

function fetchSymbolNameOverride(name) {
  if (name == 'Love') { return 'Heart' }
  else if (name == 'Heart') { return 'Heart With Sparkles' }
  else if (name == 'Moon') { return 'Crescent Moon' }
  else if (name == 'Note') { return 'Music' }
  else if (name == 'Mountains') { return 'Mountain' }
  else if (name == 'Cowboy Boot') { return 'Cowgirl Boot' }
  else {
    return name
  }
}

function hideOrShowImages() {
  let startAmount = 0;
  if ($('#ornament-type').val() && ignoreFirstImage[$('#ornament-type').val()]) {
    startAmount = 1;
  }
  var variantAmount = parseFloat(($('.variant-input[data-index="option1"]').length != 0 && $('.variant-input[data-index="option1"]').length) || 1);
  if (($('.slick-current').data('index') < (variantAmount + startAmount) && $('.slick-current').data('index') >= startAmount) || !$('.slick-current').length) {
    $('.ornament-engraving-overlay').show();
    $('#ornament-text1-overlay').show();
    $('#ornament-text2-overlay').show();
    $('#ornament-text3-overlay').show();
    $('#ornament-text4-overlay').show();
    $('#ornament-circle-text-overlay').show();
    $('#ornament-circle-text-overlay-2').show();
    $('.ring-overlay').show();
    $('.ring-text-overlay').show();
    $('.label-overlay').show();
    if ($('.ornament-image-overlay-container').attr('src')) {
      if ($('#ornament-type').val() && ignoreImageRenders[$('#ornament-type').val()]) {
        $('.ornament-image-overlay-container').removeClass('hidden-display');
        $('.preview-ornament-image').addClass('hidden-display');
        return;
      }
      $('.ornament-image-overlay-container').addClass('shown-display');
      $('.ornament-image-overlay-container').removeClass('hidden-display');
    }
  } else {
    $('.ornament-engraving-overlay').hide();
    $('#ornament-text1-overlay').hide();
    $('#ornament-text2-overlay').hide();
    $('#ornament-text3-overlay').hide();
    $('#ornament-text4-overlay').hide();
    $('#ornament-circle-text-overlay').hide();
    $('#ornament-circle-text-overlay-2').hide();
    $('.ring-overlay').hide();
    $('.ring-text-overlay').hide();
    $('.label-overlay').hide();
    $('.ornament-image-overlay-container:not(.preview-ornament-image)').removeClass('shown-display');
    $('.ornament-image-overlay-container:not(.preview-ornament-image)').addClass('hidden-display');
  }
}

if ($('.variant__label-info').length) {
  $('.color-swatch').click(function () {
    var value = $(this).closest('.variant-input') && $(this).closest('.variant-input').data('value');
    if (value) {
      var optionSet = $(this).closest('.variant-wrapper') && $(this).closest('.variant-wrapper').find('.variant__label-info') && $(this).closest('.variant-wrapper').find('.variant__label-info').find('span') && $(this).closest('.variant-wrapper').find('.variant__label-info').find('span').length;

      if (optionSet > 0) {
        $(this).closest('.variant-wrapper').find('.variant__label-info').find('span').text(value);
      }
    }
  });
}

$('body').on('click', '.slick-slide', function () {
  hideOrShowImages();
});

setInterval(function () {
  hideOrShowImages()
}, 500);

function setupButtonRow(container) {
  $(container).on('click', '.custom-button-row-item', function () {
    let value = $(this).text();
    $(container).data('value', value);
    $(container).find('.custom-button-row-item').removeClass('active');
    $(this).addClass('active');
  });
  if ($(container).find('.custom-button-row-item').length) {
    $(container).find('.custom-button-row-item')[0].click();
  }
}

function createButtonRow(container, options) {
  if (!options || !options.data || !options.data.length || !container) return;
  let html = '<label class="custom-button-row-label">' + options.name + '</label><div class="custom-button-row" data-value="">';

  for (var i = 0; i < options.data.length; i++) {
    html += '<div class="custom-button-row-item">' + options.data[i] + '</div>';
  }
  html += '</div>';
  $(container).html(html);
  setupButtonRow(container);
}

var CONSTELLATION_NAMES = [];

var ACTIVE_SELECTED = null;
var ACTIVE_FONT = 'Dayrom';
var ACTIVE_FONT_PROPERTY = 'F3';

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function removeInvalidCharacters() {
  var str = $('#input-text').val();
  str = str.replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, '');
  $("#input-text").val(str);
}

function isMobile() {
  return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()) || window.innerWidth < 1150)
}

function setAfterpay() {
  setTimeout(function () {
    var price
    if ($('.afterpay-placement-container').length) {
      if ($('.on-sale').text() && $('.on-sale').text() != '') {
        price = parseFloat($('.on-sale').text().replaceAll(' ', '').replaceAll('$', '').replaceAll('\n', ''))
      } else {
        price = parseFloat($('.product__price').text().replaceAll(' ', '').replaceAll('\n', '').replaceAll('$', ''));
      }
      $('.afterpay-placement-container').children()[0].attributes[2].value = price;
    }
  }, 500);
}

setAfterpay();

export default Backbone.View.extend({

  formatPrice: function (number, divide) {
    if (isNaN(parseFloat(number))) {
      return number;
    }

    if (divide) {
      number = parseFloat(number) / 100;
    }

    let string = parseFloat(number).toFixed(2);
    if (string.split('.') && string.split('.')[1] == '00') {
      string = string.split('.')[0];
    }

    return string;
  },

  preloadResults: function () {
    let self = this;
    let handle = $('#product-handle-input').val();
    if (!handle) return;
    $.getJSON('/products/' + handle + '.json', function (result) {
      if (result && result.product) {
        for (var i = 0; i < result.product.variants.length; i++) {
          let eachVariant = result.product.variants[i];
          let option1 = eachVariant.option1;
          let option2 = eachVariant.option2;

          let price = eachVariant.price;
          let compareAtPrice = eachVariant.compare_at_price;

          if (!PRICES_BY_TYPE[option1]) {
            PRICES_BY_TYPE[option1] = {};
          }

          PRICES_BY_TYPE[option1][option2] = {
            price: price,
            compareAtPrice: compareAtPrice
          }
        }
      }
      if (selectedBaseVariantImage) {
        self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
      } else {
        self.renderProductResults();
      }
    });
  },

  renderCustomText: function () {
    var found = false;
    $('.charm-result-inner .charm-type-name').each(function () {
      if ($(this).text() && $(this).text().toLowerCase().indexOf('personalized') > -1) {
        $('.charm-builder-personalized').show();
        $('.charm-builder-general').hide();
        found = true;
      }
    });
    if (!found) {
      $('.charm-builder-general').show();
      $('.charm-builder-personalized').hide();
    }
  },

  renderProductResults: function (preSelectedImage, preSelectedTitle, preSelectedCompareAtPrice, preSelectedPrice) {
    var self = this;
    var quantities = quantitiesById;
    var variants = variantsById;
    var finalizedHTML = '';

    var selectedType = $('.variant-input-wrap[name="Style"]').find(':checked').val() || $('.variant-input-wrap[name="Size"]').find(':checked').val();
    var selectedColor = $('.variant-input-wrap[name="Color"]').find(':checked').val() || $('.variant-input-wrap[name="Metal"]').find(':checked').val();
    var selectedImageOptions = {
      Silver: {
        Bracelet: 'https://cdn.shopify.com/s/files/1/0928/6408/files/paperclip_silver-min.jpg?v=1712333538&width=500',
        Necklace: 'https://cdn.shopify.com/s/files/1/0928/6408/files/paperclip_necklace_-_silver-min.jpg?v=1712333541&width=500',
      },
      Gold: {
        Bracelet: 'https://cdn.shopify.com/s/files/1/0928/6408/files/paperclip_bracelet_gold-min.jpg?v=1712333528&width=500',
        Necklace: 'https://cdn.shopify.com/s/files/1/0928/6408/files/paperclip_bracelet_gold_necklace-min.jpg?v=1712333534&width=500',
      },
      Black: {
        Bracelet: 'https://cdn.shopify.com/s/files/1/0928/6408/files/black_bracelet-min.jpg?v=1726157793&width=500',
        Necklace: 'https://cdn.shopify.com/s/files/1/0928/6408/files/paperclip_chain_necklace_-_black-min.jpg?v=1726157793&width=500',
      },
      'Rose Gold': {
        Bracelet: 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/rosegoldpaperclipchainbracelet-min.jpg?v=1731533293&width=500',
        Necklace: 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/rosegoldpaperclipchainnecklace-min.jpg?v=1731533291&width=500'
      }
    }

    if ($('#is-team-spirit').length) {
      // override color options for team spirit bracelets
      selectedImageOptions = {
        'Yellow': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_yellow_e8ddf387-b39c-4be5-a72c-020f335a7694.jpg?width=500',
        'Blue': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_darkblue_b009cba7-1aed-4ee4-9837-7b86eeee5159.jpg?width=500',
        'Royal Blue': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_lightblue_0f37898f-f405-44fa-a4b8-e8935f9c967a.jpg?width=500',
        'Black': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_black_3949db2c-7c2a-4403-bc3a-7ca391aaf244.jpg?width=500',
        'Green': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_green_ab1a8c2e-9f6e-448d-92de-eef792ad5744.jpg?width=500',
        'Orange': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_orange_1853af25-7b8c-4179-89f3-18ba27c6b672.jpg?width=500',
        'Purple': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_purple_e0cdce5f-6317-4149-83a4-cc24275635ef.jpg?width=500',
        'Red': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_red_dcc9a2fa-c52f-4be1-8770-e5b9780a243b.jpg?width=500',
        'White': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/0825WF23560_white.jpg?width=500',
      }
    }

    if ($('#is-collar-builder').length) {
      selectedImageOptions = {
        'Black': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/blackdogcollar-min.jpg?width=500',
        'Maroon': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/MaroonDogCollar-min.jpg?width=500',
        'Blush': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Blush-min.jpg?width=500',
        'Icy Blue': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/IceyBlue-min.jpg?width=500',
        'Steel': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Steel-min.jpg?width=500',
      }
    }

    if ($('#is-tumbler-cup').length) {
      selectedImageOptions = {
        'Black': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/tumblerchainblack_7a405521-7cc1-4acf-a687-3e69686a2b43.jpg?width=500',
        'Silver': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/TumblerChain_cfe030d6-911c-4826-b625-0d6de1548502.jpg?width=500',
        'Gold': 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/tumblerchaingold_0feff685-15ce-4cd8-995f-617427b7c397.jpg?width=500'
      }
    }

    if ($('#is-keychain-builder').length) {
      selectedImageOptions = {
        'White': 'https://wear-felicity-development.myshopify.com/cdn/shop/files/wf207253917_05-min_1800x1800.jpg?width=500',
        'Black': 'https://wear-felicity-development.myshopify.com/cdn/shop/files/wf207253917_04-min_1800x1800.jpg?width=500',
        'Lavender': 'https://wear-felicity-development.myshopify.com/cdn/shop/files/wf207253917_03-min_1800x1800.jpg?width=500',
        'Blush': 'https://wear-felicity-development.myshopify.com/cdn/shop/files/wf207253917_01-min_1800x1800.jpg?width=500',
        'Icy Blue': 'https://wear-felicity-development.myshopify.com/cdn/shop/files/wf207253917_02-min_1800x1800.jpg?width=500',
      }
    }

    if (selectedType && selectedColor) {
      if (selectedImageOptions[selectedColor]) {
        let image = selectedImageOptions[selectedColor][selectedType] || selectedImageOptions[selectedColor];
        let productTitle = `Paper Clip Chain ${selectedType}`
        let price = "";
        let compareAtPrice = "";

        if ($('#is-collar-builder').length) {
          productTitle = 'Dog Collar';
        }

        if ($('#is-keychain-builder').length) {
          productTitle = 'Keychain';
        }

        if (PRICES_BY_TYPE && PRICES_BY_TYPE[selectedColor] && PRICES_BY_TYPE[selectedColor][selectedType] && PRICES_BY_TYPE[selectedColor][selectedType]['price']) {
          price = '<span style="color: #9d2226!important;">$' + this.formatPrice(PRICES_BY_TYPE[selectedColor][selectedType]['price']) + '</span>';
          if (PRICES_BY_TYPE[selectedColor][selectedType]['compareAtPrice']) {
            compareAtPrice = '<span style="text-decoration: line-through;">$' + this.formatPrice(PRICES_BY_TYPE[selectedColor][selectedType]['compareAtPrice']) + '</span> ';
          }
        }

        finalizedHTML += '<div class="charm-type-option" data-parent-type="totals" data-type="totals" data-uuid="DEFAULT" data-variant-id="DEFAULT" data-product="DEFAULT">';
        finalizedHTML += '<div class="charm-img-container"><img src="' + image + '" /></div>';
        finalizedHTML += '<div class="charm-type-name">' + productTitle + '<br />' + compareAtPrice + price + '</div>';
        finalizedHTML += '</div>';
      }
    } else if (selectedColor && selectedImageOptions[selectedColor] && !selectedType) {
      let image = selectedImageOptions[selectedColor];
      let productTitle = `Team Spirit Bracelet`
      let price = "";
      let compareAtPrice = "";
      if ($('#is-tumbler-cup').length) {
        productTitle = 'Tumbler Cup Chain';
      }

      if ($('#is-collar-builder').length) {
        productTitle = 'Dog Collar';
      }

      if ($('#is-keychain-builder').length) {
        productTitle = 'Keychain';
      }

      if (PRICES_BY_TYPE && PRICES_BY_TYPE[selectedColor]['null'] && PRICES_BY_TYPE[selectedColor]['null']['price']) {
        price = '<span style="color: #9d2226!important;">$' + this.formatPrice(PRICES_BY_TYPE[selectedColor]['null']['price']) + '</span>';
        if (PRICES_BY_TYPE[selectedColor]['null']['compareAtPrice']) {
          compareAtPrice = '<span style="text-decoration: line-through;">$' + this.formatPrice(PRICES_BY_TYPE[selectedColor]['null']['compareAtPrice']) + '</span> ';
        }
      }
      finalizedHTML += '<div class="charm-type-option" data-parent-type="totals" data-type="totals" data-uuid="DEFAULT" data-variant-id="DEFAULT" data-product="DEFAULT">';
      finalizedHTML += '<div class="charm-img-container"><img src="' + image + '" /></div>';
      finalizedHTML += '<div class="charm-type-name">' + productTitle + '<br />' + compareAtPrice + price + '</div>';
      finalizedHTML += '</div>';
    } else if (preSelectedImage && preSelectedTitle) {
      if (preSelectedCompareAtPrice && preSelectedPrice) {
        preSelectedCompareAtPrice = '<span style="text-decoration: line-through;">$' + this.formatPrice(preSelectedCompareAtPrice) + '</span> ';
      }
      if (preSelectedPrice) {
        preSelectedPrice = '<span style="color: #9d2226!important;">$' + this.formatPrice(preSelectedPrice) + '</span>';
      }
      finalizedHTML += '<div class="charm-type-option" data-parent-type="totals" data-type="totals" data-uuid="DEFAULT" data-variant-id="DEFAULT" data-product="DEFAULT">';
      finalizedHTML += '<div class="charm-img-container"><img src="' + preSelectedImage + '" /></div>';
      finalizedHTML += '<div class="charm-type-name">' + preSelectedTitle + '<br />' + preSelectedCompareAtPrice + preSelectedPrice + '</div>';
      finalizedHTML += '</div>';
    }

    for (var i = 0; i < Object.keys(quantities).length; i++) {
      var eachKey = Object.keys(quantities)[i];
      var quantity = quantities[eachKey];
      if (quantities[eachKey] <= 0 && customVariants[eachKey]) {
        customVariants[eachKey] = [];
        quantities[eachKey] = 0;
      }
      var eachVariant = variants[eachKey];
      var image = eachVariant['featured_image'] && eachVariant['featured_image']['src'];
      image = image + '&width=500';
      var hasMultipleOptions = eachVariant && (eachVariant.option1 && eachVariant.option2) ? true : false;
      var tagCheck = eachVariant && hasMultipleOptions && productsById[eachVariant['productId']] && productsById[eachVariant['productId']].tags && (productsById[eachVariant['productId']].tags.indexOf('birthstone') > -1 || productsById[eachVariant['productId']].tags.indexOf('number charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('letter') > -1) && productsById[eachVariant['productId']].tags.indexOf('charm') > -1;
      var title = tagCheck ? eachVariant['title'] + ' Charm' : productsById[eachVariant['productId']]['title'];
      if (title && title.indexOf(' / ') > -1) {
        title = title.split(' / ').slice(1).join(' / ');
      }
      var price = '<span style="color: #9d2226!important;">$' + this.formatPrice(variantsById[eachVariant['id']]['price']) + '</span>';
      var compareAtPrice = "";
      if (parseFloat(variantsById[eachVariant['id']]['compare_at_price'])) {
        compareAtPrice = '<span style="text-decoration: line-through;">$' + this.formatPrice(variantsById[eachVariant['id']]['compare_at_price']) + '</span> ';
      }
      if (!(customVariants[eachKey] && customVariants[eachKey].length)) {
        for (var i2 = 0; i2 < quantity; i2++) {
          finalizedHTML += '<div class="charm-type-option" data-parent-type="totals" data-type="totals" data-uuid="' + eachVariant['uuid'] + '" data-variant-id="' + eachVariant['id'] + '" data-product="' + eachVariant['productId'] + '">';
          finalizedHTML += '<div class="charm-img-container"><img src="' + image + '" /><div class="charm-remove">x</div><div class="inner-layer"><div class="inner-layer-remove"></div></div></div>';
          finalizedHTML += '<div class="charm-type-name">' + title + '<br />' + compareAtPrice + price + '</div>';
          finalizedHTML += '</div>';
        }
      } else {
        var eachVariant = variants[eachKey];
        var customDetails = customVariants[eachKey];
        var tagCheck = eachVariant && productsById[eachVariant['productId']] && productsById[eachVariant['productId']].tags && (productsById[eachVariant['productId']].tags.indexOf('birthstone') > -1 || productsById[eachVariant['productId']].tags.indexOf('number charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('letter') > -1) && productsById[eachVariant['productId']].tags.indexOf('charm') > -1;
        var title = tagCheck ? eachVariant['title'] + ' Charm' : productsById[eachVariant['productId']]['title'];
        if (title && title.indexOf(' / ') > -1) {
          title = title.split(' / ').slice(1).join(' / ');
        }
        var price = '<span style="color: #9d2226!important;">$' + this.formatPrice(variantsById[eachVariant['id']]['price']) + '</span>';
        var compareAtPrice = "";
        if (parseFloat(variantsById[eachVariant['id']]['compare_at_price'])) {
          compareAtPrice = '<span style="text-decoration: line-through;">$' + this.formatPrice(variantsById[eachVariant['id']]['compare_at_price']) + '</span> ';
        }
        for (var i2 = 0; i2 < customVariants[eachKey].length; i2++) {
          var modifiedImage = customVariants[eachKey][i2]['editedURL'];
          let extraProperties = '';
          if (customVariants[eachKey][i2]['_circlerender']) {
            extraProperties += 'data-circlerender="' + customVariants[eachKey][i2]['_circlerender'] + '" ';
          }
          if (customVariants[eachKey][i2]['petPortraitName']) {
            extraProperties += 'data-pet-portrait="true" data-pet-portrait-name="' + customVariants[eachKey][i2]['petPortraitName'] + '" ';
          }
          if (customVariants[eachKey][i2]['Flower 1']) {
            extraProperties += 'data-flower-builder="true" ';
          }
          if (customVariants[eachKey][i2]['_override-text']) {
            extraProperties += 'data-override-text="true" ';
          }
          if (customVariants[eachKey][i2]['_jerseycharm']) {
            extraProperties += 'data-jersey-charm="true" data-jersey-color="' + customVariants[eachKey][i2]['color'] + '" data-jersey-number-color="' + customVariants[eachKey][i2]['numberColor'] + '" data-jersey-text="' + customVariants[eachKey][i2]['text'] + '" data-jersey-number="' + customVariants[eachKey][i2]['number'] + '" ';
          }
          if (customVariants[eachKey][i2]['petPortraitBackground']) {
            extraProperties += 'data-pet-portrait-background="' + customVariants[eachKey][i2]['petPortraitBackground'] + '" ';
          }
          finalizedHTML += '<div class="charm-type-option" data-parent-type="totals" data-line1="' + customVariants[eachKey][i2]['LINE1'] + '" data-font="' + customVariants[eachKey][i2]['font'] + '" data-engraving-type="' + customVariants[eachKey][i2]['engravingType'] + '" data-uuid="' + customVariants[eachKey][i2]['uuid'] + '" data-original-url="' + customVariants[eachKey][i2]['originalURL'] + '" data-edited-url="' + customVariants[eachKey][i2]['editedURL'] + '" data-unedited-url="' + customVariants[eachKey][i2]['uneditedURL'] + '" data-type="totals" data-variant-id="' + eachVariant['id'] + '" data-product="' + eachVariant['productId'] + '" ' + extraProperties + '>';
          if (modifiedImage) {
            modifiedImage = modifiedImage.split('/')[modifiedImage.split('/').length - 1];
            modifiedImage = modifiedImage.split('.');
            modifiedImage.pop();
            modifiedImage = modifiedImage.join('.');
            let isOverride = false;
            if (variantsById[eachKey] && productsById[variantsById[eachKey]['productId']] && productsById[variantsById[eachKey]['productId']]['tags'].indexOf('pave') > -1) {
              isOverride = true;
            }
            let isCirclePave = false;
            if (productsById[eachVariant['productId']] && productsById[eachVariant['productId']]['tags'].indexOf('pave-circle-charm') > -1) {
              isCirclePave = true;
            }
            let isCustomPhotoCharm = false;
            if (productsById[eachVariant['productId']] && productsById[eachVariant['productId']]['tags'].indexOf('personalized-photo-charm') > -1) {
              isCustomPhotoCharm = true;
            }
            let isCustomHeartPhotoCharm = false;
            if (productsById[eachVariant['productId']] && productsById[eachVariant['productId']]['tags'].indexOf('personalized-heart-photo-charm') > -1) {
              isCustomHeartPhotoCharm = true;
            }
            let isSunburstCharm = false;
            if (productsById[eachVariant['productId']] && productsById[eachVariant['productId']]['tags'].indexOf('sunburst-charm') > -1) {
              isSunburstCharm = true;
            }
            modifiedImage = self.generatePreviewImage(modifiedImage, eachVariant['title'], isOverride, eachVariant['option2'] == 'Large', isCirclePave, isCustomPhotoCharm, isCustomHeartPhotoCharm, isSunburstCharm);
            finalizedHTML += '<div class="charm-img-container" style="position: relative; width: 125px; height: 125px;"><img src="' + modifiedImage + '" /><div class="charm-remove">x</div><div class="inner-layer"><div class="inner-layer-remove"></div></div></div>';
          } else {
            finalizedHTML += '<div class="charm-img-container" style="position: relative; width: 125px; height: 125px;"><div class="charm-img-inner" style="position: relative; height: 125px; width: 100%;">';
            if (customVariants[eachKey][i2]['_jerseycharm']) {
              finalizedHTML += '<div class="jersey-charm-overlay"><canvas class="jersey-charm-text-overlay-render" id="jersey-canvas-' + customVariants[eachKey][i2]['uuid'] + '"></canvas><span class="jersey-charm-text-overlay-render-text" id="jersey-text-overlay-' + customVariants[eachKey][i2]['uuid'] + '"><span></span></span><div class="overlay-image" style="height: 54%; background-color: ' + customVariants[eachKey][i2]['color'] + '"></div>';
            }
            finalizedHTML += '<img src="' + image + '" />';
            if (customVariants[eachKey][i2]['_jerseycharm']) {
              finalizedHTML += '</div>';
            }
            if (customVariants[eachKey][i2]['engravingType']) {
              finalizedHTML += '<span class="preview-text preview-result-text"><span></span></span>';
            }
            finalizedHTML += '</div>';
            finalizedHTML += '<div class="charm-remove">x</div><div class="inner-layer"><div class="inner-layer-remove"></div></div></div>';
          }
          finalizedHTML += '<div class="charm-type-name">' + title + '<br />' + compareAtPrice + price + '</div>';
          finalizedHTML += '</div>';
        }
      }
    }
    $('.charm-container-inner[data-type="result"]').html(finalizedHTML);
    window.dispatchEvent(new CustomEvent('loadCharmResultPreviews'));

    // now loop through and check for engraving types
    $('.charm-type-option').each(function () {
      let line1 = $(this).data('line1');
      if ($(this).data('engraving-type')) {
        let span = $(this).find('.preview-text');
        self.renderText($(span), $(span).find('span'), $(this).find('img'), $(this).data('engraving-type'), $(this).data('font'));
        $(span).find('span').text(line1);
        self.renderText($(span), $(span).find('span'), $(this).find('img'), $(this).data('engraving-type'), $(this).data('font'));
      }
    });

    self.renderCustomText();
    if (!CREATED_LISTENER) {
      CREATED_LISTENER = true;
      $(document).on('variantChange', function () {
        if (selectedBaseVariantImage) {
          self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
        } else {
          self.renderProductResults();
        }
      });
    }
  },

  renderContainer: function (parentType, type, items) {
    var self = this;
    var finalizedHTML = '';
    let order = 0;
    for (var i = 0; i < items.length; i++) {
      let eachProduct = items[i];
      const variants = (eachProduct.variants && eachProduct.variants[0] && eachProduct.variants[0].option1 && eachProduct.variants[0].option2) ? eachProduct.variants.sort((a, b) => (a.option2 < b.option2) ? -1 : (a.option2 > b.option2) ? 1 : 0) : eachProduct.variants;

      for (var i2 = 0; i2 < variants.length; i2++) {
        if ($('#is-keychain-builder').length) {
          if (eachProduct.tags && eachProduct.tags.indexOf('keychain-only-large') > -1) {
            if (variants[i2].option2 !== 'Large') {
              continue;
            }
          }
        }

        order += 1;
        let eachVariant = variants[i2];
        let hasMultipleOptions = eachVariant && (eachVariant.option1 && eachVariant.option2) ? true : false;
        let tagCheck = eachVariant && hasMultipleOptions && productsById[eachVariant['productId']] && productsById[eachVariant['productId']].tags && (productsById[eachVariant['productId']].tags.indexOf('birthstone') > -1 || productsById[eachVariant['productId']].tags.indexOf('dog-collar-birthstone-charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('dog-collar-letter-charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('dog-collar-seasonal-charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('number charm') > -1 || productsById[eachVariant['productId']].tags.indexOf('letter') > -1) && productsById[eachVariant['productId']].tags.indexOf('charm') > -1;
        let title = tagCheck ? eachVariant['title'] + ' Charm' : productsById[eachVariant['productId']]['title'];
        // override for letter / birthstone charms
        title = title.replace('Collar Charm', 'Charm');
        if (title && title.indexOf(' / ') > -1) {
          title = title.split(' / ').slice(1).join(' / ');
        }

        let oos = false;
        if (eachProduct.tags && eachProduct.tags.indexOf('oos_' + eachVariant['sku']) > -1) {
          oos = true;
        }

        let image = eachVariant['featured_image'] && eachVariant['featured_image']['src'];
        image = image + '&width=500';
        let price = eachVariant['price'];

        if (!isNaN(parseFloat(price))) {
          price = '$' + parseFloat(price).toFixed(0);
        }

        if (($('#is-keychain-builder').length || $('#is-collar-builder').length) && productsById[eachVariant['productId']]) {
          let tags = productsById[eachVariant['productId']].tags;
          if (eachVariant.option1) {
            if (tags.indexOf('keychain-only-large') > -1) {
              title = eachVariant.option1 + ' ' + title;
            } else if (tags.indexOf('dog-collar-birthstone-charm') > -1) {
              title = eachVariant.option1 + ' ' + title;
            }
          }
        }

        let tags = eachVariant && productsById[eachVariant['productId']] && productsById[eachVariant['productId']].tags;

        if ($('#is-team-spirit').length) {
          if (type == 'all') {
            if (tags && tags.indexOf('sport charm') > -1) {
              order = 100 + order;
            } else if (tags && tags.indexOf('number charm') > -1) {
              order = 200 + order;
            } else if (tags && tags.indexOf('birthstone') > -1) {
              order = 400 + order;
            } else if (tags && tags.indexOf('charm letter') > -1) {
              order = 500 + order;
            } else if (tags && tags.indexOf('symbol') > -1) {
              order = 300 + order;
            } else if (tags && tags.indexOf('seasonal-charm') > -1) {
              order = 600 + order;
            }
          }
        } else if ($('#is-collar-builder').length) {
          if (type == 'all') {
            if (tags.indexOf('dog-collar-symbol-charm') > -1) {
              order = 100 + order;
            } else if (tags.indexOf('dog-collar-birthstone-charm') > -1) {
              order = 200 + order;
            } else if (tags.indexOf('dog-collar-letter-charm') > -1) {
              order = 300 + order;
            } else if (tags.indexOf('dog-collar-seasonal-charm') > -1) {
              order = 400 + order;
            }
          }
        } else if ($('#is-keychain-builder').length) {
          if (tags && tags.indexOf('sport charm') > -1) {
            order = 100 + order;
          } else if (tags && tags.indexOf('number charm') > -1) {
            order = 200 + order;
          } else if (tags && tags.indexOf('birthstone') > -1) {
            order = 400 + order;
          } else if (tags && tags.indexOf('charm letter') > -1) {
            order = 500 + order;
          } else if (tags && tags.indexOf('symbol') > -1) {
            order = 300 + order;
          } else if (tags && tags.indexOf('seasonal-charm') > -1) {
            order = 600 + order;
          }
        }

        var productId = eachVariant['featured_image'] && eachVariant['featured_image']['product_id'];
        finalizedHTML += '<div class="charm-type-option" style="order: ' + order + '" data-parent-type="' + parentType + '" data-type="' + type + '" data-variant-id="' + eachVariant['id'] + '" data-product="' + productId + '">';
        if (oos) {
          finalizedHTML += '<div class="oos-badge"><span>Out of Stock</span></div>';
        }
        finalizedHTML += '<div class="charm-img-container"><img src="' + image + '" />';
        if (!oos) {
          finalizedHTML += '<div class="charm-add">+</div>';
        }
        finalizedHTML += '<div class="inner-layer"><div class="inner-layer-left"></div>';
        if (!oos) {
          finalizedHTML += '<div class="inner-layer-right"></div>';
        }
        finalizedHTML += '</div><div class="charm-type-name">' + title + '</div></div>';
        if (parentType == 'charm-bases') {
          finalizedHTML += '<div class="charm-price">' + price + '</div>';
        }
        finalizedHTML += '</div>';
      }
    }
    $('.charm-container-inner[data-type="' + parentType + '"]').html(finalizedHTML);
    self.preloadResults();
  },

  generatePreviewImage: function (newImage, variant, isOverride, isLarge, isCirclePave, isCustomPhotoCharm, isCustomHeartPhotoCharm, isSunburstCharm) {
    if (isCustomHeartPhotoCharm) {
      if (variant == 'Silver') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_600,h_600,g_north_west,x_885,y_530/c_fill,w_500,h_500/v1754493615/heartphotocharm-min_7d95fe32-ff5e-49c9-826e-81fd954a40c9_ambqm4.jpg'
      } else {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_600,h_600,g_north_west,x_885,y_530/c_fill,w_500,h_500/v1754493613/heartphotocharm-gold-min_0984a739-a6ed-4dad-82ac-d8940e2e4a51_dse4lv.jpg';
      }
    }
    if (isSunburstCharm) {
      if (variant == 'Silver') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_595,h_595,g_north_west,x_895,y_660/c_fill,w_500,h_500/v1761335393/sunburst_silver-min_whouxm.jpg';
      } else if (variant == 'Gold') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_595,h_595,g_north_west,x_895,y_660/c_fill,w_500,h_500/v1761335392/sunburst_charm_gold-min_q1c2oq.jpg';
      }
    }
    if (isCustomPhotoCharm) {
      if (variant == 'Silver') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_715,h_715,g_north_west,x_375,y_650/c_fill,w_500,h_500/v1754410731/Charm_CustomPic_S-min_1_hki21b.jpg';
      } else {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_715,h_715,g_north_west,x_375,y_650/c_fill,w_500,h_500/v1754410727/Charm_CustomPic_G-min_1_voyg8w.jpg';
      }
    }
    if (isCirclePave) {
      if (variant == 'Silver') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/c_fill,w_500,h_500/v1748027624/Circle_Pave_Photo_Gem_Silver-min_ru6qou.jpg';
      } else if (variant == 'Gold') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/c_fill,w_500,h_500/v1748027624/Pave_Gold_Circle_Charm-min_ua1wmd.jpg';
      }
    }
    if (isLarge) {
      if (variant == 'Silver / Large') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_202,h_202,g_north_west,x_268,y_261/v1740778551/silver_keychain_2-min_zajosl.jpg';
      } else if (variant == 'Gold / Large') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_202,h_202,g_north_west,x_268,y_261/v1740778551/gold_keychain_2-min_omtqgk.jpg';
      } else if (variant == 'Black / Large') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_202,h_202,g_north_west,x_268,y_261/v1740778551/black_keychain_2-min_qdnh5h.jpg';
      } else if (variant == 'Rose Gold / Large') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_202,h_202,g_north_west,x_268,y_261/v1740778551/rose_gold_keychain_2-min_n8hyyv.jpg';
      }
    }
    if (isOverride) {
      if (variant == 'Gold') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_203,h_203,g_north_west,x_284,y_164/v1730672565/gold_heart_pave-min_ehgwmk.jpg';
      } else if (variant == 'Silver') {
        return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_203,h_203,g_north_west,x_284,y_164/v1730672565/silver_heart_pave-min_pirjug.jpg';
      }
    }
    if (!variant) {
      return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_600,h_600,g_north_west,x_856,y_590/v1683674289/circle_bracelet_product_g9puem.jpg';
    } else if (variant == 'Gold') {
      return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/v1683674289/circle_bracelet_product_gold.jpg';
    } else if (variant == 'Silver') {
      return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/v1683674289/circle_bracelet_product_silver.jpg';
    } else if (variant == 'Black') {
      return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/v1725817816/qvgcz6pwqm9kev5z1jk4.jpg';
    } else if (variant == 'Rose Gold') {
      return 'https://res.cloudinary.com/dgwldii6i/image/upload/l_' + newImage + ',r_max,w_610,h_610,g_north_west,x_839,y_493/v1731533172/rose_gold_charm-min_fg1xgv.jpg';
    }
  },

  generateUUID: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

  handleQuantities: function () {
    var totalQuantity = 0;
    for (var i = 0; i < Object.keys(quantitiesById).length; i++) {
      totalQuantity += quantitiesById[Object.keys(quantitiesById)[i]];
    }
    if (totalQuantity == 2 || (totalQuantity % 3 == 2 && totalQuantity != 0)) {
      //    $('.charm-builder-free').show();
    } else {
      $('.charm-builder-free').hide();
    }
  },

  handleCustomVariantSelector: function () {
    let GLOBAL_SELECT = {
      Birthstone: null,
      Size: null,
      Variant: null,
    }
    let SELECTIONS_TABLE = {
      "Silver": {
        "Amethyst": {
          "5": "45785419153578",
          "6": "45785419186346",
          "7": "45785419219114",
          "8": "45785419251882",
          "9": "45785419284650"
        },
        "Aquamarine": {
          "5": "45785419317418",
          "6": "45785419350186",
          "7": "45785419382954",
          "8": "45785419415722",
          "9": "45785419448490"
        },
        "Blue Zircon": {
          "5": "45785419481258",
          "6": "45785419514026",
          "7": "45785419546794",
          "8": "45785419579562",
          "9": "45785419612330"
        },
        "Diamond": {
          "5": "45785419645098",
          "6": "45785419677866",
          "7": "45785419710634",
          "8": "45785419743402",
          "9": "45785419776170"
        },
        "Emerald": {
          "5": "45785419808938",
          "6": "45785419841706",
          "7": "45785419874474",
          "8": "45785419907242",
          "9": "45785419940010"
        },
        "Alexandrite": {
          "5": "45785419972778",
          "6": "45785420005546",
          "7": "45785420038314",
          "8": "45785420071082",
          "9": "45785420103850"
        },
        "Yellow Topaz": {
          "5": "45785420136618",
          "6": "45785420169386",
          "7": "45785420202154",
          "8": "45785420234922",
          "9": "45785420267690"
        },
        "Opal": {
          "5": "45785420300458",
          "6": "45785420333226",
          "7": "45785420365994",
          "8": "45785420398762",
          "9": "45785420431530"
        },
        "Peridot": {
          "5": "45785420464298",
          "6": "45785420497066",
          "7": "45785420529834",
          "8": "45785420562602",
          "9": "45785420595370"
        },
        "Ruby": {
          "5": "45785420628138",
          "6": "45785420660906",
          "7": "45785420693674",
          "8": "45785420726442",
          "9": "45785420759210"
        },
        "Sapphire": {
          "5": "45785420791978",
          "6": "45785420824746",
          "7": "45785420857514",
          "8": "45785420890282",
          "9": "45785420923050"
        },
        "Garnet": {
          "5": "45785420955818",
          "6": "45785420988586",
          "7": "45785421021354",
          "8": "45785421054122",
          "9": "45785421086890"
        },
      },
      "Gold": {
        "Amethyst": {
          "5": "45033443885226",
          "6": "45033443917994",
          "7": "45033443950762",
          "8": "45033443983530",
          "9": "45033444016298"
        },
        "Aquamarine": {
          "5": "45033466691754",
          "6": "45033466724522",
          "7": "45033466757290",
          "8": "45033466790058",
          "9": "45033466822826"
        },
        "Blue Zircon": {
          "5": "45033466855594",
          "6": "45033466888362",
          "7": "45033466921130",
          "8": "45033466953898",
          "9": "45033466986666"
        },
        "Diamond": {
          "5": "45033467019434",
          "6": "45033467052202",
          "7": "45033467084970",
          "8": "45033467117738",
          "9": "45033467150506"
        },
        "Emerald": {
          "5": "45033467183274",
          "6": "45033467216042",
          "7": "45033467248810",
          "8": "45033467281578",
          "9": "45033467314346"
        },
        "Alexandrite": {
          "5": "45033467347114",
          "6": "45033467379882",
          "7": "45033467412650",
          "8": "45033467445418",
          "9": "45033467478186"
        },
        "Yellow Topaz": {
          "5": "45033467510954",
          "6": "45033467543722",
          "7": "45033467576490",
          "8": "45033467609258",
          "9": "45033467642026"
        },
        "Opal": {
          "5": "45033467674794",
          "6": "45033467707562",
          "7": "45033467740330",
          "8": "45033467773098",
          "9": "45033467805866"
        },
        "Peridot": {
          "5": "45033467838634",
          "6": "45033467871402",
          "7": "45033467904170",
          "8": "45033467936938",
          "9": "45033467969706"
        },
        "Ruby": {
          "5": "45033468002474",
          "6": "45033468035242",
          "7": "45033468068010",
          "8": "45033468100778",
          "9": "45033468133546"
        },
        "Sapphire": {
          "5": "45033468166314",
          "6": "45033468199082",
          "7": "45033468231850",
          "8": "45033468264618",
          "9": "45033468297386"
        },
        "Garnet": {
          "5": "45033468330154",
          "6": "45033468362922",
          "7": "45033468395690",
          "8": "45033468428458",
          "9": "45033468461226"
        },
      },
    }
    if ($('.option-override').length) {
      let urlParams = new URLSearchParams(window.location.href);
      // grab current variant
      const url = new URL(window.location.href);
      const args = new URLSearchParams(url.search);
      const currentVariant = args.get('variant');

      if (currentVariant) {
        for (var i = 0; i < Object.keys(SELECTIONS_TABLE).length; i++) {
          let metalType = Object.keys(SELECTIONS_TABLE)[i];
          for (var i2 = 0; i2 < Object.keys(SELECTIONS_TABLE[metalType]).length; i2++) {
            let birthstone = Object.keys(SELECTIONS_TABLE[metalType])[i2];
            for (var i3 = 0; i3 < Object.keys(SELECTIONS_TABLE[metalType][birthstone]).length; i3++) {
              let size = Object.keys(SELECTIONS_TABLE[metalType][birthstone])[i3];
              if (SELECTIONS_TABLE[metalType][birthstone][size] == currentVariant) {
                GLOBAL_SELECT['Size'] = size;
                GLOBAL_SELECT['Birthstone'] = birthstone;
                break
              }
            }
          }
        }
      }
      if (urlParams.get('size')) {
        GLOBAL_SELECT['Size'] = urlParams.get('size');
      }
      if (urlParams.get('birthstone')) {
        GLOBAL_SELECT['Birthstone'] = urlParams.get('birthstone');
      }
      $('body').on('click', '.variant-input', function () {
        let optionType = $(this).closest('.variant-input-wrap').attr('name');
        let value = $(this).data('value');
        GLOBAL_SELECT[optionType] = value;
      });
      $('.option-override-link').on('click', function () {
        let link = $(this).data('link');
        let birthstone = GLOBAL_SELECT["Birthstone"] ? GLOBAL_SELECT["Birthstone"] : "Amethyst";
        let size = GLOBAL_SELECT["Size"] ? GLOBAL_SELECT["Size"] : "5";
        if (link.indexOf('silver') > -1) {
          link += `${link.indexOf("?") > -1 ? "&" : "?"}variant=${SELECTIONS_TABLE["Silver"][birthstone][size]}&size=${size}&birthstone=${birthstone}`;
        } else {
          link += `${link.indexOf("?") > -1 ? "&" : "?"}variant=${SELECTIONS_TABLE["Gold"][birthstone][size]}&size=${size}&birthstone=${birthstone}`;
        }
        window.location.href = link;
      });
    }
  },

  handlePetPortraitATCConfirm: function (properties, variantId, addButton, $modal) {
    var self = this;

    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }

    const uuid = self.generateUUID();
    properties['uuid'] = uuid;

    if (!customVariants[variantId]) {
      customVariants[variantId] = [properties];
    } else {
      customVariants[variantId].push(properties);
    }

    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }

    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    //$('.charm-type-option[data-variant-id="' + variantId + '"]').data('uuid', uuid);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }

    if (addButton) {
      addButton.prop('disabled', false);
      addButton.text('Add to Cart');
    }

    if ($modal) {
      $modal.close();
    }

    self.handleQuantities();

    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  handlePetPortraitATC: function () {
    let self = this;
    _selfRef = self;
    let $secondaryModal = new theme.Modals('pet-portrait-upload-confirm-modal', 'pet-portrait-upload-confirm-modal', {
      solid: true
    });

    document.querySelector('#pet-portrait-confirm-upload-button').addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      IS_PET_PORTRAIT_CONFIRMING = true;
      $secondaryModal.close();
      modalPond.browse();
    });

    $('#skip-pet-portrait-upload').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      $secondaryModal.close();
      IS_PET_PORTRAIT_CONFIRMING = false;
      handleAddPetPortait();
    });

    $('#close-pet-portrait-upload-confirm-modal').click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      $secondaryModal.close();
      IS_PET_PORTRAIT_CONFIRMING = false;
    });

    $('#add-pet-portrait').click(function (e) {
      e.stopPropagation();
      e.preventDefault();

      const validation = handlePortraitValidation($('#MODAL_TEXT1').val(), $('#modal-pet-portrait-name-error'));
      if (!validation) return;

      if (!$('.pet-portrait-image-container').data('cloudinary-url')) {
        petModal.close();
        setTimeout(() => {
          $secondaryModal.open();
        }, 500);
        return;
      }

      IS_PET_PORTRAIT_CONFIRMING = false;
      handleAddPetPortait();
    });
  },

  addJerseyConfirm: function (variantId, data) {
    const self = this;

    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }

    let uuid = self.generateUUID();
    data['uuid'] = uuid;

    if (!customVariants[variantId]) {
      customVariants[variantId] = [data];
    } else {
      customVariants[variantId].push(data);
    }

    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }

    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('jersey-charm', true);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('jersey-color', data['color']);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('jersey-number-color', data['numberColor']);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('jersey-text', data['text']);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('jersey-number', data['number']);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }
    self.handleQuantities();
    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  addEngravableConfirm: function (variantId, engravingType, font) {
    var self = this;
    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }
    var uuid = self.generateUUID();
    let data = generateTextValues(ACTIVE_FONT_PROPERTY);
    data['LINE1'] = $('#preview-modal-text1-overlay').text();
    data['engravingType'] = engravingType;
    data['uuid'] = uuid;
    data['font'] = font;
    if (!customVariants[variantId]) {
      customVariants[variantId] = [data];
    } else {
      customVariants[variantId].push(data);
    }
    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }
    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    //$('.charm-type-option[data-variant-id="' + variantId + '"]').data('uuid', uuid);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }
    self.handleQuantities();
    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  renderText(textLabel, spanLabel, imageContainer, engravingType, font) {
    IS_SYMBOL_INPUT_CHECKER = false;
    $(textLabel).css('transform', 'translate(-50%,-50%)');
    let fontChosen = (font || ACTIVE_FONT);
    if (engravingType == 'HEART_CHARM') {
      var width = $(imageContainer).width();
      var height = $(imageContainer).height();

      $(textLabel).css('max-height', '100%');
      $(textLabel).css('height', '20%');
      $(textLabel).css('width', '25%');
      $(textLabel).css('left', '49.5%');
      $(textLabel).css('top', '58%');

      $(textLabel).css('font-family', fontChosen);

      let magnumMulti = 1;
      if (fontChosen == 'Magnum') {
        magnumMulti = 1.1;
      }

      if (containsNonLatinCodepoints($(textLabel).text())) {
        $(textLabel).css('top', '60%');
      }

      TextFill(textLabel, {
        explicitWidth: width * .3 * magnumMulti,
        explicitHeight: height * .3 * magnumMulti,
      });

      if (fontChosen == 'Magnum') {
        $(textLabel).css('top', '60%');

        if (!checkMostlyUppercase($(textLabel).text())) {
          $(textLabel).css('top', '58.5%');
        }
      } else if (fontChosen == 'Nickainley Normal') {
        $(textLabel).css('top', '60%');

        if (!checkMostlyUppercase($(textLabel).text())) {
          $(textLabel).css('top', '59.5%');
        }
      } else if (!checkMostlyUppercase($(textLabel).text())) {
        $(textLabel).css('top', '57.5%');
      }
    } else if (engravingType == 'CIRCLE_CHARM') {
      var width = $(imageContainer).width();
      var height = $(imageContainer).height();

      $(textLabel).css('max-height', '100%');
      $(textLabel).css('height', '20%');
      $(textLabel).css('width', '14.66%');
      $(textLabel).css('left', '49.25%');
      $(textLabel).css('top', '57.25%');

      $(textLabel).css('font-family', fontChosen);

      let magnumMulti = 1;
      if (fontChosen == 'Magnum') {
        magnumMulti = 1.1;
      }

      if (containsNonLatinCodepoints($(textLabel).text())) {
        $(textLabel).css('top', '59.5%');
      }
      TextFill(textLabel, {
        explicitWidth: width * .2 * magnumMulti,
        explicitHeight: height * .3 * magnumMulti,
      });

      if (fontChosen == 'Magnum') {
        $(textLabel).css('top', '59%');

        if (!checkMostlyUppercase($(textLabel).text())) {
          $(textLabel).css('top', '58.5%');
        }
      } else if (fontChosen == 'Nickainley Normal') {
        $(textLabel).css('top', '58.5%');

        if (!checkMostlyUppercase($(textLabel).text())) {
          $(textLabel).css('top', '58%');
        }
      }
    } else if (engravingType == 'PAVE_CIRCLE_ENGRAVABLE_CHARM') {
      var width = $(imageContainer).width();
      var height = $(imageContainer).height();

      $(textLabel).css('max-height', '100%');
      $(textLabel).css('height', '40%');
      $(textLabel).css('width', '33%');
      $(textLabel).css('max-width', '33%');
      $(textLabel).css('left', '49%');
      $(textLabel).css('top', '63.5%');
      $(textLabel).css('font-family', fontChosen);

      if (containsNonLatinCodepoints($(textLabel).text())) {
        $(textLabel).css('top', '65.5%');
      }
      TextFill(textLabel, {
        explicitWidth: width * .35,
        explicitHeight: height * .4,
      });

      if (fontChosen == 'Magnum') {
        $(textLabel).css('top', '67%');
      } else if (fontChosen == 'Nickainley Normal') {
        $(textLabel).css('top', '66%');
      }
    } else if (engravingType == 'ENGRAVABLE_BAR_CHARM') {
      console.log('bar charm test')
      $(textLabel).css('max-height', '15%');
      $(textLabel).css('height', '15%');
      $(textLabel).css('width', '60%');
      $(textLabel).css('max-width', '60%');
      $(textLabel).css('left', '19.75%');
      $(textLabel).css('top', '53.5%');
      $(textLabel).css('font-family', fontChosen);
      $(textLabel).css('transform', 'rotate(-90deg)');

      IS_SYMBOL_INPUT_CHECKER = true;

      if (containsNonLatinCodepoints($(textLabel).text())) {
        $(textLabel).css('left', '21%');
      }

      if (ACTIVE_FONT == 'Magnum') {
        $(textLabel).css('left', '20.5%');
      } else if (ACTIVE_FONT == 'Nickainley Normal') {
        $(textLabel).css('left', '20.5%');
      } else if (ACTIVE_FONT == 'Holland Land') {
        $(textLabel).css('left', '20%');
      }

      let width = $(imageContainer).width();
      let height = $(imageContainer).height();

      TextFill(textLabel, {
        explicitWidth: width * 0.60,
        explicitHeight: height * .15,
      });
    }
  },

  addCustomEngravableRequest: function (variantId, tags, image) {
    let self = this;
    var $modal = new theme.Modals('engraving-upload-modal', 'engraving-upload-modal', {
      solid: true
    });
    $modal.open();
    ENGRAVABLE_ID = variantId;

    $('#preview-modal-text1-overlay span').text('');

    // render image
    $('#preview-modal-image').attr('src', image);

    // render containers
    $('.preview-modal-dropdown-container').html('');

    // determine type through tags and setup text rendering
    let engravingType = '';
    if (tags.indexOf('engravable-heart-charm') > -1) {
      engravingType = 'HEART_CHARM';
    } else if (tags.indexOf('engravable-circle-charm') > -1) {
      engravingType = 'CIRCLE_CHARM';
    } else if (tags.indexOf('pave-circle-engravable-charm') > -1) {
      engravingType = 'PAVE_CIRCLE_ENGRAVABLE_CHARM';
    } else if (tags.indexOf('engravable-circle-photo-necklace') > -1) {
      engravingType = 'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE';
    } else if (tags.indexOf('engravable-bar-charm') > -1) {
      engravingType = 'ENGRAVABLE_BAR_CHARM';
    } else if (tags.indexOf('engravable-bar-tennis-bracelet') > -1) {
      engravingType = 'ENGRAVABLE_BAR_TENNIS_BRACELET';
    } else if (tags.indexOf('engravable-bar-paperclip-bracelet') > -1) {
      engravingType = 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET';
    } else if (tags.indexOf('engravable-bar-paperclip-necklace') > -1) {
      engravingType = 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE';
    } else if (tags.indexOf('engravable-bar-circle-photo-bracelet') > -1) {
      engravingType = 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET';
    } else if (tags.indexOf('engravable-circle-photo-bookmark') > -1) {
      engravingType = 'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK';
    } else if (tags.indexOf('engravable-heart-photo-bookmark') > -1) {
      engravingType = 'ENGRAVABLE_HEART_PHOTO_BOOKMARK';
    } else if (tags.indexOf('engravable-bar-ring') > -1) {
      engravingType = 'ENGRAVABLE_BAR_RING';
    } else if (tags.indexOf('engravable-heart-locket-keychain') > -1) {
      engravingType = 'ENGRAVABLE_HEART_LOCKET_KEYCHAIN';
    } else if (tags.indexOf('circle-photo-square-keychain') > -1) {
      engravingType = 'CIRCLE_PHOTO_SQUARE_KEYCHAIN';
    } else if (tags.indexOf('engravable-circle-photo-lariat-necklace') > -1) {
      engravingType = 'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE';
    }

    // render font containers
    let FONT_OVERRIDES = FONTS_BY_TAG[engravingType];
    var fontContainerHtml = '';
    for (var i = 0; i < FONT_OVERRIDES.length; i++) {
      var eachFontName = FONT_OVERRIDES[i];
      var nameWithoutExtension = eachFontName.split('.')[0];
      var actualFontName = toTitleCase(nameWithoutExtension.replaceAll('_', ' ')).replaceAll('Font ', '')
      var containerHtml = '<div class="ornament-button font-button font-selector" data-font="' + actualFontName + '" data-name="' + nameWithoutExtension + '"><span class="font-example" style="font-family: ' + actualFontName + ';">Aa</span></div>'
      fontContainerHtml += containerHtml;
    }

    if (!FONT_OVERRIDES.includes('font_dayrom.ttf')) {
      ACTIVE_FONT = 'Alga';
      ACTIVE_FONT_PROPERTY = 'F8';
    }

    $('.preview-modal-font-container').html(fontContainerHtml);

    // handle font change events
    $('.preview-modal-font-container').on('click', '.font-button', function () {
      $('.font-button').removeClass('active');
      $(this).addClass('active');
      ACTIVE_FONT = $(this).data('font');
      ACTIVE_FONT_PROPERTY = FONT_PROPERTIES[ACTIVE_FONT];
      $('#chosen-font').val(ACTIVE_FONT_PROPERTY);
      self.renderText($('#preview-modal-text1-overlay'), $('#preview-modal-text1-overlay span'), $('#engraving-preview-modal img'), engravingType);
    });

    $('.preview-modal-font-container').find('.font-button:first').click();

    renderContainersByType(engravingType, true);

    if (engravingType == 'HEART_CHARM') {
      $('#engraving-upload-modal .symbol-input').on('change keyup paste input', function () {
        $('#preview-modal-text1-overlay span').text($(this).val());
        self.renderText($('#preview-modal-text1-overlay'), $('#preview-modal-text1-overlay span'), $('#engraving-preview-modal img'), engravingType);
      });
    } else if (engravingType == 'CIRCLE_CHARM') {
      $('#engraving-upload-modal .symbol-input').on('change keyup paste input', function () {
        $('#preview-modal-text1-overlay span').text($(this).val());
        self.renderText($('#preview-modal-text1-overlay'), $('#preview-modal-text1-overlay span'), $('#engraving-preview-modal img'), engravingType);
      });
    } else if (engravingType == 'PAVE_CIRCLE_ENGRAVABLE_CHARM') {
      $('#engraving-upload-modal .symbol-input').on('change keyup paste input', function () {
        $('#preview-modal-text1-overlay span').text($(this).val());
        self.renderText($('#preview-modal-text1-overlay'), $('#preview-modal-text1-overlay span'), $('#engraving-preview-modal img'), engravingType);
      });
    } else if (engravingType == 'ENGRAVABLE_BAR_CHARM') {
      $('#engraving-upload-modal .symbol-input').on('change keyup paste input', function () {
        $('#preview-modal-text1-overlay span').text($(this).val());
        self.renderText($('#preview-modal-text1-overlay'), $('#preview-modal-text1-overlay span'), $('#engraving-preview-modal img'), engravingType);
      });
    }

    // handle on save click (if not exists)
    $('#upload-engraving-save').off('click');
    $('#upload-engraving-save').click(function () {
      $modal.close();
      self.addEngravableConfirm(ENGRAVABLE_ID, engravingType, ACTIVE_FONT);
    });
  },

  addNonPhotoConfirm: function (variantId, tags, text) {
    var self = this;
    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }
    var uuid = self.generateUUID();
    const data = {
      'LINE1': text,
      'uuid': uuid,
      '_override-text': true,
    }
    if (!customVariants[variantId]) {
      customVariants[variantId] = [data];
    } else {
      customVariants[variantId].push(data);
    }
    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }
    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('override-text', true);
    //$('.charm-type-option[data-variant-id="' + variantId + '"]').data('uuid', uuid);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }
    self.handleQuantities();
    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  addNonPhotoCustomRequest: function (variantId, tags) {
    let self = this;
    $('#confirm-personalization').off('click');
    var $modal = new theme.Modals('non-photo-custom-modal', 'non-photo-custom-modal', {
      solid: true
    });
    if (tags.indexOf('line1') > -1) {
      let foundLength = false;
      for (var i = 0; i < tags.length; i++) {
        const tag = tags[i];
        if (tag.indexOf('line1-length-') > -1) {
          let length = tag.split('line1-length-')[1];
          $('#NON_PHOTO_CUSTOM_TEXT_1').attr('maxlength', length);
          foundLength = true;
        }
      }
      if (!foundLength) {
        $('#NON_PHOTO_CUSTOM_TEXT_1').attr('maxlength', 12);
      }
      $('#NON_PHOTO_CUSTOM_TEXT_1').on('change keyup paste input', function () {
        let length = $(this).val().length;
        let maxLength = $('#NON_PHOTO_CUSTOM_TEXT_1').attr('maxlength');
        if (length > 0) {
          $(this).parent().find('.characters-remaining').text(maxLength - length + ' characters remaining');
        } else {
          $(this).parent().find('.characters-remaining').text('0 characters remaining');
        }
      });
      $('#NON_PHOTO_CUSTOM_TEXT_1').parent().find('.characters-remaining').text($('#NON_PHOTO_CUSTOM_TEXT_1').attr('maxlength') + ' characters remaining');
      $('#confirm-personalization').on('click', function () {
        if (!isNotEmptyText($('#NON_PHOTO_CUSTOM_TEXT_1').val())) {
          $('.invalid-text').show();
        } else {
          $('.invalid-text').hide();
          $modal.close();
          self.addNonPhotoConfirm(variantId, tags, $('#NON_PHOTO_CUSTOM_TEXT_1').val());
        }
      });
    }
    $modal.open();
  },

  addCustomItemRequest: function () {
    // pop up custom item modal
    // on success add it to the list
    // on failure do nothing
    var $modal = new theme.Modals('upload-start-modal', 'upload-start-modal', {
      solid: true
    });
    $modal.open();
    $('#upload-file').on('change', async function (uploadEvent) {
      $modal.close();
    });
  },

  addFlowerConfirm: function (variantId, properties) {
    const self = this;
    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }
    var uuid = self.generateUUID();
    properties['uuid'] = uuid;
    if (!customVariants[variantId]) {
      customVariants[variantId] = [properties];
    } else {
      customVariants[variantId].push(properties);
    }
    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }
    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }
    self.handleQuantities();
    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  addCustomItemConfirm: function (variantId, uneditedURL, editedURL, originalURL) {
    // let's take the item url and convert it into an example charm using the method
    // let's then add it to the product results feature
    var self = this;
    if (quantitiesById[variantId]) {
      quantitiesById[variantId] += 1;
    } else {
      quantitiesById[variantId] = 1;
    }
    var uuid = self.generateUUID();
    if (!customVariants[variantId]) {
      customVariants[variantId] = [{ editedURL: editedURL, uneditedURL: uneditedURL, uuid: uuid, originalURL: originalURL }];
    } else {
      customVariants[variantId].push({ editedURL: editedURL, uneditedURL: uneditedURL, uuid: uuid, originalURL: originalURL });
    }
    if (!MOST_RECENT_CUSTOM_VARIANT[variantId]) {
      MOST_RECENT_CUSTOM_VARIANT[variantId] = [uuid];
    } else {
      MOST_RECENT_CUSTOM_VARIANT[variantId].push(uuid);
    }
    $('.charm-type-option[data-variant-id="' + variantId + '"]').addClass('custom-variant');
    $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').data('quantity', quantitiesById[variantId]);
    if (!$('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-selector-controls').length) {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-quantity-selector" data-quantity="1"><div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">' + quantitiesById[variantId] + '</span><span class="charm-quantity-add">+</span></div></div>');
    } else {
      $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
    }
    self.handleQuantities();
    if (selectedBaseVariantImage) {
      self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
    } else {
      self.renderProductResults();
    }
  },

  renderDropdownContainer: function (text, type) {
    var dropdownHtml = '<div class="tabs" id="' + type + '-dropdown">'
    dropdownHtml += '<div class="tab">'
    dropdownHtml += '<input type="checkbox" class="accordion-check" id="' + type + '-check">'
    dropdownHtml += '<label class="tab-label" for="' + type + '-check">' + text + '</label>'
    dropdownHtml += '<div class="tab-content" data-tab="' + type + '">'
    dropdownHtml += '</div></div></div>'
    return dropdownHtml;
  },

  fetchColorUrl: function (color) {
    if (!color || !color.length) return [false, color ? color.toLowerCase() : 'white'];

    const formattedColor = color.trim().replace(' / ', '-').replace('/', '-');

    if (color.toLowerCase() === 'silver') {
      return [false, '#e6e6e6'];
    } else if (color.toLowerCase() === 'gold') {
      return [false, '#eee8aa'];
    } else if (SWATCHES_CONFIG[formattedColor]) {
      return [true, SWATCHES_CONFIG[formattedColor]];
    } else {
      return [false, color.toLowerCase()];
    }
  },

  getCurrentProduct: function (done) {
    const url = `https://${window.location.host + window.location.pathname}.json`;
    fetch(url).then((response) => response.json()).then((data) => {
      done(data);
    });
  },

  fetchSelectedVariantNames: function (selectedId, done) {
    const self = this;
    self.getCurrentProduct((productDetails) => {
      if (productDetails && productDetails.product && productDetails.product.variants && productDetails.product.variants.length) {
        const variants = productDetails.product.variants;

        if (variants && variants.length > 0) {
          for (var i = 0; i < variants.length; i++) {
            const variant = variants[i];
            const variantId = variant.id;

            if (!variantId || !variant) continue;

            if (variantId.toString() === selectedId) {
              done([variant.option1, variant.option2, variant.option3]);
            }
          }
        } else {
          done([]);
        }
      } else {
        done([]);
      }
    });
  },

  renderUpsellContainer: function (productId) {
    let containerHtml = '<div class="photo-charm-upsell-multi" data-product="' + productId + '">'
    containerHtml += '<img class="lazyload photo-charm-image-multi" data-product="' + productId + '" data-sizes="auto" alt="upsell-photo" data-src="https://cdn.shopify.com/s/files/1/0586/0117/7256/files/gold_bubble_letter-min.png?width=500" height="100" width="auto" />';
    containerHtml += '<div class="photo-charm-text-multi" data-product="' + productId + '">';
    containerHtml += '<span class="photo-charm-upsell-title-multi" data-product="' + productId + '">Add a Custom Photo Gem</span><br />';
    containerHtml += '<span class="photo-charm-upsell-strikethrough-price-multi" data-product="' + productId + '">$40.00</span> ';
    containerHtml += '<span class="photo-charm-upsell-price-multi" data-product="' + productId + '">$20.00</span><br />';
    containerHtml += '<div class="photo-charm-upsell-swatches-multi" data-product="' + productId + '"></div>';
    containerHtml += '<div class="photo-charm-upsell-sizes-multi" data-product="' + productId + '"></div></div>';
    containerHtml += '<div class="photo-charm-add-multi" data-product="' + productId + '">';
    containerHtml += '<button class="photo-charm-upsell-add-multi" data-product="' + productId + '" id="photo-charm-upsell-add-' + productId + '">Add</button></div></div>';

    $('.photo-charm-upsell-container-parent').append(containerHtml);
  },

  determineActiveUpsellSkus: function () {
    const self = this;
    self.getCurrentProduct((productDetails) => {
      if (productDetails && productDetails.product && productDetails.product.tags) {
        let tags = productDetails.product.tags;
        if (!tags || !tags.length) return;

        tags = tags.split(', ');
        for (var i = 0; i < tags.length; i++) {
          const tag = tags[i];
          if (tag.indexOf('upsell_') > -1) {
            const productId = tag.split('_')[1];
            if (!productId) continue;
            self.renderUpsellProduct(parseInt(productId));
          }
        }

        // on complete loop, let's also check for bulk upsells
        if (tags.indexOf('upsell-charm-7913275687082') > -1 || tags.indexOf('upsell-charm-7906553397418') > -1 || tags.indexOf('upsell-multi') > -1) {
          self.handleUpsellUpload();
        }
      }
    });
  },

  addUpsellToCart: function (button, variantId, photo, photoParam, upsellModal) {
    if (!button || !variantId) return;
    const $addToCart = button;
    const $body = $(document.body);
    const buttonText = $(button).text();

    $addToCart.removeClass('is-added').addClass('is-adding');
    $addToCart.prop('disabled', true);

    let propertyName = photoParam ?? 'photo';

    let properties = {};
    if (photo) {
      properties[propertyName] = photo;
    }

    var cartAdditions = [{
      quantity: 1,
      id: variantId,
      properties: properties
    }];

    const data = {
      items: cartAdditions
    };
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    xhr.send(JSON.stringify(data));
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding').addClass('is-added');
        ShopifyAPI.getCart(function (cart) {
          $body.trigger('afterAddToCart.ajaxCart', cart);
          $('.cart-link').trigger('click');
        });
        $(button)
          .text(buttonText)
          .prop('disabled', false)
          .removeClass('btn--no-animate');
        if (upsellModal) {
          $('.editorLoading').hide();
          upsellModal.close();
        }
      }
    };
  },

  loadPinturaUpsellEditor: function (productId, file) {
    const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
    let pinturaData = pintura.appendDefaultEditor('.pintura-editor-upsell-' + productId, {
      src: file,
      imageCropAspectRatio: 1,
      cropEnableButtonFlipHorizontal: false,
      cropEnableButtonFlipVertical: false,
      imageCropLimitToImage: true,
      willRenderCanvas: (shapes, state) => {
        const {
          utilVisibility,
          selectionRect,
          lineColor,
          backgroundColor,
        } = state;

        if (utilVisibility.crop <= 0) return shapes;

        const { x, y, width, height } = selectionRect;

        const defaultShape = {
          x: x + width * 0.5,
          y: y + height * 0.5,
          rx: width * 0.5,
          ry: height * 0.5,
          opacity: utilVisibility.crop,
          inverted: true,
          backgroundColor: [...backgroundColor, 0.5],
          strokeWidth: 1,
          strokeColor: [...lineColor],
        }

        return {
          // Copy all props from current shapes
          ...shapes,

          // Now we add an inverted ellipse shape to the interface shapes array
          interfaceShapes: [
            defaultShape,
            // Spread all existing interface shapes onto the array
            ...shapes.interfaceShapes,
          ],
        };
      },
      imageReader: createDefaultImageReader({
        preprocessImageFile: async (file, options, onprogress) => {
          return file;
        },
      }),
      imageWriter: createDefaultImageWriter({
        mimeType: 'image/jpeg',
        quality: 0.5,
        targetSize: {
          width: 1000,
          height: 1000,
          fit: 'contain',
          upscale: false,
        },
        postprocessImageData: (imageData) =>
          new Promise((resolve) => {
            const canvas = document.createElement('canvas');
            canvas.width = imageData.width;
            canvas.height = imageData.height;
            const ctx = canvas.getContext('2d');
            ctx.putImageData(imageData, 0, 0);

            ctx.globalCompositeOperation = 'destination-in';

            ctx.fillStyle = 'black';
            ctx.beginPath();
            ctx.arc(
              imageData.width * 0.5,
              imageData.height * 0.5,
              imageData.width * 0.5,
              0,
              2 * Math.PI
            );
            ctx.fill();

            resolve(
              ctx.getImageData(0, 0, canvas.width, canvas.height)
            );
          }),
      })
    });
    $('.PinturaRoot').append('<div class="editorLoading"><div class="lds-dual-ring"></div> <span style="text-align: center;">Loading...</span></div>')

    $('#upsell-upload-file-multi-' + productId).replaceWith($('#upsell-upload-file-multi-' + productId).val('').clone(true));

    return pinturaData;
  },

  processPinturaFile: function (productId, pinturaData, selectedVariant, responseType, $upsellUpload) {
    const self = this;
    pinturaData.processImage().then((imageWriterResult) => {
      var formData = new FormData();
      formData.append('file', imageWriterResult.dest);
      formData.append('upload_preset', 'ml_unsigned');
      formData.append('api_key', '211575742393728');
      $('.editorLoading').css('display', 'flex');
      $.ajax({
        url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
        type: 'POST',
        data: formData,
        async: true,
        success: function (data) {

        },
        error: function (data, error, errorThrown) {
          $('#upsell-upload-save-multi-' + productId)
            .text('Upload & Add to Cart')
            .prop('disabled', false)
            .removeClass('btn--no-animate');
          $('.editorLoading').hide();
        },
        cache: false,
        contentType: false,
        processData: false,
        timeout: 15000
      }).done(function (response) {
        var optionsRevised = response.url;
        var newResponse = response.url;
        if (optionsRevised.indexOf('http://res.cloudinary.com/dgwldii6i/image/upload/') > -1) {
          var splitImage = optionsRevised.split('http://res.cloudinary.com/dgwldii6i/image/upload/')[1];
          var splitName = 'l_' + splitImage.split('/')[1];
          if (splitName) {
            splitName = splitName.substr(0, splitName.lastIndexOf('.'));
          }
          optionsRevised = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
          newResponse = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
        }

        var $addToCart = $('#upsell-upload-save-multi-' + productId);
        self.addUpsellToCart($addToCart, selectedVariant, newResponse, responseType, $upsellUpload);
      });
    });
  },

  renderUpsellProduct: function (productId) {
    if ($('.photo-charm-upsell-container-multi[data-product="' + productId + '"]').length) return;
    const self = this;
    const $upsellUpload = new theme.Modals('upsell-upload-modal-' + productId, 'upsell-upload-modal-' + productId, {
      solid: true
    });
    const selectedID = productId;
    const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
    let pinturaData;

    self.renderUpsellContainer(productId);

    function fetchProductsPages(products, index, done) {
      $.getJSON('/collections/upsell-products/products.json?limit=250', function (result) {
        if (result && result.products && result.products.length) {
          for (var i = 0; i < result.products.length; i++) {
            products.push(result.products[i]);
          }

          if (result.products.length == 250) {
            return fetchProductsPages(products, index + 1, done);
          }
        }
        done(products);
      });
    }

    fetchProductsPages([], 1, (productsList) => {
      let productDetails;
      if (!productsList || !productsList.length) return;
      for (var i = 0; i < productsList.length; i++) {
        if (productsList[i].id == selectedID) {
          productDetails = productsList[i];
          break;
        }
      }
      if (!productDetails) return;
      let productOptions = productDetails.options;
      let productVariants = productDetails.variants;
      let selectedVariant;

      let firstColor = 'DEFAULT';
      let firstSize = 'DEFAULT';

      if (productOptions.length) {
        firstColor = productOptions[0].values[0];
        if (productOptions.length > 1) {
          firstSize = productOptions[1].values[0];
        }
      }

      let upsellVariantsById = {};
      let upsellVariantsByOption = { 'DEFAULT': { 'DEFAULT': {} } };

      for (var i = 0; i < productVariants.length; i++) {
        upsellVariantsById[productVariants[i].id] = productVariants[i];

        let firstOption = productVariants[i].option1 || 'DEFAULT';
        let secondOption = productVariants[i].option2 || 'DEFAULT';

        if (!upsellVariantsByOption[firstOption]) {
          upsellVariantsByOption[firstOption] = {};
        }
        upsellVariantsByOption[firstOption][secondOption] = productVariants[i];
      }

      function loadOptions() {
        if ($('.photo-charm-upsell-sizes-multi[data-product="' + productId + '"] div').length !== 0 || $('.photo-charm-upsell-swatches-multi[data-product="' + productId + '"] div').length !== 0) return;

        for (var i = 0; i < productOptions.length; i++) {
          let option = productOptions[i];
          let optionName = option.name;
          let optionValues = option.values;

          for (var i2 = 0; i2 < optionValues.length; i2++) {
            let optionValue = optionValues[i2];

            if (optionName.toLowerCase() == 'color' || optionName.toLowerCase() == 'metal') {
              const isActive = optionValue == firstColor;
              const result = self.fetchColorUrl(optionValue);
              const isImage = result[0];
              const color = result[1];

              let imageHtml;
              if (isImage) {
                imageHtml = '<img src="' + color + '" />';
              } else {
                imageHtml = '<div style="background-color: ' + color + ';"></div>';
              }

              $('.photo-charm-upsell-swatches-multi[data-product="' + productId + '"]').append('<div class="photo-charm-upsell-swatch-multi' + (isActive ? ' active' : '') + '" data-product="' + productId + '" data-color="' + optionValue + '">' + imageHtml + '</div>');
            } else {
              const isActive = optionValue == firstSize;
              $('.photo-charm-upsell-sizes-multi[data-product="' + productId + '"]').append('<div class="photo-charm-upsell-size-multi' + (isActive ? ' active' : '') + '" data-product="' + productId + '" data-size="' + optionValue + '">' + optionValue + '</div>');
            }
          }
        }
      }

      function updatePrice(selectionId) {
        const selectedVariantDetails = upsellVariantsById[selectionId];
        const price = selectedVariantDetails.price;
        const compareAtPrice = selectedVariantDetails.compare_at_price;
        let image = selectedVariantDetails.featured_image?.src;

        if (!image || image == '') {
          image = productDetails.images[0].src;
        }

        $('.photo-charm-upsell-title-multi[data-product="' + productId + '"]').text(productDetails.title);
        if (!image) {
          $('.photo-charm-image-multi[data-product="' + productId + '"]').hide();
        } else {
          $('.photo-charm-image-multi[data-product="' + productId + '"]').attr('src', image + '&width=500');
          $('.photo-charm-image-multi[data-product="' + productId + '"]').attr('data-src', image + '&width=500');
        }
        $('.photo-charm-upsell-price-multi[data-product="' + productId + '"]').html('$' + price);

        if (!compareAtPrice) {
          $('.photo-charm-upsell-strikethrough-price-multi[data-product="' + productId + '"]').hide();
        } else {
          $('.photo-charm-upsell-strikethrough-price-multi[data-product="' + productId + '"]').html('$' + compareAtPrice);
        }
      }

      function updateVariant(color, size) {
        color = color || 'DEFAULT';
        size = size || 'DEFAULT';
        selectedVariant = upsellVariantsByOption[color][size].id;
        if (upsellVariantsByOption[color] && upsellVariantsByOption[color][size]) {
          updatePrice(upsellVariantsByOption[color][size].id);
        }
      }

      $('body').on('click', '.photo-charm-upsell-swatch-multi[data-product="' + productId + '"]', function (e) {
        firstColor = $(e.currentTarget).data('color') || 'DEFAULT';
        $('.photo-charm-upsell-swatch-multi[data-product="' + productId + '"]').removeClass('active');
        $(this).addClass('active');
        updateVariant(firstColor, firstSize);
      });

      $('body').on('click', '.photo-charm-upsell-size-multi[data-product="' + productId + '"]', function (e) {
        firstSize = $(e.currentTarget).data('size') || 'DEFAULT';
        $('.photo-charm-upsell-size-multi[data-product="' + productId + '"]').removeClass('active');
        $(this).addClass('active');
        updateVariant(firstColor, firstSize);
      });

      updateVariant(firstColor, firstSize);

      $('.upsell-upload-save-multi-' + productId).on('click', function (e) {
        $('.upload__preview-wrap').show();

        self.processPinturaFile(productId, pinturaData, selectedVariant, 'photo', $upsellUpload);
      });

      loadOptions();

      $('#upsell-upload-file-multi-' + productId).on('change', function (uploadEvent) {
        const file = uploadEvent.target.files[0];
        if (file) {
          $upsellUpload.open();
          $('.pintura-editor-upsell-' + productId).html('');
          pinturaData = self.loadPinturaUpsellEditor(productId, file);
        }
      });

      $('.photo-charm-upsell-add-multi[data-product="' + productId + '"]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        let isCustom = productDetails.tags && (
          productDetails.tags.indexOf('charm custom') > -1
          || productDetails.tags.indexOf('customitem') > -1
        );

        let isEngravable = productDetails.tags && (
          productDetails.tags.indexOf('custom-engravable-new') > -1
        );

        if (isEngravable) {
          self.addCustomEngravableRequest(productDetails?.variants?.[0]?.id, productDetails.tags, productDetails?.variants?.[0]?.featured_image?.src);
        } else if (isCustom) {
          $('#upsell-upload-file-multi-' + productId).click();
        } else {
          self.addUpsellToCart($('.photo-charm-upsell-add-multi[data-product="' + productId + '"]'), selectedVariant);
        }
      });
    });
  },

  generateSwatchImage: function (iconName, fullIconName) {
    let colorImage = 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/Icon-' + fullIconName + '.png';
    return '<div class="color-swatch" data-custom-value="' + iconName + '" role="button" style="background-image: url(' + colorImage + '); background-color: ' + iconName + '"></div>'
  },

  reloadCustomSwatches: function () {
    $('.custom-swatch').click(function () {
      const container = $(this).closest('.custom-swatch-container');
      const swatch = $(this).find('.color-swatch');
      const customValue = $(swatch).data('custom-value');
      const wrapperContainer = $(this).closest('.variant-wrapper');
      $(container).find('.color-swatch').removeClass('active');
      $(swatch).addClass('active');
      $(container).data('selected-swatch', customValue);
      $(wrapperContainer).find('.variant__label-info').text('— ' + customValue);
    });

    $('.custom-swatch:first').click();
  },

  addPetPortraitRequest: function (isWatercolor) {
    let self = this;
    petModal = new theme.Modals('pet-portrait-modal', 'pet-portrait-modal', {
      solid: true
    });
    if (isWatercolor) {
      if (!ORIG_CUSTOM_SWATCH_CONTAINER) {
        ORIG_CUSTOM_SWATCH_CONTAINER = $('.custom-swatch-container').html();
      }

      IS_WATERCOLOR = true;

      $('#pet-portrait-modal .modal-title').text('');

      $('#MODAL_TEXT1').val('');
      $('#MODAL_TEXT1').attr('maxlength', 14);
      $('#MODAL_TEXT1').parent().find('.characters-remaining').text('14 characters maximum. Only Letters and Numbers.');

      let html = '';
      let colors = [
        'Blue',
        'Black',
        'Purple',
        'Yellow',
        'Gray'
      ]

      for (var i = 0; i < colors.length; i++) {
        html += '<div class="custom-swatch">' + self.generateSwatchImage(colors[i], colors[i] + '_Watercolor') + '</div>';
      }

      $('.custom-swatch-container').html(html);
      self.reloadCustomSwatches();
    } else {
      // set to original custom swatch container if exists, otherwise it should be prerendered
      if (ORIG_CUSTOM_SWATCH_CONTAINER) {
        $('.custom-swatch-container').html(ORIG_CUSTOM_SWATCH_CONTAINER);
        self.reloadCustomSwatches();
      }

      $('#pet-portrait-modal .modal-title').text('Add a Pet Portrait');

      IS_WATERCOLOR = false;

      $('#MODAL_TEXT1').val('');
      $('#MODAL_TEXT1').attr('maxlength', 8);
      $('#MODAL_TEXT1').parent().find('.characters-remaining').text('8 characters maximum. Only Letters and Numbers.');
    }
    petModal.open();
  },

  addJerseyRequest: function (variantId, image) {
    ACTIVE_JERSEY_VARIANT_ID = variantId;
    $('.jersey-preview-image img').attr('src', image);
    $jerseyModal.open();
  },

  addFlowerRequest: function (variantId, tags, image) {
    const self = this;
    const $flowerModal = new theme.Modals('charm-builder-flower-modal', 'charm-builder-flower-modal', {
      solid: true
    });

    flowerSelection = [{
      month: 'DEFAULT',
      flower: 'Select month',
      color: 'DEFAULT'
    }];
    flowerText = '';
    $('#flower-builder-modal-text').val('');
    $('.flower-builder-count-option:first').click();
    $flowerModal.open();

    $('#submit-flower-modal').off('click');
    $('#submit-flower-modal').click(function () {
      $flowerModal.close();
      self.addFlowerConfirm(LAST_SELECTED_VARIANT_ID, buildPropertiesObject(flowerSelection));
    });
  },

  handleUpsellUpload: function () {
    const self = this;
    const $upsellUpload = new theme.Modals('upsell-upload-modal', 'upsell-upload-modal', {
      solid: true
    });
    const selectedID = 7906553397418; // 7829478473896;
    const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
    let pinturaData;

    const fetchIdData = function () {
      $.getJSON('/collections/upsell-products/products.json', function (result) {
        if (result && result.products && result.products.length) {
          for (var i = 0; i < result.products.length; i++) {
            const productDetails = result.products[i];
            const productVariants = productDetails.variants;
            const productOptions = productDetails.options;

            if (productDetails.id != selectedID) continue;

            let firstColor = 'DEFAULT';
            let firstSize = 'DEFAULT';

            if (productOptions.length) {
              firstColor = productOptions[0].values[0];
              if (productOptions.length > 1) {
                firstSize = productOptions[1].values[0];
              }
            }
            let selectedVariant;
            let upsellVariantsById = {};
            let upsellVariantsByOption = { 'DEFAULT': { 'DEFAULT': {} } };

            for (var i = 0; i < productVariants.length; i++) {
              upsellVariantsById[productVariants[i].id] = productVariants[i];

              let firstOption = productVariants[i].option1 || 'DEFAULT';
              let secondOption = productVariants[i].option2 || 'DEFAULT';

              if (!upsellVariantsByOption[firstOption]) {
                upsellVariantsByOption[firstOption] = {};
              }
              upsellVariantsByOption[firstOption][secondOption] = productVariants[i];
            }

            function loadOptions() {
              if ($('.photo-charm-upsell-sizes div').length !== 0 || $('.photo-charm-upsell-swatches div').length !== 0) return;
              for (var i = 0; i < productOptions.length; i++) {
                let option = productOptions[i];
                let optionName = option.name;
                let optionValues = option.values;

                for (var i2 = 0; i2 < optionValues.length; i2++) {
                  let optionValue = optionValues[i2];

                  if (optionName.toLowerCase() == 'color' || optionName.toLowerCase() == 'metal') {
                    const isActive = optionValue == firstColor;
                    const result = self.fetchColorUrl(optionValue);
                    const isImage = result[0];
                    const color = result[1];

                    let imageHtml;
                    if (isImage) {
                      imageHtml = '<img src="' + color + '" />';
                    } else {
                      imageHtml = '<div style="background-color: ' + color + ';"></div>';
                    }

                    $('.photo-charm-upsell-swatches').append('<div class="photo-charm-upsell-swatch' + (isActive ? ' active' : '') + '" data-color="' + optionValue + '">' + imageHtml + '</div>');
                  } else {
                    const isActive = optionValue == firstSize;
                    $('.photo-charm-upsell-sizes').append('<div class="photo-charm-upsell-size' + (isActive ? ' active' : '') + '" data-size="' + optionValue + '">' + optionValue + '</div>');
                  }
                }
              }
            }

            function updatePrice(idContainer) {
              const selectedVariantDetails = upsellVariantsById[idContainer || selectedVariant];
              const price = selectedVariantDetails.price;
              const compareAtPrice = selectedVariantDetails.compare_at_price;
              let image = selectedVariantDetails.featured_image.src;
              const title = selectedVariantDetails.title.toLowerCase().trim();

              switch (title) {
                case 'gold':
                  image = 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/gold_bubble_letter-min.png?width=500';
                  break;
                case 'silver':
                  image = 'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/bubble_letter_with_charm-min.png?width=500';
                  break;
              }

              $('.photo-charm-image').attr('src', image);
              $('.photo-charm-upsell-price').html('$' + price);
              $('.photo-charm-upsell-strikethrough-price').html('$' + compareAtPrice);
            }

            function updateVariant(color, size) {
              color = color || 'DEFAULT';
              size = size || 'DEFAULT';
              if (upsellVariantsByOption[color] && upsellVariantsByOption[color][size]) {
                selectedVariant = upsellVariantsByOption[color][size].id;
                updatePrice(upsellVariantsByOption[color][size].id);
              }
            }

            $('body').on('variantChange', function (data) {
              if (data.variant && data.variant.id) {
                firstColor = data.variant.option1;
                $('.photo-charm-upsell-swatch').removeClass('active');
                $('.photo-charm-upsell-swatch[data-color="' + firstColor + '"]').addClass('active');
                updateVariant(data.variant.option1, 'DEFAULT');
              }
            });

            $('body').on('click', '.photo-charm-upsell-swatch', function (e) {
              firstColor = $(e.currentTarget).data('color') || 'DEFAULT';
              $('.photo-charm-upsell-swatch').removeClass('active');
              $(this).addClass('active');
              updateVariant(firstColor, firstSize);
            });

            $('body').on('click', '.photo-charm-upsell-size', function (e) {
              firstSize = $(e.currentTarget).data('size') || 'DEFAULT';
              $('.photo-charm-upsell-size').removeClass('active');
              $(this).addClass('active');
              updateVariant(firstColor, firstSize);
            });

            $('.upsell-upload-save').on('click', function (e) {
              $('.upload__preview-wrap').show();

              pinturaData.processImage().then((imageWriterResult) => {
                var formData = new FormData();
                formData.append('file', imageWriterResult.dest);
                formData.append('upload_preset', 'ml_unsigned');
                formData.append('api_key', '211575742393728');
                $('.editorLoading').css('display', 'flex');
                $.ajax({
                  url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
                  type: 'POST',
                  data: formData,
                  async: true,
                  success: function (data) {

                  },
                  error: function (data, error, errorThrown) {
                    $('#upsell-upload-save-multi')
                      .text('Upload & Add to Cart')
                      .prop('disabled', false)
                      .removeClass('btn--no-animate');
                    $('.editorLoading').hide();
                  },
                  cache: false,
                  contentType: false,
                  processData: false,
                  timeout: 15000
                }).done(function (response) {
                  var optionsRevised = response.url;
                  var newResponse = response.url;
                  if (optionsRevised.indexOf('http://res.cloudinary.com/dgwldii6i/image/upload/') > -1) {
                    var splitImage = optionsRevised.split('http://res.cloudinary.com/dgwldii6i/image/upload/')[1];
                    var splitName = 'l_' + splitImage.split('/')[1];
                    if (splitName) {
                      splitName = splitName.substr(0, splitName.lastIndexOf('.'));
                    }
                    optionsRevised = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
                    newResponse = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
                  }

                  self.addUpsellToCart($('#upsell-upload-save-multi'), selectedVariant, newResponse, 'photo', $upsellUpload);
                });
              });
            });

            loadOptions();

            self.fetchSelectedVariantNames($('select[name="id"]').val(), (variantNames) => {
              if (variantNames.length >= 1) {
                $('.photo-charm-upsell-swatch').removeClass('active');
                $('.photo-charm-upsell-swatch[data-color="' + variantNames[0] + '"]').addClass('active');
                updateVariant(variantNames[0], firstSize);
              } else {
                $('.photo-charm-upsell-swatch').removeClass('active');
                $('.photo-charm-upsell-swatch[data-color="' + firstColor + '"]').addClass('active');
                updateVariant(firstColor, firstSize);
              }
            });

            $('#upsell-upload-file').on('change', async function (uploadEvent) {
              const file = uploadEvent.target.files[0];
              $upsellUpload.open();
              $('#pintura-editor-upsell').html('');

              pinturaData = pintura.appendDefaultEditor('#pintura-editor-upsell', {
                src: file,
                imageCropAspectRatio: 1,
                cropEnableButtonFlipHorizontal: false,
                cropEnableButtonFlipVertical: false,
                imageCropLimitToImage: true,
                willRenderCanvas: (shapes, state) => {
                  const {
                    utilVisibility,
                    selectionRect,
                    lineColor,
                    backgroundColor,
                  } = state;

                  if (utilVisibility.crop <= 0) return shapes;

                  const { x, y, width, height } = selectionRect;

                  const defaultShape = {
                    x: x + width * 0.5,
                    y: y + height * 0.5,
                    rx: width * 0.5,
                    ry: height * 0.5,
                    opacity: utilVisibility.crop,
                    inverted: true,
                    backgroundColor: [...backgroundColor, 0.5],
                    strokeWidth: 1,
                    strokeColor: [...lineColor],
                  }

                  return {
                    // Copy all props from current shapes
                    ...shapes,

                    // Now we add an inverted ellipse shape to the interface shapes array
                    interfaceShapes: [
                      defaultShape,
                      // Spread all existing interface shapes onto the array
                      ...shapes.interfaceShapes,
                    ],
                  };
                },
                imageReader: createDefaultImageReader({
                  preprocessImageFile: async (file, options, onprogress) => {
                    return file;
                  },
                }),
                imageWriter: createDefaultImageWriter({
                  mimeType: 'image/jpeg',
                  quality: 0.5,
                  targetSize: {
                    width: 1000,
                    height: 1000,
                    fit: 'contain',
                    upscale: false,
                  },
                  postprocessImageData: (imageData) =>
                    new Promise((resolve) => {
                      const canvas = document.createElement('canvas');
                      canvas.width = imageData.width;
                      canvas.height = imageData.height;
                      const ctx = canvas.getContext('2d');
                      ctx.putImageData(imageData, 0, 0);

                      ctx.globalCompositeOperation = 'destination-in';

                      ctx.fillStyle = 'black';
                      ctx.beginPath();
                      ctx.arc(
                        imageData.width * 0.5,
                        imageData.height * 0.5,
                        imageData.width * 0.5,
                        0,
                        2 * Math.PI
                      );
                      ctx.fill();

                      resolve(
                        ctx.getImageData(0, 0, canvas.width, canvas.height)
                      );
                    }),
                })
              });
              $('.PinturaRoot').append('<div class="editorLoading"><div class="lds-dual-ring"></div> <span style="text-align: center;">Loading...</span></div>')

              $(this).replaceWith($(this).val('').clone(true));
            });
          }
        }
      });
    }

    $('#photo-charm-upsell-add').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $('#upsell-upload-file').click();
    });

    fetchIdData();
  },

  initialize: function (opts) {
    var self = this;

    this.handleCustomVariantSelector();

    var classes = {
      disabled: 'disabled'
    };

    var $container = this.$container = $('.product-section');

    this.inModal = $container.closest('.modal').length;

    if (!this.inModal) {
      this.initUploader();
    }
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    var firstDate = new Date(new Date().setDate(new Date().getDate() + 14));
    var secondDate = new Date(new Date().setDate(new Date().getDate() + 23));

    var firstDateString = monthNames[firstDate.getMonth()] + ' ' + firstDate.getDate();
    var secondDateString = monthNames[secondDate.getMonth()] + ' ' + secondDate.getDate();
    $('.dynamic-shipping-date').text(firstDateString + ' - ' + secondDateString);

    var charmType = 'ALL';
    var baseType = 'ALL';

    // check if we're on a bracelet page
    /*if ($('.bracelet-variant-label').length) {
      const grayProduct = $('.variant-input[data-value="Gray"]');
      grayProduct.append('</div>');
      grayProduct.append($('.bracelet-variant-label'));
    }*/

    if ($('.upsell-upload-modal').length) {
      self.determineActiveUpsellSkus();
    }

    if ($('.custom-bracelet-field').length) {
      $('.custom-bracelet-field input').on('change keyup paste input', function () {
        var text = $(this).val();
        if ($('#watercolor-portrait').length) {
          text = text.replace(/[^a-zA-Z0-9\s]/g, '')
        } else {
          text = text.replace(/[^a-zA-Z0-9]/g, '');
        }
        $(this).val(text);
        let charCount = text.length;

        $('.custom-bracelet-field .characters-remaining').text((parseInt($(this).attr('maxlength')) || 12) - charCount + ` Characters ${charCount === 0 ? 'Maximum' : 'Remaining'}. Only Letters and Numbers.`);
      });

      let options = { data: ['Black', 'Silver', 'Gold', 'Rose Gold'], name: 'Letter Block Color' };
      if ($('.custom-select-container').length) {
        createButtonRow($('.custom-select-container'), options);
      }

      $('body').on('click', '.add-to-cart-btn', function (e) {
        var selectedID = $("select[name='id']").val();
        e.preventDefault();
        e.stopPropagation();

        var $addToCart = $('.add-to-cart-btn');
        var $body = $(document.body);
        $addToCart.removeClass('is-added').addClass('is-adding');
        $addToCart.prop('disabled', true);

        var properties = { 'Text': $('.custom-bracelet-field input').val() };
        if ($('.custom-select-container') && $('.custom-select-container').data('value')) {
          properties[options.name] = $('.custom-select-container').data('value');
        }

        var cartAdditions = [{
          quantity: 1,
          id: selectedID,
          properties: properties
        }];

        const data = {
          items: cartAdditions
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').addClass('is-added');
            ShopifyAPI.getCart(function (cart) {
              $body.trigger('afterAddToCart.ajaxCart', cart);
              $('.cart-link').trigger('click');
            });
          } else {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').removeClass('is-added');
            if (xhr.response && xhr.status && xhr.status != 200) {
              let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
                solid: true
              });
              let message = xhr.response && JSON.parse(xhr.response).message;
              if (message && message.indexOf("'") > -1) {
                let start = message.split("'");
                let end = ' is sold out. Please remove the item.';
                message = start[0] + "'" + start[1] + "'" + end;
              }
              $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
              $('#warning-modal-close').click(function (e) {
                warningModal.close();
              });
              warningModal.open();
            }
          }
        };
      });
    }

    function handleCharmSelectorRender(products) {
      let html = ''
      if (products && products.length) {
        for (var i = 0; i < products.length; i++) {
          let eachProduct = products[i];

          for (var i2 = 0; i2 < eachProduct.variants.length; i2++) {
            let eachVariant = eachProduct.variants[i2];
            let variantId = eachVariant['id'];
            let productId = eachProduct['id'];
            let image = eachVariant['featured_image']['src'];
            let productTitle = eachProduct['title'];
            let compareAtPrice = eachVariant['compare_at_price'];
            let price = eachVariant['price'];
            let primaryOption = eachVariant['option1'];

            html += '<div class="charm-type-option base-item" data-parent-type="bases-parent" data-price="' + price + '" data-compare-price="' + compareAtPrice + '" data-type="bases-parent" data-uuid="DEFAULT" data-variant-id="' + variantId + '" data-product="' + productId + '">';
            html += '<div class="charm-img-container"><img src="' + image + '" /></div>';
            html += '<div class="charm-type-name">' + productTitle + ' - ' + primaryOption + '</div>';
            html += '</div>';
          }
        }
      }
      $('.charm-base-selector-container').html(html);
    }

    if ($('.charm-container-inner').length) {
      self.handlePetPortraitATC();
      if ($('.charm-base-selector-container').length) {
        const baseCollection = $('#earring-builder').length ? 'earring-base' : 'charm-bases';
        const baseLink = `/collections/${baseCollection}/products.json?page=1&limit=250`;
        fetch(baseLink)
          .then((response) => response.json())
          .then((result) => {
            const products = result.products;
            handleCharmSelectorRender(products);

            $('body').on('click', '.base-item', function () {
              let variantId = $(this).data('variant-id');
              let productId = $(this).data('product');
              $('.base-item').removeClass('base-active');
              $(this).addClass('base-active');
              selectedBaseVariantId = variantId;
              selectedBaseVariantTitle = $(this).find('.charm-type-name').text();
              selectedBaseVariantImage = $(this).find('.charm-img-container img').attr('src');
              selectedBaseVariantCompareAtPrice = $(this).data('compare-price');
              selectedBaseVariantPrice = $(this).data('price');
              self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
            });

            let interval = setInterval(function () {
              $('.base-item').first().click();
            }, 100);

            setTimeout(function () {
              clearInterval(interval);
            }, 500);
          });
      }

      var charms = [];
      var charmsByCategory = {
        'birthstones': [],
        'personalized': [],
        'symbols': [],
        'custom': [],
        'letters': [],
        'seasonal': [],
        'sports': [],
        'numbers': [],
        'spiritual': [],
        'zodiac': []
      };
      var bases = [];
      var basesByCategory = {
        'bracelets': [],
        'necklaces': [],
        'earrings': []
      };

      // For charms -> Setup collections for "Charms" (every charm - tag items by charm) - handle /charms
      // -> Bases (every charm base - tag items by "charm base") - handle /bases
      // -> Tag items within those categories based off of the titles. Bases should have /bracelets /necklaces - and those items should be tagged "charm bracelet" and "charm necklace"
      // -> Charms should have /birthstones /symbols - "charm birthstones" "charm symbols"
      // Fetch charms

      let charmLink = '/collections/charms/products.json?page=1&limit=250';
      let isCollarBuilder = false;
      if ($('#is-collar-builder').length) {
        charmLink = '/collections/dog-collar-charms/products.json?page=1&limit=250';
        isCollarBuilder = true;
      } else if ($('#is-team-spirit').length) {
        charmLink = '/collections/team-spirit-charms/products.json?page=1&limit=250';
      } else if ($('#is-keychain-builder').length) {
        charmLink = '/collections/build-your-keychain/products.json?page=1&limit=250';
      }
      fetch(charmLink)
        .then((response) => response.json())
        .then((result) => {
          var products = result.products;
          charms = products;
          if (products) {
            for (var i = 0; i < products.length; i++) {
              var eachProduct = products[i];
              var tags = eachProduct['tags'];

              if (isCollarBuilder) {
                if (tags.indexOf('dog-collar-symbol-charm') > -1) {
                  charmsByCategory['symbols'].push(eachProduct);
                } else if (tags.indexOf('dog-collar-birthstone-charm') > -1) {
                  charmsByCategory['birthstones'].push(eachProduct);
                } else if (tags.indexOf('dog-collar-letter-charm') > -1) {
                  charmsByCategory['letters'].push(eachProduct);
                } else if (tags.indexOf('dog-collar-seasonal-charm') > -1) {
                  charmsByCategory['seasonal'].push(eachProduct);
                }
              } else {
                if (tags.indexOf('charm personalized') > -1) {
                  charmsByCategory['personalized'].push(eachProduct);
                }
                if (tags.indexOf('birthstone') > -1) {
                  charmsByCategory['birthstones'].push(eachProduct);
                }
                if (tags.indexOf('symbol') > -1) {
                  charmsByCategory['symbols'].push(eachProduct);
                }
                if (tags.indexOf('charm custom') > -1) {
                  charmsByCategory['custom'].push(eachProduct);
                }
                if (tags.indexOf('charm letter') > -1) {
                  charmsByCategory['letters'].push(eachProduct);
                }
                if (tags.indexOf('sport charm') > -1) {
                  charmsByCategory['sports'].push(eachProduct);
                }
                if (tags.indexOf('seasonal-charm') > -1) {
                  charmsByCategory['seasonal'].push(eachProduct);
                }
                if (tags.indexOf('number charm') > -1) {
                  charmsByCategory['numbers'].push(eachProduct);
                }
                if (tags.indexOf('charm spiritual') > -1) {
                  charmsByCategory['spiritual'].push(eachProduct);
                }
                if (tags.indexOf('charm zodiac') > -1) {
                  charmsByCategory['zodiac'].push(eachProduct);
                }
              }
              productsById[eachProduct['id']] = eachProduct;
              for (var i2 = 0; i2 < eachProduct.variants.length; i2++) {
                var eachVariant = eachProduct.variants[i2];
                let sku = eachVariant['sku'];
                eachVariant['productId'] = eachProduct['id'];
                variantsById[eachVariant['id']] = eachVariant;
              }
            }
            $('.charm-item-type[data-type="all"]').click();
          }
        });


      // Fetch base types
      fetch('/collections/charm-bases/products.json?page=1&limit=250') // todo set category name
        .then((response) => response.json())
        .then((result) => {
          var products = result.products;
          bases = products;
          if (products) {
            for (var i = 0; i < products.length; i++) {
              var eachProduct = products[i];
              var tags = eachProduct['tags'];
              if (tags.indexOf('charm bracelet') > -1) {
                basesByCategory['bracelets'].push(eachProduct);
              } else if (tags.indexOf('charm necklace') > -1) {
                basesByCategory['necklaces'].push(eachProduct);
              } else if (tags.indexOf('charm earrings') > -1) {
                basesByCategory['earrings'].push(eachProduct);
              }
            }
            $('.charm-base-type[data-type="all"]').click();
          }
        });

      $('body').on('click', '.charm-item-type', function () {
        if (!$(this).hasClass('charm-add') && !$(this).hasClass('charm-quantity-subtract') && !$(this).hasClass('charm-quantity-add')) {
          var type = $(this).data('type');
          var parentType = $(this).parent().data('type');
          var items = charms;
          if (type != 'all') {
            items = charmsByCategory[type];
          }
          var html = self.renderContainer(parentType, type, items);
          $('.charm-item-type').removeClass('active');
          $(this).addClass('active');
          $('.charm-container-inner').scrollTop(0);
          $('.charm-container-inner').scrollLeft(0);
        }
      });

      let CHARM_BASES_BY_CATEGORY = {
        bracelets: [],
        necklaces: [],
        earrings: [],
        all: []
      };
      fetch('/collections/charm-bases/products.json?page=1&limit=250')
        .then((response) => response.json())
        .then((result) => {
          var products = result.products;
          for (var i = 0; i < products.length; i++) {
            let tags = products[i]['tags'];
            if (tags.indexOf('charm bracelet base') > -1) {
              CHARM_BASES_BY_CATEGORY['bracelets'].push(products[i]);
            } else if (tags.indexOf('charm necklace base') > -1) {
              CHARM_BASES_BY_CATEGORY['necklaces'].push(products[i]);
            }
          }
          CHARM_BASES_BY_CATEGORY['all'] = products;
        });

      $('body').on('click', '.charm-base-selector-type', function () {
        $('.charm-base-selector-type').removeClass('active');
        $(this).addClass('active');
        $('.charm-base-selector-container').scrollTop(0);
        $('.charm-base-selector-container').scrollLeft(0);
        var type = $(this).data('type');
        var items = CHARM_BASES_BY_CATEGORY[type];
        handleCharmSelectorRender(items);
      });

      window.addEventListener('addJerseyRequest', function (e) {
        self.addJerseyConfirm(e.detail.variantId, e.detail);
      });

      $('body').on('click', '.charm-base-type', function () {
        var type = $(this).data('type');
        var parentType = $(this).parent().data('type');
        var items = bases;
        if (type != 'all') {
          items = basesByCategory[type];
        }
        var html = self.renderContainer(parentType, type, items);
        $('.charm-base-type').removeClass('active');
        $(this).addClass('active');
      });

      $('body').on('click', '.inner-layer-right', function (e) {
        var parent = $(this).parent();
        var variantId = $(this).parent().closest('.charm-type-option').data('variant-id');
        var productId = $(this).parent().closest('.charm-type-option').data('product');
        var quantity = $(this).closest('.charm-image-container').find('.charm-quantity-selector').data('quantity');
        var charmQuantityHTML = '';
        var variantType = $(this).parent().closest('.charm-type-option').data('type');
        if (productsById[productId]['tags'].indexOf('charm custom') > -1 || productsById[productId]['tags'].indexOf('custom-engravable-new') > -1 || productsById[productId]['tags'].indexOf('flower-builder') > -1) {
          if (productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('pet-portrait-charm') > -1) {
            LAST_SELECTED_VARIANT_ID = variantId;
            self.addPetPortraitRequest(productsById[productId]['tags'].indexOf('watercolor-portrait-charm') > -1);
          } else if (productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('personalized-jersey-charm') > -1) {
            LAST_SELECTED_VARIANT_ID = variantId;
            self.addJerseyRequest(variantId, variantsById[variantId]?.featured_image?.src);
          }
          else if ((productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('custom-engravable-new') > -1)) {
            self.addCustomEngravableRequest(variantId, productsById[productId]['tags'], variantsById[variantId]?.featured_image?.src);
          } else if (productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('flower-builder') > -1) {
            LAST_SELECTED_VARIANT_ID = variantId;
            self.addFlowerRequest(variantId, productsById[productId]['tags'], variantsById[variantId]?.featured_image?.src);
          } else if ((productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('non-photo-custom') > -1 && productsById[productId]['tags'].indexOf('line1') > -1)) {
            LAST_SELECTED_VARIANT_ID = variantId;
            self.addNonPhotoCustomRequest(variantId, productsById[productId]['tags']);
          } else if ((productsById[productId] && productsById[productId]['tags'] && productsById[productId]['tags'].indexOf('charm custom') > -1)) {
            LAST_SELECTED_VARIANT_ID = variantId;
            self.addCustomItemRequest();
          } else {
            charmQuantityHTML += '<div class="charm-quantity-selector" data-quantity="1">';
            charmQuantityHTML += '<div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">1</span><span class="charm-quantity-add">+</span>';
            charmQuantityHTML += '</div></div>';
            $(this).closest('.charm-img-container').append(charmQuantityHTML);
            quantitiesById[variantId] = 1;
            $(this).closest('.charm-img-container').find('.charm-add').remove();
            self.handleQuantities(quantitiesById);
            self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
          }
        } else {
          var quantity = $(this).closest('.charm-type-option').find('.charm-quantity-selector').data('quantity');
          if (!$(this).closest('.charm-type-option').find('.charm-quantity-selector').length) {
            charmQuantityHTML += '<div class="charm-quantity-selector" data-quantity="1">';
            charmQuantityHTML += '<div class="charm-selector-controls"><span class="charm-quantity-subtract">-</span><span class="charm-quantity">1</span><span class="charm-quantity-add">+</span>';
            charmQuantityHTML += '</div></div>';
            $(this).closest('.charm-img-container').append(charmQuantityHTML);
            quantitiesById[variantId] = 1;
            $(this).closest('.charm-img-container').find('.charm-add').remove();
            self.handleQuantities(quantitiesById);
            self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
          } else {
            quantity = parseInt(quantity);
            quantity++;
            var variantId = $(this).closest('.charm-type-option').data('variant-id');
            quantitiesById[variantId] = quantity;
            $(this).closest('.charm-type-option').find('.charm-quantity').text(quantity);
            $(this).closest('.charm-img-container').find('.charm-quantity-selector').data('quantity', quantity);
          }
          self.handleQuantities(quantitiesById);
          self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
        }
      });

      $('body').on('click', '.charm-quantity-subtract', function () {
        removeItem($(this), e, true);
      });

      function removeItem(element, e, recent) {
        var variantId = $(element).closest('.charm-type-option').data('variant-id');
        var quantity = quantitiesById[variantId];
        quantity--;
        quantitiesById[variantId] = quantity;
        if (customVariants[variantId]) {
          var newCustom = [];
          for (var i = 0; i < customVariants[variantId].length; i++) {
            if (recent) {
              if (customVariants[variantId][i]['uuid'] != MOST_RECENT_CUSTOM_VARIANT[variantId][MOST_RECENT_CUSTOM_VARIANT[variantId].length - 1]) {
                newCustom.push(customVariants[variantId][i]);
              }
            } else {
              if (customVariants[variantId][i]['uuid'] != $(element).closest('.charm-type-option').data('uuid')) {
                newCustom.push(customVariants[variantId][i]);
              }
            }
          }
          if (recent) {
            MOST_RECENT_CUSTOM_VARIANT.pop();
          } else {
            // one last check against recent, because if the user manually removes an item, we want to remove that from most recent
            var newMost = [];
            for (var i = 0; i < MOST_RECENT_CUSTOM_VARIANT[variantId].length; i++) {
              if ($(element).closest('.charm-type-option').data('uuid') != MOST_RECENT_CUSTOM_VARIANT[variantId][i]) {
                newMost.push(MOST_RECENT_CUSTOM_VARIANT[variantId][i]);
              }
            }
            MOST_RECENT_CUSTOM_VARIANT[variantId] = newMost;
          }
          customVariants[variantId] = newCustom;
          if (newCustom && newCustom.length == 0) {
            delete customVariants[variantId];
            if (quantitiesById[variantId]) {
              quantitiesById[variantId] = 0;
            }
          }
        }

        if (quantitiesById[variantId] > 0) {
          $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity').text(quantitiesById[variantId]);
          $('.charm-type-option[data-variant-id="' + variantId + '"]').data('quantity', quantitiesById[variantId]);
        } else {
          $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-img-container').append('<div class="charm-add">+</div>');
          $('.charm-type-option[data-variant-id="' + variantId + '"]').find('.charm-quantity-selector').remove();
        }
        self.handleQuantities(quantitiesById);
        self.renderProductResults(selectedBaseVariantImage, selectedBaseVariantTitle, selectedBaseVariantCompareAtPrice, selectedBaseVariantPrice);
      }

      $('body').on('click', '.inner-layer-left', function (e) {
        removeItem($(this), e, true);
      });

      $('body').on('click', '.inner-layer-remove', function (e) {
        removeItem($(this), e);
      });

      $('body').on('click', '.add-to-cart-btn', function (e) {
        var selectedID = selectedBaseVariantId || $("select[name='id']").val();
        e.preventDefault();
        e.stopPropagation();
        var $addToCart = $('.add-to-cart-btn');
        var $body = $(document.body);
        $addToCart.removeClass('is-added').addClass('is-adding');
        $addToCart.prop('disabled', true);
        var cartAdditions = [{ quantity: 1, id: selectedID }];
        $('.charm-result-inner').find('.charm-type-option').each(function (item) {
          if ($(this).data('uuid') === 'DEFAULT') return;
          var variantId = $(this).data('variant-id');
          if (customVariants[variantId] && customVariants[variantId][0] && (customVariants[variantId][0]['LINE 1'] || customVariants[variantId][0]['LINE 1'] == '')) return;
          var originalURL = $(this).data('original-url');
          var quantity = 1;
          if ($(this).data('pet-portrait') || $(this).data('pet-portrait-background')) {
            cartAdditions.push({ quantity: quantity, id: variantId, properties: { 'photo': originalURL, 'Name': $(this).data('pet-portrait-name'), 'Background': $(this).data('pet-portrait-background'), '_circlerender': 'IGNORE' } });
          } else if ($(this).data('jersey-charm')) {
            cartAdditions.push({ quantity: quantity, id: variantId, properties: { 'Jersey Text': $(this).data('jersey-text'), 'Jersey Number': $(this).data('jersey-number'), '_jersey_color': $(this).data('jersey-color'), '_jersey_number_color': $(this).data('jersey-number-color'), '_jerseycharm': true } });
          } else if ($(this).data('override-text')) {
            cartAdditions.push({ quantity: quantity, id: variantId, properties: { 'LINE 1': $(this).data('line1') } });
          } else if (!$(this).data('flower-builder')) {
            cartAdditions.push({ quantity: quantity, id: variantId, properties: { 'photo': originalURL } });
          }
        });
        if (Object.keys(customVariants).length) {
          for (var i = 0; i < Object.keys(customVariants).length; i++) {
            var variantId = Object.keys(customVariants)[i];
            var customVariant = customVariants[variantId];
            for (var i2 = 0; i2 < customVariant.length; i2++) {
              var eachCustomVariant = customVariant[i2];
              if ((eachCustomVariant['LINE 1'] || eachCustomVariant['Flower 1'] || eachCustomVariant['LINE 1'] == '') && !eachCustomVariant['_override-text']) {
                let properties = JSON.parse(JSON.stringify(eachCustomVariant));
                delete properties['uuid'];
                delete properties['LINE1'];
                delete properties['engravingType'];
                delete properties['font'];
                cartAdditions.push({ quantity: 1, id: variantId, properties: properties });
              }
            }
          }
        }
        const data = {
          items: cartAdditions
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').addClass('is-added');
            ShopifyAPI.getCart(function (cart) {
              $body.trigger('afterAddToCart.ajaxCart', cart);
              $('.cart-link').trigger('click');
            });
          } else {
            if (xhr.response && xhr.status && xhr.status != 200) {
              $addToCart.prop('disabled', false);
              $addToCart.removeClass('is-adding').removeClass('is-added');

              let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
                solid: true
              });
              let message = xhr.response && JSON.parse(xhr.response).message;
              if (message && message.indexOf("'") > -1) {
                let start = message.split("'");
                let end = ' is sold out. Please remove the item.';
                message = start[0] + "'" + start[1] + "'" + end;
              }
              $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
              $('#warning-modal-close').click(function (e) {
                warningModal.close();
              });
              warningModal.open();
            }
          }
        };
      });
    } else if ($('.custom-ring-field').length) {
      // custom ring container

      // TODO fix size guide on mobile - we'll want a text size guide as well for mobile devices
      // TODO add in checkout fields

      // TODO dynamic dropdowns (awaiting notes)

      // TODO for production, change asset url base
      // TODO image overlay matches bottom of image

      // TODO ensure that size change doesn't affect any other pages using a size selector! Comment on product-form at very end of code. + create a test product for this
      if ((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))) {
        // hide size guide pdf
        // show mobile text
        // todo add mobile friendly download button

        // show #size-guide-container
        // todo hide desktop size guide
        // todo create css for mobile container
        $('#size-guide-container').show();
        $('.ring-size-guide-inner').hide();
      }

      $('body').on('click', '.add-to-cart-btn', function (e) {
        var selectedID = $("select[name='id']").val();
        e.preventDefault();
        e.stopPropagation();
        var $addToCart = $('.add-to-cart-btn');
        var $body = $(document.body);
        $addToCart.removeClass('is-added').addClass('is-adding');
        $addToCart.prop('disabled', true);

        // let's do some quick field changes to make the engraving text correct
        var engravingProperty = '';
        if (ACTIVE_SELECTED) {
          engravingProperty = 'Z-' + (SYMBOL_NAMES[ACTIVE_SELECTED] || ZODIAC_NAMES[ACTIVE_SELECTED])
        } else {
          engravingProperty = ACTIVE_FONT_PROPERTY + "-'" + $('#input-text').val() + "'"
        }

        var properties = { '_ENGRAVING': engravingProperty }

        function decodeEntities(encodedString) {
          var textArea = document.createElement('textarea');
          textArea.innerHTML = encodedString;
          return textArea.value;
        }

        if ($('#override-font-property').val()) {
          let line1 = $('#input-text').val();
          if (ACTIVE_SELECTED) {
            line1 = decodeEntities(ICON_NAMES[ACTIVE_SELECTED]);
          }
          let resultValue = '[FONT_' + ACTIVE_FONT_PROPERTY + '][LINE 1_' + line1 + ']';
          properties = { '_engraving_data': resultValue };
        }

        if (ACTIVE_SELECTED) {
          properties['Symbol'] = fetchSymbolNameOverride(ACTIVE_SELECTED.replace('.svg', '').replace('-', ' '));
        } else {
          properties['Text'] = $('#input-text').val()
        }

        var cartAdditions = [{
          quantity: 1,
          id: selectedID,
          properties: properties
        }];

        const data = {
          items: cartAdditions
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').addClass('is-added');
            ShopifyAPI.getCart(function (cart) {
              $body.trigger('afterAddToCart.ajaxCart', cart);
              $('.cart-link').trigger('click');
            });
          } else {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').removeClass('is-added');

            if (xhr.response && xhr.status && xhr.status != 200) {
              let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
                solid: true
              });
              let message = xhr.response && JSON.parse(xhr.response).message;
              if (message && message.indexOf("'") > -1) {
                let start = message.split("'");
                let end = ' is sold out. Please remove the item.';
                message = start[0] + "'" + start[1] + "'" + end;
              }
              $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
              $('#warning-modal-close').click(function (e) {
                warningModal.close();
              });
              warningModal.open();
            }
          }
        };
      });

      var FONT_MULTIPLIERS = {
        'Nickainley Normal': [2.1, 1.1],
        'Kumbh Sans': [2.2, 1.1],
        'Holland Land': [2.2, 1.1],
        'Magnum': [2.4, 1.2],
        'Dayrom': [2.2, 1.1]
      }

      if ($('#custom-ring-type').val() == 'HEART') {
        FONT_MULTIPLIERS = {
          'Nickainley Normal': [2.1, 1.1],
          'Kumbh Sans': [2.2, 1.1],
          'Holland Land': [2.2, 1.1],
          'Magnum': [2.4, 1.2],
          'Dayrom': [2.1, 1.1]
        }
      }

      function renderText() {
        var canvas = $('.ring-overlay')[0];
        var previewCanvas = $('.ring-overlay-preview')[0];
        var context = canvas.getContext('2d');
        var previewContext = previewCanvas.getContext('2d');
        var baseSize = 4;
        var singleLine = ($('#input-text').val().length == 1) ? 0 : 1;

        baseSize *= (FONT_MULTIPLIERS[ACTIVE_FONT][singleLine] || 1)
        context.textBaseline = 'middle';
        context.textAlign = 'center';

        previewContext.textBaseline = 'middle';
        previewContext.textAlign = 'center';

        context.font = baseSize + 'rem ' + ACTIVE_FONT;
        context.fillStyle = '#6f6556';
        context.clearRect(0, 0, canvas.width, canvas.height);

        previewContext.font = (baseSize * 0.75) + 'rem ' + ACTIVE_FONT;
        previewContext.fillStyle = '#6f6556';
        previewContext.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
        if (ACTIVE_SELECTED) {
          if ($('#custom-ring-type').val() == 'CIRCLE') {
            $('.ring-overlay').css('max-width', '46%');
            $('.ring-overlay').css('height', '40%');

            $('.ring-overlay-preview').css('max-width', '34.5%');
            $('.ring-overlay-preview').css('height', '30%');
          } else {
            $('.ring-overlay').css('max-width', '46%');
            $('.ring-overlay').css('height', '40%');

            $('.ring-overlay-preview').css('max-width', '34.5%');
            $('.ring-overlay-preview').css('height', '30%');
          }

          if (ACTIVE_SELECTED == 'Infinity.svg' || ACTIVE_SELECTED == 'Mountains.svg' || ACTIVE_SELECTED == 'Aquarius.svg' || ACTIVE_SELECTED == 'Libra.svg') {
            // Reduce by 25%
            if ($('#custom-ring-type').val() == 'CIRCLE') {
              $('.ring-overlay').css('max-width', '32.2%');
              $('.ring-overlay').css('height', '28%');

              $('.ring-overlay-preview').css('max-width', '24.15%');
              $('.ring-overlay-preview').css('height', '21%');
            } else {
              $('.ring-overlay').css('max-width', '32.2%');
              $('.ring-overlay').css('height', '28%');

              $('.ring-overlay-preview').css('max-width', '24.15%');
              $('.ring-overlay-preview').css('height', '21%');
            }
          } else if (ACTIVE_SELECTED == 'Cheers.svg') {
            $('.ring-overlay').css('left', '49.75%');

            $('.ring-overlay-preview').css('left', '49.75%');
          } else {
            $('.ring-overlay').css('left', '51.75%');

            $('.ring-overlay-preview').css('left', '51.4%');
          }
          var image = new Image();
          image.onload = function () {
            var maxHeight = canvas.height * 0.45;
            var maxWidth = canvas.width * 0.45;

            var maxPreviewHeight = previewCanvas.height * 0.45;
            var maxPreviewWidth = previewCanvas.width * 0.45;

            var wRatio = maxWidth / image.height;
            var hRatio = maxHeight / image.height;

            var previewWRatio = maxPreviewWidth / image.height;
            var previewHRatio = maxPreviewHeight / image.height;

            var centerShift_x = ((canvas.width - image.width * wRatio) / 2);
            var centerShift_y = (canvas.height - image.height * hRatio) / 2;

            var centerShift_previewX = ((previewCanvas.width - image.width * previewWRatio) / 2);
            var centerShift_previewY = ((previewCanvas.height - image.height * previewHRatio) / 2);

            context.drawImage(
              image,
              0,
              0,
              image.width,
              image.height,
              centerShift_x,
              centerShift_y,
              image.width * wRatio,
              image.height * hRatio
            );

            previewContext.drawImage(
              image,
              0,
              0,
              image.width,
              image.height,
              centerShift_previewX,
              centerShift_previewY,
              image.width * previewWRatio,
              image.height * previewHRatio
            );
          }
          var symbolUrl = ASSET_URL_BASE + ACTIVE_SELECTED.split('.')[0] + '-gray.svg';
          image.src = symbolUrl;
        } else if ($('#input-text').val()) {
          var indent = 0;
          if ($('#custom-ring-type').val() == 'CIRCLE') {
            if ($('#input-text').val()) {
              $('.ring-overlay').css('height', '26%');
              $('.ring-overlay').css('max-width', '55%');

              $('.ring-overlay-preview').css('height', '26%');
              $('.ring-overlay-preview').css('max-width', '55%');
            }
          } else if ($('#custom-ring-type').val() == 'HEART') {
            if ($('#input-text').val()) {
              $('.ring-overlay').css('max-width', '60%');
              $('.ring-overlay').css('height', '26%');

              $('.ring-overlay-preview').css('max-width', '60%');
              $('.ring-overlay-preview').css('height', '26%');
            }
          }
          /*if ($('#input-text').val().length == 1 && $('#input-text').val() == $('#input-text').val().toUpperCase()) {
            // only enable indents for single-character uppercase letters
            indent = 0;
          }*/
          var { actualBoundingBoxAscent, actualBoundingBoxDescent } = context.measureText($('#input-text').val());
          context.fillText($('#input-text').val(), (canvas.width / 2) + indent, canvas.height / 2 + (actualBoundingBoxAscent - actualBoundingBoxDescent) / 2);


          var { actualBoundingBoxAscent, actualBoundingBoxDescent } = previewContext.measureText($('#input-text').val());
          previewContext.fillText($('#input-text').val(), (previewCanvas.width / 2) + indent, previewCanvas.height / 2 + (actualBoundingBoxAscent - actualBoundingBoxDescent) / 2);
        }
      }

      $('#modal-add-to-cart-second').click(function () {
        $('.add-to-cart-btn').click();
      });

      $('#viewPreview').click(function () {
        var selectedID = $("select[name='id']").val();
        var revisedURL = $('#img_' + selectedID).val();
        $('#ring-preview-image').attr('src', revisedURL);
        var $upload = new theme.Modals('preview-modal', 'preview-modal', {
          solid: true
        });
        $upload.open();
      });

      $('body').on('click', '#ring-size-guide-close', function () {
        $('#ring-size-guide').hide();
        $('body').css('overflow-y', 'scroll');
      });

      $('body').on('click', '#ring-size-guide-show', function () {
        $('#ring-size-guide').show();
        $('body').css('overflow-y', 'hidden');
      });

      $('body').on('click', '.ring-size-guide', function (e) {
        if (e.target != this) return
        $('#ring-size-guide').hide();
        $('body').css('overflow-y', 'scroll');
      });

      $('body').on('click', '.ring-size-guide-inner', function (e) {
        if (e.target != this) return
        $('#ring-size-guide').hide();
        $('body').css('overflow-y', 'scroll');
      });

      $('body').on('click', '#ring-size-guide-download', function (e) {
        if (e.target != this && e.target.id != 'clickable-image') return
        window.open('https://cdn.shopify.com/s/files/1/0586/0117/7256/files/ring-size-guide.pdf', '_blank');
      });

      $('#input-text').on('change keyup paste input', (e) => {
        removeInvalidCharacters();
        if (ACTIVE_SELECTED) {
          $('.characters-remaining').text(' characters remaining');
          if (e.key == 'Backspace') {
            ACTIVE_SELECTED = null;
            $('#chosen-is-symbol').val('false');
            $('#chosen-symbol').val('');
            $('#chosen-text').val('');
            $('#input-image').hide();
            $('.symbol-selector').removeClass('active');
            $('#input-text').prop('maxlength', 3);
            $('.input-count-amount').text(3);
            $('#input-text').css('padding-left', '8px');
            $('#input-clear').css('display', 'none');
            renderText();
          } else {
            e.stopPropagation();
            e.preventDefault();
            $('#input-text').prop('maxlength', 0);
            $('.input-count-amount').text(0);
            $('#input-clear').css('display', 'flex');
            $('#chosen-text').val('');
            renderText();
          }
        } else {
          $('#chosen-text').val(e.target.value);
          $('#input-text').prop('maxlength', 3);
          if ((3 - e.target.value.length) == 1) {
            $('.characters-remaining').text(' character remaining');
          } else {
            $('.characters-remaining').text(' characters remaining');
          }
          if (e.target.value.length > 0) {
            $('#input-clear').css('display', 'flex');
          } else {
            $('#input-clear').css('display', 'none');
          }
          $('.input-count-amount').text(3 - e.target.value.length)
          renderText();
        }
      });

      $('body').on('click', '.font-button', function () {
        $('.font-button').removeClass('active');
        $(this).addClass('active');
        ACTIVE_FONT = $(this).data('font');
        ACTIVE_FONT_PROPERTY = FONT_PROPERTIES[ACTIVE_FONT];
        $('#chosen-font').val(ACTIVE_FONT_PROPERTY);
        renderText();
      });

      $('body').on('click', '.symbol-selector', function () {
        $('.symbol-selector').removeClass('active');
        $(this).addClass('active');
        ACTIVE_SELECTED = $(this).data('symbol');
        $('#chosen-is-symbol').val('true');
        $('#chosen-symbol').val(SYMBOL_NAMES[ACTIVE_SELECTED] || ZODIAC_NAMES[ACTIVE_SELECTED]);
        $('#chosen-text').val('');
        $('#input-text').val('');
        $('#input-text').prop('maxlength', 0);
        $('.input-count-amount').text(0);
        $('#input-image').show();
        $('#input-clear').css('display', 'flex');
        $('#input-text').css('padding-left', '38px');
        $('#input-image').attr('src', ASSET_URL_BASE + $(this).data('symbol'));
        renderText();
      });

      $('body').on('click', '#input-clear', function () {
        ACTIVE_SELECTED = null;
        $('#chosen-is-symbol').val('false');
        $('#chosen-symbol').val('');
        $('#chosen-text').val('');
        $('#input-image').hide();
        $('.symbol-selector').removeClass('active');
        $('#input-text').prop('maxlength', 3);
        $('.input-count-amount').text(3);
        $('#input-text').css('padding-left', '8px');
        $('#input-clear').css('display', 'none');
        $('#input-text').val('');
        $('.characters-remaining').text(' characters remaining');
        renderText();
      });

      var fontContainerHtml = '';
      for (var i = 0; i < FONT_NAMES.length; i++) {
        var eachFontName = FONT_NAMES[i];
        var nameWithoutExtension = eachFontName.split('.')[0];
        var actualFontName = toTitleCase(nameWithoutExtension.replaceAll('_', ' ')).replaceAll('Font ', '')
        var containerHtml = '<div class="ring-button font-button font-selector" data-font="' + actualFontName + '" data-name="' + nameWithoutExtension + '"><span class="font-example" style="font-family: ' + actualFontName + ';">Aa</span></div>'
        fontContainerHtml += containerHtml;
      }

      $('.font-container').html(fontContainerHtml);
      $('.ring-button[data-font="' + ACTIVE_FONT + '"]').addClass('active');

      var symbolContainerHtml = self.renderDropdownContainer('Symbols', 'symbols');
      $('.symbol-container').html(symbolContainerHtml);
      $('.tab-label[for="symbols-check"]').click();

      for (var i = 0; i < Object.keys(SYMBOL_NAMES).length; i++) {
        var fileName = Object.keys(SYMBOL_NAMES)[i];
        var symbolUrl = ASSET_URL_BASE + fileName.split('.')[0] + '-gray.svg';
        var symbolName = toTitleCase(fileName.replaceAll('-', ' ').replaceAll('_', ' ')).split('.')[0];
        var buttonHtml = '<div class="symbol-mini"><div class="ring-button symbol-selector" data-symbol="' + fileName + '" data-name="' + fileName + '"><img class="symbol-image" src="' + symbolUrl + '" /></div><div class="symbol-name">' + fetchSymbolNameOverride(symbolName) + '</div></div>';
        $('.tab-content[data-tab="symbols"]').append(buttonHtml);
      }

      var zodiacSymbolContainerHtml = self.renderDropdownContainer('Zodiac', 'zodiac-symbols');
      $('.zodiac-container').html(zodiacSymbolContainerHtml);
      for (var i = 0; i < Object.keys(ZODIAC_NAMES).length; i++) {
        var fileName = Object.keys(ZODIAC_NAMES)[i];
        var symbolUrl = ASSET_URL_BASE + fileName;
        var symbolName = toTitleCase(fileName.replaceAll('-', ' ').replaceAll('_', ' ')).split('.')[0];
        var buttonHtml = '<div class="symbol-mini"><div class="ring-button symbol-selector" data-symbol="' + fileName + '" data-name="' + fileName + '"><img class="symbol-image" src="' + symbolUrl + '" /></div><div class="symbol-name">' + fetchSymbolNameOverride(symbolName) + '</div></div>';
        $('.tab-content[data-tab="zodiac-symbols"]').append(buttonHtml);
      }
    } else if ($('.custom-ornament-field').length) {
      var ORNAMENT_TYPE = $('#ornament-type').val();

      var $ornamentConfirm = new theme.Modals('upload-confirm-modal', 'upload-confirm-modal', {
        solid: true
      });

      if ($('.engravable-new').length) {
        setInterval(handleActiveBraceletColor, 500);
      }

      var overrideSkip = false;

      $('#skip-upload-ornament').on('click', function () {
        $('button.add-to-cart').addClass('skip-upload');
        $('button.add-to-cart').click();
      });

      $('#upload-button-ornament').on('click', function () {
        $('#upload-file').click();
        forceATC = true;
        $('#upload-save').text('Upload & Add to Cart');
        var $addToCart = $('.add-to-cart-btn')
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding');
      });

      $('#upload-save').on('click', function () {
        var $addToCart = $('.add-to-cart-btn')
        $addToCart.prop('disabled', false);
        $addToCart.removeClass('is-adding');
      });

      function cloneCanvas(oldCanvas, newCanvas) {

        //create a new canvas
        var context = newCanvas.getContext('2d');

        //set dimensions
        newCanvas.width = oldCanvas.width;
        newCanvas.height = oldCanvas.height;

        //apply the old canvas to the new one
        context.drawImage(oldCanvas, 0, 0);

        //return the new canvas
        return newCanvas;
      }

      window.onresize = function () {
        renderText();
      }

      function loadPreviewSizing(ornamentType) {
        if (ornamentType == 'BIRD') {
          var previewWidth = $('#ornament-preview-body').width();
          var previewFontSizeLine1 = 0.028571428571429 * previewWidth;
          $('#ornament-text1-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text2-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text3-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text4-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
        } else if (ornamentType == 'HEART') {
          var previewWidth = $('#ornament-preview-body').width();
          var previewFontSizeLine1 = 0.029357798165138 * previewWidth;
          $('#ornament-text1-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text2-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text3-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text4-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
        } else if (ornamentType == 'PAW') {
          var previewWidth = $('#ornament-preview-body').width();
          var previewFontSizeLine1 = 0.029243697478992 * previewWidth;
          $('#ornament-text1-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text2-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text3-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text4-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
        } else if (ornamentType == 'ZODIAC') {
          var previewWidth = $('#ornament-preview-body').width();
          var previewFontSizeLine1 = 0.04436974789916 * previewWidth;
          var previewFontSizeLine2 = 0.025546218487395 * previewWidth;
          $('#ornament-text1-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text2-overlay-preview').css('font-size', previewFontSizeLine2 + 'px');
        } else if (ornamentType == 'CIRCLE_SYMBOL') {
          var previewWidth = $('#ornament-preview-body').width();
          var previewFontSizeLine1 = 0.026890756302521 * previewWidth;
          $('#ornament-text1-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text2-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
          $('#ornament-text3-overlay-preview').css('font-size', previewFontSizeLine1 + 'px');
        } else if (ornamentType == 'HEART_PHOTO_KEYCHAIN') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .15,
            explicitHeight: previewHeight * .2,
          });
        } else if (ornamentType == 'CIRCLE_CHARM') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          if (containsNonLatinCodepoints($('#ornament-text1-overlay-preview').text())) {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .2,
              explicitHeight: previewHeight * .3,
            });
          } else {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .2,
              explicitHeight: previewHeight * .3,
            });
          }
        } else if (ornamentType == 'HEART_CHARM') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .18,
            explicitHeight: previewHeight * .28,
          });
        } else if (ornamentType == 'CIRCLE_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();

          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .115,
            explicitHeight: previewHeight * .165,
          });
          TextFill('#ornament-text1-overlay', {
            explicitWidth: previewWidth * .115,
            explicitHeight: previewHeight * .165,
          });
        } else if (ornamentType == 'SQUARE_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();

          let magnumMulti = 1
          if (ACTIVE_FONT == 'Magnum') {
            magnumMulti = 1.1;
          }

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .175 * magnumMulti,
            explicitHeight: previewHeight * .225 * magnumMulti,
          });
        } else if (ornamentType == 'CIRCLE_PHOTO_KEYCHAIN') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .1,
            explicitHeight: previewHeight * .1,
          });

          TextFill('#ornament-text2-overlay-preview', {
            explicitWidth: previewWidth * .1,
            explicitHeight: previewHeight * .1,
          });

          TextFill('#ornament-text3-overlay-preview', {
            explicitWidth: previewWidth * .1,
            explicitHeight: previewHeight * .1,
          });

          TextFill('#ornament-text4-overlay-preview', {
            explicitWidth: previewWidth * .1,
            explicitHeight: previewHeight * .1,
          });
        } else if (ornamentType == 'SPIN_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();

          let linesOfText = 0;
          let activeLines = [];
          if ($('#ornament-text1-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text1-overlay-preview');
          }
          if ($('#ornament-text2-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text2-overlay-preview');
          }
          if ($('#ornament-text3-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text3-overlay-preview');
          }

          if ($('.selector-button[data-type="FRONT"]').hasClass('active')) {
            $('#ornament-symbol-overlay-preview').hide();
          }

          if (linesOfText == 1) {
            TextFill(activeLines[0], {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .20,
            });
          } else if (linesOfText == 2) {
            TextFill(activeLines[0], {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .1,
            });

            TextFill(activeLines[1], {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .1,
            });
          } else {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .065,
            });

            TextFill('#ornament-text2-overlay-preview', {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .065,
            });

            TextFill('#ornament-text3-overlay-preview', {
              explicitWidth: previewWidth * .20,
              explicitHeight: previewHeight * .065,
            });
          }

          TextFill('#ornament-symbol-overlay-preview', {
            explicitWidth: previewWidth * .20,
            explicitHeight: previewHeight * .20,
          });
        } else if (ornamentType == 'CIRCLE_QUADRANT_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .12,
            explicitHeight: previewHeight * .12,
          });

          TextFill('#ornament-text2-overlay-preview', {
            explicitWidth: previewWidth * .12,
            explicitHeight: previewHeight * .12,
          });

          TextFill('#ornament-text3-overlay-preview', {
            explicitWidth: previewWidth * .12,
            explicitHeight: previewHeight * .12,
          });

          TextFill('#ornament-text4-overlay-preview', {
            explicitWidth: previewWidth * .12,
            explicitHeight: previewHeight * .12,
          });
        } else if (ornamentType == 'BAR_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          let magnumMulti = 1
          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Holland Land') {
            magnumMulti = 1.3;
          }

          if (containsNonLatinCodepoints($('#ornament-text1-overlay-preview').text())) {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .35 * magnumMulti,
              explicitHeight: previewHeight * .05 * magnumMulti,
            });

            if ($('#ornament-type').val() == 'BAR_BRACELET' && containsNonLatinCodepoints($("#ornament-text1-overlay-preview").text())) {
              let amountInString = nonLatinCodepointsInString($("#ornament-text1-overlay-preview").text());
              let stringLength = $("#ornament-text1-overlay-preview").text().length;
              if (amountInString == stringLength) return;
              let resultTextArray = $('#ornament-text1-overlay-preview').text().split('');
              let textSize = $('#ornament-text1-overlay-preview').find('span').css('font-size').replace('px', '');
              let html = '';
              let upper = 0;
              let lower = 0;
              for (var i = 0; i < resultTextArray.length; i++) {
                if (resultTextArray[i] == resultTextArray[i].toUpperCase() && !containsNonLatinCodepoints(resultTextArray[i])) {
                  upper++;
                } else {
                  lower++;
                }
              }
              textSize = parseInt(textSize);
              for (var i = 0; i < resultTextArray.length; i++) {
                if (containsNonLatinCodepoints(resultTextArray[i])) {
                  if (upper >= 1) {
                    html += '<span style="padding-top: 0.205em; font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  } else {
                    html += '<span class="diff-padding" style="font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  }
                } else {
                  html += '<span style="font-size: ' + (textSize) + 'px">' + resultTextArray[i] + '</span>';
                }
              }
              $('#ornament-text1-overlay-preview').find('span').html(html);
            }
          } else {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .35 * magnumMulti,
              explicitHeight: previewHeight * .07 * magnumMulti,
            });
          }
        } else if (ornamentType == 'ENGRAVABLE_SNOWFLAKE_ORNAMENT') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .13,
            explicitHeight: previewHeight * .15,
          });
        } else if (ornamentType == 'HEART_BIRTHSTONE_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .15,
            explicitHeight: previewHeight * .05,
          });
        } else if (ornamentType == 'OVAL_VERTICAL_LOCKET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .10,
            explicitHeight: previewHeight * .17,
          });
        } else if (ornamentType == 'OVAL_LOCKET_RING') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .18,
            explicitHeight: previewHeight * .2,
          });
        } else if (ornamentType == 'OVAL_LOCKET_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .14,
            explicitHeight: previewHeight * .12,
          });
        } else if (ornamentType == 'HEART_LOCKET_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .13,
            explicitHeight: previewHeight * .17,
          });
        } else if (ornamentType == 'HEART_LOCKET_RING') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .17,
            explicitHeight: previewHeight * .17,
          });
        } else if (ornamentType == 'HEART_LOCKET_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .11,
            explicitHeight: previewHeight * .11,
          });
        } else if (ornamentType == 'FLIP_LOCKET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .17,
            explicitHeight: previewHeight * .11,
          });
        } else if (ornamentType == 'ENGRAVABLE_ID_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          let magnumMulti = 1
          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Holland Land') {
            magnumMulti = 1.3;
          }
          if (containsNonLatinCodepoints($('#ornament-text1-overlay-preview').text())) {
            TextFill('#ornament-text1-overlay-preview', {
              explicitWidth: previewWidth * .30 * magnumMulti,
              explicitHeight: previewHeight * .04 * magnumMulti,
            });

            if (containsNonLatinCodepoints($("#ornament-text1-overlay-preview").text())) {
              let amountInString = nonLatinCodepointsInString($("#ornament-text1-overlay-preview").text());
              let stringLength = $("#ornament-text1-overlay-preview").text().length;
              if (amountInString == stringLength) return;
              let resultTextArray = $('#ornament-text1-overlay-preview').text().split('');
              let textSize = $('#ornament-text1-overlay-preview').find('span').css('font-size').replace('px', '');
              let html = '';
              let upper = 0;
              let lower = 0;
              for (var i = 0; i < resultTextArray.length; i++) {
                if (resultTextArray[i] == resultTextArray[i].toUpperCase() && !containsNonLatinCodepoints(resultTextArray[i])) {
                  upper++;
                } else {
                  lower++;
                }
              }
              textSize = parseInt(textSize);
              for (var i = 0; i < resultTextArray.length; i++) {
                if (containsNonLatinCodepoints(resultTextArray[i])) {
                  if (upper >= 1) {
                    html += '<span style="padding-top: 0.205em; font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  } else {
                    html += '<span class="diff-padding" style="font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  }
                } else {
                  html += '<span style="font-size: ' + (textSize) + 'px">' + resultTextArray[i] + '</span>';
                }
              }
              $('#ornament-text1-overlay-preview').find('span').html(html);
            }
          }
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .30,
            explicitHeight: previewHeight * .04,
          });
        } else if (ornamentType == 'ENGRAVABLE_PENDANT_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          let magnumMulti = 1
          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Holland Land') {
            magnumMulti = 1.3;
          }

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .30,
            explicitHeight: previewHeight * .04,
          });
        } else if (ornamentType == 'PAVE_CIRCLE_ENGRAVABLE_CHARM') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          let magnumMulti = 1
          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Holland Land') {
            magnumMulti = 1.3;
          }

          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .49,
            explicitHeight: previewHeight * .35,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_TENNIS_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .45,
            explicitHeight: previewHeight * .07,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .45,
            explicitHeight: previewHeight * .06,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .35,
            explicitHeight: previewHeight * .05,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .35,
            explicitHeight: previewHeight * .06,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .50,
            explicitHeight: previewHeight * .04,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_PHOTO_BOOKMARK') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .50,
            explicitHeight: previewHeight * .04,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_RING') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .50,
            explicitHeight: previewHeight * .1,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_LOCKET_KEYCHAIN') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .50,
            explicitHeight: previewHeight * .1,
          });
        } else if (ORNAMENT_TYPE == 'CIRCLE_PHOTO_SQUARE_KEYCHAIN') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .15,
            explicitHeight: previewHeight * .2,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE') {
          let previewWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewWidth * .1,
            explicitHeight: previewHeight * .15,
          });
        }
      }
      let engravingUploadModal;
      if ($('#engraving-upload-modal').length) {
        engravingUploadModal = new theme.Modals('engraving-upload-modal', 'engraving-upload-modal', {
          solid: true
        });
      }

      let FONT_OVERRIDES = ORNAMENT_FONT_NAMES;
      if (FONTS_BY_TAG[ORNAMENT_TYPE]) {
        FONT_OVERRIDES = FONTS_BY_TAG[ORNAMENT_TYPE];
      }

      function renderText() {
        loadPreviewSizing(ORNAMENT_TYPE)

        if (ORNAMENT_TYPE == "ZODIAC") {
          ACTIVE_FONT = 'Grafolita';
          ACTIVE_FONT_PROPERTY = 'F6';

          var width = $('#ornament-text1-overlay').parent().width();

          var fontSizeLine1 = 0.04436974789916 * width;
          var fontSizeLine2 = 0.025546218487395 * width;

          var canvasWidth = $('.ornament-engraving-overlay')[0].width;
          $('.ornament-engraving-overlay').css('top', '35%');
          $('.ornament-engraving-overlay').css('max-height', '30%');
          $('.ornament-engraving-overlay').css('width', '65%');
          $('.ornament-engraving-overlay').css('left', '34%');

          $('#ornament-text1-overlay').css('top', '51%');
          $('#ornament-text1-overlay').css('width', '45%');
          $('#ornament-text1-overlay').css('max-width', '45%');
          $('#ornament-text1-overlay').css('height', 'auto');
          $('#ornament-text1-overlay').css('left', '34%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');
          $('#ornament-text1-overlay').css('letter-spacing', '0.1em');

          $('#ornament-text2-overlay').css('top', '55%');
          $('#ornament-text2-overlay').css('width', '35%');
          $('#ornament-text2-overlay').css('max-width', '85%');
          $('#ornament-text2-overlay').css('height', 'auto');
          $('#ornament-text2-overlay').css('left', '34%');
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-size', fontSizeLine2 + 'px');
          $('#ornament-text2-overlay').css('letter-spacing', '0.1em');

          $('#ornament-engraving-overlay-preview').css('top', '35%');
          $('#ornament-engraving-overlay-preview').css('max-height', '30%');
          $('#ornament-engraving-overlay-preview').css('width', '65%');
          $('#ornament-engraving-overlay-preview').css('left', '34%');

          $('#ornament-text1-overlay-preview').css('top', '51%');
          $('#ornament-text1-overlay-preview').css('width', '45%');
          $('#ornament-text1-overlay-preview').css('max-width', '45%');
          $('#ornament-text1-overlay-preview').css('height', 'auto');
          $('#ornament-text1-overlay-preview').css('left', '34%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('letter-spacing', '0.1em');

          $('#ornament-text2-overlay-preview').css('top', '55%');
          $('#ornament-text2-overlay-preview').css('width', '35%');
          $('#ornament-text2-overlay-preview').css('max-width', '85%');
          $('#ornament-text2-overlay-preview').css('height', 'auto');
          $('#ornament-text2-overlay-preview').css('left', '34%');
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay-preview').css('letter-spacing', '0.1em');
        } else if (ORNAMENT_TYPE == "BIRD") {
          ACTIVE_FONT = 'Dayrom';
          ACTIVE_FONT_PROPERTY = 'F3';

          var width = $('#ornament-text1-overlay').parent().width();
          var fontSizeLine1 = 0.028571428571429 * width;

          $('#ornament-text1-overlay').css('top', '37%');
          $('#ornament-text1-overlay').css('letter-spacing', -0.1);
          $('#ornament-text1-overlay').css('width', '32.5%');
          $('#ornament-text1-overlay').css('max-width', '50%');
          $('#ornament-text1-overlay').css('height', 'auto');
          $('#ornament-text1-overlay').css('left', '46%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text2-overlay').css('top', '41%');
          $('#ornament-text2-overlay').css('letter-spacing', -0.1);
          $('#ornament-text2-overlay').css('width', '32.5%');
          $('#ornament-text2-overlay').css('max-width', '50%');
          $('#ornament-text2-overlay').css('height', 'auto');
          $('#ornament-text2-overlay').css('left', '46%');
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text3-overlay').css('top', '45%');
          $('#ornament-text3-overlay').css('letter-spacing', -0.1);
          $('#ornament-text3-overlay').css('width', '32.5%');
          $('#ornament-text3-overlay').css('max-width', '50%');
          $('#ornament-text3-overlay').css('height', 'auto');
          $('#ornament-text3-overlay').css('left', '46%');
          $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text1-overlay-preview').css('top', '37%');
          $('#ornament-text1-overlay-preview').css('letter-spacing', -0.1);
          $('#ornament-text1-overlay-preview').css('width', '32.5%');
          $('#ornament-text1-overlay-preview').css('max-width', '50%');
          $('#ornament-text1-overlay-preview').css('height', 'auto');
          $('#ornament-text1-overlay-preview').css('left', '46%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text2-overlay-preview').css('top', '41%');
          $('#ornament-text2-overlay-preview').css('letter-spacing', -0.1);
          $('#ornament-text2-overlay-preview').css('width', '32.5%');
          $('#ornament-text2-overlay-preview').css('max-width', '50%');
          $('#ornament-text2-overlay-preview').css('height', 'auto');
          $('#ornament-text2-overlay-preview').css('left', '46%');
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text3-overlay-preview').css('top', '45%');
          $('#ornament-text3-overlay-preview').css('letter-spacing', -0.1);
          $('#ornament-text3-overlay-preview').css('width', '32.5%');
          $('#ornament-text3-overlay-preview').css('max-width', '50%');
          $('#ornament-text3-overlay-preview').css('height', 'auto');
          $('#ornament-text3-overlay-preview').css('left', '46%');
          $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);

        } else if (ORNAMENT_TYPE == "CIRCLE_SYMBOL") {
          ACTIVE_FONT = 'Dayrom';
          ACTIVE_FONT_PROPERTY = 'F3';
          $('.ornament-engraving-overlay').css('top', '36%');
          $('.ornament-engraving-overlay').css('height', '20%');
          $('.ornament-engraving-overlay').css('max-width', '20%');
          $('.ornament-engraving-overlay').css('left', '34%');

          $('#ornament-engraving-overlay-preview').css('top', '36%');
          $('#ornament-engraving-overlay-preview').css('height', '20%');
          $('#ornament-engraving-overlay-preview').css('max-width', '20%');
          $('#ornament-engraving-overlay-preview').css('left', '34%');

          var width = $('#ornament-text1-overlay').parent().width();
          var fontSizeLine1 = 0.026890756302521 * width;

          $('#ornament-text1-overlay').css('top', '49%');
          $('#ornament-text1-overlay').css('left', '34%');
          $('#ornament-text1-overlay').css('width', '50%');
          $('#ornament-text1-overlay').css('max-width', '85%');
          $('#ornament-text1-overlay').css('height', 'auto');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text2-overlay').css('top', '56%');
          $('#ornament-text2-overlay').css('left', '34%');
          $('#ornament-text2-overlay').css('width', '45%');
          $('#ornament-text2-overlay').css('max-width', '85%');
          $('#ornament-text2-overlay').css('height', 'auto');
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text3-overlay').css('top', '63%');
          $('#ornament-text3-overlay').css('left', '34%');
          $('#ornament-text3-overlay').css('width', '30%');
          $('#ornament-text3-overlay').css('max-width', '85%');
          $('#ornament-text3-overlay').css('height', 'auto');
          $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text1-overlay-preview').css('top', '49%');
          $('#ornament-text1-overlay-preview').css('left', '34%');
          $('#ornament-text1-overlay-preview').css('width', '50%');
          $('#ornament-text1-overlay-preview').css('max-width', '85%');
          $('#ornament-text1-overlay-preview').css('height', 'auto');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text2-overlay-preview').css('top', '56%');
          $('#ornament-text2-overlay-preview').css('left', '34%');
          $('#ornament-text2-overlay-preview').css('width', '45%');
          $('#ornament-text2-overlay-preview').css('max-width', '85%');
          $('#ornament-text2-overlay-preview').css('height', 'auto');
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text3-overlay-preview').css('top', '63%');
          $('#ornament-text3-overlay-preview').css('left', '34%');
          $('#ornament-text3-overlay-preview').css('width', '30%');
          $('#ornament-text3-overlay-preview').css('max-width', '85%');
          $('#ornament-text3-overlay-preview').css('height', 'auto');
          $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);
        } else if (ORNAMENT_TYPE == "HEART") {
          ACTIVE_FONT = 'Kumbh Sans';
          ACTIVE_FONT_PROPERTY = 'F2';

          var canvasWidth = $('.ornament-engraving-overlay')[0].width;
          $('.ornament-engraving-overlay').css('top', '32%');
          $('.ornament-engraving-overlay').css('max-height', '30%');
          $('.ornament-engraving-overlay').css('width', canvasWidth * 0.65);

          var width = $('#ornament-text1-overlay').parent().width();
          var fontSizeLine1 = 0.029357798165138 * width;

          $('#ornament-text1-overlay').css('top', '35%');
          $('#ornament-text1-overlay').css('left', '34%');
          $('#ornament-text1-overlay').css('max-width', '85%');
          $('#ornament-text1-overlay').css('height', 'auto');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text2-overlay').css('top', '40%');
          $('#ornament-text2-overlay').css('left', '34%');
          $('#ornament-text2-overlay').css('max-width', '85%');
          $('#ornament-text2-overlay').css('height', 'auto');
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text3-overlay').css('top', '45%');
          $('#ornament-text3-overlay').css('left', '34%');
          $('#ornament-text3-overlay').css('max-width', '85%');
          $('#ornament-text3-overlay').css('height', 'auto');
          $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text4-overlay').css('top', '50%');
          $('#ornament-text4-overlay').css('left', '34%');
          $('#ornament-text4-overlay').css('max-width', '85%');
          $('#ornament-text4-overlay').css('height', 'auto');
          $('#ornament-text4-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text4-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text1-overlay-preview').css('top', '35%');
          $('#ornament-text1-overlay-preview').css('left', '34%');
          $('#ornament-text1-overlay-preview').css('max-width', '85%');
          $('#ornament-text1-overlay-preview').css('height', 'auto');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text2-overlay-preview').css('top', '40%');
          $('#ornament-text2-overlay-preview').css('left', '34%');
          $('#ornament-text2-overlay-preview').css('max-width', '85%');
          $('#ornament-text2-overlay-preview').css('height', 'auto');
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text3-overlay-preview').css('top', '45%');
          $('#ornament-text3-overlay-preview').css('left', '34%');
          $('#ornament-text3-overlay-preview').css('max-width', '85%');
          $('#ornament-text3-overlay-preview').css('height', 'auto');
          $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text4-overlay-preview').css('top', '50%');
          $('#ornament-text4-overlay-preview').css('left', '34%');
          $('#ornament-text4-overlay-preview').css('max-width', '85%');
          $('#ornament-text4-overlay-preview').css('height', 'auto');
          $('#ornament-text4-overlay-preview').css('font-family', ACTIVE_FONT);
        } else if (ORNAMENT_TYPE == "PAW") {
          ACTIVE_FONT = 'Kumbh Sans';
          ACTIVE_FONT_PROPERTY = 'F2';
          var canvasWidth = $('.ornament-engraving-overlay')[0].width;
          $('.ornament-engraving-overlay').css('top', '32%');
          $('.ornament-engraving-overlay').css('left', '34%');
          $('.ornament-engraving-overlay').css('max-height', '30%');
          $('.ornament-engraving-overlay').css('width', canvasWidth * 0.65);

          var width = $('#ornament-text1-overlay').parent().width();
          var fontSizeLine1 = 0.029243697478992 * width;

          $('#ornament-text1-overlay').css('top', '58%');
          $('#ornament-text1-overlay').css('left', '34%');
          $('#ornament-text1-overlay').css('max-height', '30%');
          $('#ornament-text1-overlay').css('max-width', '40%');
          $('#ornament-text1-overlay').css('height', 'auto');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text2-overlay').css('top', '62%');
          $('#ornament-text2-overlay').css('left', '34%');
          $('#ornament-text2-overlay').css('max-height', '30%');
          $('#ornament-text2-overlay').css('max-width', '40%');
          $('#ornament-text2-overlay').css('height', 'auto');
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-size', fontSizeLine1 + 'px');

          $('#ornament-text1-overlay-preview').css('top', '58%');
          $('#ornament-text1-overlay-preview').css('left', '34%');
          $('#ornament-text1-overlay-preview').css('max-height', '30%');
          $('#ornament-text1-overlay-preview').css('max-width', '40%');
          $('#ornament-text1-overlay-preview').css('height', 'auto');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text2-overlay-preview').css('top', '62%');
          $('#ornament-text2-overlay-preview').css('left', '34%');
          $('#ornament-text2-overlay-preview').css('max-height', '30%');
          $('#ornament-text2-overlay-preview').css('max-width', '40%');
          $('#ornament-text2-overlay-preview').css('height', 'auto');
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);
        } else if (ORNAMENT_TYPE == "CIRCLE_CENTER_CUTOUT") {
          ACTIVE_FONT = 'Dayrom';
          ACTIVE_FONT_PROPERTY = 'F3';

          $('.ornament-engraving-overlay').css('max-height', '100%');
          $('.ornament-engraving-overlay').css('height', '70%');
          $('.ornament-engraving-overlay').css('width', '30%');

          $('#ornament-circle-text-overlay').css('max-height', '100%');
          $('#ornament-circle-text-overlay').css('height', '60%');
          $('#ornament-circle-text-overlay').css('width', '60%');
          $('#ornament-circle-text-overlay').css('top', '29%');
          $('#ornament-circle-text-overlay').css('left', '4%');

          $('#ornament-circle-text-overlay-2').css('max-height', '100%');
          $('#ornament-circle-text-overlay-2').css('height', '60%');
          $('#ornament-circle-text-overlay-2').css('width', '60%');
          $('#ornament-circle-text-overlay-2').css('top', '27%');
          $('#ornament-circle-text-overlay-2').css('left', '4%');

          $('#ornament-circle-text-overlay-preview').css('max-height', '100%');
          $('#ornament-circle-text-overlay-preview').css('height', '60%');
          $('#ornament-circle-text-overlay-preview').css('width', '60%');
          $('#ornament-circle-text-overlay-preview').css('top', '29%');
          $('#ornament-circle-text-overlay-preview').css('left', '4%');

          $('#ornament-circle-text-overlay-2-preview').css('max-height', '100%');
          $('#ornament-circle-text-overlay-2-preview').css('height', '60%');
          $('#ornament-circle-text-overlay-2-preview').css('width', '60%');
          $('#ornament-circle-text-overlay-2-preview').css('top', '27%');
          $('#ornament-circle-text-overlay-2-preview').css('left', '4%');
        } else if (ORNAMENT_TYPE == "CIRCLE_HEART_CUTOUT") {
          ACTIVE_FONT = 'Dayrom';
          ACTIVE_FONT_PROPERTY = 'F1';

          $('.ornament-engraving-overlay').css('max-height', '100%');
          $('.ornament-engraving-overlay').css('height', '70%');
          $('.ornament-engraving-overlay').css('width', '30%');

          $('#ornament-circle-text-overlay').css('max-height', '100%');
          $('#ornament-circle-text-overlay').css('height', '35%');
          $('#ornament-circle-text-overlay').css('width', '35%');
          $('#ornament-circle-text-overlay').css('top', '37%');
          $('#ornament-circle-text-overlay').css('left', '17%');

          $('#ornament-circle-text-overlay-2').css('max-height', '100%');
          $('#ornament-circle-text-overlay-2').css('height', '35%');
          $('#ornament-circle-text-overlay-2').css('width', '35%');
          $('#ornament-circle-text-overlay-2').css('top', '39%');
          $('#ornament-circle-text-overlay-2').css('left', '17%');

          $('#ornament-circle-text-overlay-preview').css('max-height', '100%');
          $('#ornament-circle-text-overlay-preview').css('height', '35%');
          $('#ornament-circle-text-overlay-preview').css('width', '35%');
          $('#ornament-circle-text-overlay-preview').css('top', '37%');
          $('#ornament-circle-text-overlay-preview').css('left', '17%');

          $('#ornament-circle-text-overlay-2-preview').css('max-height', '100%');
          $('#ornament-circle-text-overlay-2-preview').css('height', '35%');
          $('#ornament-circle-text-overlay-2-preview').css('width', '35%');
          $('#ornament-circle-text-overlay-2-preview').css('top', '39%');
          $('#ornament-circle-text-overlay-2-preview').css('left', '17%');
        } else if (ORNAMENT_TYPE == "CRESCENT_STAR") {
          ACTIVE_FONT = 'Grafolita';
          ACTIVE_FONT_PROPERTY = 'F6';
          $('.ornament-engraving-overlay').css('max-height', '100%');
          $('.ornament-engraving-overlay').css('height', '70%');
          $('.ornament-engraving-overlay').css('width', '30%');
          $('.ornament-engraving-overlay').css('left', '34%');
          $('#ornament-circle-text-overlay').css('max-height', '100%');
          $('#ornament-circle-text-overlay').css('height', '66%');
          $('#ornament-circle-text-overlay').css('width', '70%');
          $('#ornament-circle-text-overlay').css('left', '8%');
          $('#ornament-circle-text-overlay').css('top', '19%');
          $('#ornament-circle-text-overlay-preview').css('max-height', '100%');
          $('#ornament-circle-text-overlay-preview').css('height', '66%');
          $('#ornament-circle-text-overlay-preview').css('width', '70%');
          $('#ornament-circle-text-overlay-preview').css('left', '8%');
          $('#ornament-circle-text-overlay-preview').css('top', '19%');
        } else if (ORNAMENT_TYPE == "HEART_PHOTO_KEYCHAIN") {
          if (!ACTIVE_FONT || ACTIVE_FONT == 'Dayrom') {
            ACTIVE_FONT = 'Alga';
            ACTIVE_FONT_PROPERTY = 'F8';
            $('.font-button[data-font="' + ACTIVE_FONT + '"]').click();
          }

          // let's predefine input containers

          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();
          var fontSizeLine1 = 0.079510703363914 * width;

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '10.33%');
          $('#ornament-text1-overlay').css('width', '14.66%');
          $('#ornament-text1-overlay').css('left', '12.5%');
          $('#ornament-text1-overlay').css('top', '73%');
          $('#ornament-text1-overlay').css('rotate', '22.78deg');

          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .15,
            explicitHeight: height * .2,
          });

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '10.33%');
          $('#ornament-text1-overlay-preview').css('width', '14.66%');
          $('#ornament-text1-overlay-preview').css('left', '12.5%');
          $('#ornament-text1-overlay-preview').css('top', '73%');
          $('#ornament-text1-overlay-preview').css('rotate', '22.78deg');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay span').removeClass('text-only');
            $('#ornament-text1-overlay span').addClass('symbol-only');

            $('#ornament-text1-overlay-preview span').removeClass('text-only');
            $('#ornament-text1-overlay-preview span').addClass('symbol-only');
          } else {
            $('#ornament-text1-overlay span').removeClass('symbol-only');
            $('#ornament-text1-overlay span').addClass('text-only');

            $('#ornament-text1-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text1-overlay-preview span').addClass('text-only');
          }

          if (checkMostlyUppercase($('#ornament-text1-overlay').text())) {
            if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley') {
              $('#ornament-text1-overlay span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay span').removeClass('extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
            } else {
              $('#ornament-text1-overlay span').addClass('extra-padding');
              $('#ornament-text1-overlay span').removeClass('multi-extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
            }
          } else {
            $('#ornament-text1-overlay span').removeClass('extra-padding');
            $('#ornament-text1-overlay span').removeClass('multi-extra-padding');

            $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
          }
        } else if (ORNAMENT_TYPE == 'SPIN_NECKLACE') {
          if (!ACTIVE_FONT || ACTIVE_FONT == 'Dayrom') {
            ACTIVE_FONT = 'Alga';
            ACTIVE_FONT_PROPERTY = 'F8';
            $('.font-button[data-font="' + ACTIVE_FONT + '"]').click();
          }
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();
          var fontSizeLine1 = 0.040076923076923 * width;

          let linesOfText = 0;
          let activeLines = [];
          if ($('#ornament-text1-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text1-overlay');
          }
          if ($('#ornament-text2-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text2-overlay');
          }
          if ($('#ornament-text3-overlay').text().length > 0) {
            linesOfText++;
            activeLines.push('#ornament-text3-overlay');
          }

          if (linesOfText == 1) {
            // merge center line into real center / larger dimensions
            TextFill(activeLines[0], {
              explicitWidth: width * .2,
              explicitHeight: height * .2,
            });

            $(activeLines[0]).css('height', '20%');
            $(activeLines[0]).css('width', '20%');
            $(activeLines[0]).css('left', '50.8%');
            $(activeLines[0]).css('top', '70%');
            $(activeLines[0]).css('font-family', ACTIVE_FONT);

            $(activeLines[0] + '-preview').css('height', '20%');
            $(activeLines[0] + '-preview').css('width', '20%');
            $(activeLines[0] + '-preview').css('left', '50.8%');
            $(activeLines[0] + '-preview').css('top', '70%');
            $(activeLines[0] + '-preview').css('font-family', ACTIVE_FONT);
          } else if (linesOfText == 2) {
            TextFill(activeLines[0], {
              explicitWidth: width * .2,
              explicitHeight: height * .1,
            });

            TextFill(activeLines[1], {
              explicitWidth: width * .2,
              explicitHeight: height * .1,
            });

            $(activeLines[0]).css('height', '10%');
            $(activeLines[0]).css('width', '20%');
            $(activeLines[0]).css('left', '50.8%');
            $(activeLines[0]).css('top', '66%');
            $(activeLines[0]).css('font-family', ACTIVE_FONT);

            $(activeLines[1]).css('max-height', '100%');
            $(activeLines[1]).css('height', '10%');
            $(activeLines[1]).css('width', '15%');
            $(activeLines[1]).css('left', '50.8%');
            $(activeLines[1]).css('top', '73%');
            $(activeLines[1]).css('font-family', ACTIVE_FONT);

            $(activeLines[0] + '-preview').css('height', '10%');
            $(activeLines[0] + '-preview').css('width', '20%');
            $(activeLines[0] + '-preview').css('left', '50.8%');
            $(activeLines[0] + '-preview').css('top', '66%');
            $(activeLines[0] + '-preview').css('font-family', ACTIVE_FONT);

            $(activeLines[1] + '-preview').css('max-height', '100%');
            $(activeLines[1] + '-preview').css('height', '10%');
            $(activeLines[1] + '-preview').css('width', '15%');
            $(activeLines[1] + '-preview').css('left', '50.8%');
            $(activeLines[1] + '-preview').css('top', '73%');
            $(activeLines[1] + '-preview').css('font-family', ACTIVE_FONT);

          } else {
            TextFill('#ornament-text1-overlay', {
              explicitWidth: width * .2,
              explicitHeight: height * .065,
            });

            TextFill('#ornament-text2-overlay', {
              explicitWidth: width * .2,
              explicitHeight: height * .065,
            });

            TextFill('#ornament-text3-overlay', {
              explicitWidth: width * .2,
              explicitHeight: height * .065,
            });
            // default case
            $('#ornament-text1-overlay').css('height', '6.5%');
            $('#ornament-text1-overlay').css('width', '20%');
            $('#ornament-text1-overlay').css('left', '50.8%');
            $('#ornament-text1-overlay').css('top', '64%');
            $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

            $('#ornament-text2-overlay').css('max-height', '100%');
            $('#ornament-text2-overlay').css('height', '6.5%');
            $('#ornament-text2-overlay').css('width', '15%');
            $('#ornament-text2-overlay').css('left', '50.8%');
            $('#ornament-text2-overlay').css('top', '70.5%');
            $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);

            $('#ornament-text3-overlay').css('max-height', '100%');
            $('#ornament-text3-overlay').css('height', '6.5%');
            $('#ornament-text3-overlay').css('width', '15%');
            $('#ornament-text3-overlay').css('left', '50.8%');
            $('#ornament-text3-overlay').css('top', '77%');
            $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);

            $('#ornament-text1-overlay-preview').css('height', '6.5%');
            $('#ornament-text1-overlay-preview').css('width', '20%');
            $('#ornament-text1-overlay-preview').css('left', '50.8%');
            $('#ornament-text1-overlay-preview').css('top', '64%');
            $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

            $('#ornament-text2-overlay-preview').css('max-height', '100%');
            $('#ornament-text2-overlay-preview').css('height', '6.5%');
            $('#ornament-text2-overlay-preview').css('width', '15%');
            $('#ornament-text2-overlay-preview').css('left', '50.8%');
            $('#ornament-text2-overlay-preview').css('top', '70.5%');
            $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);

            $('#ornament-symbol-overlay-preview').css('max-height', '100%');
            $('#ornament-symbol-overlay-preview').css('height', '20%');
            $('#ornament-symbol-overlay-preview').css('width', '20%');
            $('#ornament-symbol-overlay-preview').css('left', '50.8%');
            $('#ornament-symbol-overlay-preview').css('top', '70.5%');
            $('#ornament-symbol-overlay-preview').css('font-family', ACTIVE_FONT);

            $('#ornament-text3-overlay-preview').css('max-height', '100%');
            $('#ornament-text3-overlay-preview').css('height', '6.5%');
            $('#ornament-text3-overlay-preview').css('width', '15%');
            $('#ornament-text3-overlay-preview').css('left', '50.8%');
            $('#ornament-text3-overlay-preview').css('top', '77%');
            $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);
          }
        } else if (ORNAMENT_TYPE == 'SQUARE_NECKLACE') {
          if (!ACTIVE_FONT || ACTIVE_FONT == 'Dayrom') {
            ACTIVE_FONT = 'Alga';
            ACTIVE_FONT_PROPERTY = 'F8';
            $('.font-button[data-font="' + ACTIVE_FONT + '"]').click();
          }
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();
          let magnumMulti = 1;
          if (ACTIVE_FONT == 'Magnum') {
            magnumMulti = 1.1;
          }

          TextFill('.preview-text', {
            explicitWidth: width * .175 * magnumMulti,
            explicitHeight: height * .225 * magnumMulti
          });

          //$('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '20%');
          $('#ornament-text1-overlay').css('width', '15%');
          $('#ornament-text1-overlay').css('left', '49.5%');
          $('#ornament-text1-overlay').css('top', '73.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          // $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          //$('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '20%');
          $('#ornament-text1-overlay-preview').css('width', '15%');
          $('#ornament-text1-overlay-preview').css('left', '49.5%');
          $('#ornament-text1-overlay-preview').css('top', '73.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          //  $('#ornament-text1-overlay-preview').css('font-size', fontSizeLine1 + 'px');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay span').removeClass('text-only');
            $('#ornament-text1-overlay span').addClass('symbol-only');

            $('#ornament-text1-overlay-preview span').removeClass('text-only');
            $('#ornament-text1-overlay-preview span').addClass('symbol-only');
          } else {
            $('#ornament-text1-overlay span').removeClass('symbol-only');
            $('#ornament-text1-overlay span').addClass('text-only');

            $('#ornament-text1-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text1-overlay-preview span').addClass('text-only');
          }

          if (checkMostlyUppercase($('#ornament-text1-overlay').text())) {
            if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley') {
              $('#ornament-text1-overlay span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay span').removeClass('extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
            } else {
              $('#ornament-text1-overlay span').addClass('extra-padding');
              $('#ornament-text1-overlay span').removeClass('multi-extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
            }
          } else {
            $('#ornament-text1-overlay span').removeClass('extra-padding');
            $('#ornament-text1-overlay span').removeClass('multi-extra-padding');

            $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
          }
        } else if (ORNAMENT_TYPE == 'CIRCLE_QUADRANT_NECKLACE') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '12%'); // 4.5
          $('#ornament-text1-overlay').css('width', '12%');
          $('#ornament-text1-overlay').css('left', '48.5%');
          $('#ornament-text1-overlay').css('top', '66%');

          $('#ornament-text2-overlay').css('max-height', '100%');
          $('#ornament-text2-overlay').css('height', '12%'); // 4.5
          $('#ornament-text2-overlay').css('width', '12%');
          $('#ornament-text2-overlay').css('left', '59%');
          $('#ornament-text2-overlay').css('top', '76%');

          $('#ornament-text3-overlay').css('max-height', '100%');
          $('#ornament-text3-overlay').css('height', '12%'); // 4.5
          $('#ornament-text3-overlay').css('width', '12%');
          $('#ornament-text3-overlay').css('left', '48%');
          $('#ornament-text3-overlay').css('top', '85.5%');

          $('#ornament-text4-overlay').css('max-height', '100%');
          $('#ornament-text4-overlay').css('height', '12%'); // 4.5
          $('#ornament-text4-overlay').css('width', '12%');
          $('#ornament-text4-overlay').css('left', '38%');
          $('#ornament-text4-overlay').css('top', '76%');

          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text4-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text4-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '12%'); // 4.5
          $('#ornament-text1-overlay-preview').css('width', '12%');
          $('#ornament-text1-overlay-preview').css('left', '48.5%');
          $('#ornament-text1-overlay-preview').css('top', '66%');

          $('#ornament-text2-overlay-preview').css('max-height', '100%');
          $('#ornament-text2-overlay-preview').css('height', '12%'); // 4.5
          $('#ornament-text2-overlay-preview').css('width', '12%');
          $('#ornament-text2-overlay-preview').css('left', '59%');
          $('#ornament-text2-overlay-preview').css('top', '76%');

          $('#ornament-text3-overlay-preview').css('max-height', '100%');
          $('#ornament-text3-overlay-preview').css('height', '12%'); // 4.5
          $('#ornament-text3-overlay-preview').css('width', '12%');
          $('#ornament-text3-overlay-preview').css('left', '48%');
          $('#ornament-text3-overlay-preview').css('top', '85.5%');

          $('#ornament-text4-overlay-preview').css('max-height', '100%');
          $('#ornament-text4-overlay-preview').css('height', '12%'); // 4.5
          $('#ornament-text4-overlay-preview').css('width', '12%');
          $('#ornament-text4-overlay-preview').css('left', '38%');
          $('#ornament-text4-overlay-preview').css('top', '76%');

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .12,
            explicitHeight: height * .12,
          });

          TextFill('#ornament-text2-overlay', {
            explicitWidth: width * .12,
            explicitHeight: height * .12,
          });

          TextFill('#ornament-text3-overlay', {
            explicitWidth: width * .12,
            explicitHeight: height * .12,
          });

          TextFill('#ornament-text4-overlay', {
            explicitWidth: width * .12,
            explicitHeight: height * .12,
          });
        } else if (ORNAMENT_TYPE == 'CIRCLE_CHARM') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '15%');
          $('#ornament-text1-overlay').css('width', '14.66%');
          $('#ornament-text1-overlay').css('left', '48.5%');
          $('#ornament-text1-overlay').css('top', '57.25%');

          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          let magnumMulti = 1;
          if (ACTIVE_FONT == 'Magnum') {
            magnumMulti = 1.1;
          }

          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '15%');
          $('#ornament-text1-overlay-preview').css('width', '14.66%');
          $('#ornament-text1-overlay-preview').css('left', '48.5%');
          $('#ornament-text1-overlay-preview').css('top', '57.25%');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '59.5%');
            $('#ornament-text1-overlay-preview').css('top', '59.5%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .2 * magnumMulti,
            explicitHeight: height * .3 * magnumMulti,
          });

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '60%');
            $('#ornament-text1-overlay-preview').css('top', '60%');

            if (!checkMostlyUppercase($('#ornament-text1-overlay').text())) {
              $('#ornament-text1-overlay').css('top', '58.5%');
              $('#ornament-text1-overlay-preview').css('top', '58.5%');
            }
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '60.5%');
            $('#ornament-text1-overlay-preview').css('top', '60.5%');

            if (!checkMostlyUppercase($('#ornament-text1-overlay').text())) {
              $('#ornament-text1-overlay').css('top', '59.5%');
              $('#ornament-text1-overlay-preview').css('top', '59.5%');
            }
          }
        } else if (ORNAMENT_TYPE == 'HEART_CHARM') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();
          var fontSizeLine1 = 0.061962134251291 * width;

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '15%');
          $('#ornament-text1-overlay').css('width', '14.66%');
          $('#ornament-text1-overlay').css('left', '49.15%');
          $('#ornament-text1-overlay').css('top', '58%');

          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('font-size', fontSizeLine1 + 'px');

          let magnumMulti = 1;
          if (ACTIVE_FONT == 'Magnum') {
            magnumMulti = 1.1;
          }

          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '15%');
          $('#ornament-text1-overlay-preview').css('width', '14.66%');
          $('#ornament-text1-overlay-preview').css('left', '49.15%');
          $('#ornament-text1-overlay-preview').css('top', '58%');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '60%');
            $('#ornament-text1-overlay-preview').css('top', '60%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .18 * magnumMulti,
            explicitHeight: height * .28 * magnumMulti,
          });

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '61%');
            $('#ornament-text1-overlay-preview').css('top', '61%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '60%');
            $('#ornament-text1-overlay-preview').css('top', '60%');
          }
        } else if (ORNAMENT_TYPE == 'CIRCLE_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '10.2%'); // 4.5
          $('#ornament-text1-overlay').css('width', '12%');
          $('#ornament-text1-overlay').css('left', '48.5%');
          $('#ornament-text1-overlay').css('top', '82.4%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '10.2%'); // 4.5
          $('#ornament-text1-overlay-preview').css('width', '12%');
          $('#ornament-text1-overlay-preview').css('left', '48.5%');
          $('#ornament-text1-overlay-preview').css('top', '82.4%');

          TextFill('.preview-text', {
            explicitWidth: width * .115,
            explicitHeight: height * .165,
          });

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay span').removeClass('text-only');
            $('#ornament-text1-overlay span').addClass('symbol-only');

            $('#ornament-text1-overlay-preview span').removeClass('text-only');
            $('#ornament-text1-overlay-preview span').addClass('symbol-only');
          } else {
            $('#ornament-text1-overlay span').removeClass('symbol-only');
            $('#ornament-text1-overlay span').addClass('text-only');

            $('#ornament-text1-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text1-overlay-preview span').addClass('text-only');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '84.2%');
            $('#ornament-text1-overlay-preview').css('top', '84.2%');

            if (!checkMostlyUppercase($('#ornament-text1-overlay').text())) {
              $('#ornament-text1-overlay').css('top', '82.5%');
              $('#ornament-text1-overlay-preview').css('top', '82.5%');
            }
          }
        } else if (ORNAMENT_TYPE == 'CIRCLE_PHOTO_KEYCHAIN') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '10%'); // 4.5
          $('#ornament-text1-overlay').css('width', '10%');
          $('#ornament-text1-overlay').css('left', '19%');
          $('#ornament-text1-overlay').css('top', '69%');
          $('#ornament-text1-overlay').css('rotate', '11deg');

          $('#ornament-text2-overlay').css('max-height', '100%');
          $('#ornament-text2-overlay').css('height', '10%'); // 4.5
          $('#ornament-text2-overlay').css('width', '10%');
          $('#ornament-text2-overlay').css('left', '25%');
          $('#ornament-text2-overlay').css('top', '80.3%');
          $('#ornament-text2-overlay').css('rotate', '17deg');

          $('#ornament-text3-overlay').css('max-height', '100%');
          $('#ornament-text3-overlay').css('height', '10%'); // 4.5
          $('#ornament-text3-overlay').css('width', '10%');
          $('#ornament-text3-overlay').css('left', '15%');
          $('#ornament-text3-overlay').css('top', '85.5%');
          $('#ornament-text3-overlay').css('rotate', '15deg');

          $('#ornament-text4-overlay').css('max-height', '100%');
          $('#ornament-text4-overlay').css('height', '10%'); // 4.5
          $('#ornament-text4-overlay').css('width', '10%');
          $('#ornament-text4-overlay').css('left', '8%');
          $('#ornament-text4-overlay').css('top', '76%');
          $('#ornament-text4-overlay').css('rotate', '18deg');

          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text4-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text2-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text3-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text4-overlay-preview').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '10%'); // 4.5
          $('#ornament-text1-overlay-preview').css('width', '10%');
          $('#ornament-text1-overlay-preview').css('left', '19%');
          $('#ornament-text1-overlay-preview').css('top', '69%');
          $('#ornament-text1-overlay-preview').css('rotate', '11deg');

          $('#ornament-text2-overlay-preview').css('max-height', '100%');
          $('#ornament-text2-overlay-preview').css('height', '10%'); // 4.5
          $('#ornament-text2-overlay-preview').css('width', '10%');
          $('#ornament-text2-overlay-preview').css('left', '25%');
          $('#ornament-text2-overlay-preview').css('top', '80.3%');
          $('#ornament-text2-overlay-preview').css('rotate', '17deg');

          $('#ornament-text3-overlay-preview').css('max-height', '100%');
          $('#ornament-text3-overlay-preview').css('height', '10%'); // 4.5
          $('#ornament-text3-overlay-preview').css('width', '10%');
          $('#ornament-text3-overlay-preview').css('left', '15%');
          $('#ornament-text3-overlay-preview').css('top', '85.5%');
          $('#ornament-text3-overlay-preview').css('rotate', '15deg');

          $('#ornament-text4-overlay-preview').css('max-height', '100%');
          $('#ornament-text4-overlay-preview').css('height', '10%'); // 4.5
          $('#ornament-text4-overlay-preview').css('width', '10%');
          $('#ornament-text4-overlay-preview').css('left', '8%');
          $('#ornament-text4-overlay-preview').css('top', '76%');
          $('#ornament-text4-overlay-preview').css('rotate', '18deg');

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .1,
            explicitHeight: height * .10,
          });

          TextFill('#ornament-text2-overlay', {
            explicitWidth: width * .1,
            explicitHeight: height * .10,
          });

          TextFill('#ornament-text3-overlay', {
            explicitWidth: width * .1,
            explicitHeight: height * .10,
          });

          TextFill('#ornament-text4-overlay', {
            explicitWidth: width * .1,
            explicitHeight: height * .10,
          });

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay span').removeClass('text-only');
            $('#ornament-text1-overlay span').addClass('symbol-only');
            $('#ornament-text2-overlay span').removeClass('text-only');
            $('#ornament-text2-overlay span').addClass('symbol-only');
            $('#ornament-text3-overlay span').removeClass('text-only');
            $('#ornament-text3-overlay span').addClass('symbol-only');
            $('#ornament-text4-overlay span').removeClass('text-only');
            $('#ornament-text4-overlay span').addClass('symbol-only');

            $('#ornament-text1-overlay-preview span').removeClass('text-only');
            $('#ornament-text1-overlay-preview span').addClass('symbol-only');
            $('#ornament-text2-overlay-preview span').removeClass('text-only');
            $('#ornament-text2-overlay-preview span').addClass('symbol-only');
            $('#ornament-text3-overlay-preview span').removeClass('text-only');
            $('#ornament-text3-overlay-preview span').addClass('symbol-only');
            $('#ornament-text4-overlay-preview span').removeClass('text-only');
            $('#ornament-text4-overlay-preview span').addClass('symbol-only');
          } else {
            $('#ornament-text1-overlay span').removeClass('symbol-only');
            $('#ornament-text1-overlay span').addClass('text-only');
            $('#ornament-text2-overlay span').removeClass('symbol-only');
            $('#ornament-text2-overlay span').addClass('text-only');
            $('#ornament-text3-overlay span').removeClass('symbol-only');
            $('#ornament-text3-overlay span').addClass('text-only');
            $('#ornament-text4-overlay span').removeClass('symbol-only');
            $('#ornament-text4-overlay span').addClass('text-only');

            $('#ornament-text1-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text1-overlay-preview span').addClass('text-only');
            $('#ornament-text2-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text2-overlay-preview span').addClass('text-only');
            $('#ornament-text3-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text3-overlay-preview span').addClass('text-only');
            $('#ornament-text4-overlay-preview span').removeClass('symbol-only');
            $('#ornament-text4-overlay-preview span').addClass('text-only');
          }

          if (checkMostlyUppercase($('#ornament-text1-overlay').text())) {
            if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley') {
              $('#ornament-text1-overlay span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay span').removeClass('extra-padding');
              $('#ornament-text2-overlay span').addClass('multi-extra-padding');
              $('#ornament-text2-overlay span').removeClass('extra-padding');
              $('#ornament-text3-overlay span').addClass('multi-extra-padding');
              $('#ornament-text3-overlay span').removeClass('extra-padding');
              $('#ornament-text4-overlay span').addClass('multi-extra-padding');
              $('#ornament-text4-overlay span').removeClass('extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
              $('#ornament-text2-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text2-overlay-preview span').removeClass('extra-padding');
              $('#ornament-text3-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text3-overlay-preview span').removeClass('extra-padding');
              $('#ornament-text4-overlay-preview span').addClass('multi-extra-padding');
              $('#ornament-text4-overlay-preview span').removeClass('extra-padding');
            } else {
              $('#ornament-text1-overlay span').addClass('extra-padding');
              $('#ornament-text1-overlay span').removeClass('multi-extra-padding');
              $('#ornament-text2-overlay span').addClass('extra-padding');
              $('#ornament-text2-overlay span').removeClass('multi-extra-padding');
              $('#ornament-text3-overlay span').addClass('extra-padding');
              $('#ornament-text3-overlay span').removeClass('multi-extra-padding');
              $('#ornament-text4-overlay span').addClass('extra-padding');
              $('#ornament-text4-overlay span').removeClass('multi-extra-padding');

              $('#ornament-text1-overlay-preview span').addClass('extra-padding');
              $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
              $('#ornament-text2-overlay-preview span').addClass('extra-padding');
              $('#ornament-text2-overlay-preview span').removeClass('multi-extra-padding');
              $('#ornament-text3-overlay-preview span').addClass('extra-padding');
              $('#ornament-text3-overlay-preview span').removeClass('multi-extra-padding');
              $('#ornament-text4-overlay-preview span').addClass('extra-padding');
              $('#ornament-text4-overlay-preview span').removeClass('multi-extra-padding');
            }
          } else {
            $('#ornament-text1-overlay span').removeClass('extra-padding');
            $('#ornament-text1-overlay span').removeClass('multi-extra-padding');
            $('#ornament-text2-overlay span').removeClass('extra-padding');
            $('#ornament-text2-overlay span').removeClass('multi-extra-padding');
            $('#ornament-text3-overlay span').removeClass('extra-padding');
            $('#ornament-text3-overlay span').removeClass('multi-extra-padding');
            $('#ornament-text4-overlay span').removeClass('extra-padding');
            $('#ornament-text4-overlay span').removeClass('multi-extra-padding');

            $('#ornament-text1-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text1-overlay-preview span').removeClass('multi-extra-padding');
            $('#ornament-text2-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text2-overlay-preview span').removeClass('multi-extra-padding');
            $('#ornament-text3-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text3-overlay-preview span').removeClass('multi-extra-padding');
            $('#ornament-text4-overlay-preview span').removeClass('extra-padding');
            $('#ornament-text4-overlay-preview span').removeClass('multi-extra-padding');
          }
        } else if (ORNAMENT_TYPE == 'BAR_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '7%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '40%');
          $('#ornament-text1-overlay').css('left', '49.5%');
          $('#ornament-text1-overlay').css('top', '80%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '7%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '40%');
          $('#ornament-text1-overlay-preview').css('left', '49.5%');
          $('#ornament-text1-overlay-preview').css('top', '80%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          let magnumMulti = 1;
          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Holland Land') {
            magnumMulti = 1.3;
          }

          if (ACTIVE_FONT == 'Nickainley' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '80.5%');
            $('#ornament-text1-overlay-preview').css('top', '80.5%');
          } else if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '80.5%');
            $('#ornament-text1-overlay-preview').css('top', '80.5%');
          } else {
            $('#ornament-text1-overlay').css('top', '80%');
            $('#ornament-text1-overlay-preview').css('top', '80%');
          }

          $('#ornament-text1-overlay span').removeClass('text-only');

          $('#ornament-text1-overlay-preview span').removeClass('text-only');
          if ($('#ornament-text1-overlay').find('.textfill-clho').length > 0 && magnumMulti == 1) {
            TextFill('#ornament-text1-overlay', {
              explicitWidth: width * .35,
              explicitHeight: height * .05,
            });
          } else {
            TextFill('#ornament-text1-overlay', {
              explicitWidth: width * .35,
              explicitHeight: height * .05,
            });
          }
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_SNOWFLAKE_ORNAMENT') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '15%');
          $('#ornament-text1-overlay').css('width', '13%');
          $('#ornament-text1-overlay').css('max-width', '15%');
          $('#ornament-text1-overlay').css('left', '49.25%');
          $('#ornament-text1-overlay').css('top', '65%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '15%');
          $('#ornament-text1-overlay-preview').css('width', '13%');
          $('#ornament-text1-overlay-preview').css('max-width', '15%');
          $('#ornament-text1-overlay-preview').css('left', '49.25%');
          $('#ornament-text1-overlay-preview').css('top', '65%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '66%');
            $('#ornament-text1-overlay-preview').css('top', '66%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .13,
            explicitHeight: height * .15,
          });
        } else if (ORNAMENT_TYPE == 'HEART_BIRTHSTONE_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '7%');
          $('#ornament-text1-overlay').css('width', '15%');
          $('#ornament-text1-overlay').css('max-width', '15%');
          $('#ornament-text1-overlay').css('left', '49.5%');
          $('#ornament-text1-overlay').css('top', '83.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '7%');
          $('#ornament-text1-overlay-preview').css('width', '15%');
          $('#ornament-text1-overlay-preview').css('max-width', '15%');
          $('#ornament-text1-overlay-preview').css('left', '49.5%');
          $('#ornament-text1-overlay-preview').css('top', '83.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '84%');
            $('#ornament-text1-overlay-preview').css('top', '84%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .15,
            explicitHeight: height * .05,
          });
        } else if (ORNAMENT_TYPE == 'OVAL_VERTICAL_LOCKET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '17%');
          $('#ornament-text1-overlay').css('width', '10%');
          $('#ornament-text1-overlay').css('max-width', '10%');
          $('#ornament-text1-overlay').css('left', '46.15%');
          $('#ornament-text1-overlay').css('top', '72.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '17%');
          $('#ornament-text1-overlay-preview').css('width', '10%');
          $('#ornament-text1-overlay-preview').css('max-width', '10%');
          $('#ornament-text1-overlay-preview').css('left', '46.15%');
          $('#ornament-text1-overlay-preview').css('top', '72.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '73.5%');
            $('#ornament-text1-overlay-preview').css('top', '73.5%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .10,
            explicitHeight: height * .17,
          });
        } else if (ORNAMENT_TYPE == 'OVAL_LOCKET_RING') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '20%');
          $('#ornament-text1-overlay').css('width', '18%');
          $('#ornament-text1-overlay').css('max-width', '18%');
          $('#ornament-text1-overlay').css('left', '49.5%');
          $('#ornament-text1-overlay').css('top', '48.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '20%');
          $('#ornament-text1-overlay-preview').css('width', '18%');
          $('#ornament-text1-overlay-preview').css('max-width', '18%');
          $('#ornament-text1-overlay-preview').css('left', '49.5%');
          $('#ornament-text1-overlay-preview').css('top', '48.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '50%');
            $('#ornament-text1-overlay-preview').css('top', '50%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .18,
            explicitHeight: height * .2,
          });
        } else if (ORNAMENT_TYPE == 'OVAL_LOCKET_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '12%');
          $('#ornament-text1-overlay').css('width', '16%');
          $('#ornament-text1-overlay').css('max-width', '16%');
          $('#ornament-text1-overlay').css('left', '47.25%');
          $('#ornament-text1-overlay').css('top', '80.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '12%');
          $('#ornament-text1-overlay-preview').css('width', '16%');
          $('#ornament-text1-overlay-preview').css('max-width', '16%');
          $('#ornament-text1-overlay-preview').css('left', '47.25%');
          $('#ornament-text1-overlay-preview').css('top', '80.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '81%');
            $('#ornament-text1-overlay-preview').css('top', '81%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .14,
            explicitHeight: height * .12,
          });
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_NECKLACE') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '17%');
          $('#ornament-text1-overlay').css('width', '13%');
          $('#ornament-text1-overlay').css('max-width', '13%');
          $('#ornament-text1-overlay').css('left', '46.5%');
          $('#ornament-text1-overlay').css('top', '70.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '17%');
          $('#ornament-text1-overlay-preview').css('width', '13%');
          $('#ornament-text1-overlay-preview').css('max-width', '13%');
          $('#ornament-text1-overlay-preview').css('left', '46.5%');
          $('#ornament-text1-overlay-preview').css('top', '70.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '72.25%');
            $('#ornament-text1-overlay-preview').css('top', '72.25%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '71.25%');
            $('#ornament-text1-overlay-preview').css('top', '71.25%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .13,
            explicitHeight: height * .17,
          });
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_RING') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '17%');
          $('#ornament-text1-overlay').css('width', '17%');
          $('#ornament-text1-overlay').css('max-width', '17%');
          $('#ornament-text1-overlay').css('left', '51%');
          $('#ornament-text1-overlay').css('top', '51%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '17%');
          $('#ornament-text1-overlay-preview').css('width', '17%');
          $('#ornament-text1-overlay-preview').css('max-width', '17%');
          $('#ornament-text1-overlay-preview').css('left', '51%');
          $('#ornament-text1-overlay-preview').css('top', '51%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '52%');
            $('#ornament-text1-overlay-preview').css('top', '52%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .17,
            explicitHeight: height * .17,
          });
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '11%');
          $('#ornament-text1-overlay').css('width', '13%');
          $('#ornament-text1-overlay').css('max-width', '13%');
          $('#ornament-text1-overlay').css('left', '47.5%');
          $('#ornament-text1-overlay').css('top', '82%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '11%');
          $('#ornament-text1-overlay-preview').css('width', '13%');
          $('#ornament-text1-overlay-preview').css('max-width', '13%');
          $('#ornament-text1-overlay-preview').css('left', '47.5%');
          $('#ornament-text1-overlay-preview').css('top', '82%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '83.25%');
            $('#ornament-text1-overlay-preview').css('top', '83.25%');
          } else if (ACTIVE_FONT == 'Holland Land') {
            $('#ornament-text1-overlay').css('top', '83.35%');
            $('#ornament-text1-overlay-preview').css('top', '83.35%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .11,
            explicitHeight: height * .11,
          });
        } else if (ORNAMENT_TYPE == 'FLIP_LOCKET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '13%');
          $('#ornament-text1-overlay').css('width', '20%');
          $('#ornament-text1-overlay').css('max-width', '20%');
          $('#ornament-text1-overlay').css('left', '47.75%');
          $('#ornament-text1-overlay').css('top', '76.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '13%');
          $('#ornament-text1-overlay-preview').css('width', '20%');
          $('#ornament-text1-overlay-preview').css('max-width', '20%');
          $('#ornament-text1-overlay-preview').css('left', '47.75%');
          $('#ornament-text1-overlay-preview').css('top', '76.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum' || ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '77.25%');
            $('#ornament-text1-overlay-preview').css('top', '77.25%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .20,
            explicitHeight: height * .13,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_ID_BRACELET') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '4%');
          $('#ornament-text1-overlay').css('width', '30%');
          $('#ornament-text1-overlay').css('max-width', '30%');
          $('#ornament-text1-overlay').css('left', '51.5%');
          $('#ornament-text1-overlay').css('top', '82.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '4%');
          $('#ornament-text1-overlay-preview').css('width', '30%');
          $('#ornament-text1-overlay-preview').css('max-width', '30%');
          $('#ornament-text1-overlay-preview').css('left', '51.5%');
          $('#ornament-text1-overlay-preview').css('top', '82.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '83%');
            $('#ornament-text1-overlay-preview').css('top', '83%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '83%');
            $('#ornament-text1-overlay-preview').css('top', '83%');
          }

          if ($('.variant__label-info').text().indexOf('Black') > -1) {
            $('#ornament-text1-overlay').css('top', '82%');
            $('#ornament-text1-overlay-preview').css('top', '82%');

            if (ACTIVE_FONT != 'Nickainley Normal' && ACTIVE_FONT != 'Magnum') {
              $('#ornament-text1-overlay').css('top', '81.75%');
              $('#ornament-text1-overlay-preview').css('top', '81.75%');
            }
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .30,
            explicitHeight: height * .04,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_PENDANT_NECKLACE') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('justify-content', 'left');
          $('#ornament-text1-overlay').css('rotate', '-90deg');
          $('#ornament-text1-overlay').css('max-height', '3.5%');
          $('#ornament-text1-overlay').css('height', '3.5%');
          $('#ornament-text1-overlay').css('width', '30%');
          $('#ornament-text1-overlay').css('max-width', '30%');
          $('#ornament-text1-overlay').css('left', '35.4%');
          $('#ornament-text1-overlay').css('top', '47.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('justify-content', 'left');
          $('#ornament-text1-overlay-preview').css('rotate', '-90deg');
          $('#ornament-text1-overlay-preview').css('max-height', '3.5%');
          $('#ornament-text1-overlay-preview').css('height', '3.5%');
          $('#ornament-text1-overlay-preview').css('width', '30%');
          $('#ornament-text1-overlay-preview').css('max-width', '30%');
          $('#ornament-text1-overlay-preview').css('left', '35.5%');
          $('#ornament-text1-overlay-preview').css('top', '47.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('left', '35.4%');
            $('#ornament-text1-overlay-preview').css('left', '35.4%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('left', '35.4%');
            $('#ornament-text1-overlay-preview').css('left', '35.4%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * .25,
            explicitHeight: height * .035,
          });
        } else if (ORNAMENT_TYPE == 'PAVE_CIRCLE_ENGRAVABLE_CHARM') {
          var width = $('#ornament-text1-overlay').parent().width();
          var height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '100%');
          $('#ornament-text1-overlay').css('height', '35%');
          $('#ornament-text1-overlay').css('width', '49%');
          $('#ornament-text1-overlay').css('max-width', '49%');
          $('#ornament-text1-overlay').css('left', '48.5%');
          $('#ornament-text1-overlay').css('top', '63.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '100%');
          $('#ornament-text1-overlay-preview').css('height', '35%');
          $('#ornament-text1-overlay-preview').css('width', '49%');
          $('#ornament-text1-overlay-preview').css('max-width', '49%');
          $('#ornament-text1-overlay-preview').css('left', '48.5%');
          $('#ornament-text1-overlay-preview').css('top', '63.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '65.5%');
            $('#ornament-text1-overlay-preview').css('top', '65.5%');
          }

          let widthMulti = 0.49;
          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '66%');
            $('#ornament-text1-overlay-preview').css('top', '66%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '64%');
            $('#ornament-text1-overlay-preview').css('top', '64%');
            $('#ornament-text1-overlay').css('width', '45%');
            $('#ornament-text1-overlay').css('max-width', '45%');
            widthMulti = 0.45;
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * widthMulti,
            explicitHeight: height * .35,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE') {
          $('#ornament-circle-text-overlay').css('top', '4.25%');
          $('#ornament-circle-text-overlay').css('height', '70%');
          $('#ornament-circle-text-overlay').css('width', '45%');
          $('#ornament-circle-text-overlay').css('left', '17%');
          $('#ornament-circle-text-overlay').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay').css('max-width', '100%');
          $('#ornament-circle-text-overlay').css('z-index', '15');

          $('#ornament-circle-text-overlay-2').css('top', '50%');
          $('#ornament-circle-text-overlay-2').css('height', '70%');
          $('#ornament-circle-text-overlay-2').css('width', '44%');
          $('#ornament-circle-text-overlay-2').css('left', '17.5%');
          $('#ornament-circle-text-overlay-2').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-2').css('max-width', '100%');
          $('#ornament-circle-text-overlay-2').css('z-index', '15');

          $('#ornament-circle-text-overlay-3').css('top', '50.5%');
          $('#ornament-circle-text-overlay-3').css('height', '25%');
          $('#ornament-circle-text-overlay-3').css('width', '25%');
          $('#ornament-circle-text-overlay-3').css('left', '26.25%');
          $('#ornament-circle-text-overlay-3').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-3').css('max-width', '100%');
          $('#ornament-circle-text-overlay-3').css('z-index', '15');

          $('#ornament-circle-text-overlay-4').css('top', '50%');
          $('#ornament-circle-text-overlay-4').css('height', '25%');
          $('#ornament-circle-text-overlay-4').css('width', '25%');
          $('#ornament-circle-text-overlay-4').css('left', '27.75%');
          $('#ornament-circle-text-overlay-4').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-4').css('max-width', '100%');
          $('#ornament-circle-text-overlay-4').css('z-index', '15');

          $('#ornament-circle-text-overlay-5').css('top', '50%');
          $('#ornament-circle-text-overlay-5').css('height', '25%');
          $('#ornament-circle-text-overlay-5').css('width', '25%');
          $('#ornament-circle-text-overlay-5').css('left', '26.5%');
          $('#ornament-circle-text-overlay-5').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-5').css('max-width', '100%');
          $('#ornament-circle-text-overlay-5').css('z-index', '15');

          $('#ornament-circle-text-overlay-6').css('top', '50%');
          $('#ornament-circle-text-overlay-6').css('height', '25%');
          $('#ornament-circle-text-overlay-6').css('width', '25%');
          $('#ornament-circle-text-overlay-6').css('left', '27.85%');
          $('#ornament-circle-text-overlay-6').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-6').css('max-width', '100%');
          $('#ornament-circle-text-overlay-6').css('z-index', '15');


          $('#ornament-circle-text-overlay-preview').css('top', '4.25%');
          $('#ornament-circle-text-overlay-preview').css('height', '70%');
          $('#ornament-circle-text-overlay-preview').css('width', '45%');
          $('#ornament-circle-text-overlay-preview').css('left', '17%');
          $('#ornament-circle-text-overlay-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-preview').css('z-index', '15');

          $('#ornament-circle-text-overlay-2-preview').css('top', '50%');
          $('#ornament-circle-text-overlay-2-preview').css('height', '70%');
          $('#ornament-circle-text-overlay-2-preview').css('width', '44%');
          $('#ornament-circle-text-overlay-2-preview').css('left', '17.5%');
          $('#ornament-circle-text-overlay-2-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-2-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-2-preview').css('z-index', '15');

          $('#ornament-circle-text-overlay-3-preview').css('top', '50.5%');
          $('#ornament-circle-text-overlay-3-preview').css('height', '25%');
          $('#ornament-circle-text-overlay-3-preview').css('width', '25%');
          $('#ornament-circle-text-overlay-3-preview').css('left', '26.25%');
          $('#ornament-circle-text-overlay-3-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-3-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-3-preview').css('z-index', '15');

          $('#ornament-circle-text-overlay-4-preview').css('top', '50%');
          $('#ornament-circle-text-overlay-4-preview').css('height', '25%');
          $('#ornament-circle-text-overlay-4-preview').css('width', '25%');
          $('#ornament-circle-text-overlay-4-preview').css('left', '27.75%');
          $('#ornament-circle-text-overlay-4-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-4-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-4-preview').css('z-index', '15');

          $('#ornament-circle-text-overlay-5-preview').css('top', '50%');
          $('#ornament-circle-text-overlay-5-preview').css('height', '25%');
          $('#ornament-circle-text-overlay-5-preview').css('width', '25%');
          $('#ornament-circle-text-overlay-5-preview').css('left', '26.5%');
          $('#ornament-circle-text-overlay-5-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-5-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-5-preview').css('z-index', '15');

          $('#ornament-circle-text-overlay-6-preview').css('top', '50%');
          $('#ornament-circle-text-overlay-6-preview').css('height', '25%');
          $('#ornament-circle-text-overlay-6-preview').css('width', '25%');
          $('#ornament-circle-text-overlay-6-preview').css('left', '27.85%');
          $('#ornament-circle-text-overlay-6-preview').css('text-transform', 'uppercase');
          $('#ornament-circle-text-overlay-6-preview').css('max-width', '100%');
          $('#ornament-circle-text-overlay-6-preview').css('z-index', '15');
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_CHARM') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '15%');
          $('#ornament-text1-overlay').css('height', '15%');
          $('#ornament-text1-overlay').css('width', '60%');
          $('#ornament-text1-overlay').css('max-width', '60%');
          $('#ornament-text1-overlay').css('left', '19.5%');
          $('#ornament-text1-overlay').css('top', '53.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('transform', 'rotate(-90deg)');

          $('#ornament-text1-overlay-preview').css('max-height', '15%');
          $('#ornament-text1-overlay-preview').css('height', '15%');
          $('#ornament-text1-overlay-preview').css('width', '60%');
          $('#ornament-text1-overlay-preview').css('max-width', '60%');
          $('#ornament-text1-overlay-preview').css('left', '19.5%');
          $('#ornament-text1-overlay-preview').css('top', '53.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('transform', 'rotate(-90deg)');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('left', '21%');
            $('#ornament-text1-overlay-preview').css('left', '21%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('left', '21.5%');
            $('#ornament-text1-overlay-preview').css('left', '21.5%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('left', '21.5%');
            $('#ornament-text1-overlay-preview').css('left', '21.5%');
          } else if (ACTIVE_FONT == 'Holland Land') {
            $('#ornament-text1-overlay').css('left', '20.5%');
            $('#ornament-text1-overlay-preview').css('left', '20.5%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.60,
            explicitHeight: height * .15,
          });

          let previewParentWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewParentHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewParentWidth * 0.60,
            explicitHeight: previewParentHeight * .15,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_TENNIS_BRACELET') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '7%');
          $('#ornament-text1-overlay').css('height', '7%');
          $('#ornament-text1-overlay').css('width', '45%');
          $('#ornament-text1-overlay').css('max-width', '45%');
          $('#ornament-text1-overlay').css('left', '50%');
          $('#ornament-text1-overlay').css('top', '91.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '7%');
          $('#ornament-text1-overlay-preview').css('height', '7%');
          $('#ornament-text1-overlay-preview').css('width', '45%');
          $('#ornament-text1-overlay-preview').css('max-width', '45%');
          $('#ornament-text1-overlay-preview').css('left', '50%');
          $('#ornament-text1-overlay-preview').css('top', '91.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '91.75%');
            $('#ornament-text1-overlay-preview').css('top', '91.75%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '92%');
            $('#ornament-text1-overlay-preview').css('top', '92%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '92%');
            $('#ornament-text1-overlay-preview').css('top', '92%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.45,
            explicitHeight: height * .07,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '6%');
          $('#ornament-text1-overlay').css('height', '6%');
          $('#ornament-text1-overlay').css('width', '45%');
          $('#ornament-text1-overlay').css('max-width', '45%');
          $('#ornament-text1-overlay').css('left', '52%');
          $('#ornament-text1-overlay').css('top', '84.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '6%');
          $('#ornament-text1-overlay-preview').css('height', '6%');
          $('#ornament-text1-overlay-preview').css('width', '45%');
          $('#ornament-text1-overlay-preview').css('max-width', '45%');
          $('#ornament-text1-overlay-preview').css('left', '52%');
          $('#ornament-text1-overlay-preview').css('top', '84.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '84.5%');
            $('#ornament-text1-overlay-preview').css('top', '84.5%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '85%');
            $('#ornament-text1-overlay-preview').css('top', '85%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '85%');
            $('#ornament-text1-overlay-preview').css('top', '85%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.45,
            explicitHeight: height * .06,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '5%');
          $('#ornament-text1-overlay').css('height', '5%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '48%');
          $('#ornament-text1-overlay').css('top', '80.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '5%');
          $('#ornament-text1-overlay-preview').css('height', '5%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '48%');
          $('#ornament-text1-overlay-preview').css('top', '80.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '80.5%');
            $('#ornament-text1-overlay-preview').css('top', '80.5%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '81%');
            $('#ornament-text1-overlay-preview').css('top', '81%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '81%');
            $('#ornament-text1-overlay-preview').css('top', '81%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.35,
            explicitHeight: height * .05,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '6%');
          $('#ornament-text1-overlay').css('height', '6%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '37.5%');
          $('#ornament-text1-overlay').css('top', '66.75%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '6%');
          $('#ornament-text1-overlay-preview').css('height', '6%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '37.5%');
          $('#ornament-text1-overlay-preview').css('top', '66.75%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '67.25%');
            $('#ornament-text1-overlay-preview').css('top', '67.25%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '67.75%');
            $('#ornament-text1-overlay-preview').css('top', '67.75%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '67.75%');
            $('#ornament-text1-overlay-preview').css('top', '67.75%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.35,
            explicitHeight: height * .06,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '4%');
          $('#ornament-text1-overlay').css('height', '4%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '33%');
          $('#ornament-text1-overlay').css('top', '30.75%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('transform', 'rotate(-90deg)');

          $('#ornament-text1-overlay-preview').css('max-height', '4%');
          $('#ornament-text1-overlay-preview').css('height', '4%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '33%');
          $('#ornament-text1-overlay-preview').css('top', '30.75%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('transform', 'rotate(-90deg)');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('left', '33.5%');
            $('#ornament-text1-overlay-preview').css('left', '33.5%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('left', '34%');
            $('#ornament-text1-overlay-preview').css('left', '34%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('left', '34%');
            $('#ornament-text1-overlay-preview').css('left', '34%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.50,
            explicitHeight: height * .04,
          });

          let previewParentWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewParentHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewParentWidth * 0.50,
            explicitHeight: previewParentHeight * .04,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_PHOTO_BOOKMARK') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '4%');
          $('#ornament-text1-overlay').css('height', '4%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '33%');
          $('#ornament-text1-overlay').css('top', '30.75%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('transform', 'rotate(-90deg)');

          $('#ornament-text1-overlay-preview').css('max-height', '4%');
          $('#ornament-text1-overlay-preview').css('height', '4%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '33%');
          $('#ornament-text1-overlay-preview').css('top', '30.75%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('transform', 'rotate(-90deg)');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('left', '33.5%');
            $('#ornament-text1-overlay-preview').css('left', '33.5%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('left', '34%');
            $('#ornament-text1-overlay-preview').css('left', '34%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('left', '34%');
            $('#ornament-text1-overlay-preview').css('left', '34%');
          }

          let previewParentWidth = $('#ornament-text1-overlay-preview').parent().width();
          let previewParentHeight = $('#ornament-text1-overlay-preview').parent().height();
          TextFill('#ornament-text1-overlay-preview', {
            explicitWidth: previewParentWidth * 0.50,
            explicitHeight: previewParentHeight * .04,
          });

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.50,
            explicitHeight: height * .04,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_RING') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '10%');
          $('#ornament-text1-overlay').css('height', '10%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '47%');
          $('#ornament-text1-overlay').css('top', '62.5%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('transform', 'translate(-50%, -50%) rotate(2deg)');

          $('#ornament-text1-overlay-preview').css('max-height', '10%');
          $('#ornament-text1-overlay-preview').css('height', '10%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '47%');
          $('#ornament-text1-overlay-preview').css('top', '62.5%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('transform', 'translate(-50%, -50%) rotate(2deg)');

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '63%');
            $('#ornament-text1-overlay-preview').css('top', '63%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '63.5%');
            $('#ornament-text1-overlay-preview').css('top', '63.5%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '63.5%');
            $('#ornament-text1-overlay-preview').css('top', '63.5%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.50,
            explicitHeight: height * .1,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_LOCKET_KEYCHAIN') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '10%');
          $('#ornament-text1-overlay').css('height', '10%');
          $('#ornament-text1-overlay').css('width', '35%');
          $('#ornament-text1-overlay').css('max-width', '35%');
          $('#ornament-text1-overlay').css('left', '47.5%');
          $('#ornament-text1-overlay').css('top', '81%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay').css('transform', 'translate(-50%, -50%) rotate(-2deg)');

          $('#ornament-text1-overlay-preview').css('max-height', '10%');
          $('#ornament-text1-overlay-preview').css('height', '10%');
          $('#ornament-text1-overlay-preview').css('width', '35%');
          $('#ornament-text1-overlay-preview').css('max-width', '35%');
          $('#ornament-text1-overlay-preview').css('left', '47%');
          $('#ornament-text1-overlay-preview').css('top', '81%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);
          $('#ornament-text1-overlay-preview').css('transform', 'translate(-50%, -50%) rotate(-2deg)');

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '82%');
            $('#ornament-text1-overlay-preview').css('top', '82%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '82%');
            $('#ornament-text1-overlay-preview').css('top', '82%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.50,
            explicitHeight: height * .1,
          });
        } else if (ORNAMENT_TYPE == 'CIRCLE_PHOTO_SQUARE_KEYCHAIN') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '20%');
          $('#ornament-text1-overlay').css('height', '20%');
          $('#ornament-text1-overlay').css('width', '15%');
          $('#ornament-text1-overlay').css('max-width', '15%');
          $('#ornament-text1-overlay').css('left', '28%');
          $('#ornament-text1-overlay').css('top', '82.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '20%');
          $('#ornament-text1-overlay-preview').css('height', '20%');
          $('#ornament-text1-overlay-preview').css('width', '15%');
          $('#ornament-text1-overlay-preview').css('max-width', '15%');
          $('#ornament-text1-overlay-preview').css('left', '28%');
          $('#ornament-text1-overlay-preview').css('top', '82.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '82.75%');
            $('#ornament-text1-overlay-preview').css('top', '82.75%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '83.25%');
            $('#ornament-text1-overlay-preview').css('top', '83.25%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '83.25%');
            $('#ornament-text1-overlay-preview').css('top', '83.25%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.15,
            explicitHeight: height * .2,
          });
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE') {
          let width = $('#ornament-text1-overlay').parent().width();
          let height = $('#ornament-text1-overlay').parent().height();

          $('#ornament-text1-overlay').css('max-height', '15%');
          $('#ornament-text1-overlay').css('height', '15%');
          $('#ornament-text1-overlay').css('width', '10%');
          $('#ornament-text1-overlay').css('max-width', '10%');
          $('#ornament-text1-overlay').css('left', '28%');
          $('#ornament-text1-overlay').css('top', '78.25%');
          $('#ornament-text1-overlay').css('font-family', ACTIVE_FONT);

          $('#ornament-text1-overlay-preview').css('max-height', '15%');
          $('#ornament-text1-overlay-preview').css('height', '15%');
          $('#ornament-text1-overlay-preview').css('width', '10%');
          $('#ornament-text1-overlay-preview').css('max-width', '10%');
          $('#ornament-text1-overlay-preview').css('left', '28%');
          $('#ornament-text1-overlay-preview').css('top', '78.25%');
          $('#ornament-text1-overlay-preview').css('font-family', ACTIVE_FONT);

          if (containsNonLatinCodepoints($('#ornament-text1-overlay').text())) {
            $('#ornament-text1-overlay').css('top', '78.5%');
            $('#ornament-text1-overlay-preview').css('top', '78.5%');
          }

          if (ACTIVE_FONT == 'Magnum') {
            $('#ornament-text1-overlay').css('top', '80%');
            $('#ornament-text1-overlay-preview').css('top', '80%');
          } else if (ACTIVE_FONT == 'Nickainley Normal') {
            $('#ornament-text1-overlay').css('top', '80%');
            $('#ornament-text1-overlay-preview').css('top', '80%');
          }

          TextFill('#ornament-text1-overlay', {
            explicitWidth: width * 0.1,
            explicitHeight: height * .15,
          });
        }
        var image = $('#input-image');
        var canvas = $('.ornament-engraving-overlay')[0];
        var previewCanvas = $('#ornament-engraving-overlay-preview')[0];

        const context = canvas.getContext('2d');
        const previewContext = previewCanvas.getContext('2d');

        var baseSize = 1.5;

        context.fillStyle = '#6f6556'
        context.textBaseline = 'middle';
        context.textAlign = 'center';

        previewContext.fillStyle = '#6f6556';
        previewContext.textBaseline = 'middle';
        previewContext.textAlign = 'center'

        context.font = baseSize + 'rem ' + ACTIVE_FONT;
        context.clearRect(0, 0, canvas.width, canvas.height);

        previewContext.font = baseSize + 'rem ' + ACTIVE_FONT
        previewContext.clearRect(0, 0, previewCanvas.width, previewCanvas.height)

        if (ACTIVE_SELECTED) {
          var image = new Image();
          image.onload = function () {
            var maxHeight = canvas.height * 0.45;
            var maxWidth = canvas.width * 0.45;

            var previewMaxHeight = previewCanvas.height * 0.45;
            var previewMaxWidth = previewCanvas.width * 0.45;

            var wRatio = maxWidth / image.height;
            var hRatio = maxHeight / image.height;

            var previewWRatio = previewMaxWidth / image.height;
            var previewHRatio = previewMaxHeight / image.height;

            if (hRatio == 0.45) {
              maxHeight = canvas.height * 0.55;
              maxWidth = canvas.width * 0.55;

              wRatio = maxWidth / image.height;
              hRatio = maxHeight / image.height;

              previewMaxHeight = previewCanvas.height * 0.55;
              previewMaxWidth = previewCanvas.width * 0.55;

              previewWRatio = previewMaxWidth / image.height;
              previewHRatio = previewMaxHeight / image.height;
            }

            var centerShift_x = ((canvas.width - image.width * wRatio) / 2);
            var centerShift_y = (canvas.height - image.height * hRatio) / 2;

            var previewCenterShiftX = ((previewCanvas.width - image.width * previewWRatio) / 2)
            var previewCenterShiftY = ((previewCanvas.height - image.height * previewHRatio) / 2)

            context.drawImage(
              image,
              0,
              0,
              image.width,
              image.height,
              centerShift_x,
              centerShift_y,
              image.width * wRatio,
              image.height * hRatio
            );

            previewContext.drawImage(
              image,
              0,
              0,
              image.width,
              image.height,
              previewCenterShiftX,
              previewCenterShiftY,
              image.width * previewWRatio,
              image.height * previewHRatio
            )
          }
          var symbolUrl = ASSET_URL_BASE + ACTIVE_SELECTED;
          image.src = symbolUrl;
        }

        let hasSet = false;

        function handleTextRender(textInput, textField) {
          if ($('#locket-type').val() && !hasSet) {
            setInterval(function () {
              $(textInput).val($(textInput).val().replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/, ''));
              if ($(textInput).val() && $(textInput).val().length > parseInt($(textInput).attr('maxlength'))) {
                $(textInput).val($(textInput).val().substring(0, parseInt($(textInput).attr('maxlength'))));
              }
            }, 100);
          } else if ($(textInput).val()) {
            $(textInput).val($(textInput).val().replace(/(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/, ''));
            if ($(textInput).val() && $(textInput).val().length > parseInt($(textInput).attr('maxlength'))) {
              $(textInput).val($(textInput).val().substring(0, parseInt($(textInput).attr('maxlength'))));
            }
          }
          if (ORNAMENT_TYPE == 'CRESCENT_STAR' || ORNAMENT_TYPE == 'CIRCLE_HEART_CUTOUT' || ORNAMENT_TYPE == 'CIRCLE_CENTER_CUTOUT') {
            if (ORNAMENT_TYPE == 'CRESCENT_STAR') {
              var newSize = (0.067226890756303 * $('#ornament-circle-text-overlay').width()) + 'px';
              $('#ornament-circle-text-overlay').css('font', newSize + ' ' + ACTIVE_FONT);
              getCircularText(document.getElementById('ornament-circle-text-overlay'), $(textInput).val(), $('#ornament-circle-text-overlay').width(), 240, "center", false, false, ACTIVE_FONT, newSize, 0.013333333333333334 * $('#ornament-circle-text-overlay').width());
              getCircularText(document.getElementById('ornament-circle-text-overlay-3'), $(textInput).val(), $('#ornament-circle-text-overlay-3').width(), 240, "center", false, false, ACTIVE_FONT, newSize, 4);
            } else if (ORNAMENT_TYPE == 'CIRCLE_CENTER_CUTOUT') {
              var newSize = (0.094117647058824 * $('#ornament-circle-text-overlay').width()) + 'px';
              if (textField == 1) {
                getCircularText(document.getElementById('ornament-circle-text-overlay'), $(textInput).val(), $('#ornament-circle-text-overlay').width(), 0, "center", false, true, ACTIVE_FONT, newSize, -2);
                //  getCircularText(document.getElementById('ornament-circle-text-overlay-3'), $(textInput).val(), $('#ornament-circle-text-overlay-3').width(), 0, "center", false, true, ACTIVE_FONT, newSize + 'rem', -2);
              } else {
                getCircularText(document.getElementById('ornament-circle-text-overlay-2'), $(textInput).val(), $('#ornament-circle-text-overlay-2').width(), 180, 'center', false, false, ACTIVE_FONT, newSize, -2);
                getCircularText(document.getElementById('ornament-circle-text-overlay-4'), $(textInput).val(), $('#ornament-circle-text-overlay-4').width(), 180, 'center', false, false, ACTIVE_FONT, newSize, -2);
              }
            } else if (ORNAMENT_TYPE == 'CIRCLE_HEART_CUTOUT') {
              var letterSpacing = 0;
              var newSize = (0.103529411764706 * $('#ornament-circle-text-overlay').width());
              var newSecondSize = (0.103529411764706 * $('#ornament-circle-text-overlay').width());
              if (textField == 1 && ($(textInput).val().toUpperCase() != $(textInput).val())) {
                newSize = newSize * 1.3;
              }
              if (textField != 1 && ($(textInput).val().toUpperCase() != $(textInput).val())) {
                newSecondSize = newSecondSize * 1.3;
              }
              newSize = newSize + 'px'
              newSecondSize = newSecondSize + 'px';
              if (textField == 1) {
                getCircularText(document.getElementById('ornament-circle-text-overlay'), $(textInput).val(), $('#ornament-circle-text-overlay').width(), 0, "center", false, true, ACTIVE_FONT, newSize, letterSpacing);
                // getCircularText(document.getElementById('ornament-circle-text-overlay-3'), $(textInput).val(), $('#ornament-circle-text-overlay-3').width(), 0, "center", false, true, ACTIVE_FONT, newSize + 'rem', letterSpacing);
              } else {
                getCircularText(document.getElementById('ornament-circle-text-overlay-2'), $(textInput).val(), $('#ornament-circle-text-overlay-2').width(), 180, 'center', false, false, ACTIVE_FONT, newSecondSize, letterSpacing);
                getCircularText(document.getElementById('ornament-circle-text-overlay-4'), $(textInput).val(), $('#ornament-circle-text-overlay-4').width(), 180, 'center', false, false, ACTIVE_FONT, newSecondSize, letterSpacing);
              }
            }
          } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE') {
            $('#font-container').parent().hide();
            ACTIVE_FONT = 'Kumbh Sans';
            ACTIVE_FONT_PROPERTY = 'F2';
            let textInputs = {};

            let i = 1;
            $('.symbol-input').each(function () {
              textInputs[i] = $(this).val();
              i++;
            });

            let text = $(textInput).val();
            const canvasElement = document.getElementById('ornament-circle-text-overlay');
            const canvasWidth = $('#ornament-circle-text-overlay').parent().width();

            const secondCanvasElement = document.getElementById('ornament-circle-text-overlay-2');
            const thirdCanvasElement = document.getElementById('ornament-circle-text-overlay-3');
            const fourthCanvasElement = document.getElementById('ornament-circle-text-overlay-4');
            const fifthCanvasElement = document.getElementById('ornament-circle-text-overlay-5');
            const sixthCanvasElement = document.getElementById('ornament-circle-text-overlay-6');

            const firstPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-preview');
            const secondPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-2-preview');
            const thirdPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-3-preview');
            const fourthPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-4-preview');
            const fifthPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-5-preview');
            const sixthPreviewCanvasElement = document.getElementById('ornament-circle-text-overlay-6-preview');

            // reset text across all canvas elements

            let BOTTOM_PREVIEW_OPTIONS = {
              element: canvasElement,
              text: textInputs[1],
              width: canvasWidth,
              fontSize: 0.045 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 180,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let BOTTOM_PREVIEW_OPTIONS_PREVIEW = {
              element: firstPreviewCanvasElement,
              text: textInputs[1],
              width: canvasWidth,
              fontSize: 0.045 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 180,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_PREVIEW_OPTIONS = {
              element: secondCanvasElement,
              text: (textInputs[4] && textInputs[4].length) ? textInputs[3] : textInputs[2],
              width: canvasWidth,
              fontSize: 0.045 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 0,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_PREVIEW_OPTIONS_PREVIEW = {
              element: secondPreviewCanvasElement,
              text: (textInputs[4] && textInputs[4].length) ? textInputs[3] : textInputs[2],
              width: canvasWidth,
              fontSize: 0.045 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 0,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_LEFT_PREVIEW_OPTIONS = {
              element: sixthCanvasElement,
              text: textInputs[3],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: -60,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_LEFT_PREVIEW_OPTIONS_PREVIEW = {
              element: sixthPreviewCanvasElement,
              text: textInputs[3],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: -60,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_RIGHT_PREVIEW_OPTIONS = {
              element: fifthCanvasElement,
              text: textInputs[2],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 60,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW = {
              element: fifthPreviewCanvasElement,
              text: textInputs[2],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 60,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let LEFT_PREVIEW_OPTIONS = {
              element: fourthCanvasElement,
              text: textInputs[4],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: -90,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let LEFT_PREVIEW_OPTIONS_PREVIEW = {
              element: fourthPreviewCanvasElement,
              text: textInputs[4],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: -90,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: false,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let RIGHT_PREVIEW_OPTIONS = {
              element: thirdCanvasElement,
              text: textInputs[2],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 90,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: true,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            let RIGHT_PREVIEW_OPTIONS_PREVIEW = {
              element: thirdPreviewCanvasElement,
              text: textInputs[2],
              width: canvasWidth,
              fontSize: 0.12 * canvasWidth + 'px',
              kerning: text.length * 0.1,
              rotation: 90,
              textCentering: "center",
              font: ACTIVE_FONT,
              align: false,
              textInside: true,
              textColor: 'rgb(0,0,0)',
              isBold: true
            }

            // reset all others
            getCircularText(
              BOTTOM_PREVIEW_OPTIONS.element,
              '',
              BOTTOM_PREVIEW_OPTIONS.width,
              BOTTOM_PREVIEW_OPTIONS.rotation,
              BOTTOM_PREVIEW_OPTIONS.textCentering,
              BOTTOM_PREVIEW_OPTIONS.align,
              BOTTOM_PREVIEW_OPTIONS.textInside,
              BOTTOM_PREVIEW_OPTIONS.font,
              BOTTOM_PREVIEW_OPTIONS.fontSize,
              BOTTOM_PREVIEW_OPTIONS.kerning,
              BOTTOM_PREVIEW_OPTIONS.textColor,
              BOTTOM_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.width,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.rotation,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.textCentering,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.align,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.textInside,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.font,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.fontSize,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.kerning,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.textColor,
              BOTTOM_PREVIEW_OPTIONS_PREVIEW.isBold
            );
            getCircularText(
              TOP_PREVIEW_OPTIONS.element,
              '',
              TOP_PREVIEW_OPTIONS.width,
              TOP_PREVIEW_OPTIONS.rotation,
              TOP_PREVIEW_OPTIONS.textCentering,
              TOP_PREVIEW_OPTIONS.align,
              TOP_PREVIEW_OPTIONS.textInside,
              TOP_PREVIEW_OPTIONS.font,
              TOP_PREVIEW_OPTIONS.fontSize,
              TOP_PREVIEW_OPTIONS.kerning,
              TOP_PREVIEW_OPTIONS.textColor,
              TOP_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              TOP_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              TOP_PREVIEW_OPTIONS_PREVIEW.width,
              TOP_PREVIEW_OPTIONS_PREVIEW.rotation,
              TOP_PREVIEW_OPTIONS_PREVIEW.textCentering,
              TOP_PREVIEW_OPTIONS_PREVIEW.align,
              TOP_PREVIEW_OPTIONS_PREVIEW.textInside,
              TOP_PREVIEW_OPTIONS_PREVIEW.font,
              TOP_PREVIEW_OPTIONS_PREVIEW.fontSize,
              TOP_PREVIEW_OPTIONS_PREVIEW.kerning,
              TOP_PREVIEW_OPTIONS_PREVIEW.textColor,
              TOP_PREVIEW_OPTIONS_PREVIEW.isBold
            );
            getCircularText(
              TOP_RIGHT_PREVIEW_OPTIONS.element,
              '',
              TOP_RIGHT_PREVIEW_OPTIONS.width,
              TOP_RIGHT_PREVIEW_OPTIONS.rotation,
              TOP_RIGHT_PREVIEW_OPTIONS.textCentering,
              TOP_RIGHT_PREVIEW_OPTIONS.align,
              TOP_RIGHT_PREVIEW_OPTIONS.textInside,
              TOP_RIGHT_PREVIEW_OPTIONS.font,
              TOP_RIGHT_PREVIEW_OPTIONS.fontSize,
              TOP_RIGHT_PREVIEW_OPTIONS.kerning,
              TOP_RIGHT_PREVIEW_OPTIONS.textColor,
              TOP_RIGHT_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.width,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.rotation,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textCentering,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.align,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textInside,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.font,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.fontSize,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.kerning,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textColor,
              TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.isBold
            );
            getCircularText(
              TOP_LEFT_PREVIEW_OPTIONS.element,
              '',
              TOP_LEFT_PREVIEW_OPTIONS.width,
              TOP_LEFT_PREVIEW_OPTIONS.rotation,
              TOP_LEFT_PREVIEW_OPTIONS.textCentering,
              TOP_LEFT_PREVIEW_OPTIONS.align,
              TOP_LEFT_PREVIEW_OPTIONS.textInside,
              TOP_LEFT_PREVIEW_OPTIONS.font,
              TOP_LEFT_PREVIEW_OPTIONS.fontSize,
              TOP_LEFT_PREVIEW_OPTIONS.kerning,
              TOP_LEFT_PREVIEW_OPTIONS.textColor,
              TOP_LEFT_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.width,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.rotation,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textCentering,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.align,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textInside,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.font,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.fontSize,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.kerning,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textColor,
              TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.isBold
            );
            getCircularText(
              RIGHT_PREVIEW_OPTIONS.element,
              '',
              RIGHT_PREVIEW_OPTIONS.width,
              RIGHT_PREVIEW_OPTIONS.rotation,
              RIGHT_PREVIEW_OPTIONS.textCentering,
              RIGHT_PREVIEW_OPTIONS.align,
              RIGHT_PREVIEW_OPTIONS.textInside,
              RIGHT_PREVIEW_OPTIONS.font,
              RIGHT_PREVIEW_OPTIONS.fontSize,
              RIGHT_PREVIEW_OPTIONS.kerning,
              RIGHT_PREVIEW_OPTIONS.textColor,
              RIGHT_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              RIGHT_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              RIGHT_PREVIEW_OPTIONS_PREVIEW.width,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.rotation,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.textCentering,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.align,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.textInside,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.font,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.fontSize,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.kerning,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.textColor,
              RIGHT_PREVIEW_OPTIONS_PREVIEW.isBold
            );
            getCircularText(
              LEFT_PREVIEW_OPTIONS.element,
              '',
              LEFT_PREVIEW_OPTIONS.width,
              LEFT_PREVIEW_OPTIONS.rotation,
              LEFT_PREVIEW_OPTIONS.textCentering,
              LEFT_PREVIEW_OPTIONS.align,
              LEFT_PREVIEW_OPTIONS.textInside,
              LEFT_PREVIEW_OPTIONS.font,
              LEFT_PREVIEW_OPTIONS.fontSize,
              LEFT_PREVIEW_OPTIONS.kerning,
              LEFT_PREVIEW_OPTIONS.textColor,
              LEFT_PREVIEW_OPTIONS.isBold
            );
            getCircularText(
              LEFT_PREVIEW_OPTIONS_PREVIEW.element,
              '',
              LEFT_PREVIEW_OPTIONS_PREVIEW.width,
              LEFT_PREVIEW_OPTIONS_PREVIEW.rotation,
              LEFT_PREVIEW_OPTIONS_PREVIEW.textCentering,
              LEFT_PREVIEW_OPTIONS_PREVIEW.align,
              LEFT_PREVIEW_OPTIONS_PREVIEW.textInside,
              LEFT_PREVIEW_OPTIONS_PREVIEW.font,
              LEFT_PREVIEW_OPTIONS_PREVIEW.fontSize,
              LEFT_PREVIEW_OPTIONS_PREVIEW.kerning,
              LEFT_PREVIEW_OPTIONS_PREVIEW.textColor,
              LEFT_PREVIEW_OPTIONS_PREVIEW.isBold
            );

            if (textInputs[1] && textInputs[1].length > 0) {
              getCircularText(
                BOTTOM_PREVIEW_OPTIONS.element,
                BOTTOM_PREVIEW_OPTIONS.text,
                BOTTOM_PREVIEW_OPTIONS.width,
                BOTTOM_PREVIEW_OPTIONS.rotation,
                BOTTOM_PREVIEW_OPTIONS.textCentering,
                BOTTOM_PREVIEW_OPTIONS.align,
                BOTTOM_PREVIEW_OPTIONS.textInside,
                BOTTOM_PREVIEW_OPTIONS.font,
                BOTTOM_PREVIEW_OPTIONS.fontSize,
                BOTTOM_PREVIEW_OPTIONS.kerning,
                BOTTOM_PREVIEW_OPTIONS.textColor,
                BOTTOM_PREVIEW_OPTIONS.isBold
              );
              getCircularText(
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.element,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.text,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.width,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.rotation,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.textCentering,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.align,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.textInside,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.font,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.fontSize,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.kerning,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.textColor,
                BOTTOM_PREVIEW_OPTIONS_PREVIEW.isBold
              );
            }

            if (textInputs[2] && !(textInputs[3] && textInputs[3].length > 0)) {
              getCircularText(
                TOP_PREVIEW_OPTIONS.element,
                TOP_PREVIEW_OPTIONS.text,
                TOP_PREVIEW_OPTIONS.width,
                TOP_PREVIEW_OPTIONS.rotation,
                TOP_PREVIEW_OPTIONS.textCentering,
                TOP_PREVIEW_OPTIONS.align,
                TOP_PREVIEW_OPTIONS.textInside,
                TOP_PREVIEW_OPTIONS.font,
                TOP_PREVIEW_OPTIONS.fontSize,
                TOP_PREVIEW_OPTIONS.kerning,
                TOP_PREVIEW_OPTIONS.textColor,
                TOP_PREVIEW_OPTIONS.isBold
              );
              getCircularText(
                TOP_PREVIEW_OPTIONS_PREVIEW.element,
                TOP_PREVIEW_OPTIONS_PREVIEW.text,
                TOP_PREVIEW_OPTIONS_PREVIEW.width,
                TOP_PREVIEW_OPTIONS_PREVIEW.rotation,
                TOP_PREVIEW_OPTIONS_PREVIEW.textCentering,
                TOP_PREVIEW_OPTIONS_PREVIEW.align,
                TOP_PREVIEW_OPTIONS_PREVIEW.textInside,
                TOP_PREVIEW_OPTIONS_PREVIEW.font,
                TOP_PREVIEW_OPTIONS_PREVIEW.fontSize,
                TOP_PREVIEW_OPTIONS_PREVIEW.kerning,
                TOP_PREVIEW_OPTIONS_PREVIEW.textColor,
                TOP_PREVIEW_OPTIONS_PREVIEW.isBold
              );
            } else if (textInputs[2] && (textInputs[3] && textInputs[3].length > 0)) {
              if (textInputs[4] && textInputs[4].length > 0) {
                // reset 2/3
                getCircularText(
                  TOP_RIGHT_PREVIEW_OPTIONS.element,
                  '',
                  TOP_RIGHT_PREVIEW_OPTIONS.width,
                  TOP_RIGHT_PREVIEW_OPTIONS.rotation,
                  TOP_RIGHT_PREVIEW_OPTIONS.textCentering,
                  TOP_RIGHT_PREVIEW_OPTIONS.align,
                  TOP_RIGHT_PREVIEW_OPTIONS.textInside,
                  TOP_RIGHT_PREVIEW_OPTIONS.font,
                  TOP_RIGHT_PREVIEW_OPTIONS.fontSize,
                  TOP_RIGHT_PREVIEW_OPTIONS.kerning,
                  TOP_RIGHT_PREVIEW_OPTIONS.textColor,
                  TOP_RIGHT_PREVIEW_OPTIONS.isBold
                );
                getCircularText(
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.element,
                  '',
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.isBold
                );

                getCircularText(
                  TOP_LEFT_PREVIEW_OPTIONS.element,
                  '',
                  TOP_LEFT_PREVIEW_OPTIONS.width,
                  TOP_LEFT_PREVIEW_OPTIONS.rotation,
                  TOP_LEFT_PREVIEW_OPTIONS.textCentering,
                  TOP_LEFT_PREVIEW_OPTIONS.align,
                  TOP_LEFT_PREVIEW_OPTIONS.textInside,
                  TOP_LEFT_PREVIEW_OPTIONS.font,
                  TOP_LEFT_PREVIEW_OPTIONS.fontSize,
                  TOP_LEFT_PREVIEW_OPTIONS.kerning,
                  TOP_LEFT_PREVIEW_OPTIONS.textColor,
                  TOP_LEFT_PREVIEW_OPTIONS.isBold
                );

                getCircularText(
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.element,
                  '',
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.isBold
                );

                getCircularText(
                  RIGHT_PREVIEW_OPTIONS.element,
                  RIGHT_PREVIEW_OPTIONS.text,
                  RIGHT_PREVIEW_OPTIONS.width,
                  RIGHT_PREVIEW_OPTIONS.rotation,
                  RIGHT_PREVIEW_OPTIONS.textCentering,
                  RIGHT_PREVIEW_OPTIONS.align,
                  RIGHT_PREVIEW_OPTIONS.textInside,
                  RIGHT_PREVIEW_OPTIONS.font,
                  RIGHT_PREVIEW_OPTIONS.fontSize,
                  RIGHT_PREVIEW_OPTIONS.kerning,
                  RIGHT_PREVIEW_OPTIONS.textColor,
                  RIGHT_PREVIEW_OPTIONS.isBold
                );

                getCircularText(
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.element,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.text,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.width,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.align,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.font,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  RIGHT_PREVIEW_OPTIONS_PREVIEW.isBold
                );

                getCircularText(
                  TOP_PREVIEW_OPTIONS.element,
                  TOP_PREVIEW_OPTIONS.text,
                  TOP_PREVIEW_OPTIONS.width,
                  TOP_PREVIEW_OPTIONS.rotation,
                  TOP_PREVIEW_OPTIONS.textCentering,
                  TOP_PREVIEW_OPTIONS.align,
                  TOP_PREVIEW_OPTIONS.textInside,
                  TOP_PREVIEW_OPTIONS.font,
                  TOP_PREVIEW_OPTIONS.fontSize,
                  TOP_PREVIEW_OPTIONS.kerning,
                  TOP_PREVIEW_OPTIONS.textColor,
                  TOP_PREVIEW_OPTIONS.isBold
                );

                getCircularText(
                  TOP_PREVIEW_OPTIONS_PREVIEW.element,
                  TOP_PREVIEW_OPTIONS_PREVIEW.text,
                  TOP_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_PREVIEW_OPTIONS_PREVIEW.isBold
                );

                getCircularText(
                  LEFT_PREVIEW_OPTIONS.element,
                  LEFT_PREVIEW_OPTIONS.text,
                  LEFT_PREVIEW_OPTIONS.width,
                  LEFT_PREVIEW_OPTIONS.rotation,
                  LEFT_PREVIEW_OPTIONS.textCentering,
                  LEFT_PREVIEW_OPTIONS.align,
                  LEFT_PREVIEW_OPTIONS.textInside,
                  LEFT_PREVIEW_OPTIONS.font,
                  LEFT_PREVIEW_OPTIONS.fontSize,
                  LEFT_PREVIEW_OPTIONS.kerning,
                  LEFT_PREVIEW_OPTIONS.textColor,
                  LEFT_PREVIEW_OPTIONS.isBold
                );

                getCircularText(
                  LEFT_PREVIEW_OPTIONS_PREVIEW.element,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.text,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.width,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.align,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.font,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  LEFT_PREVIEW_OPTIONS_PREVIEW.isBold
                );
              } else {
                // reset the old
                getCircularText(
                  TOP_PREVIEW_OPTIONS.element,
                  '',
                  TOP_PREVIEW_OPTIONS.width,
                  TOP_PREVIEW_OPTIONS.rotation,
                  TOP_PREVIEW_OPTIONS.textCentering,
                  TOP_PREVIEW_OPTIONS.align,
                  TOP_PREVIEW_OPTIONS.textInside,
                  TOP_PREVIEW_OPTIONS.font,
                  TOP_PREVIEW_OPTIONS.fontSize,
                  TOP_PREVIEW_OPTIONS.kerning,
                  TOP_PREVIEW_OPTIONS.textColor,
                  TOP_PREVIEW_OPTIONS.isBold
                );
                getCircularText(
                  TOP_PREVIEW_OPTIONS_PREVIEW.element,
                  '',
                  TOP_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_PREVIEW_OPTIONS_PREVIEW.isBold
                );
                // setup 2/3
                getCircularText(
                  TOP_RIGHT_PREVIEW_OPTIONS.element,
                  TOP_RIGHT_PREVIEW_OPTIONS.text,
                  TOP_RIGHT_PREVIEW_OPTIONS.width,
                  TOP_RIGHT_PREVIEW_OPTIONS.rotation,
                  TOP_RIGHT_PREVIEW_OPTIONS.textCentering,
                  TOP_RIGHT_PREVIEW_OPTIONS.align,
                  TOP_RIGHT_PREVIEW_OPTIONS.textInside,
                  TOP_RIGHT_PREVIEW_OPTIONS.font,
                  TOP_RIGHT_PREVIEW_OPTIONS.fontSize,
                  TOP_RIGHT_PREVIEW_OPTIONS.kerning,
                  TOP_RIGHT_PREVIEW_OPTIONS.textColor,
                  TOP_RIGHT_PREVIEW_OPTIONS.isBold
                );
                getCircularText(
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.element,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.text,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_RIGHT_PREVIEW_OPTIONS_PREVIEW.isBold
                );

                getCircularText(
                  TOP_LEFT_PREVIEW_OPTIONS.element,
                  TOP_LEFT_PREVIEW_OPTIONS.text,
                  TOP_LEFT_PREVIEW_OPTIONS.width,
                  TOP_LEFT_PREVIEW_OPTIONS.rotation,
                  TOP_LEFT_PREVIEW_OPTIONS.textCentering,
                  TOP_LEFT_PREVIEW_OPTIONS.align,
                  TOP_LEFT_PREVIEW_OPTIONS.textInside,
                  TOP_LEFT_PREVIEW_OPTIONS.font,
                  TOP_LEFT_PREVIEW_OPTIONS.fontSize,
                  TOP_LEFT_PREVIEW_OPTIONS.kerning,
                  TOP_LEFT_PREVIEW_OPTIONS.textColor,
                  TOP_LEFT_PREVIEW_OPTIONS.isBold
                );

                getCircularText(
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.element,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.text,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.width,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.rotation,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textCentering,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.align,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textInside,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.font,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.fontSize,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.kerning,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.textColor,
                  TOP_LEFT_PREVIEW_OPTIONS_PREVIEW.isBold
                );
              }
            }
          } else {
            $('#ornament-text' + textField + '-overlay').find('span').text($(textInput).val());
            $('#ornament-text' + textField + '-overlay-preview').find('span').text($(textInput).val());

            if ($('#ornament-type').val() == 'BAR_BRACELET') {
              let amountInString = nonLatinCodepointsInString($(textInput).val());
              let stringLength = $(textInput).val().length;
              if (amountInString == stringLength) return;
              let resultTextArray = $('#ornament-text1-overlay').text().split('');
              let textSize = $('#ornament-text1-overlay').find('span').css('font-size').replace('px', '');

              let upper = 0;
              let lower = 0;
              for (var i = 0; i < resultTextArray.length; i++) {
                if (resultTextArray[i] == resultTextArray[i].toUpperCase() && !containsNonLatinCodepoints(resultTextArray[i])) {
                  upper++;
                } else {
                  lower++;
                }
              }
              let html = '';
              textSize = parseInt(textSize);
              for (var i = 0; i < resultTextArray.length; i++) {
                if (containsNonLatinCodepoints(resultTextArray[i])) {
                  if (upper >= 1) {
                    html += '<span style="padding-top: 0.205em; font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  } else {
                    html += '<span class="diff-padding" style="font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  }
                } else {
                  html += '<span style="font-size: ' + (textSize) + 'px">' + resultTextArray[i] + '</span>';
                }
              }
              $('#ornament-text1-overlay').find('span').html(html);
            } else if ($('#ornament-type').val() == 'ENGRAVABLE_PENDANT_NECKLACE') {
              let amountInString = nonLatinCodepointsInString($(textInput).val());
              let stringLength = $(textInput).val().length;
              if (amountInString == stringLength) return;
              let resultTextArray = $('#ornament-text1-overlay').text().split('');
              let textSize = $('#ornament-text1-overlay').find('span').css('font-size').replace('px', '');

              let upper = 0;
              let lower = 0;
              for (var i = 0; i < resultTextArray.length; i++) {
                if (resultTextArray[i] == resultTextArray[i].toUpperCase() && !containsNonLatinCodepoints(resultTextArray[i])) {
                  upper++;
                } else {
                  lower++;
                }
              }
              let html = '';
              textSize = parseInt(textSize);
              for (var i = 0; i < resultTextArray.length; i++) {
                if (containsNonLatinCodepoints(resultTextArray[i])) {
                  if (upper >= 1) {
                    html += '<span style="padding-top: 0.105em; font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  } else {
                    html += '<span class="" style="font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  }
                } else {
                  html += '<span style="font-size: ' + (textSize) + 'px">' + resultTextArray[i] + '</span>';
                }
              }
              $('#ornament-text1-overlay').find('span').html(html);
              $('#ornament-text1-overlay-preview').find('span').html(html);
            } else if ($('#ornament-type').val() == 'ENGRAVABLE_ID_BRACELET') {
              let amountInString = nonLatinCodepointsInString($(textInput).val());
              let stringLength = $(textInput).val().length;
              if (amountInString == stringLength) return;
              let resultTextArray = $('#ornament-text1-overlay').text().split('');
              let textSize = $('#ornament-text1-overlay').find('span').css('font-size').replace('px', '');

              let upper = 0;
              let lower = 0;
              for (var i = 0; i < resultTextArray.length; i++) {
                if (resultTextArray[i] == resultTextArray[i].toUpperCase() && !containsNonLatinCodepoints(resultTextArray[i])) {
                  upper++;
                } else {
                  lower++;
                }
              }
              let html = '';
              textSize = parseInt(textSize);
              for (var i = 0; i < resultTextArray.length; i++) {
                if (containsNonLatinCodepoints(resultTextArray[i])) {
                  if (upper >= 1) {
                    html += '<span style="padding-top: 0.105em; font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  } else {
                    html += '<span class="" style="font-size: ' + (textSize * 0.70) + 'px">' + resultTextArray[i] + '</span>';
                  }
                } else {
                  html += '<span style="font-size: ' + (textSize) + 'px">' + resultTextArray[i] + '</span>';
                }
              }
              $('#ornament-text1-overlay').find('span').html(html);
              $('#ornament-text1-overlay-preview').find('span').html(html);
            }
          }
        }

        handleTextRender($('#TEXT1'), 1);
        handleTextRender($('#TEXT2'), 2);
        handleTextRender($('#TEXT3'), 3);
        handleTextRender($('#TEXT4'), 4);

        // check for heart keychain
        if (ORNAMENT_TYPE == 'HEART_PHOTO_KEYCHAIN') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'SPIN_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
          handleTextRender($('.symbol-input')[1], 2);
          handleTextRender($('.symbol-input')[2], 3);

          $('#ornament-symbol-overlay-preview').find('span').text($($('.active-character')[0]).text());
        } else if (ORNAMENT_TYPE == 'SQUARE_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'CIRCLE_QUADRANT_NECKLACE') {
          $('#ornament-text' + 1 + '-overlay').find('span').text($($('.active-character')[3]).text());
          $('#ornament-text' + 2 + '-overlay').find('span').text($($('.active-character')[1]).text());
          $('#ornament-text' + 3 + '-overlay').find('span').text($($('.active-character')[2]).text());
          $('#ornament-text' + 4 + '-overlay').find('span').text($($('.active-character')[0]).text());

          $('#ornament-text' + 1 + '-overlay-preview').find('span').text($($('.active-character')[3]).text());
          $('#ornament-text' + 2 + '-overlay-preview').find('span').text($($('.active-character')[1]).text());
          $('#ornament-text' + 3 + '-overlay-preview').find('span').text($($('.active-character')[2]).text());
          $('#ornament-text' + 4 + '-overlay-preview').find('span').text($($('.active-character')[0]).text());
        } else if (ORNAMENT_TYPE == 'CIRCLE_CHARM') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'HEART_CHARM') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'CIRCLE_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'CIRCLE_PHOTO_KEYCHAIN') {
          $('#ornament-text' + 4 + '-overlay').find('span').text($($('.active-character')[0]).text());
          $('#ornament-text' + 2 + '-overlay').find('span').text($($('.active-character')[1]).text());
          $('#ornament-text' + 3 + '-overlay').find('span').text($($('.active-character')[2]).text());
          $('#ornament-text' + 1 + '-overlay').find('span').text($($('.active-character')[3]).text());

          $('#ornament-text' + 4 + '-overlay-preview').find('span').text($($('.active-character')[0]).text());
          $('#ornament-text' + 2 + '-overlay-preview').find('span').text($($('.active-character')[1]).text());
          $('#ornament-text' + 3 + '-overlay-preview').find('span').text($($('.active-character')[2]).text());
          $('#ornament-text' + 1 + '-overlay-preview').find('span').text($($('.active-character')[3]).text());
        } else if (ORNAMENT_TYPE == 'BAR_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_SNOWFLAKE_ORNAMENT') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'HEART_BIRTHSTONE_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'OVAL_VERTICAL_LOCKET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'OVAL_LOCKET_RING') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'OVAL_LOCKET_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_RING') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'HEART_LOCKET_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'FLIP_LOCKET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_ID_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_PENDANT_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'PAVE_CIRCLE_ENGRAVABLE_CHARM') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_CHARM') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_TENNIS_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_PAPERCLIP_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_CIRCLE_PHOTO_BRACELET') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_BOOKMARK') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_PHOTO_BOOKMARK') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_BAR_RING') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_HEART_LOCKET_KEYCHAIN') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'CIRCLE_PHOTO_SQUARE_KEYCHAIN') {
          handleTextRender($('.symbol-input')[0], 1);
        } else if (ORNAMENT_TYPE == 'ENGRAVABLE_CIRCLE_PHOTO_LARIAT_NECKLACE') {
          handleTextRender($('.symbol-input')[0], 1);
        }
      }

      $('#viewPreview').click(function () {
        var $upload = new theme.Modals('preview-modal', 'preview-modal', {
          solid: true
        });
        $upload.open();
        loadPreviewSizing(ORNAMENT_TYPE);
        if (ORNAMENT_TYPE == 'CRESCENT_STAR') {
          var width = document.getElementById("ornament-circle-text-overlay-preview").width;
          var previewSize = (0.067226890756303 * width) + 'px';
          $('#ornament-circle-text-overlay-preview').css('font', previewSize + ' ' + ACTIVE_FONT);
          getCircularText(document.getElementById('ornament-circle-text-overlay-preview'), $('#TEXT1').val(), width, 240, "center", false, false, ACTIVE_FONT, previewSize, 0.013333333333333334 * width);
        } else if (ORNAMENT_TYPE == 'CIRCLE_HEART_CUTOUT') {
          var width = $('#ornament-circle-text-overlay-preview').width()
          var previewSize = (0.103529411764706 * width)
          var previewSecondSize = (0.103529411764706 * width)
          if ($('#TEXT1').val() != $('#TEXT1').val().toUpperCase()) {
            previewSize = previewSize * 1.3;
          }
          if ($('#TEXT2').val() != $('#TEXT2').val().toUpperCase()) {
            previewSecondSize = previewSecondSize * 1.3;
          }
          previewSize = previewSize + 'px';
          previewSecondSize = previewSecondSize + 'px';
          getCircularText(document.getElementById('ornament-circle-text-overlay-preview'), $('#TEXT1').val(), width, 0, "center", false, true, ACTIVE_FONT, previewSize, 0);
          getCircularText(document.getElementById('ornament-circle-text-overlay-2-preview'), $('#TEXT2').val(), width, 180, "center", false, false, ACTIVE_FONT, previewSecondSize, 0);
        } else if (ORNAMENT_TYPE == 'CIRCLE_CENTER_CUTOUT') {
          var width = document.getElementById("ornament-circle-text-overlay-preview").width;
          var previewSize = (0.094117647058824 * width) + 'px';
          getCircularText(document.getElementById('ornament-circle-text-overlay-preview'), $('#TEXT1').val(), width, 0, "center", false, true, ACTIVE_FONT, previewSize, 0);
          getCircularText(document.getElementById('ornament-circle-text-overlay-2-preview'), $('#TEXT2').val(), width, 180, "center", false, false, ACTIVE_FONT, previewSize, 0);
        } else if (containersByType[ORNAMENT_TYPE]) {
          var selectedID = $("select[name='id']").val();
          var revisedURL = $('#img_' + selectedID).val();
          if (revisedURL.indexOf('no-image') > -1) {
            revisedURL = $('#img_' + productId).attr('src');
          }
          $('.ornament-preview-image-container img').attr('src', revisedURL);
        }
      });

      // Handle character count text on inputs
      function handleInputCount(el) {
        var length = 0
        if ($(el).val()) {
          length = $(el).val().length;
        }
        $(el).parent().find('.input-count').find('.input-count-amount').text(parseInt($(el).attr('maxlength')) - length);
        $(el).on('change keyup paste input', function () {
          if ($('#locket-type').val()) {
            $(el).val($(el).val().replace(/[\u{1F600}-\u{1F6FF}]/u, ''));
          }
          $(el).val($(el).val().replace(/[^\p{L}\p{N}\p{P}\p{Z}^$\n]/gu, ''));
          var length = 0;
          if ($(el).val()) {
            length = $(el).val().length
          }
          var count = parseInt($(el).attr('maxlength')) - length;
          if (count == 1) {
            $(el).parent().find('.input-count').find('.characters-remaining').text(' character remaining');
          } else {
            $(el).parent().find('.input-count').find('.characters-remaining').text(' characters remaining');
          }
          $(el).parent().find('.input-count').find('.input-count-amount').text(count);
        })
      }

      setInterval(function () {
        renderText();
      }, 500);

      // Handle dynamic max characters on inputs
      function handleCharacterMaximums() {
        if (ORNAMENT_TYPE == "ZODIAC") {
          $('#TEXT1').attr('maxlength', 12);
          $('#TEXT2').attr('maxlength', 18);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
        } else if (ORNAMENT_TYPE == "BIRD") {
          $('#TEXT1').attr('maxlength', 16);
          $('#TEXT2').attr('maxlength', 16);
          $('#TEXT3').attr('maxlength', 16);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
          handleInputCount($('#TEXT3'));
        } else if (ORNAMENT_TYPE == "CIRCLE_CENTER_CUTOUT") {
          // load in library
          $('#TEXT1').attr('maxlength', 24);
          $('#TEXT2').attr('maxlength', 24);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
        } else if (ORNAMENT_TYPE == "CIRCLE_HEART_CUTOUT") {
          // load in library
          $('#TEXT1').attr('maxlength', 20);
          $('#TEXT2').attr('maxlength', 20);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
        } else if (ORNAMENT_TYPE == "CIRCLE_SYMBOL") {
          $('#TEXT1').attr('maxlength', 22);
          $('#TEXT2').attr('maxlength', 18);
          $('#TEXT3').attr('maxlength', 10);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
          handleInputCount($('#TEXT3'));
        } else if (ORNAMENT_TYPE == "CRESCENT_STAR") {
          // load in library
          $('#TEXT1').attr('maxlength', 25);
          handleInputCount($('#TEXT1'));
        } else if (ORNAMENT_TYPE == "HEART") {
          $('#TEXT1').attr('maxlength', 15);
          $('#TEXT2').attr('maxlength', 15);
          $('#TEXT3').attr('maxlength', 12);
          $('#TEXT4').attr('maxlength', 12);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
          handleInputCount($('#TEXT3'));
          handleInputCount($('#TEXT4'));
        } else if (ORNAMENT_TYPE == "PAW") {
          $('#TEXT1').attr('maxlength', 12);
          $('#TEXT2').attr('maxlength', 12);
          handleInputCount($('#TEXT1'));
          handleInputCount($('#TEXT2'));
        }
      }

      // Setup input containers
      renderContainersByType(ORNAMENT_TYPE);

      // Setup font container
      var fontContainerHtml = '';
      for (var i = 0; i < FONT_OVERRIDES.length; i++) {
        var eachFontName = FONT_OVERRIDES[i];
        var nameWithoutExtension = eachFontName.split('.')[0];
        var actualFontName = toTitleCase(nameWithoutExtension.replaceAll('_', ' ')).replaceAll('Font ', '')
        var containerHtml = '<div class="ornament-button font-button font-selector" data-font="' + actualFontName + '" data-name="' + nameWithoutExtension + '"><span class="font-example" style="font-family: ' + actualFontName + ';">Aa</span></div>'
        fontContainerHtml += containerHtml;
      }

      if (!FONT_OVERRIDES.includes('font_dayrom.ttf')) {
        ACTIVE_FONT = 'Alga';
        ACTIVE_FONT_PROPERTY = 'F8';
      }

      $('.font-container').html(fontContainerHtml);
      $('.ornament-button[data-font="' + ACTIVE_FONT + '"]').addClass('active');

      // Setup font buttons
      $('body').on('click', '.font-button', function () {
        $('.font-button').removeClass('active');
        $(this).addClass('active');
        ACTIVE_FONT = $(this).data('font');
        ACTIVE_FONT_PROPERTY = FONT_PROPERTIES[ACTIVE_FONT];
        $('#FONT').val(ACTIVE_FONT_PROPERTY);
        renderText();
        renderText();
      });

      // Setup symbol container
      var symbolContainerHtml = self.renderDropdownContainer('Symbols', 'symbols');
      $('.symbol-container').html(symbolContainerHtml);

      for (var i = 0; i < Object.keys(SYMBOL_NAMES).length; i++) {
        var fileName = Object.keys(SYMBOL_NAMES)[i];
        var symbolUrl = ASSET_URL_BASE + fileName;
        var symbolName = toTitleCase(fileName.replaceAll('-', ' ').replaceAll('_', ' ')).split('.')[0];
        var buttonHtml = '<div class="symbol-mini"><div class="ornament-button symbol-selector" data-symbol="' + fileName + '" data-name="' + fileName + '"><img class="symbol-image" src="' + symbolUrl + '" /></div><div class="symbol-name">' + fetchSymbolNameOverride(symbolName) + '</div></div>';
        $('.tab-content[data-tab="symbols"]').append(buttonHtml);
      }

      $('.symbol-input').on('change', function () {
        renderText();
      });

      // Setup symbol buttons
      $('body').on('click', '.symbol-selector', function () {
        $('.symbol-selector').removeClass('active');
        $(this).addClass('active');
        ACTIVE_SELECTED = $(this).data('symbol');
        $('#SYMBOL').val(SYMBOL_NAMES[ACTIVE_SELECTED] || ZODIAC_NAMES[ACTIVE_SELECTED]);
        renderText();
      });

      // Setup other symbol container
      var zodiacSymbolContainerHtml = self.renderDropdownContainer('Zodiac', 'zodiac-symbols');
      $('.zodiac-container').html(zodiacSymbolContainerHtml);
      for (var i = 0; i < Object.keys(ZODIAC_NAMES).length; i++) {
        var fileName = Object.keys(ZODIAC_NAMES)[i];
        var symbolUrl = ASSET_URL_BASE + fileName;
        var symbolName = toTitleCase(fileName.replaceAll('-', ' ').replaceAll('_', ' ')).split('.')[0];
        var buttonHtml = '<div class="symbol-mini"><div class="ornament-button symbol-selector" data-symbol="' + fileName + '" data-name="' + fileName + '"><img class="symbol-image" src="' + symbolUrl + '" /></div><div class="symbol-name">' + fetchSymbolNameOverride(symbolName) + '</div></div>';
        $('.tab-content[data-tab="zodiac-symbols"]').append(buttonHtml);
      }

      if (ORNAMENT_TYPE == 'ZODIAC') {
        $('.tab-label[for="zodiac-symbols-check"]').click();
      } else {
        $('.tab-label[for="symbols-check"]').click();
      }

      // Handle ATC events
      $('body').on('click', '.add-to-cart-btn', function (e) {
        var selectedID = $("select[name='id']").val();
        e.preventDefault();
        e.stopPropagation();

        var $addToCart = $('.add-to-cart-btn');
        var $body = $(document.body);
        if ($('#upload-preview').attr('src') == '' && !$('button.add-to-cart').hasClass('skip-upload') && !overrideSkip && $('.upload-confirm-modal').length > 0) {
          // $('button.add-to-cart').prop('disabled', true);
          $ornamentConfirm.open();
        } else {
          overrideSkip = false;
          $('button.add-to-cart').prop('disabled', false);
          $addToCart.removeClass('is-added').addClass('is-adding');
          var engravingProperty = '';
          if (ACTIVE_SELECTED) {
            engravingProperty = 'Z-' + (SYMBOL_NAMES[ACTIVE_SELECTED] || ZODIAC_NAMES[ACTIVE_SELECTED])
          }

          var properties = {
            '_FONT': ACTIVE_FONT_PROPERTY,
            '_SYMBOL_NAME': ACTIVE_SELECTED ? fetchSymbolNameOverride(ACTIVE_SELECTED.replace('.svg', '').replace('-', ' ')) : '',
            '_SYMBOL': ACTIVE_SELECTED,
            '_TEXT1': $('#TEXT1').val(),
            '_TEXT2': $('#TEXT2').val(),
            '_TEXT3': $('#TEXT3').val(),
            '_TEXT4': $('#TEXT4').val(),
            '_ENGRAVING': engravingProperty
          }

          if ($('#upload-circle-property').val() && $('#locket-type').val() && $('#ornament-type').val()) {
            properties['_circlerender'] = $('#upload-circle-property').val();
          }

          if ($('#TEXT1').val()) {
            properties['Line 1'] = $('#TEXT1').val();
          }
          if ($('#TEXT2').val()) {
            properties['Line 2'] = $('#TEXT2').val();
          }
          if ($('#TEXT3').val()) {
            properties['Line 3'] = $('#TEXT3').val();
          }
          if ($('#TEXT4').val()) {
            properties['Line 4'] = $('#TEXT4').val();
          }

          if (ACTIVE_SELECTED) {
            properties['Symbol'] = fetchSymbolNameOverride(ACTIVE_SELECTED.replace('.svg', '').replace('-', ' '));
          }

          if ($('#upload-unedited-property').val()) {
            properties['photo'] = $('#upload-unedited-property').val();
          }
          if ($('#upload-circle-property').val() == 'false' || $('#upload-circle-property').val() == 'true') {
            properties['circlerender'] = $('#upload-circle-property').val();
          }

          let additionalProperties = generateTextValues($('#FONT').val());
          if (additionalProperties) {
            let keys = Object.keys(additionalProperties);
            for (var i = 0; i < keys.length; i++) {
              properties[keys[i]] = additionalProperties[keys[i]];
            }
          }
          $('.ajaxcart__item-result').css('font-family', 'Alga');

          var cartAdditions = [{
            quantity: 1,
            id: selectedID,
            properties: properties
          }];

          const data = {
            items: cartAdditions
          };
          const xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/add.js', true);
          xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
          xhr.send(JSON.stringify(data));
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              $addToCart.prop('disabled', false);
              $addToCart.removeClass('is-adding').addClass('is-added');
              ShopifyAPI.getCart(function (cart) {
                $body.trigger('afterAddToCart.ajaxCart', cart);
                $('.cart-link').trigger('click');
              });
            } else {
              $addToCart.prop('disabled', false);
              $addToCart.removeClass('is-adding').removeClass('is-added');

              if (xhr.response && xhr.status && xhr.status != 200) {
                let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
                  solid: true
                });
                let message = xhr.response && JSON.parse(xhr.response).message;
                if (message && message.indexOf("'") > -1) {
                  let start = message.split("'");
                  let end = ' is sold out. Please remove the item.';
                  message = start[0] + "'" + start[1] + "'" + end;
                }
                $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
                $('#warning-modal-close').click(function (e) {
                  warningModal.close();
                });
                warningModal.open();
              }
            }
          };
        }
      });

      // Setup character maximums for input fields
      handleCharacterMaximums();

      // Setup change events
      $('#TEXT1').on('change keyup paste input', function () {
        renderText();
      });
      $('#TEXT2').on('change keyup paste input', function () {
        renderText();
      });
      $('#TEXT3').on('change keyup paste input', function () {
        renderText();
      });
      $('#TEXT4').on('change keyup paste input', function () {
        renderText();
      });

      $('.symbol-input').on('change keyup paste input', function () {
        renderText();
      });

      function handleSelect(selectType) {
        if (selectType == 'BACK') {
          $('#ornament-text1-overlay-preview').hide();
          $('#ornament-text2-overlay-preview').hide();
          $('#ornament-text3-overlay-preview').hide();
          $('#ornament-text4-overlay-preview').hide();
          $('#ornament-symbol-overlay-preview').show();
        } else {
          $('#ornament-symbol-overlay-preview').hide();
          $('#ornament-text1-overlay-preview').show();
          $('#ornament-text2-overlay-preview').show();
          $('#ornament-text3-overlay-preview').show();
          $('#ornament-text4-overlay-preview').show();
        }
        renderText();
      }

      $('.selector-button').click(function (e) {
        $('.selector-button').removeClass('active');
        $(this).addClass('active');
        handleSelect($(this).data('type'));
        e.preventDefault();
        e.stopPropagation();
      });
    } else if ($('.custom-product-input-field').length) {
    } else if ($('#locket-type').val()) {
      $('body').on('click', '.add-to-cart-btn', function (e) {
        var selectedID = $("select[name='id']").val();
        e.preventDefault();
        e.stopPropagation();
        var $addToCart = $('.add-to-cart-btn');
        var $body = $(document.body);
        $addToCart.removeClass('is-added').addClass('is-adding');
        $addToCart.prop('disabled', true);

        var properties = { '_circlerender': $('#upload-circle-property').val(), 'photo': $('#upload-unedited-property').val() };

        var cartAdditions = [{
          quantity: 1,
          id: selectedID,
          properties: properties
        }];

        const data = {
          items: cartAdditions
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        xhr.send(JSON.stringify(data));
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').addClass('is-added');
            ShopifyAPI.getCart(function (cart) {
              $body.trigger('afterAddToCart.ajaxCart', cart);
              $('.cart-link').trigger('click');
            });
          } else {
            $addToCart.prop('disabled', false);
            $addToCart.removeClass('is-adding').removeClass('is-added');

            if (xhr.response && xhr.status && xhr.status != 200) {
              let warningModal = new theme.Modals('warning-modal', 'warning-modal', {
                solid: true
              });
              let message = xhr.response && JSON.parse(xhr.response).message;
              if (message && message.indexOf("'") > -1) {
                let start = message.split("'");
                let end = ' is sold out. Please remove the item.';
                message = start[0] + "'" + start[1] + "'" + end;
              }
              $('.warning-modal-text').text(message || 'An error occurred while adding items to your cart. Please try again.');
              $('#warning-modal-close').click(function (e) {
                warningModal.close();
              });
              warningModal.open();
            }
          }
        };
      });
    }
  },

  events: {},

  fileToBlob: async (file) => {
    return new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type })
  },

  loadScript: function (url, callback) {
    let script;
    const scripts = Array.from(document.querySelectorAll('script'));
    const existingScript = scripts.find(function (script) {
      script.src === url
    });
    if (existingScript) {
      script = existingScript;
    } else {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      }
    } else {
      script.onload = function () {
        callback()
      }
    }
  },

  initUploader: function () {
    var self = this;
    var $modal = new theme.Modals('upload-modal', 'upload-modal', {
      solid: true
    });
    var $confirmModal = new theme.Modals('upload-confirm-modal', 'upload-confirm-modal', {
      solid: true
    });
    const { appendDefaultEditor, openDefaultEditor, createDefaultImageReader, createDefaultImageWriter } = pintura;
    var pinturaData;

    $('#upload-file').on('change', async function (uploadEvent) {
      const file = uploadEvent.target.files[0];

      $modal.open();
      $('.pintura-editor').html('');
      /*
        openDefaultEditor({
          src: './image.jpeg',
          imageBackgroundImage: './my-background-image.jpeg'
        })
      */
      const currentPageType = ($('#locket-type').length && $('#locket-type').val()) ?? 'DEFAULT';

      let equippedShape;
      let equippedPostProcess = (imageData) => { return imageData }; // default to empty
      switch (currentPageType) {
        case 'heart':
          // TODO set postprocess
          break;
        case 'rectangle':
          // TODO set postprocess
          break;
        case 'oval':
          // TODO set postprocess
          break;
        case 'oval-vertical':
          break;
        default:
          equippedPostProcess = (imageData) =>
            new Promise((resolve) => {
              // Create a canvas element to handle the imageData
              const canvas = document.createElement('canvas');
              canvas.width = imageData.width;
              canvas.height = imageData.height;
              const ctx = canvas.getContext('2d');
              ctx.putImageData(imageData, 0, 0);

              // Only draw image where we render our circular mask
              ctx.globalCompositeOperation = 'destination-in';

              // Draw our circular mask
              ctx.fillStyle = 'black';
              ctx.beginPath();
              ctx.arc(
                imageData.width * 0.5,
                imageData.height * 0.5,
                imageData.width * 0.5,
                0,
                2 * Math.PI
              );
              ctx.fill();

              // Returns the modified imageData
              resolve(
                ctx.getImageData(0, 0, canvas.width, canvas.height)
              );
            });
          break;
      }

      pinturaData = pintura.appendDefaultEditor('.pintura-editor', {
        // The source image to load
        src: file,
        // This will set a square crop aspect ratio
        imageCropAspectRatio: (currentPageType === 'rectangle') ? 1.332 : 1,
        cropEnableButtonFlipHorizontal: false,
        cropEnableButtonFlipVertical: false,
        imageCropLimitToImage: true,
        //imageBackgroundImage: file,
        willRenderCanvas: (shapes, state) => {
          const {
            utilVisibility,
            selectionRect,
            lineColor,
            backgroundColor,
          } = state;

          // Exit if crop utils is not visible
          if (utilVisibility.crop <= 0) return shapes;

          // Get variable shortcuts to the crop selection rect
          const { x, y, width, height } = selectionRect;

          // let's define shapes
          const rectangleShape = {
            x: x + width * 0.5,
            y: y + height * 0.5,
            opacity: utilVisibility.crop,
            inverted: true,
            backgroundColor: [...backgroundColor, 0.5],
            strokeWidth: 1,
            strokeColor: [...lineColor],
          };

          const ellipseShape = {
            x: selectionRect.x,
            y: selectionRect.y,
            width: selectionRect.width,
            height: selectionRect.height,
            opacity: 0.5,
            backgroundSize: 'contain',
            backgroundImage:
              'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/oval_horizontal.png',
          };

          const verticalEllipseShape = {
            x: selectionRect.x,
            y: selectionRect.y,
            width: selectionRect.width,
            height: selectionRect.height,
            opacity: 0.5,
            backgroundSize: 'contain',
            backgroundImage:
              'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/oval_verticle.png',
          };

          const heartShape = {
            x: selectionRect.x,
            y: selectionRect.y,
            width: selectionRect.width,
            height: selectionRect.height,
            opacity: 0.5,
            backgroundSize: 'contain',
            backgroundImage:
              'https://cdn.shopify.com/s/files/1/0586/0117/7256/files/heart_100.png',
          };

          const defaultShape = {
            x: x + width * 0.5,
            y: y + height * 0.5,
            rx: width * 0.5,
            ry: height * 0.5,
            opacity: utilVisibility.crop,
            inverted: true,
            backgroundColor: [...backgroundColor, 0.5],
            strokeWidth: 1,
            strokeColor: [...lineColor],
          }

          switch (currentPageType) {
            case 'heart':
              equippedShape = heartShape;
              break;
            case 'rectangle':
              equippedShape = rectangleShape;
              break;
            case 'oval':
              equippedShape = ellipseShape;
              break;
            case 'oval-vertical':
              equippedShape = verticalEllipseShape;
              break;
            default:
              equippedShape = defaultShape;
              break;
          }

          return {
            // Copy all props from current shapes
            ...shapes,

            // Now we add an inverted ellipse shape to the interface shapes array
            interfaceShapes: [
              equippedShape,
              // Spread all existing interface shapes onto the array
              ...shapes.interfaceShapes,
            ],
          };
        },
        imageReader: createDefaultImageReader({
          preprocessImageFile: async (file, options, onprogress) => {
            // I think the best approach would be to preprocess the image
            // and expand the canvas a bit adding the blurred image behind.
            // You could then set the `imageCrop` property of the editor to zoom back in on the original image bounds.

            // get canvas dimensions from image
            // expand canvas dimensions by 50%
            // put larger image behind canvas based off of size
            // layer new image on top
            // send same file

            return file;
          },
        }),
        imageWriter: createDefaultImageWriter({
          // Scale down the output image
          // Convert to PNG so masked area is transparent
          mimeType: 'image/jpeg',
          quality: 0.5,
          targetSize: {
            width: 1000,
            height: 1000,
            fit: 'contain',
            upscale: false,
          },
          postprocessImageData: equippedPostProcess,
        })
      });
      $('.PinturaRoot').append('<div class="editorLoading"><div class="lds-dual-ring"></div> <span style="text-align: center;">Loading...</span></div>')

      /*const pinturaData = pintura.appendDefaultEditor('.pintura-editor', {
          // The source image to load
          src: file,
          // This will set a square crop aspect ratio
          imageCropAspectRatio: 1,
      });*/

      setTimeout(function () {
        //Keep all variants enabled after modal is opened
        $('.variant-input').find('input').prop('disabled', false);
        $('.variant-input').find('label').toggleClass('disabled', false);
      }, 500);


      // Reset field so if customer reselects the same file we can rerun crop UI.
      $(this).replaceWith($(this).val('').clone(true));
    });

    $('.cr-slider-wrap').on('change', function () {
      setTimeout(function () {
        $('.variant-input').find('input').prop('disabled', false);
        $('.variant-input').find('label').toggleClass('disabled', false);
      }, 200);
    });

    $('.cr-boundary').on('touchmove', function () {
      setTimeout(function () {
        $('.variant-input').find('input').prop('disabled', false);
        $('.variant-input').find('label').toggleClass('disabled', false);
      }, 200);
    });

    $('.cr-pen').on('touchmove', function () {
      setTimeout(function () {
        $('.variant-input').find('input').prop('disabled', false);
        $('.variant-input').find('label').toggleClass('disabled', false);
      }, 200);
    });

    $('#upload-preview').on('load', function () {
      $(this).parent().removeClass('upload__preview-wrap--loading');
    });

    $('.img__preview').on('load', function () {
      // $(this).parent().removeClass('cart__preview-wrap--loading');
    });

    var overrideSkip = false;

    $('#upload-save').on('click', function () {
      $('#upload-save')
        .text('Uploading…')
        .prop('disabled', true)
        .addClass('btn--no-animate');

      // ** Send to Cloudinary
      $('.upload__preview-wrap').show();

      const currentPageType = ($('#locket-type').length && $('#locket-type').val()) ?? 'DEFAULT';
      pinturaData.processImage().then((imageWriterResult) => {
        // Logs resulting image
        var formData = new FormData();
        formData.append('file', imageWriterResult.dest);
        formData.append('upload_preset', 'ml_unsigned');
        formData.append('api_key', '211575742393728');
        $('.editorLoading').css('display', 'flex');

        $.ajax({
          url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
          type: 'POST',
          data: formData,
          async: true,
          success: function (data) { },
          error: function (data, error, errorThrown) {
            $('#upload-preview')
              .attr('src', '')
              .addClass('upload__preview--active');
            $('#upload-preview')
              .parent()
              .addClass('upload__preview-wrap--loading');
            $('.upload__preview-wrap').hide();
            $('#upload-property').val('');
            $('#upload-unedited-property').val('');
            $modal.close();
            if (!$('#ornament-type').val()) {
              $('#upload-save')
                .text('Upload & Add to Cart')
                .prop('disabled', false)
                .removeClass('btn--no-animate');
            } else {
              $('#upload-save')
                .text('Upload')
                .prop('disabled', false)
                .removeClass('btn--no-animate');
            }
            $('.editorLoading').hide();
            overrideSkip = true;
            $('button.add-to-cart').addClass('skip-upload');
            $('button.add-to-cart').click();
          },
          cache: false,
          contentType: false,
          processData: false,
          timeout: 15000
        }).done(function (response) {
          var optionsRevised = response.url;
          var newResponse = response.url;
          if (optionsRevised.indexOf('http://res.cloudinary.com/dgwldii6i/image/upload/') > -1) {
            var splitImage = optionsRevised.split('http://res.cloudinary.com/dgwldii6i/image/upload/')[1];
            var splitName = 'l_' + splitImage.split('/')[1];
            if (splitName) {
              splitName = splitName.substr(0, splitName.lastIndexOf('.'));
            }
            var splitID = splitImage.split('/')[0];
            optionsRevised = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
            newResponse = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage; //'https://res.cloudinary.com/dgwldii6i/image/upload/e_blur:2000/' + splitName + ',c_scale,w_0.9/fl_layer_apply/' + splitImage;            
            let newSource = 'https://res.cloudinary.com/dgwldii6i/image/upload/c_scale,h_250,w_250/' + splitImage;
            let removeHeightAttr = false;
            let circleRender = 'CIRCLE';
            switch (currentPageType) {
              case 'heart':
                circleRender = 'HEART';
                break;
              case 'oval':
                newSource = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
                circleRender = 'OVAL';
                removeHeightAttr = true;
                break;
              case 'oval-vertical':
                newSource = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
                circleRender = 'OVAL_VERTICAL';
                removeHeightAttr = true;
                break;
              case 'rectangle':
                newSource = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
                circleRender = 'SQUARE';
                removeHeightAttr = true;
                break;
              default:
                newSource = 'https://res.cloudinary.com/dgwldii6i/image/upload/c_scale,h_250,w_250/' + splitImage;
                break;
            }

            if (circleRender === 'HEART') {
              $('#upload-preview').hide();
              var scaleDownFactor = 0.8;
              var newWidth = 643 * scaleDownFactor;
              var newHeight = 643 * scaleDownFactor;
              var newX = (500.18 - newWidth) / 2;
              var newY = (472.42 - newHeight) / 2;
              if ($('.upload-preview-temp').length === 0) {
                let resultHtml = '<div class="upload__preview upload-preview-temp upload__preview--active"><svg class="result-svg" data-name="Layer 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500.18 472.42"><defs><clipPath id="shape5"><path class="cls-2" d="M250.22,61.56C271.92,25.59,328.01-3.61,386.03,.47c52.56,3.7,98.57,53.91,110.13,111.91,8.76,43.91,2.9,88.05-17.89,134.93-18.71,42.18-47.51,77.08-70.52,102.77-42.06,46.96-92.23,78.26-157.66,122.24-65.43-43.97-115.6-75.28-157.66-122.24-23.01-25.69-51.81-60.58-70.52-102.77C1.11,200.42-4.74,156.28,4.02,112.37,15.58,54.38,61.58,4.17,114.15,.47c58.02-4.08,114.11,25.12,135.81,61.09h.27Z"/></clipPath></defs><image width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" clip-path="url(#shape5)" xlink:href="' + newSource + '" ></image></svg></div>';
                $($('.upload__preview-wrap')[0]).append(resultHtml);
              } else {
                $('.upload-preview-temp').html('<svg class="result-svg" data-name="Layer 4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500.18 472.42"><defs><clipPath id="shape2"><path class="cls-2" d="M250.22,61.56C271.92,25.59,328.01-3.61,386.03,.47c52.56,3.7,98.57,53.91,110.13,111.91,8.76,43.91,2.9,88.05-17.89,134.93-18.71,42.18-47.51,77.08-70.52,102.77-42.06,46.96-92.23,78.26-157.66,122.24-65.43-43.97-115.6-75.28-157.66-122.24-23.01-25.69-51.81-60.58-70.52-102.77C1.11,200.42-4.74,156.28,4.02,112.37,15.58,54.38,61.58,4.17,114.15,.47c58.02-4.08,114.11,25.12,135.81,61.09h.27Z"/></clipPath></defs><image width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" clip-path="url(#shape2)" xlink:href="' + newSource + '" ></image></svg>')
              }
            } else if (circleRender == 'OVAL_VERTICAL') {
              $('#upload-preview').hide();
              var scaleDownFactor = 0.8;
              var newWidth = 643 * scaleDownFactor;
              var newHeight = 643 * scaleDownFactor;
              var newX = (375.03 - newWidth) / 2;
              var newY = (500.07 - newHeight) / 2;
              if ($('.upload-preview-temp').length === 0) {
                $($('.upload__preview-wrap')[0]).append('<div style="height: auto;" class="upload__preview upload-preview-temp upload__preview--active"><svg class="result-svg" data-name="Layer 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 375.03 500.07"><defs><clipPath id="shape2"><path class="cls-1" d="M187.78,499.64c-12.17,.64-24.05-1.2-35.78-4.2-6.77-1.73-13.37-3.97-19.83-6.65-8.3-3.44-16.21-7.58-23.82-12.32-7.8-4.86-15.11-10.33-22.09-16.3-6.42-5.49-12.41-11.4-18.08-17.65-7.54-8.3-14.44-17.12-20.55-26.52-4.14-6.38-8.05-12.92-11.78-19.54-2.64-4.69-4.86-9.63-7.2-14.49-1.63-3.37-3.28-6.74-4.68-10.2-2.18-5.38-4.26-10.81-6.18-16.29-1.89-5.39-3.8-10.8-5.24-16.33-2.44-9.35-4.75-18.74-6.66-28.2-1.52-7.53-2.61-15.18-3.47-22.82-.9-8.03-1.4-16.11-1.88-24.17-.34-5.81-.59-11.65-.46-17.47,.17-7.53,.63-15.06,1.22-22.57,.5-6.47,1.26-12.92,2.08-19.36,.57-4.51,1.33-9,2.21-13.46,1.23-6.28,2.52-12.55,4.01-18.76,2.07-8.62,4.43-17.17,7.5-25.49,2.06-5.6,4.12-11.21,6.32-16.75,3.34-8.42,7.35-16.53,11.58-24.56,6.23-11.8,13.36-23,21.47-33.58,3.47-4.53,7.23-8.83,10.93-13.17,5.45-6.39,11.48-12.22,17.79-17.75,7.03-6.16,14.48-11.77,22.39-16.76,7.27-4.59,14.78-8.75,22.75-11.97,5.74-2.32,11.58-4.42,17.5-6.24,7.47-2.3,15.12-3.92,22.91-4.75,3.69-.39,7.4-.65,11.11-.9,2.53-.17,5.09-.46,7.6-.27,6.9,.52,13.8,1.05,20.65,1.98,9.08,1.23,17.93,3.61,26.53,6.77,6.44,2.37,12.75,5.05,18.85,8.25,6.65,3.49,13.16,7.21,19.19,11.68,5.11,3.79,10.23,7.62,15.02,11.8,5.3,4.63,10.43,9.49,15.3,14.58,8.22,8.59,15.6,17.91,22.12,27.86,4.14,6.33,8.12,12.77,11.86,19.35,2.91,5.12,5.34,10.51,7.93,15.8,1.41,2.87,2.83,5.75,4.04,8.7,2.22,5.41,4.44,10.84,6.39,16.35,2.1,5.94,4.14,11.92,5.75,17.99,2.36,8.89,4.54,17.85,6.39,26.86,1.47,7.12,2.5,14.35,3.42,21.57,.84,6.57,1.61,13.17,1.79,19.78,.34,12.21,.49,24.45,.23,36.66-.16,7.61-1.03,15.21-1.89,22.78-.77,6.78-1.9,13.53-2.99,20.28-1.46,9.01-3.55,17.89-6.13,26.65-1.91,6.48-3.89,12.94-6.06,19.33-1.76,5.18-3.66,10.32-5.82,15.35-3,6.98-6.03,13.97-9.55,20.69-3.83,7.32-8.13,14.4-12.4,21.49-4.43,7.35-9.59,14.2-14.98,20.87-6.93,8.58-14.48,16.59-22.68,23.96-7.36,6.61-15.15,12.66-23.52,17.94-4.22,2.66-8.6,5.07-12.99,7.43-3.3,1.78-6.68,3.42-10.12,4.92-12.65,5.52-25.81,9.31-39.51,10.99-6.12,.75-12.31,.88-18.48,1.29,0-.14,0-.28-.01-.43Z" /></clipPath></defs><image clip-path="url(#shape2)" width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" xlink:href="' + newSource + '"></image></svg></div>');
              } else {
                $('.upload-preview-temp').html('<svg class="result-svg" data-name="Layer 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 375.03 500.07"><defs><clipPath id="shape7"><path class="cls-1" d="M187.78,499.64c-12.17,.64-24.05-1.2-35.78-4.2-6.77-1.73-13.37-3.97-19.83-6.65-8.3-3.44-16.21-7.58-23.82-12.32-7.8-4.86-15.11-10.33-22.09-16.3-6.42-5.49-12.41-11.4-18.08-17.65-7.54-8.3-14.44-17.12-20.55-26.52-4.14-6.38-8.05-12.92-11.78-19.54-2.64-4.69-4.86-9.63-7.2-14.49-1.63-3.37-3.28-6.74-4.68-10.2-2.18-5.38-4.26-10.81-6.18-16.29-1.89-5.39-3.8-10.8-5.24-16.33-2.44-9.35-4.75-18.74-6.66-28.2-1.52-7.53-2.61-15.18-3.47-22.82-.9-8.03-1.4-16.11-1.88-24.17-.34-5.81-.59-11.65-.46-17.47,.17-7.53,.63-15.06,1.22-22.57,.5-6.47,1.26-12.92,2.08-19.36,.57-4.51,1.33-9,2.21-13.46,1.23-6.28,2.52-12.55,4.01-18.76,2.07-8.62,4.43-17.17,7.5-25.49,2.06-5.6,4.12-11.21,6.32-16.75,3.34-8.42,7.35-16.53,11.58-24.56,6.23-11.8,13.36-23,21.47-33.58,3.47-4.53,7.23-8.83,10.93-13.17,5.45-6.39,11.48-12.22,17.79-17.75,7.03-6.16,14.48-11.77,22.39-16.76,7.27-4.59,14.78-8.75,22.75-11.97,5.74-2.32,11.58-4.42,17.5-6.24,7.47-2.3,15.12-3.92,22.91-4.75,3.69-.39,7.4-.65,11.11-.9,2.53-.17,5.09-.46,7.6-.27,6.9,.52,13.8,1.05,20.65,1.98,9.08,1.23,17.93,3.61,26.53,6.77,6.44,2.37,12.75,5.05,18.85,8.25,6.65,3.49,13.16,7.21,19.19,11.68,5.11,3.79,10.23,7.62,15.02,11.8,5.3,4.63,10.43,9.49,15.3,14.58,8.22,8.59,15.6,17.91,22.12,27.86,4.14,6.33,8.12,12.77,11.86,19.35,2.91,5.12,5.34,10.51,7.93,15.8,1.41,2.87,2.83,5.75,4.04,8.7,2.22,5.41,4.44,10.84,6.39,16.35,2.1,5.94,4.14,11.92,5.75,17.99,2.36,8.89,4.54,17.85,6.39,26.86,1.47,7.12,2.5,14.35,3.42,21.57,.84,6.57,1.61,13.17,1.79,19.78,.34,12.21,.49,24.45,.23,36.66-.16,7.61-1.03,15.21-1.89,22.78-.77,6.78-1.9,13.53-2.99,20.28-1.46,9.01-3.55,17.89-6.13,26.65-1.91,6.48-3.89,12.94-6.06,19.33-1.76,5.18-3.66,10.32-5.82,15.35-3,6.98-6.03,13.97-9.55,20.69-3.83,7.32-8.13,14.4-12.4,21.49-4.43,7.35-9.59,14.2-14.98,20.87-6.93,8.58-14.48,16.59-22.68,23.96-7.36,6.61-15.15,12.66-23.52,17.94-4.22,2.66-8.6,5.07-12.99,7.43-3.3,1.78-6.68,3.42-10.12,4.92-12.65,5.52-25.81,9.31-39.51,10.99-6.12,.75-12.31,.88-18.48,1.29,0-.14,0-.28-.01-.43Z" /></clipPath></defs><image clip-path="url(#shape7)" width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" xlink:href="' + newSource + '"></image></svg>')
              }
            } else if (circleRender == 'OVAL') {
              $('#upload-preview').hide();
              var scaleDownFactor = 0.8;
              var newWidth = 643 * scaleDownFactor;
              var newHeight = 643 * scaleDownFactor;
              var newX = (500.07 - newWidth) / 2;
              var newY = (375.03 - newHeight) / 2;
              if ($('.upload-preview-temp').length === 0) {
                $($('.upload__preview-wrap')[0]).append('<div style="height: auto;" class="upload__preview upload-preview-temp upload__preview--active"><svg class="result-svg" data-name="Layer 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500.07 375.03"><defs><clipPath id="shape6"><path class="cls-1" d="M.43,187.78c-.64-12.17,1.2-24.05,4.2-35.78,1.73-6.77,3.97-13.37,6.65-19.83,3.44-8.3,7.58-16.21,12.32-23.82,4.86-7.8,10.33-15.11,16.3-22.09,5.49-6.42,11.4-12.41,17.65-18.08,8.3-7.54,17.12-14.44,26.52-20.55,6.38-4.14,12.92-8.05,19.54-11.78,4.69-2.64,9.63-4.86,14.49-7.2,3.37-1.63,6.74-3.28,10.2-4.68,5.38-2.18,10.81-4.26,16.29-6.18,5.39-1.89,10.8-3.8,16.33-5.24,9.35-2.44,18.74-4.75,28.2-6.66,7.53-1.52,15.18-2.61,22.82-3.47,8.03-.9,16.11-1.4,24.17-1.88,5.81-.34,11.65-.59,17.47-.46,7.53,.17,15.06,.63,22.57,1.22,6.47,.5,12.92,1.26,19.36,2.08,4.51,.57,9,1.33,13.46,2.21,6.28,1.23,12.55,2.52,18.76,4.01,8.62,2.07,17.17,4.43,25.49,7.5,5.6,2.06,11.21,4.12,16.75,6.32,8.42,3.34,16.53,7.35,24.56,11.58,11.8,6.23,23,13.36,33.58,21.47,4.53,3.47,8.83,7.23,13.17,10.93,6.39,5.45,12.22,11.48,17.75,17.79,6.16,7.03,11.77,14.48,16.76,22.39,4.59,7.27,8.75,14.78,11.97,22.75,2.32,5.74,4.42,11.58,6.24,17.5,2.3,7.47,3.92,15.12,4.75,22.91,.39,3.69,.65,7.4,.9,11.11,.17,2.53,.46,5.09,.27,7.6-.52,6.9-1.05,13.8-1.98,20.65-1.23,9.08-3.61,17.93-6.77,26.53-2.37,6.44-5.05,12.75-8.25,18.85-3.49,6.65-7.21,13.16-11.68,19.19-3.79,5.11-7.62,10.23-11.8,15.02-4.63,5.3-9.49,10.43-14.58,15.3-8.59,8.22-17.91,15.6-27.86,22.12-6.33,4.14-12.77,8.12-19.35,11.86-5.12,2.91-10.51,5.34-15.8,7.93-2.87,1.41-5.75,2.83-8.7,4.04-5.41,2.22-10.84,4.44-16.35,6.39-5.94,2.1-11.92,4.14-17.99,5.75-8.89,2.36-17.85,4.54-26.86,6.39-7.12,1.47-14.35,2.5-21.57,3.42-6.57,.84-13.17,1.61-19.78,1.79-12.21,.34-24.45,.49-36.66,.23-7.61-.16-15.21-1.03-22.78-1.89-6.78-.77-13.53-1.9-20.28-2.99-9.01-1.46-17.89-3.55-26.65-6.13-6.48-1.91-12.94-3.89-19.33-6.06-5.18-1.76-10.32-3.66-15.35-5.82-6.98-3-13.97-6.03-20.69-9.55-7.32-3.83-14.4-8.13-21.49-12.4-7.35-4.43-14.2-9.59-20.87-14.98-8.58-6.93-16.59-14.48-23.96-22.68-6.61-7.36-12.66-15.15-17.94-23.52-2.66-4.22-5.07-8.6-7.43-12.99-1.78-3.3-3.42-6.68-4.92-10.12-5.52-12.65-9.31-25.81-10.99-39.51-.75-6.12-.88-12.31-1.29-18.48,.14,0,.28,0,.43-.01Z"/></clipPath></defs><image clip-path="url(#shape6)" width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" xlink:href="' + newSource + '"></image></svg></div>');
              } else {
                $('.upload-preview-temp').html('<svg class="result-svg" data-name="Layer 5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 500.07 375.03"><defs><clipPath id="shape7"><path class="cls-1" d="M.43,187.78c-.64-12.17,1.2-24.05,4.2-35.78,1.73-6.77,3.97-13.37,6.65-19.83,3.44-8.3,7.58-16.21,12.32-23.82,4.86-7.8,10.33-15.11,16.3-22.09,5.49-6.42,11.4-12.41,17.65-18.08,8.3-7.54,17.12-14.44,26.52-20.55,6.38-4.14,12.92-8.05,19.54-11.78,4.69-2.64,9.63-4.86,14.49-7.2,3.37-1.63,6.74-3.28,10.2-4.68,5.38-2.18,10.81-4.26,16.29-6.18,5.39-1.89,10.8-3.8,16.33-5.24,9.35-2.44,18.74-4.75,28.2-6.66,7.53-1.52,15.18-2.61,22.82-3.47,8.03-.9,16.11-1.4,24.17-1.88,5.81-.34,11.65-.59,17.47-.46,7.53,.17,15.06,.63,22.57,1.22,6.47,.5,12.92,1.26,19.36,2.08,4.51,.57,9,1.33,13.46,2.21,6.28,1.23,12.55,2.52,18.76,4.01,8.62,2.07,17.17,4.43,25.49,7.5,5.6,2.06,11.21,4.12,16.75,6.32,8.42,3.34,16.53,7.35,24.56,11.58,11.8,6.23,23,13.36,33.58,21.47,4.53,3.47,8.83,7.23,13.17,10.93,6.39,5.45,12.22,11.48,17.75,17.79,6.16,7.03,11.77,14.48,16.76,22.39,4.59,7.27,8.75,14.78,11.97,22.75,2.32,5.74,4.42,11.58,6.24,17.5,2.3,7.47,3.92,15.12,4.75,22.91,.39,3.69,.65,7.4,.9,11.11,.17,2.53,.46,5.09,.27,7.6-.52,6.9-1.05,13.8-1.98,20.65-1.23,9.08-3.61,17.93-6.77,26.53-2.37,6.44-5.05,12.75-8.25,18.85-3.49,6.65-7.21,13.16-11.68,19.19-3.79,5.11-7.62,10.23-11.8,15.02-4.63,5.3-9.49,10.43-14.58,15.3-8.59,8.22-17.91,15.6-27.86,22.12-6.33,4.14-12.77,8.12-19.35,11.86-5.12,2.91-10.51,5.34-15.8,7.93-2.87,1.41-5.75,2.83-8.7,4.04-5.41,2.22-10.84,4.44-16.35,6.39-5.94,2.1-11.92,4.14-17.99,5.75-8.89,2.36-17.85,4.54-26.86,6.39-7.12,1.47-14.35,2.5-21.57,3.42-6.57,.84-13.17,1.61-19.78,1.79-12.21,.34-24.45,.49-36.66,.23-7.61-.16-15.21-1.03-22.78-1.89-6.78-.77-13.53-1.9-20.28-2.99-9.01-1.46-17.89-3.55-26.65-6.13-6.48-1.91-12.94-3.89-19.33-6.06-5.18-1.76-10.32-3.66-15.35-5.82-6.98-3-13.97-6.03-20.69-9.55-7.32-3.83-14.4-8.13-21.49-12.4-7.35-4.43-14.2-9.59-20.87-14.98-8.58-6.93-16.59-14.48-23.96-22.68-6.61-7.36-12.66-15.15-17.94-23.52-2.66-4.22-5.07-8.6-7.43-12.99-1.78-3.3-3.42-6.68-4.92-10.12-5.52-12.65-9.31-25.81-10.99-39.51-.75-6.12-.88-12.31-1.29-18.48,.14,0,.28,0,.43-.01Z"/></clipPath></defs><image clip-path="url(#shape7)" width="' + newWidth + '" height="' + newHeight + '" x="' + newX + '" y="' + newY + '" xlink:href="' + newSource + '"></image></svg>')
              }
            }
            $('#upload-preview')
              .attr('src', newSource)
              .addClass('upload__preview--active');
            $('#upload-circle-property').val(circleRender);

            if (removeHeightAttr) {
              $('#upload-preview').css('height', 'auto');
            }
            if (currentPageType === 'rectangle' || currentPageType == 'heart') {
              $('#upload-preview').css('border-radius', '0');
              $('.filestack-photo img').css('border-radius', '0');
            }
          }
          $('#upload-preview')
            .parent()
            .addClass('upload__preview-wrap--loading');
          $('#upload-property').val(newResponse);
          $('#upload-unedited-property').val(optionsRevised);
          updateLatestImage(newResponse);
          $modal.close();
          if (!$('#ornament-type').val()) {
            $('#upload-save')
              .text('Upload & Add to Cart')
              .prop('disabled', false)
              .removeClass('btn--no-animate');
          } else {
            $('#upload-save')
              .text('Upload')
              .prop('disabled', false)
              .removeClass('btn--no-animate');
          }
          if ($('#upload-save').hasClass('ornament')) {
            // do nothing
            if (forceATC) {
              $('.add-to-cart-btn').click();
              forceATC = false;
              $('#upload-save').text('Upload');
            }
          } else {
            $('button.add-to-cart').click();
          }
          $('.editorLoading').hide();
        });
      });
    });

    $('#modal-add-to-cart').click(function () {
      $('.add-to-cart-btn').click();
    });

    $('#upload-save-multi').click(function () {
      // this is when a user uploads a file. let's check the input variable for the active variant ID
      // let's then add it to the results list as a custom object and let's store the image URL in the props so it's easy to reference in cart add

      var variantId = $(this).data('variant-id');

      $('#upload-save')
        .text('Uploading…')
        .prop('disabled', true)
        .addClass('btn--no-animate');

      // ** Send to Cloudinary
      $('.upload__preview-wrap').show();

      pinturaData.processImage().then((imageWriterResult) => {
        // Logs resulting image
        var formData = new FormData();
        formData.append('file', imageWriterResult.dest);
        formData.append('upload_preset', 'ml_unsigned');
        formData.append('api_key', '211575742393728');
        $('.editorLoading').css('display', 'flex');

        $.ajax({
          url: 'https://api.cloudinary.com/v1_1/dgwldii6i/image/upload',
          type: 'POST',
          data: formData,
          async: true,
          success: function (data) { },
          error: function (data, error, errorThrown) {
            $('#upload-preview')
              .attr('src', '')
              .addClass('upload__preview--active');
            $('#upload-preview')
              .parent()
              .addClass('upload__preview-wrap--loading');
            $('.upload__preview-wrap').hide();
            $('#upload-property').val('');
            $('#upload-unedited-property').val('');
            $modal.close();
            $('#upload-save')
              .text('Upload & Add to Cart')
              .prop('disabled', false)
              .removeClass('btn--no-animate');
            $('.editorLoading').hide();
            overrideSkip = true;
            $('button.add-to-cart').addClass('skip-upload');
            $('button.add-to-cart').click();
          },
          cache: false,
          contentType: false,
          processData: false,
          timeout: 15000
        }).done(function (response) {
          var optionsRevised = response.url;
          var newResponse = response.url;
          if (optionsRevised.indexOf('http://res.cloudinary.com/dgwldii6i/image/upload/') > -1) {
            var splitImage = optionsRevised.split('http://res.cloudinary.com/dgwldii6i/image/upload/')[1];
            var splitName = 'l_' + splitImage.split('/')[1];
            if (splitName) {
              splitName = splitName.substr(0, splitName.lastIndexOf('.'));
            }
            var splitID = splitImage.split('/')[0];
            optionsRevised = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage;
            newResponse = 'https://res.cloudinary.com/dgwldii6i/image/upload/' + splitImage; //'https://res.cloudinary.com/dgwldii6i/image/upload/e_blur:2000/' + splitName + ',c_scale,w_0.9/fl_layer_apply/' + splitImage;            
            $('#upload-preview')
              .attr('src', 'https://res.cloudinary.com/dgwldii6i/image/upload/c_scale,h_250,w_250/' + splitImage)
              .addClass('upload__preview--active');
          }
          $('#upload-preview')
            .parent()
            .addClass('upload__preview-wrap--loading');
          $('#upload-property').val(newResponse);
          $('#upload-unedited-property').val(optionsRevised);
          $modal.close();
          $('#upload-save')
            .text('Upload & Add to Cart')
            .prop('disabled', false)
            .removeClass('btn--no-animate');
          $('.editorLoading').hide();
          self.addCustomItemConfirm(LAST_SELECTED_VARIANT_ID, optionsRevised, newResponse, response.url);
        });
      });
    });

    $('button.add-to-cart').on('click', function () {
      if ($('#upload-preview').attr('src') == '' && !$('button.add-to-cart').hasClass('skip-upload') && !overrideSkip && $('.upload-confirm-modal').length) {
        $('button.add-to-cart').prop('disabled', true);
        $confirmModal.open();
        if (!hiddenCheck) {
          hiddenCheck = setInterval(function () {
            if (!$('.upload-confirm-modal').is(':visible')) {
              clearInterval(hiddenCheck);
              $('button.add-to-cart').prop('disabled', false);
              $('button.add-to-cart').removeClass('is-adding');
              $('button.add-to-cart').removeClass('is-added');
              clearInterval(hiddenCheck);
              hiddenCheck = null;
            }
          }, 250);
        }
      }
      else {
        overrideSkip = false;
        $('button.add-to-cart').prop('disabled', false);
      }
    });

    $('#skip-upload').on('click', function () {
      $confirmModal.close();
      $('button.add-to-cart').addClass('skip-upload');
      $('button.add-to-cart').click();
    });

    $('#upload-button').on('click', function () {
      $confirmModal.close();
      $('#upload-file').click();
    });

    $('#upload-confirm-modal .icon-close').on('click', function () {
      $('button.add-to-cart').prop('disabled', false);
    });
  },

  readFileUpload: function (blob, loadCallback) {
    if (blob) {
      let reader = new FileReader();
      reader.onload = loadCallback;
      reader.readAsDataURL(blob);
    } else {
      alert("Sorry, your browser doesn't support uploads here.");
    }
  },

  destroy: function () {
    var self = this;
    self.undelegateEvents();
  },

  responsive: function () {
    var self = this;
    ORW.utilities.mediaCheck(function () {
      // Desktop actions
    }, function () {
      // Mobile actions
    })
  },

  isMobile: function () {
    if (ORW.responsive == 'small') {
      return true;
    }
    return false;
  }
});